(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[4],{

/***/ "J2Fv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Actions */
/* unused harmony export AlgoliaProductBlock */
/* unused harmony export ContactLensesConfigurator */
/* unused harmony export CrossSellBlock */
/* unused harmony export CrossSellItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeaturedProducts$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return helpers; });
/* unused harmony export LensPacks */
/* unused harmony export Prescription */
/* unused harmony export ProductBanner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductBanner; });
/* unused harmony export ProductBlock */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProductDetail; });
/* unused harmony export ProductDetailDescription */
/* unused harmony export ProductDetailFeatures */
/* unused harmony export ProductDetailImage */
/* unused harmony export ProductDetailLensesFeatures */
/* unused harmony export ProductDetailOpticsFeatures */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProductDetailProvider; });
/* unused harmony export ProductDetailTitle */
/* unused harmony export ProductDetailUnitInfo */
/* unused harmony export ProductDiscountBar */
/* unused harmony export ProductDiscountLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ProductFrameMeasurements$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ProductListing; });
/* unused harmony export ProductPlaceholder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ProductPromotions$1; });
/* unused harmony export ProductTypes */
/* unused harmony export ProductVisualSwitcher */
/* unused harmony export PromotionBlock */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RecentlyViewedProducts$1; });
/* unused harmony export SSP */
/* unused harmony export Solution */
/* unused harmony export SubscriptionSolutionPicker */
/* unused harmony export SubscriptionSolutionPickerContainer */
/* unused harmony export VirtualTryOn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return VtoConfigProvider; });
/* unused harmony export createVtoServerConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getProductSeoInfo; });
/* unused harmony export isContactLenses */
/* unused harmony export isLightProductModel */
/* unused harmony export useHasVirtualTryOn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return useProductDetailContext; });
/* harmony import */ var _grandvision_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("k3MI");
/* harmony import */ var _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lylx");
/* harmony import */ var _grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ur++");
/* harmony import */ var _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("B4sh");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("G4qV");
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5rFJ");
/* harmony import */ var _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Dott");
/* harmony import */ var _grandvision_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wE1k");
/* harmony import */ var _grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("PM6f");
/* harmony import */ var _grandvision_carts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ioLe");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _grandvision_elements__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("m5xE");
/* harmony import */ var _grandvision_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ytpp");
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PGlZ");
/* harmony import */ var _grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("NA/S");
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ZMKu");
/* harmony import */ var _grandvision_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("MZek");
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("ehos");
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(throttle_debounce__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("fhwx");
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react_html_parser__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var load_script__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("MuZe");
/* harmony import */ var load_script__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(load_script__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var use_onclickoutside__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("uGJH");
/* harmony import */ var _grandvision_stores__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("KOn7");
























/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

// using hardcoded english locale here to map:
// https://github.com/GrandVisionHQ/gv-core-components/blob/69612677a059e714191bee6c94b62f7866e039f1/packages/common/src/ColorPicker/color-mapping.tsx#L1
var COLOR_MAPPING_LOCALE = 'en-GB';
function getDiscountText(locale, variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return '';
    }
    var priceObject = variant.prices[0];
    var description = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getNestedProperty */ "s"])(priceObject, 'discounted.discount.obj.description');
    return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(description, locale);
}
var getExtrasId = function (product) {
    if (!product || !product.masterVariant || !Array.isArray(product.masterVariant.attributes)) {
        return undefined;
    }
    var extrasAttribute = product.masterVariant.attributes.find(function (attr) { return attr.name === 'lensExtras'; });
    if (!extrasAttribute || !extrasAttribute.value) {
        return undefined;
    }
    return extrasAttribute.value.id;
};
function getPrice(variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return undefined;
    }
    var price = variant.prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: price.value.currencyCode,
        };
    }
    var discounted = price.discounted;
    return {
        currency: price.value.currencyCode,
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount,
    };
}
function getProductTypeName(product) {
    var result = product &&
        product.productType &&
        product.productType.obj &&
        _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isProductTypeName(product.productType.obj.name)
        ? product.productType.obj.name
        : false;
    return !!result ? result : undefined;
}
function getProductModelName(variant, locale, productType) {
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(productType)) {
        return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(variant, 'materialType', locale);
    }
    return variant.name || '';
}
var getProductTitle = function (productType, product, variant, locale) {
    var brand = productType.toLowerCase() === 'contact-lenses'
        ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale)
        : String(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brand'));
    var brandModel = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brandModel') || '';
    var brandModelCode = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brandModelCode') || '';
    return (brand + " " + brandModel + " " + (brandModelCode !== brandModel ? brandModelCode : '')).trim();
};
function getActiveVariant(product, sku) {
    if (!sku) {
        return product.masterVariant;
    }
    if (product.masterVariant.sku === sku) {
        return product.masterVariant;
    }
    return product.variants.find(function (variant) { return variant.sku === sku; }) || product.masterVariant;
}
function getVariantInfo(product, productType, locale, variant, getProductImageUrls, staticsUrl) {
    var activeVariant = !variant || typeof variant === 'string' ? getActiveVariant(product, variant) : variant;
    var allowBackOrderAttribute = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'allowBackOrder');
    var allowBackOrder = typeof allowBackOrderAttribute === 'undefined' ? undefined : !!allowBackOrderAttribute;
    var sharedProductInfo = {
        sku: activeVariant.sku || '',
        modelName: getProductModelName(activeVariant, locale, productType),
        header: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'header', locale),
        description: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'description', locale),
        images: getProductImages(product, activeVariant, getProductImageUrls, staticsUrl),
        usps: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValues */ "p"])(activeVariant, 'usps', locale) || [],
        price: getPrice(activeVariant),
        brand: String(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'brand')),
        discountText: getDiscountText(locale, activeVariant),
        allowBackOrder: allowBackOrder,
        excludedFromCheckout: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'excludedFromCheckout'),
        channelAvailability: activeVariant.channelAvailability,
    };
    var sharedFrameInfo = {
        name: activeVariant.name || '',
        frameColorLabel: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'frameColor', locale),
        frameColor: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'frameColor', COLOR_MAPPING_LOCALE),
        frameShape: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'frameShape', locale),
        frameMaterial: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'frameMaterial', locale),
        gender: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValues */ "p"])(activeVariant, 'gender', locale) || ['UNISEXO'],
        isKids: false,
    };
    var genderKeys = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValues */ "p"])(activeVariant, 'gender', locale);
    if (genderKeys && Array.isArray(genderKeys) && genderKeys.length) {
        sharedFrameInfo.isKids = genderKeys.some(function (a) { return a.toLowerCase() === 'kids'; });
    }
    // Contact-lenses
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(productType)) {
        return __assign(__assign({}, sharedProductInfo), { productType: 'Contact-lenses', brand: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale), replacementFrequency: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'replacementFrequency', locale), materialType: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'materialType', locale), lensType: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'lensType', locale), material: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'material', locale), waterContent: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'waterContent', locale), packageQuantity: Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'packageQuantity')), features: {
                hydration: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cbHydration'),
                softness: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cbSoftness'),
                breathability: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cbBreathability'),
                fatigue: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cbFatigue'),
                uv: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cbUV'),
                basics: !!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cbBasics'),
            }, lensProperties: {
                power: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'power'),
                baseCurve: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'baseCurve'),
                diameter: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'diameter'),
                axis: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'axis'),
                cylinder: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'cylinder'),
                addition: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'addition'),
                color: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'color'),
            }, promotionalText: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'promotionalText', locale) });
        // Sunglasses
    }
    else if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isSunglasses(productType)) {
        var availability = activeVariant.availability && {
            availableQuantity: _grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__[/* Helpers */ "c"].getAvailableQuantity(activeVariant.availability),
        };
        return __assign(__assign(__assign(__assign({}, sharedProductInfo), sharedFrameInfo), { productType: 'Sunglasses', lensColor: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(activeVariant, 'lensColor', locale), features: {
                uvCategory: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'UVCategory'),
                polarized: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'polarized'),
                glazable: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'glazeble'),
            } }), (availability ? { availability: availability } : {}));
        // Frames
    }
    else {
        return __assign(__assign(__assign({}, sharedProductInfo), sharedFrameInfo), { productType: 'Frames', compatiblePrescriptionGlassProducts: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(activeVariant, 'compatiblePrescriptionGlassProducts') });
    }
}
function getVariants(variants, staticsUrl, _a, product, formatProductUrl) {
    var productType = _a.productType;
    return variants.map(function (variant) {
        var _a, _b;
        return ({
            sku: variant.sku,
            image: (_b = (_a = getFullImageUrls(variant, staticsUrl)[0]) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '',
            url: formatProductUrl({
                productType: productType,
                sku: variant.sku,
                slug: product.slug,
            }),
        });
    });
}
function getVariantPickerLabel(variant) {
    return [variant.lensColor, variant.frameColorLabel].filter(function (str) { return str.trim() !== ''; }).join(' / ');
}
function getProductAltTag(name, product, productType, locale) {
    var brand = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product, 'brand');
    var frameColor = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(product, 'frameColor', locale);
    var lensColor = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(product, 'lensColor', locale);
    if (productType &&
        (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(productType) || _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isContactLensBundle(productType))) {
        return typeof name === 'string' ? name : Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(name, locale);
    }
    var colorInfo = (productType && _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isFrames(productType)) || !lensColor
        ? frameColor
        : "" + lensColor + (frameColor && "/" + frameColor);
    return brand + " " + product.name + " " + colorInfo;
}
var placeholderImage = {
    url: '',
    dimensions: {
        h: 0,
        w: 0,
    },
};
/**
 * This function decides where and how to load the product images
 * There are two different paths, one with a supplied staticsUrl and one without
 *  - If a staticsUrl is supplied, we return the full image urls
 *  - If no staticsUrl is given, we return the image filename in a legacy format
 * In either scenario we also decide to return the normal product images, or the images from
 * the supplied helper function ( BENE )
 */
function getProductImages(product, variant, liquidPixelHelper, staticsUrl) {
    var _a;
    // Return legacy format
    if (!staticsUrl) {
        if (liquidPixelHelper) {
            return liquidPixelHelper(product, 1200);
        }
        else {
            var _b = __read((_a = variant.images) !== null && _a !== void 0 ? _a : [], 2), primary = _b[0], secondary = _b[1];
            return { primary: primary, secondary: secondary };
        }
    }
    return liquidPixelHelper
        ? getLiquidPixelImages(liquidPixelHelper, product, staticsUrl)
        : getFullImageUrls(variant, staticsUrl);
}
/**
 * Prepends variant images with staticsUrl
 */
function getFullImageUrls(variant, staticsUrl) {
    if (!variant.images || !variant.images.length) {
        return [placeholderImage];
    }
    return variant.images.map(function (image) { return ({
        url: "" + staticsUrl + image.url,
        dimensions: __assign({}, image.dimensions),
    }); });
}
/**
 * Maps BENE product images to use full image urls
 */
function getLiquidPixelImages(liquidPixelHelper, product, staticsUrl) {
    var images = liquidPixelHelper(product, 1200);
    var productImages = Object.values(images).reduce(function (images, currentImage) {
        if (currentImage) {
            var newImage = {
                url: "" + staticsUrl + currentImage.url,
                dimensions: __assign({}, placeholderImage.dimensions),
            };
            images.push(newImage);
        }
        return images;
    }, []);
    return productImages;
}

var helpers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getDiscountText: getDiscountText,
    getExtrasId: getExtrasId,
    getPrice: getPrice,
    getProductTypeName: getProductTypeName,
    getProductModelName: getProductModelName,
    getProductTitle: getProductTitle,
    getActiveVariant: getActiveVariant,
    getVariantInfo: getVariantInfo,
    getVariants: getVariants,
    getVariantPickerLabel: getVariantPickerLabel,
    getProductAltTag: getProductAltTag,
    getProductImages: getProductImages,
    getFullImageUrls: getFullImageUrls,
    getLiquidPixelImages: getLiquidPixelImages
});

var reduceVariantInfo = function (locale) { return function (mem, variant) {
    var _a;
    if (!variant.sku || !variant.isMatchingVariant || !variant.attributes) {
        return mem;
    }
    var variationAttribute = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'variationAttribute');
    if (!variationAttribute || !Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isString */ "B"])(variationAttribute)) {
        return mem;
    }
    var title = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(variant, variationAttribute, locale);
    if (!title) {
        return mem;
    }
    var isDefault = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'default') === true;
    return __spread(mem, [
        __assign({ sku: variant.sku, title: title,
            isDefault: isDefault }, (((_a = variant.images) === null || _a === void 0 ? void 0 : _a.length) ? { image: variant.images[0] } : {})),
    ]);
}; };
var getVariants$1 = function (product, sku, locale) {
    var productHasOnlyMasterVariant = !product.variants.length;
    return productHasOnlyMasterVariant
        ? {}
        : {
            variants: __spread([product.masterVariant], product.variants).reduce(reduceVariantInfo(locale), []),
        };
};
var getBaseInfo = function (product, sku, locale) {
    var _a, _b, _c, _d, _e, _f, _g;
    var variant = getActiveVariant(product, sku);
    var isMasterVariant = product.masterVariant.sku === variant.sku;
    var productHasOnlyMasterVariant = !product.variants.length;
    var isDefault = false;
    // We only want to consider the "default" value of a master variant if the product doesn't have any variants
    if (isMasterVariant && productHasOnlyMasterVariant) {
        isDefault = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'default') === true;
    }
    else if (!isMasterVariant) {
        isDefault = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'default') === true;
    }
    var rootImage;
    // We always take the root image from the masterVariant
    var _h = __read((_a = product.masterVariant.images) !== null && _a !== void 0 ? _a : [], 2), firstMasterImage = _h[0], secondMasterImage = _h[1];
    var _j = __read((_b = variant.images) !== null && _b !== void 0 ? _b : [], 1), variantImage = _j[0];
    // If it has variants the second image is the root image
    if (!isMasterVariant) {
        // If the SKU isn't the masterVariant's SKU we're constructing this object for when a variant has been selected
        rootImage = variantImage;
    }
    else {
        rootImage = productHasOnlyMasterVariant ? firstMasterImage : secondMasterImage;
    }
    var discountDescription = (_g = (_f = (_e = (_d = (_c = variant.prices) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.discounted) === null || _e === void 0 ? void 0 : _e.discount) === null || _f === void 0 ? void 0 : _f.obj) === null || _g === void 0 ? void 0 : _g.description;
    var discountText = discountDescription
        ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(discountDescription, locale)
        : undefined;
    return __assign(__assign({ sku: sku, title: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale), description: product.description ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.description, locale) : undefined, price: getPrice(variant), isDefault: isDefault }, (discountText && { discountText: discountText })), (rootImage ? { image: rootImage } : {}));
};
var getUsps = function (product, sku, locale) {
    var variant = getActiveVariant(product, sku);
    return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValues */ "p"])(variant, 'prescriptionGlassPackageUsps', locale);
};
var convertToFrameInfo = function (product, sku, locale) {
    var variant = getActiveVariant(product, sku);
    var brand = typeof Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brand') !== 'object' ? String(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brand')) : '';
    var codeAttr = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brandModelCode');
    var code = typeof codeAttr === 'string' ? codeAttr : '';
    var title = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale) || [brand, code].filter(Boolean).join(' ');
    return {
        brand: brand,
        code: code,
        price: getPrice(variant),
        sku: sku,
        title: title,
    };
};
var convertToLensTypeInfo = function (product, sku, locale) { return (__assign(__assign({}, getBaseInfo(product, sku, locale)), getVariants$1(product, sku, locale))); };
var convertToPackageInfo = function (product, sku, locale) { return (__assign(__assign({}, getBaseInfo(product, sku, locale)), { usps: getUsps(product, sku, locale) })); };
var convertToLensAddOnInfo = function (product, sku, locale) { return (__assign(__assign({}, getBaseInfo(product, sku, locale)), getVariants$1(product, sku, locale))); };
var lowToHigh = function (extractPrice) { return function (left, right) {
    return (extractPrice(left) || 0) - (extractPrice(right) || 0);
}; };

var frameSkuProp = function (_, _a) {
    var frameSku = _a.frameSku;
    return frameSku;
};
var lensTypeSkuProp = function (_, _a) {
    var lensTypeSku = _a.lensTypeSku;
    return lensTypeSku;
};
var packageSkuProp = function (_, _a) {
    var packageSku = _a.packageSku;
    return packageSku;
};
var addOnSkuProp = function (_, _a) {
    var addOnSku = _a.addOnSku;
    return addOnSku;
};
var getPrescriptionGlasses = function (state) {
    return state.prescriptionGlasses;
};
var getGeneralPrescriptionValues = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionGlasses, function (pg) { return pg.prescription; });

var getProducts = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionGlasses, function (pg) { return pg.products; });
var getFrames = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getProducts, function (p) { return p.frames; });
var getLensTypes = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getProducts, function (p) { return p.lensTypes; });
/**
 * Returns the SKUs of the lens-types that we've already loaded from the server
 */
var getKnownLensTypeSKUs = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getLensTypes, function (lensTypes) { return new Set(Object.keys(lensTypes)); });
var getPackages = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getProducts, function (p) { return p.packages; });
var getKnownPackageSKUs = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPackages, function (packages) { return new Set(Object.keys(packages)); });
var getFrame = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrames, frameSkuProp, function (frames, frameSku) { return frames[frameSku]; });
var getLensType = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getLensTypes, lensTypeSkuProp, function (lensTypes, lensTypeSku) { return lensTypes[lensTypeSku]; });
var getPackage = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPackages, packageSkuProp, function (packages, packageSku) { return packages[packageSku]; });
var getAddOns = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getProducts, function (p) { return p.addOns; });
var getKnownAddOnSKUs = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getAddOns, function (addOns) { return new Set(Object.keys(addOns)); });
var getAddOn = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getAddOns, addOnSkuProp, function (addOns, addOnSku) { return addOns[addOnSku]; });
var getBundleProductVariants = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getProducts, function (p) { return p.variants; });
/**
 * Whenever a lens type is not a master variant, we need to be able to find its parent lens type
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */
var lookupParentLensType = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleProductVariants, getLensTypes, lensTypeSkuProp, function (variants, lensTypes, lensTypeSku) {
    var masterSku = variants[lensTypeSku];
    if (!masterSku) {
        return undefined;
    }
    return lensTypes[masterSku];
});
/**
 * Whenever a lens add-on is not a master variant, we need to be able to find its parent add-on
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */
var lookupParentAddOn = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleProductVariants, getAddOns, addOnSkuProp, function (variants, addOns, addOnSku) {
    var masterSku = variants[addOnSku];
    if (!masterSku) {
        return undefined;
    }
    return addOns[masterSku];
});

var getBundles = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionGlasses, function (pg) { return pg.bundles; });
/**
 * Frames
 */
var getBundleFrames = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundles, function (b) { return b.frames; });
var getBundleFrame = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleFrames, frameSkuProp, function (frames, frameSku) { return frames[frameSku]; });
/**
 * Lens Types
 */
var getBundleLensTypes = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundles, function (b) { return b.lensTypes; });
var getBundleLensType = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleLensTypes, lensTypeSkuProp, function (lensTypes, lensTypeSku) { return lensTypes[lensTypeSku]; });
/**
 * Packages
 */
var getBundlePackages = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundles, function (b) { return b.packages; });
var getBundlePackage = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundlePackages, packageSkuProp, function (packages, packageSku) { return packages[packageSku]; });
/**
 * Add-ons
 */
var getBundleAddOns = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundles, function (b) { return b.addOns; });
var convertToParamArray = function (o) {
    return Object.entries(o).map(function (_a) {
        var _b = __read(_a, 2), name = _b[0], param = _b[1];
        return ({
            name: name,
            values: param ? param.values : new Set(),
        });
    });
};
var getOpticalParameters = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleFrame, getBundleLensType, function (bundle, lensType) {
    if (!bundle) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensType)) {
        return lensType;
    }
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(__spread(convertToParamArray(lensType.result.opticalParameters), convertToParamArray(bundle.opticalParameters)));
});

var isDefined = function (v) { return typeof v !== 'undefined'; };
var isDefinedAndHasPrice = function (v) {
    return isDefined(v) && isDefined(v.price);
};
/**
 * Checks if the SKU belongs to a master variant. This decides whether the "product" gets
 * its own tile, or that it should be part of a tile as a variant.
 */
var isMasterProduct = function (product, sku) { return (product === null || product === void 0 ? void 0 : product.masterVariant.sku) === sku; };
/**
 * These are public selectors that are meant to be used from the container components outside of this state dir
 */
var isAnyStillLoading = function (resources, skus) {
    return __spread(skus).reduce(function (isLoading, sku) {
        var _a;
        if (isLoading) {
            return isLoading;
        }
        var resource = (_a = resources[sku]) !== null && _a !== void 0 ? _a : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(resource) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(resource);
    }, false);
};
var getLensTypes$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleFrame, getBundleLensTypes, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (s) { return s; }, function (bundle, lensTypes, locale, s) {
    if (!bundle || !locale) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    var lensTypeSkus = bundle.lensTypeSkus;
    if (isAnyStillLoading(lensTypes, lensTypeSkus)) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])();
    }
    var results = __spread(lensTypeSkus).map(function (lensTypeSku) {
        var lensType = getLensType(s, { lensTypeSku: lensTypeSku });
        if (!lensType) {
            return undefined;
        }
        if (!isMasterProduct(lensType, lensTypeSku)) {
            return undefined;
        }
        return convertToLensTypeInfo(lensType, lensTypeSku, locale);
    })
        .filter(isDefinedAndHasPrice)
        .sort(lowToHigh(function (lensType) { var _a, _b, _c; return (_b = (_a = lensType.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) !== null && _b !== void 0 ? _b : (_c = lensType.price) === null || _c === void 0 ? void 0 : _c.originalPrice; }));
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(results);
});
var getPackages$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundleLensType, getBundlePackages, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (s) { return s; }, function (lensType, packages, locale, s) {
    if (!lensType || !locale) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensType)) {
        return lensType;
    }
    var packageSkus = lensType.result.packageSkus;
    if (isAnyStillLoading(packages, packageSkus)) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])();
    }
    var results = __spread(packageSkus).map(function (packageSku) {
        var packageProduct = getPackage(s, { packageSku: packageSku });
        if (!packageProduct) {
            return undefined;
        }
        if (!isMasterProduct(packageProduct, packageSku)) {
            return undefined;
        }
        return convertToPackageInfo(packageProduct, packageSku, locale);
    })
        .filter(isDefinedAndHasPrice)
        .sort(lowToHigh(function (packageInfo) { var _a, _b, _c; return (_b = (_a = packageInfo.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) !== null && _b !== void 0 ? _b : (_c = packageInfo.price) === null || _c === void 0 ? void 0 : _c.originalPrice; }));
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(results);
});
var getLensAddOns = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundlePackage, getBundleAddOns, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (s) { return s; }, function (bundlePackage, addOns, locale, s) {
    if (!bundlePackage || !locale) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(bundlePackage)) {
        return bundlePackage;
    }
    var addOnSkus = bundlePackage.result.addOnSkus;
    if (isAnyStillLoading(addOns, addOnSkus)) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])();
    }
    var results = __spread(addOnSkus).map(function (addOnSku) {
        var addOnProduct = getAddOn(s, { addOnSku: addOnSku });
        if (!addOnProduct) {
            return undefined;
        }
        if (!isMasterProduct(addOnProduct, addOnSku)) {
            return undefined;
        }
        return convertToLensAddOnInfo(addOnProduct, addOnSku, locale);
    })
        .filter(isDefinedAndHasPrice)
        .sort(lowToHigh(function (addOnInfo) { var _a, _b, _c; return (_b = (_a = addOnInfo.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) !== null && _b !== void 0 ? _b : (_c = addOnInfo.price) === null || _c === void 0 ? void 0 : _c.originalPrice; }));
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(results);
});

var add = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/add-to-cart');
var addSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/add-to-cart-success');
var addFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/add-to-cart-failed', function (error) { return ({ error: error }); });

var fetchLensTypes = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-lens-types', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchLensTypesSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-lens-types-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchLensTypesFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-lens-types-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchPackages = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-packages', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchPackagesSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-packages-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchPackagesFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-packages-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchAddOns = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-add-ons', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchAddOnsSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-add-ons-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchAddOnsFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/fetch-add-ons-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var selectLensType = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-lens-type', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectLensTypeFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-lens-type-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectLensTypeSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-lens-type-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectPackage = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-package', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectPackageFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-package-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectPackageSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-package-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var resetSelectedPackage = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/reset-selected-package', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectAddOn = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-add-on', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectAddOnFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-add-on-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectAddOnSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/select-add-on-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var resetSelectedAddOn = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/reset-selected-add-on', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var updatePrescriptionValue = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/update-prescription-value', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var updatePrescriptionInfo = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/update-prescription-info', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var updatePrescriptionType = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/update-prescription-type', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var updateVerificationAllowed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/update-verification-allowed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var toggleFooter = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/footer/toggle');
var openFooter = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/footer/open');
var closeFooter = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/footer/close');
var stepShown = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/step-shown', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var addToCart = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/legacy__add-to-cart');
var addToCartFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/legacy__add-to-cart-failed', function (error) { return ({ error: error }); });
var addToCartSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/legacy__add-to-cart-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var startPrescriptionGlassesConfiguration = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/start', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var nextStep = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/next-step');
var nextStepSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/next-step-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var nextStepFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/next-step-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var previousStep = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/previous-step');
var previousStepFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/previous-step-failed', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var previousStepSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('products/prescription-glasses/previous-step-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var extractSkus = function (attributeName) { return function (variant) {
    var _a;
    var attribute = (_a = variant.attributes) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.name === attributeName; });
    if (!attribute) {
        return new Set();
    }
    if (Array.isArray(attribute.value)) {
        return new Set(attribute.value);
    }
    else if (typeof attribute.value === 'string') {
        return new Set(attribute.value.split(','));
    }
    return new Set();
}; };
var extractLensTypeSkus = extractSkus('compatibleLensTypeProducts');
var extractPackageSkus = extractSkus('compatiblePackageProducts');
var extractAddOnSkus = extractSkus('compatibleOptionProduct');
var extractOpticalParameters = function (variant) {
    if (!variant.opticalParameters) {
        return {};
    }
    return Object.entries(variant.opticalParameters).reduce(function (m, _a) {
        var _b;
        var _c = __read(_a, 2), name = _c[0], value = _c[1];
        return (__assign(__assign({}, m), (_b = {}, _b[name] = {
            values: value ? new Set(value.values) : new Set(),
        }, _b)));
    }, {});
};
var indexVariantsBySku = function (products) {
    return products
        .reduce(function (m, p) { return __spread(m, [
        [p.masterVariant.sku, p.masterVariant]
    ], p.variants.map(function (v) { return [v.sku, v]; })); }, [])
        .filter(function (v) { return !!v[0]; })
        .reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), sku = _c[0], v = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[sku] = v, _b)));
    }, {});
};
var createStates = function (skus, stateCreator) {
    return __spread(skus).reduce(function (acc, sku) {
        var _a;
        var state = stateCreator(sku);
        if (!state) {
            return acc;
        }
        return __assign(__assign({}, acc), (_a = {}, _a[sku] = state, _a));
    }, {});
};
var initialState = {
    lensTypes: {},
    packages: {},
    addOns: {},
    frames: {},
};
var reducer = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(initialState, 
/**
 * Initializes a new configuration when necessary
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b;
    var _c = _a.payload, frame = _c.frame, frameSku = _c.frameSku;
    var variant = getActiveVariant(frame, frameSku);
    return __assign(__assign({}, s), { frames: (_b = {},
            _b[frameSku] = {
                lensTypeSkus: extractLensTypeSkus(variant),
                opticalParameters: extractOpticalParameters(frame.masterVariant),
            },
            _b) });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchLensTypes, function (s, a) { return (__assign(__assign({}, s), { lensTypes: __assign(__assign({}, s.lensTypes), createStates(a.payload.skus, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(); })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchLensTypesFailed, function (s, a) { return (__assign(__assign({}, s), { lensTypes: __assign(__assign({}, s.lensTypes), createStates(a.payload.skus, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(a.payload.error); })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchLensTypesSuccess, function (s, a) {
    var variantLookup = indexVariantsBySku(a.payload.products);
    return __assign(__assign({}, s), { lensTypes: __assign(__assign(__assign({}, s.lensTypes), createStates(a.payload.tried, function (sku) {
            var variant = variantLookup[sku];
            if (!variant) {
                return;
            }
            return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])({
                packageSkus: extractPackageSkus(variant),
                opticalParameters: extractOpticalParameters(variant),
            });
        })), createStates(a.payload.missing, function (sku) {
            return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("Couldn't find lens type with SKU \"" + sku + "\""));
        })) });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchPackages, function (s, _a) {
    var skus = _a.payload.skus;
    return (__assign(__assign({}, s), { packages: __assign(__assign({}, s.packages), createStates(skus, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(); })) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchPackagesFailed, function (s, a) { return (__assign(__assign({}, s), { packages: __assign(__assign({}, s.packages), createStates(a.payload.skus, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(a.payload.error); })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchPackagesSuccess, function (s, a) { return (__assign(__assign({}, s), { packages: __assign(__assign(__assign({}, s.packages), createStates(a.payload.tried, function (sku) {
        var product = a.payload.products.find(function (p) { return p.masterVariant.sku === sku; });
        if (!product) {
            return;
        }
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])({
            addOnSkus: extractAddOnSkus(product.masterVariant),
        });
    })), createStates(a.payload.missing, function (sku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("Couldn't find package with SKU \"" + sku + "\""));
    })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchAddOns, function (s, _a) {
    var skus = _a.payload.skus;
    return (__assign(__assign({}, s), { addOns: __assign(__assign({}, s.addOns), createStates(skus, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(); })) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchAddOnsFailed, function (s, a) { return (__assign(__assign({}, s), { addOns: __assign(__assign({}, s.addOns), createStates(a.payload.skus, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(a.payload.error); })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchAddOnsSuccess, function (s, a) { return (__assign(__assign({}, s), { addOns: __assign(__assign(__assign({}, s.addOns), createStates(a.payload.tried, function () { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(undefined); })), createStates(a.payload.missing, function (sku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("Couldn't find add-on with SKU \"" + sku + "\""));
    })) })); }));

var isPrescriptionValue = function (value) {
    return typeof value === 'number';
};

var defaultState = Object.freeze({
    left: {},
    right: {},
});

var getConfiguration = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionGlasses, frameSkuProp, function (pg, frameSku) { return pg.configurations[frameSku]; });
var getLensTypeSku = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration, function (config) { var _a; return (_a = config === null || config === void 0 ? void 0 : config.lensType) === null || _a === void 0 ? void 0 : _a.sku; });
var getPackageSku = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration, function (config) { return config === null || config === void 0 ? void 0 : config.package; });
var getAddOnSku = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration, function (config) { return config === null || config === void 0 ? void 0 : config.addOn; });
var getPrescription = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration, function (c) { var _a, _b; return (_b = (_a = c === null || c === void 0 ? void 0 : c.lensType) === null || _a === void 0 ? void 0 : _a.prescriptionInfo) !== null && _b !== void 0 ? _b : defaultState; });

var getPrescriptionType = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration, function (c) { return c === null || c === void 0 ? void 0 : c.prescriptionType; });
/**
 * The currently selected lens-type product for the given frame SKU
 */
var getSelectedLensType = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getLensTypeSku, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (s) { return s; }, function (lensTypeSku, locale, state) {
    if (!lensTypeSku || !locale) {
        return undefined;
    }
    var lensTypeProduct = lookupParentLensType(state, { lensTypeSku: lensTypeSku });
    if (!lensTypeProduct) {
        return undefined;
    }
    return convertToLensTypeInfo(lensTypeProduct, lensTypeSku, locale);
});
/**
 * The currently selected package product for the given frame SKU
 */
var getSelectedPackage = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPackageSku, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (s) { return s; }, function (packageSku, locale, state) {
    if (!packageSku || !locale) {
        return undefined;
    }
    var packageProduct = getPackage(state, { packageSku: packageSku });
    if (!packageProduct) {
        return undefined;
    }
    return convertToPackageInfo(packageProduct, packageSku, locale);
});
/**
 * The currently selected add-on product for the given frame SKU
 */
var getSelectedAddOn = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getAddOnSku, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (s) { return s; }, function (addOnSku, locale, state) {
    if (!addOnSku || !locale) {
        return;
    }
    var addOnProduct = lookupParentAddOn(state, { addOnSku: addOnSku });
    if (!addOnProduct) {
        return undefined;
    }
    return convertToLensAddOnInfo(addOnProduct, addOnSku, locale);
});
/**
 * The prescription parameter values as entered on the current frame / lens
 */
var getPrescription$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescription, getLensTypeSku, getOpticalParameters, function (prescription, lensTypeSku, parameters) {
    if (!lensTypeSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(parameters)) {
        return parameters;
    }
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(__assign({ parameters: parameters.result }, prescription));
});
/**
 * The prescription info as entered on the current frame / lens
 */
var getAdditionalPrescriptionInfoFormState = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescription, function (prescription) { var _a; return (_a = prescription.additionalInfo) !== null && _a !== void 0 ? _a : {}; });
// Returns the values in b that aren't present in a
var diff = function (a, b) { return new Set(__spread(b).filter(function (i) { return !a.has(i); })); };
/**
 * Get the validation state of the currently selected lens-type for the given frameSku
 */
var getPrescriptionValidationState = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescription, getLensTypeSku, getOpticalParameters, function (prescription, lensTypeSku, parameters) {
    if (!lensTypeSku) {
        return undefined;
    }
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(parameters)) {
        return undefined;
    }
    var parameterNames = new Set(parameters.result.map(function (p) { return p.name; }));
    var leftHasExtra = diff(parameterNames, Object.keys(prescription.left)).size > 0;
    var rightHasExtra = diff(parameterNames, Object.keys(prescription.right)).size > 0;
    var initialValidationState = {
        isValid: !leftHasExtra && !rightHasExtra,
        left: {
            isValid: !leftHasExtra,
        },
        right: {
            isValid: !rightHasExtra,
        },
    };
    return parameters.result.reduce(function (acc, param) {
        var _a, _b;
        var leftValue = prescription.left[param.name];
        var rightValue = prescription.right[param.name];
        var isLeftValid = isPrescriptionValue(leftValue) && param.values.has(leftValue);
        var isRightValid = isPrescriptionValue(rightValue) && param.values.has(rightValue);
        var left = __assign(__assign({}, acc.left), (_a = { isValid: acc.left.isValid && isLeftValid }, _a[param.name] = isLeftValid, _a));
        var right = __assign(__assign({}, acc.right), (_b = { isValid: acc.right.isValid && isRightValid }, _b[param.name] = isRightValid, _b));
        return {
            isValid: acc.isValid && left.isValid && right.isValid,
            left: left,
            right: right,
        };
    }, initialValidationState);
});
var getVerificationAllowed = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescription, function (c) { var _a; return (_a = c === null || c === void 0 ? void 0 : c.verificationAllowed) !== null && _a !== void 0 ? _a : false; });

var getPrescriptionType$1 = function (s, frameSku) { var _a; return ((_a = s[frameSku]) === null || _a === void 0 ? void 0 : _a.prescriptionType) || 'NewPrescription'; };
var reducer$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer({}, 
/**
 * Create a blank configuration but only on the first call
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b;
    var frameSku = _a.payload.frameSku;
    if (frameSku in s) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[frameSku] = {
        prescriptionType: 'NewPrescription',
    }, _b));
}), 
/**
 * Changes the selected lens type. If no prescriptionPrefill is passed along we reset the prescription data
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectLensTypeSuccess, function (s, _a) {
    var _b;
    var payload = _a.payload;
    var _c, _d, _e;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if ((currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.sku) === payload.lensTypeSku) {
        // Don't do anything if we're reselecting the same SKU
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[payload.frameSku] = __assign(__assign({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: {
            sku: payload.lensTypeSku,
            prescriptionInfo: __assign(__assign({}, ((_d = currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.prescriptionInfo) !== null && _d !== void 0 ? _d : {})), ((_e = payload.prescriptionPrefill) !== null && _e !== void 0 ? _e : {
                left: {},
                right: {},
            })),
        } }), _b));
}), 
/**
 * Changes the selected package for the given frameSku
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectPackageSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, frameSku = _c.frameSku, packageSku = _c.packageSku;
    var frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.package) === packageSku) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[frameSku] = __assign(__assign({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), package: packageSku }), _b));
}), 
/**
 * This is used for when there's a package selected that isn't compatible with the current lens-type
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(resetSelectedPackage, function (s, _a) {
    var _b;
    var frameSku = _a.payload.frameSku;
    return (__assign(__assign({}, s), (_b = {}, _b[frameSku] = __assign(__assign({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), package: undefined }), _b)));
}), 
/**
 * Changes the selected add-on for the given frameSku
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectAddOnSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, frameSku = _c.frameSku, addOnSku = _c.addOnSku;
    var frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.addOn) === addOnSku) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[frameSku] = __assign(__assign({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), addOn: addOnSku }), _b));
}), 
/**
 * This is used for when there's a add-on selected that isn't compatible with the current package
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(resetSelectedAddOn, function (s, _a) {
    var _b;
    var frameSku = _a.payload.frameSku;
    return (__assign(__assign({}, s), (_b = {}, _b[frameSku] = __assign(__assign({}, s[frameSku]), { prescriptionType: getPrescriptionType$1(s, frameSku), addOn: undefined }), _b)));
}), 
/**
 * Changes the prescription parameters' value for the given frameSku
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updatePrescriptionValue, function (s, _a) {
    var _b, _c, _d;
    var payload = _a.payload;
    var _e;
    var currentLensType = (_e = s[payload.frameSku]) === null || _e === void 0 ? void 0 : _e.lensType;
    if (!currentLensType) {
        return s;
    }
    var currentSide = currentLensType.prescriptionInfo[payload.side];
    if (currentSide[payload.parameter] === payload.value) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[payload.frameSku] = __assign(__assign({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: __assign(__assign({}, currentLensType), { prescriptionInfo: __assign(__assign({}, currentLensType.prescriptionInfo), (_c = {}, _c[payload.side] = __assign(__assign({}, currentSide), (_d = {}, _d[payload.parameter] = payload.value, _d)), _c)) }) }), _b));
}), 
/**
 * Changes the prescription info for the given frameSku
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updatePrescriptionInfo, function (s, _a) {
    var _b;
    var payload = _a.payload;
    var _c, _d;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if (!currentLensType) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[payload.frameSku] = __assign(__assign({}, s[payload.frameSku]), { prescriptionType: ((_d = s[payload.frameSku]) === null || _d === void 0 ? void 0 : _d.prescriptionType) || 'NewPrescription', lensType: __assign(__assign({}, currentLensType), { prescriptionInfo: __assign(__assign({}, currentLensType.prescriptionInfo), { additionalInfo: payload.value }) }) }), _b));
}), 
/**
 * Changes the type of prescription, i.e. existing, email upload, manual input, etc...
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updatePrescriptionType, function (s, _a) {
    var _b;
    var payload = _a.payload;
    return __assign(__assign({}, s), (_b = {}, _b[payload.frameSku] = __assign(__assign({}, s[payload.frameSku]), { prescriptionType: payload.prescriptionType }), _b));
}), 
/**
 * Changes the verification allowed info for the given frameSku
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updateVerificationAllowed, function (s, _a) {
    var _b;
    var payload = _a.payload;
    var _c;
    var currentLensType = (_c = s[payload.frameSku]) === null || _c === void 0 ? void 0 : _c.lensType;
    if (!currentLensType) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[payload.frameSku] = __assign(__assign({}, s[payload.frameSku]), { prescriptionType: getPrescriptionType$1(s, payload.frameSku), lensType: __assign(__assign({}, currentLensType), { prescriptionInfo: __assign(__assign({}, currentLensType.prescriptionInfo), { verificationAllowed: payload.value }) }) }), _b));
}));

var getProductImageData = function (product, sku, width, staticsUrl, getProductImageUrls) {
    var _a, _b;
    var variant = getActiveVariant(product, sku);
    var ctImage = ((_a = variant.images) === null || _a === void 0 ? void 0 : _a.length) ? variant.images[0] : undefined;
    var ctHeight = (ctImage === null || ctImage === void 0 ? void 0 : ctImage.dimensions.h) || 0;
    var ctWidth = (ctImage === null || ctImage === void 0 ? void 0 : ctImage.dimensions.w) || 0;
    // Need to guess an aspect ratio as a fallback
    var aspectRatio = ctHeight > 0 && ctWidth > 0 ? ctHeight / ctWidth : 0.6;
    var calculatedHeight = Math.floor(width * aspectRatio);
    var calculatedWidth = Math.floor(width);
    if (getProductImageUrls) {
        var customImage = getProductImageUrls(product, calculatedWidth, calculatedHeight);
        return {
            url: "" + staticsUrl + customImage.primary.url,
            dimensions: {
                h: calculatedHeight,
                w: calculatedWidth,
            },
        };
    }
    if (!((_b = variant.images) === null || _b === void 0 ? void 0 : _b.length)) {
        return undefined;
    }
    return {
        url: "" + staticsUrl + variant.images[0].url + "?w=" + calculatedWidth + "&fm=jpeg&auto=format",
        dimensions: {
            h: calculatedHeight,
            w: calculatedWidth,
        },
    };
};

var frameImageProps = function (_, props) { return props; };
var getFrameImage = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrame, frameSkuProp, frameImageProps, function (frame, frameSku, frameImageProps) {
    if (!frame) {
        return undefined;
    }
    var width = frameImageProps.width, staticsUrl = frameImageProps.staticsUrl, getProductImageUrls = frameImageProps.getProductImageUrls;
    return getProductImageData(frame, frameSku, width, staticsUrl, getProductImageUrls);
});

var getConfigurator = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionGlasses, function (pg) { return pg.configurator; });
var getCurrentStepNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c.currentStep; });
var getStepsVisited = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c.stepsVisited; });

/**
 * Please note that the first step cannot be a skippable step
 */
var stepSequence = [
    'lensType',
    'prescription',
    'prescriptionValidation',
    'lensPackage',
    'lensAddOn',
];
var isDynamicStep = function (step) { return step.hasOwnProperty('stepStatus'); };

/**
 * Exported selectors to be used in container components
 */
var getIsExtraValidationStepEnabled = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c.isExtraValidationStepEnabled; });
var getFrameSku = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c === null || c === void 0 ? void 0 : c.frameSku; });
var getFrameImage$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (_, props) { return props; }, function (frameSku, state, frameImageProps) {
    if (!frameSku) {
        return undefined;
    }
    var width = frameImageProps.width, staticsUrl = frameImageProps.staticsUrl, getProductImageUrls = frameImageProps.getProductImageUrls;
    return getFrameImage(state, {
        frameSku: frameSku,
        width: width,
        staticsUrl: staticsUrl,
        getProductImageUrls: getProductImageUrls,
    });
});
/**
 * Returns the FrameInfo of the frame that's currently being configured
 */
var getSelectedFrame = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, getFrames, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale, function (frameSku, frames, locale) {
    if (!frameSku || !locale) {
        return undefined;
    }
    var frame = frames[frameSku];
    if (!frame) {
        return undefined;
    }
    return convertToFrameInfo(frame, frameSku, locale);
});
/**
 * Get the prescription type enum value
 */
var getPrescriptionType$2 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getPrescriptionType(state, { frameSku: frameSku });
});
/**
 * The currently selected lens-type product the frame that's being configured
 */
var getSelectedLensType$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getSelectedLensType(state, { frameSku: frameSku });
});
/**
 * Returns the available lens-types for the frame that's currently being configured
 */
var getLensTypes$2 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    return getLensTypes$1(state, { frameSku: frameSku });
});
/**
 * The currently selected package product for the frame that's being configured
 */
var getSelectedPackage$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getSelectedPackage(state, { frameSku: frameSku });
});
var getPackages$2 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    return getPackages$1(state, { lensTypeSku: lensTypeSku });
});
/**
 * The currently selected add-on product for the frame that's being configured
 */
var getSelectedAddOn$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getSelectedAddOn(state, { frameSku: frameSku });
});
var getAddOns$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    var packageSku = getPackageSku(state, { frameSku: frameSku });
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku || !packageSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    return getLensAddOns(state, { packageSku: packageSku });
});
/**
 * The prescription parameter values as entered on the current frame / lens
 */
var getPrescription$2 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
    }
    return getPrescription$1(state, { frameSku: frameSku, lensTypeSku: lensTypeSku });
});
/**
 * The prescription info as entered on the current frame / lens
 */
var getAdditionalPrescriptionInfoFormState$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return {};
    }
    return getAdditionalPrescriptionInfoFormState(state, { frameSku: frameSku });
});
/**
 * Get the validation state of the currently selected lens-type/ frame
 */
var getPrescriptionValidationState$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    var lensTypeSku = getLensTypeSku(state, { frameSku: frameSku });
    if (!lensTypeSku) {
        return undefined;
    }
    return getPrescriptionValidationState(state, { frameSku: frameSku, lensTypeSku: lensTypeSku });
});
var showValidationErrorForCurrentStep = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c.stepsAttempted.has(c.currentStep); });
/**
 * Step related selectors
 */
var getCurrentStep = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, getCurrentStepNumber, function (c, currentStep) { return ({
    name: stepSequence[currentStep],
}); });
/**
 * Checks a stepName prop against the stepsVisited list in the s tate
 */
var hasVisitedStep = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getStepsVisited, function (s, _a) {
    var stepName = _a.stepName;
    return stepName;
}, function (stepsVisited, stepName) { return stepsVisited.includes(stepName); });
var hasVisitedStepPrescription = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(function (s) { return s; }, function (s) { return hasVisitedStep(s, { stepName: 'prescription' }); });
var hasVisitedStepLensPackage = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(function (s) { return s; }, function (s) { return hasVisitedStep(s, { stepName: 'lensPackage' }); });
var hasVisitedStepAddOn = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(function (s) { return s; }, function (s) { return hasVisitedStep(s, { stepName: 'lensAddOn' }); });
/**
 * Calculates the total price and total discounted price for the current configuration
 */
var getBundlePrice = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSelectedFrame, getSelectedLensType$1, getSelectedPackage$1, hasVisitedStepLensPackage, getSelectedAddOn$1, hasVisitedStepAddOn, function (frame, lensType, lensPackage, hasVisitedStepLensPackage, addOn, hasVisitedStepAddOn) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    if (!frame || !frame.price) {
        return undefined;
    }
    var bundlePrices = [
        frame.price.originalPrice,
        (_b = (_a = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _a === void 0 ? void 0 : _a.originalPrice) !== null && _b !== void 0 ? _b : 0,
        hasVisitedStepLensPackage ? (_d = (_c = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _c === void 0 ? void 0 : _c.originalPrice) !== null && _d !== void 0 ? _d : 0 : 0,
        hasVisitedStepAddOn ? (_f = (_e = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _e === void 0 ? void 0 : _e.originalPrice) !== null && _f !== void 0 ? _f : 0 : 0,
    ];
    var originalPrice = bundlePrices.reduce(function (sum, current) { return sum + current; }, 0);
    var hasDiscounts = [
        frame.price.discountedPrice,
        (_g = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _g === void 0 ? void 0 : _g.discountedPrice,
        hasVisitedStepLensPackage && ((_h = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _h === void 0 ? void 0 : _h.discountedPrice),
        hasVisitedStepAddOn && ((_j = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _j === void 0 ? void 0 : _j.discountedPrice),
    ].filter(function (p) { return typeof p === 'number' && !isNaN(p); }).length > 0;
    var bundlePricesDiscounted = hasDiscounts
        ? [
            (_l = (_k = frame.price.discountedPrice) !== null && _k !== void 0 ? _k : frame.price.originalPrice) !== null && _l !== void 0 ? _l : 0,
            (_q = (_o = (_m = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _m === void 0 ? void 0 : _m.discountedPrice) !== null && _o !== void 0 ? _o : (_p = lensType === null || lensType === void 0 ? void 0 : lensType.price) === null || _p === void 0 ? void 0 : _p.originalPrice) !== null && _q !== void 0 ? _q : 0,
            hasVisitedStepLensPackage
                ? (_u = (_s = (_r = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _r === void 0 ? void 0 : _r.discountedPrice) !== null && _s !== void 0 ? _s : (_t = lensPackage === null || lensPackage === void 0 ? void 0 : lensPackage.price) === null || _t === void 0 ? void 0 : _t.originalPrice) !== null && _u !== void 0 ? _u : 0 : 0,
            hasVisitedStepAddOn
                ? (_y = (_w = (_v = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _v === void 0 ? void 0 : _v.discountedPrice) !== null && _w !== void 0 ? _w : (_x = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _x === void 0 ? void 0 : _x.originalPrice) !== null && _y !== void 0 ? _y : 0 : 0,
        ]
        : [];
    var discountedPrice = hasDiscounts
        ? bundlePricesDiscounted.reduce(function (sum, current) { return sum + current; }, 0)
        : undefined;
    return {
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        currency: frame.price.currency,
    };
});
var isFooterOpen = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c.isFooterOpen; });
var getFormatProductUrl = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (c) { return c.formatProductUrl; });
var getVerificationAllowed$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    return getVerificationAllowed(state, { frameSku: frameSku });
});

var initialState$1 = {
    currentStep: 0,
    stepsAttempted: new Set(),
    stepsVisited: [],
    calls: {
        addToCart: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    },
    isFooterOpen: false,
};
var reducer$2 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(initialState$1, 
/**
 * Set the correct frameSku and always reset the configurator to the initial state
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b = _a.payload, frameSku = _b.frameSku, formatProductUrl = _b.formatProductUrl, isExtraValidationStepEnabled = _b.isExtraValidationStepEnabled;
    return (__assign(__assign({}, initialState$1), { frameSku: frameSku,
        formatProductUrl: formatProductUrl, stepsVisited: [stepSequence[0]], isExtraValidationStepEnabled: isExtraValidationStepEnabled }));
}), 
/**
 * When user tries to move on to the next step record so we mark the form as submitted
 *
 * This will reveal validation errors
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(nextStep, function (s) { return (__assign(__assign({}, s), { stepsAttempted: new Set(__spread(s.stepsAttempted, [s.currentStep])) })); }), 
/**
 * When the steps change is allowed it's communicated by dispatching the nextStepSuccess action
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(nextStepSuccess, function (s, a) { return (__assign(__assign({}, s), { currentStep: a.payload.newStep, stepsVisited: __spread(new Set(__spread(s.stepsVisited, [stepSequence[a.payload.newStep]]))) })); }), 
/**
 * When the current step is moved back it's communicated by dispatching the previousStepSuccess action
 *
 * When user returns from step 3 to step 2, both 3 (currentStep) and 2 (newStep) are removed so we don't show error messages when returning
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(previousStepSuccess, function (s, a) { return (__assign(__assign({}, s), { currentStep: a.payload.newStep, stepsAttempted: new Set(__spread(s.stepsAttempted).filter(function (s) { return s !== a.payload.currentStep && s !== a.payload.newStep; })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addToCart, add, function (s, _) { return (__assign(__assign({}, s), { calls: __assign(__assign({}, s.calls), { addToCart: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() }) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addToCartFailed, addFailed, function (s, a) { return (__assign(__assign({}, s), { calls: __assign(__assign({}, s.calls), { addToCart: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(a.error) }) })); }), 
/**
 * When adding the config to cart has succeeded we start from 0
 *
 * Resetting the frameSku to undefined also closes the modal
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addToCartSuccess, addSuccess, function (s, _) { return (__assign(__assign({}, initialState$1), { frameSku: undefined })); }), 
/**
 * Toggles footer
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(toggleFooter, function (s) { return (__assign(__assign({}, s), { isFooterOpen: !s.isFooterOpen })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(closeFooter, function (s) { return (__assign(__assign({}, s), { isFooterOpen: false })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(openFooter, function (s) { return (__assign(__assign({}, s), { isFooterOpen: true })); }));

var reducer$3 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(defaultState, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updatePrescriptionValue, function (s, _a) {
    var _b, _c;
    var payload = _a.payload;
    return (__assign(__assign({}, s), (_b = {}, _b[payload.side] = __assign(__assign({}, s[payload.side]), (_c = {}, _c[payload.parameter] = payload.value, _c)), _b)));
}), 
/**
 * Changes the prescription expiry date for the given frameSku
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updatePrescriptionInfo, function (s, _a) {
    var payload = _a.payload;
    return __assign(__assign({}, s), { additionalInfo: payload.value });
}));

var indexBySku = function (m, p) {
    var _a;
    if (!p.masterVariant.sku) {
        return m;
    }
    return __assign(__assign({}, m), (_a = {}, _a[p.masterVariant.sku] = p, _a));
};
var reduceProducts = function (products) { return products.reduce(indexBySku, {}); };
var initialState$2 = {
    frames: {},
    lensTypes: {},
    variants: {},
    packages: {},
    addOns: {},
};
var reduceVariant = function (masterSku) { return function (m, variant) {
    var _a;
    if (!variant.sku || !variant.isMatchingVariant) {
        return m;
    }
    return __assign(__assign({}, m), (_a = {}, _a[variant.sku] = masterSku, _a));
}; };
var indexAllVariantsBySKU = function (m, product) {
    var _a;
    var masterSku = product.masterVariant.sku;
    if (!masterSku) {
        return m;
    }
    return __assign(__assign(__assign({}, m), (_a = {}, _a[masterSku] = masterSku, _a)), product.variants.reduce(reduceVariant(masterSku), {}));
};
var addToLookup = function (s, products) { return (__assign(__assign({}, s.variants), products.reduce(indexAllVariantsBySKU, {}))); };
var reducer$4 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(initialState$2, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchLensTypesSuccess, function (s, _a) {
    var products = _a.payload.products;
    return (__assign(__assign({}, s), { lensTypes: __assign(__assign({}, s.lensTypes), reduceProducts(products)), variants: addToLookup(s, products) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchPackagesSuccess, function (s, _a) {
    var products = _a.payload.products;
    return (__assign(__assign({}, s), { packages: __assign(__assign({}, s.packages), reduceProducts(products)) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchAddOnsSuccess, function (s, _a) {
    var products = _a.payload.products;
    return (__assign(__assign({}, s), { addOns: __assign(__assign({}, s.addOns), reduceProducts(products)), variants: addToLookup(s, products) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startPrescriptionGlassesConfiguration, function (s, _a) {
    var _b;
    var _c = _a.payload, frame = _c.frame, frameSku = _c.frameSku;
    return (__assign(__assign({}, s), { frames: __assign(__assign({}, s.frames), (_b = {}, _b[frameSku] = frame, _b)) }));
}));

var getConfig = function (key) { return ({
    storage: _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* sessionStorage */ "C"],
    key: key,
}); };
var prescriptionGlassesReducer = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* combineReducers */ "t"])({
    bundles: reducer,
    configurations: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* persistReducer */ "A"])(getConfig('grandvision_pg_configurations'), reducer$1),
    prescription: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* persistReducer */ "A"])(getConfig('grandvision_pg_prescription'), reducer$3),
    products: reducer$4,
    configurator: reducer$2,
});

var defined = function (v) { return typeof v !== 'undefined'; };
function fetchBundleProducts(productType, skus) {
    var config, results, fetchedSkus, missing;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!skus.size) {
                    return [2 /*return*/, {
                            products: [],
                            tried: skus,
                            missing: new Set(),
                        }];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 1:
                config = _a.sent();
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* assertApiConfig */ "s"])(config);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].query, config.productsUrl, {
                        expand: [
                            'masterVariant.prices[*].discounted.discount',
                            'variants[*].prices[*].discounted.discount',
                        ],
                        filters: ["variants.sku:" + encodeURIComponent(__spread(skus).map(function (id) { return "\"" + id + "\""; }).join(','))],
                    }, config.apiKey)];
            case 2:
                results = (_a.sent()).results;
                fetchedSkus = new Set(results
                    .reduce(function (skus, p) { return __spread(skus, [p.masterVariant.sku], (p.variants || []).map(function (v) { return v.sku; })); }, [])
                    .filter(defined));
                missing = new Set(__spread(skus).filter(function (s) { return !fetchedSkus.has(s); }));
                return [2 /*return*/, {
                        products: results,
                        tried: skus,
                        missing: missing,
                    }];
        }
    });
}
/**
 * Lens Types
 */
function ensureLensTypesAreLoaded(_a) {
    var frameSku = _a.payload.frameSku;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(loadMissingLensTypes, frameSku)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function loadMissingLensTypes(frameSku) {
    var frame, lensTypes, lensTypeSkusToFetch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleFrame, {
                    frameSku: frameSku,
                })];
            case 1:
                frame = _a.sent();
                if (!frame) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleLensTypes)];
            case 2:
                lensTypes = _a.sent();
                lensTypeSkusToFetch = __spread(frame.lensTypeSkus).filter(function (sku) { return !(sku in lensTypes); });
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchLensTypes({ frameSku: frameSku, skus: new Set(lensTypeSkusToFetch) }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchLensTypes(_a) {
    var result, error_1;
    var _b = _a.payload, skus = _b.skus, frameSku = _b.frameSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(fetchBundleProducts, 'lens-type', skus)];
            case 1:
                result = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchLensTypesSuccess(__assign({ frameSku: frameSku }, result)))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchLensTypesFailed({ frameSku: frameSku, skus: skus, error: error_1 }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * Packages
 */
function loadMissingPackages(lensTypeSku) {
    var bundleLensType, packages, packageSkusToFetch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 1:
                bundleLensType = _a.sent();
                if (!bundleLensType || !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(bundleLensType)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundlePackages)];
            case 2:
                packages = _a.sent();
                packageSkusToFetch = __spread(bundleLensType.result.packageSkus).filter(function (packageSku) { return !(packageSku in packages); });
                if (!packageSkusToFetch.length) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchPackages({ lensTypeSku: lensTypeSku, skus: new Set(packageSkusToFetch) }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function ensurePackagesAreLoaded(_a) {
    var lensTypeSku = _a.payload.lensTypeSku;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(loadMissingPackages, lensTypeSku)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchPackages(_a) {
    var result, error_2;
    var _b = _a.payload, skus = _b.skus, lensTypeSku = _b.lensTypeSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(fetchBundleProducts, 'package', skus)];
            case 1:
                result = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchPackagesSuccess(__assign({ lensTypeSku: lensTypeSku }, result)))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                error_2 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchPackagesFailed({ lensTypeSku: lensTypeSku, skus: skus, error: error_2 }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * Add-ons
 */
function loadMissingAddOns(packageSku) {
    var bundlePackage, addons, addOnSkusToFetch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundlePackage, { packageSku: packageSku })];
            case 1:
                bundlePackage = _a.sent();
                if (!bundlePackage || !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(bundlePackage)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleAddOns)];
            case 2:
                addons = _a.sent();
                addOnSkusToFetch = __spread(bundlePackage.result.addOnSkus).filter(function (addOnSku) { return !(addOnSku in addons); });
                if (!addOnSkusToFetch.length) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchAddOns({ packageSku: packageSku, skus: new Set(addOnSkusToFetch) }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function ensureAddOnsAreLoaded(_a) {
    var packageSku = _a.payload.packageSku;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(loadMissingAddOns, packageSku)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchAddOns(_a) {
    var result, error_3;
    var _b = _a.payload, skus = _b.skus, packageSku = _b.packageSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(fetchBundleProducts, 'addon', skus)];
            case 1:
                result = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchAddOnsSuccess(__assign({ packageSku: packageSku }, result)))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                error_3 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchAddOnsFailed({ packageSku: packageSku, skus: skus, error: error_3 }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * These effects make sure data is loaded as soon as possible
 */
var listenForSelectionChanges = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(startPrescriptionGlassesConfiguration.type, ensureLensTypesAreLoaded),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectLensTypeSuccess.type, ensurePackagesAreLoaded),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectPackageSuccess.type, ensureAddOnsAreLoaded),
];
/**
 * These listen for the actual fetching actions
 */
var listenForFetchEvents = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(fetchLensTypes.type, onFetchLensTypes),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(fetchPackages.type, onFetchPackages),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(fetchAddOns.type, onFetchAddOns),
];
var bundleSagas = __spread(listenForFetchEvents, listenForSelectionChanges);

var getPrescription$3 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionGlasses, function (pg) { return pg.prescription; });

var filterPrescriptionKeysAndValues = function (prescriptionProperties, validOpticalParameters) {
    var validOpticalParamsMap = validOpticalParameters.reduce(function (m, p) {
        var _a;
        return (__assign(__assign({}, m), (_a = {}, _a[p.name] = p.values, _a)));
    }, {});
    return Object.entries(prescriptionProperties).reduce(function (m, property) {
        var _a;
        var _b = __read(property, 2), pKey = _b[0], pValue = _b[1];
        var validPropertyValues = validOpticalParamsMap[pKey];
        if (!validPropertyValues || !pValue) {
            return m;
        }
        if (validPropertyValues.has(pValue)) {
            return __assign(__assign({}, m), (_a = {}, _a[pKey] = pValue, _a));
        }
        return m;
    }, {});
};
function onSelectLensType(_a) {
    function fail(error) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectLensTypeFailed({
                        frameSku: frameSku,
                        lensTypeSku: lensTypeSku,
                        error: error,
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    var bundleFrame, lensType, prescription, opticalParameters, prescriptionPrefill, validParameters;
    var _b = _a.payload, frameSku = _b.frameSku, lensTypeSku = _b.lensTypeSku, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleFrame, {
                    frameSku: frameSku,
                })];
            case 1:
                bundleFrame = _c.sent();
                if (!(!bundleFrame || !bundleFrame.lensTypeSkus.has(lensTypeSku))) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(fail(new Error("Lens-type with SKU \"" + lensTypeSku + "\" can't be selected for frame with SKU \"" + frameSku + "\", valid lens-type SKUs are \"" + (bundleFrame && JSON.stringify(__spread(bundleFrame.lensTypeSkus))) + "\"")))];
            case 2: return [2 /*return*/, _c.sent()];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 4:
                lensType = _c.sent();
                if (!!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensType)) return [3 /*break*/, 6];
                return [5 /*yield**/, __values(fail(new Error('Lens-type not available')))];
            case 5: return [2 /*return*/, _c.sent()];
            case 6: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPrescription$3)];
            case 7:
                prescription = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getOpticalParameters, { frameSku: frameSku, lensTypeSku: lensTypeSku })];
            case 8:
                opticalParameters = _c.sent();
                prescriptionPrefill = {
                    left: {},
                    right: {},
                };
                if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(opticalParameters)) {
                    validParameters = opticalParameters.result;
                    prescriptionPrefill = {
                        left: filterPrescriptionKeysAndValues(prescription.left, validParameters),
                        right: filterPrescriptionKeysAndValues(prescription.right, validParameters),
                    };
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectLensTypeSuccess({
                        frameSku: frameSku,
                        lensTypeSku: lensTypeSku,
                        prescriptionPrefill: prescriptionPrefill,
                        reason: reason,
                    }))];
            case 9:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function ensureCompatibleLensPackage(_a) {
    var selectedPackageSku, lensType;
    var _b = _a.payload, frameSku = _b.frameSku, lensTypeSku = _b.lensTypeSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPackageSku, { frameSku: frameSku })];
            case 1:
                selectedPackageSku = _c.sent();
                if (!selectedPackageSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 2:
                lensType = _c.sent();
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensType)) {
                    return [2 /*return*/];
                }
                if (!!lensType.result.packageSkus.has(selectedPackageSku)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(resetSelectedPackage({ frameSku: frameSku }))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function ensureCompatibleLensAddOn(_a) {
    var selectedAddOnSku, bundlePackage;
    var _b = _a.payload, frameSku = _b.frameSku, packageSku = _b.packageSku;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getAddOnSku, {
                    frameSku: frameSku,
                })];
            case 1:
                selectedAddOnSku = _c.sent();
                if (!selectedAddOnSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundlePackage, { packageSku: packageSku })];
            case 2:
                bundlePackage = _c.sent();
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(bundlePackage)) {
                    return [2 /*return*/];
                }
                if (!!bundlePackage.result.addOnSkus.has(selectedAddOnSku)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(resetSelectedAddOn({ frameSku: frameSku, reason: 'default selection' }))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function onSelectPackage(_a) {
    function fail(error) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectPackageFailed({
                        frameSku: frameSku,
                        packageSku: packageSku,
                        error: error,
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    var lensTypeSku, lensPackage, lensType;
    var _b = _a.payload, frameSku = _b.frameSku, packageSku = _b.packageSku, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getLensTypeSku, {
                    frameSku: frameSku,
                })];
            case 1:
                lensTypeSku = _c.sent();
                if (!!lensTypeSku) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(fail(new Error("A lens-type needs to be selected before we can select a package")))];
            case 2: return [2 /*return*/, _c.sent()];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundlePackage, { packageSku: packageSku })];
            case 4:
                lensPackage = _c.sent();
                if (!!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensPackage)) return [3 /*break*/, 6];
                return [5 /*yield**/, __values(fail(new Error('Lens-package is unavailable')))];
            case 5: return [2 /*return*/, _c.sent()];
            case 6: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundleLensType, { lensTypeSku: lensTypeSku })];
            case 7:
                lensType = _c.sent();
                if (!!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensType)) return [3 /*break*/, 9];
                return [5 /*yield**/, __values(fail(new Error("Lens-type with SKU \"" + lensTypeSku + "\" is unavailable")))];
            case 8: return [2 /*return*/, _c.sent()];
            case 9:
                if (!!lensType.result.packageSkus.has(packageSku)) return [3 /*break*/, 11];
                return [5 /*yield**/, __values(fail(new Error("Package is not compatible with selected lens-type with SKU \"" + lensTypeSku)))];
            case 10: return [2 /*return*/, _c.sent()];
            case 11: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectPackageSuccess({
                    frameSku: frameSku,
                    lensTypeSku: lensTypeSku,
                    packageSku: packageSku,
                    reason: reason,
                }))];
            case 12:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function onSelectAddOn(_a) {
    function fail(error) {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectAddOnFailed({
                        frameSku: frameSku,
                        addOnSku: addOnSku,
                        error: error,
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }
    var config, lensType, packageSku, bundlePackage;
    var _b = _a.payload, frameSku = _b.frameSku, addOnSku = _b.addOnSku, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getConfiguration, {
                    frameSku: frameSku,
                })];
            case 1:
                config = _c.sent();
                if (!!config) return [3 /*break*/, 3];
                return [5 /*yield**/, __values(fail(new Error("No add-on can be selected for Frame: " + frameSku + ", there's no active configuration for it")))];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                lensType = config.lensType, packageSku = config.package;
                if (!(!(lensType === null || lensType === void 0 ? void 0 : lensType.sku) || !packageSku)) return [3 /*break*/, 5];
                return [5 /*yield**/, __values(fail(new Error("To select an add-on we need a lens-type, and a package; current lens-type is \"" + (lensType === null || lensType === void 0 ? void 0 : lensType.sku) + "\", package is \"" + packageSku + "\"")))];
            case 4: return [2 /*return*/, _c.sent()];
            case 5: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getBundlePackage, { packageSku: packageSku })];
            case 6:
                bundlePackage = _c.sent();
                if (!!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(bundlePackage)) return [3 /*break*/, 8];
                return [5 /*yield**/, __values(fail(new Error("Can't select add-on because package with SKU " + packageSku + " is unavailable")))];
            case 7: return [2 /*return*/, _c.sent()];
            case 8:
                if (!!bundlePackage.result.addOnSkus.has(addOnSku)) return [3 /*break*/, 10];
                return [5 /*yield**/, __values(fail(new Error("Add-on cannot be selected for selected package with SKU \"" + packageSku + "\"")))];
            case 9: return [2 /*return*/, _c.sent()];
            case 10: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectAddOnSuccess({
                    frameSku: frameSku,
                    addOnSku: addOnSku,
                    reason: reason,
                }))];
            case 11:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
var selectionHandlers = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectLensType.type, onSelectLensType),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectPackage.type, onSelectPackage),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectAddOn.type, onSelectAddOn),
];
var configurationSagas = __spread(selectionHandlers, [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectLensTypeSuccess.type, ensureCompatibleLensPackage),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectPackageSuccess.type, ensureCompatibleLensAddOn),
]);

/**
 * Get the non-medical prescription details
 */
var getAdditionalPrescriptionInfo = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getAdditionalPrescriptionInfoFormState$1, function (additionalPrescriptionInfoFormState) {
    if (!additionalPrescriptionInfoFormState) {
        return {};
    }
    var _a = _grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Util */ "D"].getValuesFromState(additionalPrescriptionInfoFormState), examDate = _a.examDate, expiryDate = _a.expiryDate, rest = __rest(_a, ["examDate", "expiryDate"]);
    return __assign(__assign(__assign({}, (examDate ? { examDate: examDate } : {})), (expiryDate ? { expiryDate: expiryDate } : {})), { opticianDetails: __assign({}, rest) });
});
/*
 * Utilities for getAddToCartLineItem -----------
 */
var configureBundleLineItemsForCart = function (config) {
    if (!config) {
        return;
    }
    var bundleLineItems = [];
    Object.keys(config).forEach(function (item) {
        var _a;
        var sku;
        if (item === 'prescriptionType' || !config[item]) {
            return;
        }
        if (item === 'lensType' && ((_a = config === null || config === void 0 ? void 0 : config.lensType) === null || _a === void 0 ? void 0 : _a.sku)) {
            sku = config.lensType.sku;
        }
        bundleLineItems.push({
            sku: sku !== null && sku !== void 0 ? sku : config[item],
        });
    });
    return bundleLineItems;
};
var configurePrescriptionInfo = function (config, additionalInfo) {
    var _a;
    var prescriptionType = config === null || config === void 0 ? void 0 : config.prescriptionType;
    if (!prescriptionType) {
        return;
    }
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isEmailPrescription(prescriptionType)) {
        return { type: 'email-prescription' };
    }
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isExistingCustomer(prescriptionType)) {
        return { type: 'existing-customer' };
    }
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType)) {
        var prescriptionInfo = (_a = config === null || config === void 0 ? void 0 : config.lensType) === null || _a === void 0 ? void 0 : _a.prescriptionInfo;
        if (!prescriptionInfo) {
            return;
        }
        var right = prescriptionInfo.right, left = prescriptionInfo.left;
        return {
            type: 'new-prescription',
            details: __assign({ rightLens: right, leftLens: left }, additionalInfo),
        };
    }
};
/*
 * end Utility functions for getAddToCartLineItem -----------
 */
/*
 * Get a line item configured to be added to cart.
 */
var getAddToCartLineItem = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getFrameSku, function (s) { return s; }, function (frameSku, state) {
    if (!frameSku) {
        return undefined;
    }
    var lineItemRawConfig = getConfiguration(state, { frameSku: frameSku });
    var additionalPrescriptionInfo = getAdditionalPrescriptionInfo(state);
    var bundleLineItems = configureBundleLineItemsForCart(lineItemRawConfig);
    var prescription = configurePrescriptionInfo(lineItemRawConfig, additionalPrescriptionInfo);
    if (!bundleLineItems || !prescription) {
        return undefined;
    }
    return {
        type: 'prescription-glasses',
        sku: frameSku,
        bundleLineItems: bundleLineItems,
        prescription: prescription,
    };
});

var lensAddOn = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(selectDefaultAddOn)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
};
var isSuccess = function (_a) {
    var packageSku = _a.packageSku;
    return function (a) {
        return _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, fetchAddOnsSuccess) && a.payload.packageSku === packageSku;
    };
};
var isFailed = function (_a) {
    var packageSku = _a.packageSku;
    return function (a) {
        return _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, fetchAddOnsFailed) && a.payload.packageSku === packageSku;
    };
};
function selectDefaultAddOn() {
    var selectedAddOn, frameSku, addOns, lensType, selectedPackage, _a, success, products, addOnSku, variants, variants_1, variants_1_1, variant;
    var e_1, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedAddOn$1)];
            case 1:
                selectedAddOn = _c.sent();
                if (!!selectedAddOn) return [3 /*break*/, 10];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getFrameSku)];
            case 2:
                frameSku = _c.sent();
                if (!frameSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getAddOns$1)];
            case 3:
                addOns = _c.sent();
                if (!(!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(addOns) && !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(addOns))) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedLensType$1)];
            case 4:
                lensType = _c.sent();
                if (!lensType) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedPackage$1)];
            case 5:
                selectedPackage = _c.sent();
                if (!selectedPackage) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(isSuccess({ packageSku: selectedPackage.sku })),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(isFailed({ packageSku: selectedPackage.sku })),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 6:
                _a = __read.apply(void 0, [_c.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getAddOns$1)];
            case 7:
                addOns = _c.sent();
                _c.label = 8;
            case 8:
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(addOns)) return [3 /*break*/, 10];
                products = addOns.result;
                addOnSku = '';
                variants = products.reduce(function (acc, p) { return __spread(acc, [p], (p.variants || [])); }, []);
                try {
                    for (variants_1 = __values(variants), variants_1_1 = variants_1.next(); !variants_1_1.done; variants_1_1 = variants_1.next()) {
                        variant = variants_1_1.value;
                        if (variant.isDefault) {
                            addOnSku = variant.sku;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (variants_1_1 && !variants_1_1.done && (_b = variants_1.return)) _b.call(variants_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!addOnSku) return [3 /*break*/, 10];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectAddOn({ frameSku: frameSku, addOnSku: addOnSku, reason: 'default selection' }))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}

var lensPackage = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(selectDefaultPackage)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var selectedPackage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedPackage$1)];
                case 1:
                    selectedPackage = _a.sent();
                    if (!selectedPackage) {
                        return [2 /*return*/, new Error("Selecting a lens-package is required")];
                    }
                    return [2 /*return*/];
            }
        });
    },
};
var isSuccess$1 = function (_a) {
    var lensTypeSku = _a.lensTypeSku;
    return function (a) {
        return _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, fetchPackagesSuccess) && a.payload.lensTypeSku === lensTypeSku;
    };
};
var isFailed$1 = function (_a) {
    var lensTypeSku = _a.lensTypeSku;
    return function (a) {
        return _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, fetchPackagesFailed) && a.payload.lensTypeSku === lensTypeSku;
    };
};
function selectDefaultPackage() {
    var selectedPackage, frameSku, packages, lensType, _a, success, packageSku, _b, _c, product;
    var e_1, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedPackage$1)];
            case 1:
                selectedPackage = _f.sent();
                if (!!selectedPackage) return [3 /*break*/, 10];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getFrameSku)];
            case 2:
                frameSku = _f.sent();
                if (!frameSku) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPackages$2)];
            case 3:
                packages = _f.sent();
                if (!(!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(packages) && !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(packages))) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedLensType$1)];
            case 4:
                lensType = _f.sent();
                if (!lensType) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(isSuccess$1({ lensTypeSku: lensType.sku })),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(isFailed$1({ lensTypeSku: lensType.sku })),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 5:
                _a = __read.apply(void 0, [_f.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPackages$2)];
            case 6:
                packages = _f.sent();
                _f.label = 7;
            case 7:
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(packages)) return [3 /*break*/, 9];
                packageSku = (_e = packages.result[0]) === null || _e === void 0 ? void 0 : _e.sku;
                try {
                    for (_b = __values(packages.result), _c = _b.next(); !_c.done; _c = _b.next()) {
                        product = _c.value;
                        if (product.isDefault) {
                            packageSku = product.sku;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!packageSku) return [3 /*break*/, 9];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectPackage({ frameSku: frameSku, packageSku: packageSku, reason: 'default selection' }))];
            case 8:
                _f.sent();
                _f.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(loadMissingAddOns, selectedPackage.sku)];
            case 11:
                _f.sent();
                _f.label = 12;
            case 12: return [2 /*return*/];
        }
    });
}

var lensType = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(selectDefaultLensType)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var lensType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedLensType$1)];
                case 1:
                    lensType = _a.sent();
                    if (!lensType) {
                        return [2 /*return*/, new Error("Selecting a lens-type is required")];
                    }
                    return [2 /*return*/];
            }
        });
    },
};
var isSuccess$2 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].guard(fetchLensTypesSuccess);
var isFailed$2 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].guard(fetchLensTypesFailed);
function selectDefaultLensType() {
    var lensType, frameSku, lensTypes, _a, success, lensTypeSku, _b, _c, product;
    var e_1, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedLensType$1)];
            case 1:
                lensType = _f.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getFrameSku)];
            case 2:
                frameSku = _f.sent();
                if (!frameSku) {
                    return [2 /*return*/];
                }
                if (!!lensType) return [3 /*break*/, 9];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getLensTypes$2)];
            case 3:
                lensTypes = _f.sent();
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(lensTypes)) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(function (a) { return isSuccess$2(a); }),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(function (a) { return isFailed$2(a) && a.payload.frameSku === frameSku; }),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 4:
                _a = __read.apply(void 0, [_f.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getLensTypes$2)];
            case 5:
                lensTypes = _f.sent();
                _f.label = 6;
            case 6:
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensTypes)) return [3 /*break*/, 8];
                lensTypeSku = (_e = lensTypes.result[0]) === null || _e === void 0 ? void 0 : _e.sku;
                try {
                    for (_b = __values(lensTypes.result), _c = _b.next(); !_c.done; _c = _b.next()) {
                        product = _c.value;
                        if (product.isDefault) {
                            lensTypeSku = product.sku;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!lensTypeSku) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectLensType({ frameSku: frameSku, lensTypeSku: lensTypeSku, reason: 'default selection' }))];
            case 7:
                _f.sent();
                _f.label = 8;
            case 8: return [3 /*break*/, 11];
            case 9: 
            // If no default lens-type is selected we make sure to kick-off the rest of the loading sequence by:
            return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(loadMissingPackages, lensType.sku)];
            case 10:
                // If no default lens-type is selected we make sure to kick-off the rest of the loading sequence by:
                _f.sent();
                _f.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}

var prescription = {
    onNext: onNext,
};
function onNext() {
    var prescriptionType, validationState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPrescriptionType$2)
                // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
            ];
            case 1:
                prescriptionType = _a.sent();
                // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
                if (!prescriptionType) {
                    return [2 /*return*/, new Error("Prescription type is not defined")];
                }
                // Only validate prescription if user fills in their prescription via our form, which is type "NewPrescription".
                if (!_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPrescriptionValidationState$1)];
            case 2:
                validationState = _a.sent();
                if (!(validationState === null || validationState === void 0 ? void 0 : validationState.isValid)) {
                    return [2 /*return*/, new Error("Need valid prescription data for unknown customer")];
                }
                return [2 /*return*/];
        }
    });
}

var prescriptionValidation = {
    onNext: onNext$1,
    stepStatus: function (s) {
        /**
         * Page should only show when the customer chose to enter their prescription manually via our form ("NewPrescription").
         */
        var isStepEnabled = getIsExtraValidationStepEnabled(s);
        var prescriptionType = getPrescriptionType$2(s);
        var isNewPrescription = _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType);
        if (!isStepEnabled) {
            return 'hidden';
        }
        return isNewPrescription ? 'active' : 'skip';
    },
};
function onNext$1() {
    var isVerificationAllowed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getVerificationAllowed$1)];
            case 1:
                isVerificationAllowed = _a.sent();
                return [2 /*return*/, !isVerificationAllowed];
        }
    });
}

var steps = {
    lensType: lensType,
    prescription: prescription,
    prescriptionValidation: prescriptionValidation,
    lensPackage: lensPackage,
    lensAddOn: lensAddOn,
};

/**
 * This selector has its own file because it uses the "steps" variable. Since each step in "steps" imports selectors
 * from state/selectors, importing this "getSteps" selector into state/selectors would cause a circular dependency.
 */
var getSteps = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getCurrentStepNumber, function (s) { return s; }, function (currentStepNumber, s) {
    return stepSequence.reduce(function (acc, stepName, i) {
        var stepStatus = 'active';
        var step = steps[stepName];
        if (isDynamicStep(step)) {
            stepStatus = step.stepStatus(s);
            if (stepStatus === 'hidden') {
                return acc;
            }
        }
        return __spread(acc, [
            {
                name: stepName,
                isCurrent: currentStepNumber === i,
                skip: stepStatus === 'skip',
            },
        ]);
    }, []);
});
var isLastStep = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSteps, function (steps) {
    var lastStepIsCurrentStep = steps[steps.length - 1].isCurrent;
    if (lastStepIsCurrentStep) {
        return true;
    }
    // We're not on the last step, we have to check skipped steps to be sure we're not practically on the last step
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    var remainingSteps = steps.slice(currentStep + 1);
    return remainingSteps.every(function (s) { return s.skip; });
});

var getActiveSteps = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSteps, function (steps) { return steps.filter(function (s) { return !s.skip; }); });

function onNextStep() {
    var activeSteps, currentStepName, currentStep, step, result, nextActiveStepName, nextActiveStepIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getActiveSteps)];
            case 1:
                activeSteps = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getCurrentStep)];
            case 2:
                currentStepName = (_a.sent()).name;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getCurrentStepNumber)];
            case 3:
                currentStep = _a.sent();
                step = steps[currentStepName];
                if (!step.onNext) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(step.onNext)];
            case 4:
                result = _a.sent();
                if (!result) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStepFailed({ currentStep: currentStep, reason: result }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6:
                nextActiveStepName = activeSteps.reduce(function (stepName, curr, index) { var _a; return (curr.isCurrent ? (_a = activeSteps[index + 1]) === null || _a === void 0 ? void 0 : _a.name : stepName); }, undefined);
                if (!!nextActiveStepName) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStepFailed({
                        currentStep: currentStep,
                        reason: new Error("We're already on the last step. Make sure you dispatch addToCart action instead"),
                    }))];
            case 7:
                _a.sent();
                return [2 /*return*/];
            case 8:
                nextActiveStepIndex = stepSequence.indexOf(nextActiveStepName);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStepSuccess({
                        currentStep: currentStep,
                        newStep: nextActiveStepIndex,
                    }))];
            case 9:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function triggerOnEnterForFirstStep() {
    var stepsResult, currentStepName, step, stepStatus, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSteps)];
            case 1:
                stepsResult = _c.sent();
                currentStepName = (_b = stepsResult[0]) === null || _b === void 0 ? void 0 : _b.name;
                if (!currentStepName) {
                    return [2 /*return*/];
                }
                step = steps[currentStepName];
                if (!isDynamicStep(step)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(step.stepStatus)];
            case 2:
                _a = _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(function () { return 'active'; })];
            case 4:
                _a = _c.sent();
                _c.label = 5;
            case 5:
                stepStatus = _a;
                if (!(stepStatus !== 'active')) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStep())];
            case 6:
                _c.sent();
                return [2 /*return*/];
            case 7:
                if (!(step && step.onEnter)) return [3 /*break*/, 9];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(step.onEnter)];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(stepShown({ step: currentStepName }))];
            case 10:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function onSuccessfulStepSwitch(_a) {
    var stepName, step;
    var newStep = _a.payload.newStep;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                stepName = stepSequence[newStep];
                step = steps[stepName];
                if (!step.onEnter) return [3 /*break*/, 2];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(step.onEnter)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(stepShown({ step: stepName }))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onPreviousStep() {
    var activeSteps, currentStep, previousActiveStepName, previousActiveStepIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getActiveSteps)];
            case 1:
                activeSteps = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getCurrentStepNumber)
                    /**
                     * Get the name of the first previous active step
                     */
                ];
            case 2:
                currentStep = _a.sent();
                previousActiveStepName = activeSteps.reduce(function (stepName, curr, index) { var _a; return (curr.isCurrent ? (_a = activeSteps[index - 1]) === null || _a === void 0 ? void 0 : _a.name : stepName); }, undefined);
                if (!!previousActiveStepName) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(previousStepFailed({
                        currentStep: currentStep,
                        reason: new Error("Can't go back beyond the first step"),
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                previousActiveStepIndex = stepSequence.indexOf(previousActiveStepName);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(previousStepSuccess({
                        currentStep: currentStep,
                        newStep: previousActiveStepIndex,
                    }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function closeFooter$1() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(closeFooter())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var configuratorSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(nextStep.type, onNextStep),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(previousStep.type, onPreviousStep),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])([nextStepSuccess.type, previousStepSuccess.type], onSuccessfulStepSwitch),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])([nextStep.type, previousStep.type], closeFooter$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(startPrescriptionGlassesConfiguration.type, triggerOnEnterForFirstStep),
];

function getBundleProductTitle(bundleProduct) {
    var _a, _b;
    if (!bundleProduct) {
        return;
    }
    if ((_a = bundleProduct.variants) === null || _a === void 0 ? void 0 : _a.length) {
        var selected = (_b = bundleProduct.variants) === null || _b === void 0 ? void 0 : _b.find(function (v) { return v.sku === bundleProduct.sku; });
        // to prevent "title -"
        if (!selected || !(selected === null || selected === void 0 ? void 0 : selected.title)) {
            return bundleProduct.title;
        }
        return bundleProduct.title + " - " + selected.title;
    }
    else {
        return bundleProduct.title;
    }
}

var stepMapping = {
    lensType: {
        name: 'lens type',
        id: '100',
    },
    prescription: {
        name: 'prescription',
        id: '200',
    },
    prescriptionValidation: {
        name: 'prescription validation',
        id: '250',
    },
    lensPackage: {
        name: 'lens package',
        id: '300',
    },
    lensAddOn: {
        name: 'add-ons',
        id: '400',
    },
};
/**
 * SHARED SELECTORS
 * Most data layer selectors will use these
 */
var getStepData = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getCurrentStep, function (currentStep) { return stepMapping[currentStep.name]; });
var getPrice$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getBundlePrice, function (bundlePrice) {
    if (!bundlePrice) {
        console.warn("Need bundle price to log data layer event. Received \"" + JSON.stringify(bundlePrice) + "\"");
        return;
    }
    var discountedPrice = bundlePrice.discountedPrice, originalPrice = bundlePrice.originalPrice;
    /**
     * Both "discountedPrice" and "originalPrice" are in cents, as per usual. There is no e.g. "centAmount" property
     * to check here anymore.
     */
    return discountedPrice ? (discountedPrice / 100).toFixed(2) : (originalPrice / 100).toFixed(2);
});
var formatPrescriptionValue = function (value) {
    return typeof value === 'number' && !isNaN(value) ? value.toFixed(2) : 'n/a';
};
/**
 * Creates a reducer function that converts PrescriptionValue to a data-layer PrescriptionValue
 */
var reduceParameter = function (values) { return function (info, _a) {
    var _b;
    var name = _a.name;
    return (__assign(__assign({}, info), (_b = {}, _b[name] = formatPrescriptionValue(values[name]), _b)));
}; };
var getLensParameters = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescription$2, function (pre) {
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(pre)) {
        return;
    }
    var _a = pre.result, parameters = _a.parameters, left = _a.left, right = _a.right;
    return {
        OS: parameters.reduce(reduceParameter(left), {}),
        OD: parameters.reduce(reduceParameter(right), {}),
    };
});
var getSelectedLensTypeName = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getLensTypes, getSelectedLensType$1, function (s) { return s; }, function (lensTypes, selectedLensType, state) {
    if (!lensTypes || !selectedLensType) {
        return;
    }
    var lensTypeProduct = lookupParentLensType(state, {
        lensTypeSku: selectedLensType.sku,
    });
    if (!lensTypeProduct) {
        return;
    }
    var lensTypeInfo = convertToLensTypeInfo(lensTypeProduct, selectedLensType.sku, 'en');
    return getBundleProductTitle(lensTypeInfo);
});
var getSelectedPackageName = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPackages, getSelectedPackage$1, function (packages, selectedPackage) {
    if (!packages || !selectedPackage) {
        return;
    }
    var packageProductData = packages[selectedPackage.sku];
    if (!packageProductData) {
        return;
    }
    return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(packageProductData.name, 'en');
});
var getSelectedAddOnName = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSelectedAddOn$1, function (s) { return s; }, function (selectedAddOn, state) {
    if (!selectedAddOn) {
        return 'no add-on';
    }
    var addOnProduct = lookupParentAddOn(state, {
        addOnSku: selectedAddOn.sku,
    });
    if (!addOnProduct) {
        return;
    }
    var addOnInfo = convertToLensAddOnInfo(addOnProduct, selectedAddOn.sku, 'en');
    return getBundleProductTitle(addOnInfo);
});
var getProductConfig = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSelectedLensTypeName, getSelectedPackageName, getSelectedAddOnName, getPrice$1, getLensParameters, hasVisitedStepAddOn, function (lensTypeName, packageName, addOnName, price, lens, hasVisitedStepAddOn) {
    return __assign(__assign(__assign(__assign(__assign({}, (lensTypeName ? { lensType: lensTypeName.toLowerCase() } : {})), (packageName ? { lensPackage: packageName.toLowerCase() } : {})), (hasVisitedStepAddOn && addOnName ? { 'add-ons': addOnName.toLowerCase() } : {})), { price: price !== null && price !== void 0 ? price : '0' }), (lens ? { lens: lens } : {}));
});
var getConfigFlow = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getStepData, getPrescriptionType$2, hasVisitedStepPrescription, function (stepData, prescriptionType, hasVisitedStepPrescription) {
    var manualRx = _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType);
    return __assign({ version: '1.0', step: stepData }, (hasVisitedStepPrescription &&
        !!prescriptionType &&
        !_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isEmailPrescription(prescriptionType)
        ? { manualRx: manualRx }
        : {}));
});
var getUser = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getPrescriptionType$2, function (prescriptionType) {
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isEmailPrescription(prescriptionType)) {
        // Note: there isn't yet a Data Layer implementation plan for the EmailPrescription option
        // this will be updated when that plan is finalized.
        return;
    }
    return {
        custStatus: _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isExistingCustomer(prescriptionType)
            ? 'customer'
            : 'prob noncustomer',
    };
});

function onStartConfiguration() {
    var openConfiguratorEvent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                openConfiguratorEvent = {
                    event: 'RxGlassesConfigEvent',
                    eventAction: 'click on button',
                    eventLabel: 'configure glasses button',
                };
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* DataLayer */ "g"].Actions.pushEvent(openConfiguratorEvent))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onPushEvent(eventAction, eventLabel) {
    var productConfig, configFlow, user, hasVisitedStepPrescription$1, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getProductConfig)];
            case 1:
                productConfig = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getConfigFlow)];
            case 2:
                configFlow = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getUser)];
            case 3:
                user = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(hasVisitedStepPrescription)];
            case 4:
                hasVisitedStepPrescription$1 = _a.sent();
                action = _grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* DataLayer */ "g"].Actions.pushEvent(__assign(__assign({ event: 'RxGlassesConfigEvent', eventAction: eventAction,
                    eventLabel: eventLabel }, (hasVisitedStepPrescription$1 && user ? { user: user } : {})), { RxGlasses: {
                        configFlow: configFlow,
                        productConfig: productConfig,
                    } }));
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(action)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 *
 */
var createSelectionHandler = function (eventAction) {
    return function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(onPushEvent, eventAction)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
};
var manualLensTypeSelection = function (a) {
    return _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, selectLensTypeSuccess) &&
        a.payload.reason === 'user selection';
};
var manualLensPackageSelection = function (a) {
    return _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, selectPackageSuccess) &&
        a.payload.reason === 'user selection';
};
var manualAddOnSelection = function (a) {
    return (_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, selectAddOnSuccess) ||
        _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].isType(a, resetSelectedAddOn)) &&
        a.payload.reason === 'user selection';
};
var listenForSelectionChanges$1 = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(manualLensTypeSelection, createSelectionHandler('select lens type')),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(manualLensPackageSelection, createSelectionHandler('select lens package')),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(manualAddOnSelection, createSelectionHandler('select add-on')),
];
/**
 * Logs a 'view step' event an every step change
 */
function onViewStep() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(onPushEvent, 'view step')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs a 'select rx attribute' on every prescription value change
 * Also logs an event label with the paramater name and eye side, i.e. "axis left"
 */
function onUpdatePrescriptionValue(_a) {
    var _b = _a.payload, parameter = _b.parameter, side = _b.side;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(onPushEvent, 'select rx attribute', parameter + " " + side)];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Logs an 'existing customer' value change
 */
function onUpdatePrescriptionType(_a) {
    var _b = _a.payload, prescriptionType = _b.prescriptionType, reason = _b.reason;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (reason === 'default selection') {
                    return [2 /*return*/];
                }
                if (!_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isExistingCustomer(prescriptionType)) return [3 /*break*/, 2];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(onPushEvent, 'existing customer', 'yes')];
            case 1:
                _c.sent();
                _c.label = 2;
            case 2:
                if (!_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(onPushEvent, 'existing customer', 'no')];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
/**
 * Logs when successfully moved to the next step
 */
function onNextStep$1() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(onPushEvent, 'click on button', 'next step')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var dataLayerSagas = __spread([
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(startPrescriptionGlassesConfiguration.type, onStartConfiguration),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(stepShown.type, onViewStep),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(updatePrescriptionValue.type, onUpdatePrescriptionValue)
], listenForSelectionChanges$1, [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(updatePrescriptionType.type, onUpdatePrescriptionType),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(nextStep.type, onNextStep$1),
]);

var getAdditionalPrescriptionInfo$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getAdditionalPrescriptionInfoFormState$1, function (additionalPrescriptionInfoFormState) {
    if (!additionalPrescriptionInfoFormState) {
        return {};
    }
    var _a = _grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Util */ "D"].getValuesFromState(additionalPrescriptionInfoFormState), examDate = _a.examDate, expiryDate = _a.expiryDate, rest = __rest(_a, ["examDate", "expiryDate"]);
    return {
        examDate: examDate,
        expiryDate: expiryDate,
        opticianDetails: JSON.stringify(rest),
    };
});
var getAddToCartCall = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator, function (configurator) { return (configurator === null || configurator === void 0 ? void 0 : configurator.calls.addToCart) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(); });

function filterUndefinedValues(obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (value !== undefined ? __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)) : acc);
    }, {});
}
function removeEmptyProperties(obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        var isEmpty = value === undefined || value === null || value === '';
        return isEmpty ? acc : __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
}
function onAddToCart() {
    var intl, locale, frameSku, lensTypeSku, packageSku, addOnSku, addOnLineItem, prescription, bundleChildLineItems, startSequenceId, prescriptionType_1, additionalPrescriptionInfo, prescriptionData_1, getPrescriptionConfig, prescriptionConfig, country, currency, formatProductUrl, prescriptionGlassesBundleLineItems, startAction, error_1, _a, success, failed, timeout, sequence;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getIntl)];
            case 1:
                intl = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale)];
            case 2:
                locale = _c.sent();
                if (!(!intl || !locale)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error("Need intl data to add product to cart")))];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getFrameSku)];
            case 5:
                frameSku = _c.sent();
                if (!!frameSku) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error("Need a frame SKU to add product to cart")))];
            case 6:
                _c.sent();
                return [2 /*return*/];
            case 7: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getLensTypeSku, { frameSku: frameSku })];
            case 8:
                lensTypeSku = _c.sent();
                if (!!lensTypeSku) return [3 /*break*/, 10];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error("Need a lens type SKU to add product to cart")))];
            case 9:
                _c.sent();
                return [2 /*return*/];
            case 10: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPackageSku, { frameSku: frameSku })];
            case 11:
                packageSku = _c.sent();
                if (!!packageSku) return [3 /*break*/, 13];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error("Need a package SKU to add product to cart")))];
            case 12:
                _c.sent();
                return [2 /*return*/];
            case 13: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getAddOnSku, { frameSku: frameSku })];
            case 14:
                addOnSku = _c.sent();
                addOnLineItem = addOnSku
                    ? [
                        {
                            productType: 'PrescriptionGlassPackageOptions',
                            sku: addOnSku,
                        },
                    ]
                    : [];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPrescription$2)];
            case 15:
                prescription = _c.sent();
                bundleChildLineItems = __spread([
                    {
                        productType: 'LensTypes',
                        sku: lensTypeSku,
                    },
                    {
                        productType: 'PrescriptionGlassPackages',
                        sku: packageSku,
                    }
                ], addOnLineItem);
                _c.label = 16;
            case 16:
                _c.trys.push([16, 23, , 25]);
                if (!!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(prescription)) return [3 /*break*/, 18];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error("No prescription found for frame with SKU " + frameSku)))];
            case 17:
                _c.sent();
                return [2 /*return*/];
            case 18: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPrescriptionType$2)];
            case 19:
                prescriptionType_1 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getAdditionalPrescriptionInfo$1)];
            case 20:
                additionalPrescriptionInfo = _c.sent();
                prescriptionData_1 = __assign({ rightLens: filterUndefinedValues(prescription.result.right), leftLens: filterUndefinedValues(prescription.result.left) }, removeEmptyProperties(additionalPrescriptionInfo));
                getPrescriptionConfig = function () {
                    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType_1)) {
                        return __assign({ type: prescriptionType_1 }, prescriptionData_1);
                    }
                    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isExistingCustomer(prescriptionType_1) ||
                        _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isEmailPrescription(prescriptionType_1)) {
                        return { type: prescriptionType_1 };
                    }
                };
                prescriptionConfig = getPrescriptionConfig();
                country = intl.country, currency = intl.currency;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getFormatProductUrl)];
            case 21:
                formatProductUrl = _c.sent();
                prescriptionGlassesBundleLineItems = [
                    {
                        bundleMainLineItem: {
                            productType: 'Frames',
                            sku: frameSku,
                        },
                        bundleChildLineItems: bundleChildLineItems,
                        quantity: 1,
                        prescription: prescriptionConfig,
                    },
                ];
                startAction = _grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.addToCart({
                    locale: locale,
                    country: country,
                    currency: currency,
                    formatProductUrl: formatProductUrl,
                    prescriptionGlassesBundleLineItems: prescriptionGlassesBundleLineItems,
                });
                startSequenceId = startAction.sequenceId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(startAction)];
            case 22:
                _c.sent();
                return [3 /*break*/, 25];
            case 23:
                error_1 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(error_1))];
            case 24:
                _c.sent();
                return [3 /*break*/, 25];
            case 25:
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.ADD_TO_CART_SUCCESS),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.ADD_TO_CART_FAILED),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 26:
                _a = __read.apply(void 0, [_c.sent(), 3]), success = _a[0], failed = _a[1], timeout = _a[2];
                sequence = (_b = failed === null || failed === void 0 ? void 0 : failed.sequenceId) !== null && _b !== void 0 ? _b : success === null || success === void 0 ? void 0 : success.sequenceId;
                if (typeof sequence === 'number' && sequence !== startSequenceId) {
                    // If the sequence ID doesn't match to the ID from the action we've put from this saga, we don't act on it
                    return [3 /*break*/, 25];
                }
                if (!timeout) return [3 /*break*/, 28];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error('Adding configured products to cart exceeded the timeout of 30 seconds.')))];
            case 27:
                _c.sent();
                return [2 /*return*/];
            case 28:
                if (!failed) return [3 /*break*/, 30];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(failed.error))];
            case 29:
                _c.sent();
                return [2 /*return*/];
            case 30:
                if (!success) return [3 /*break*/, 32];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartSuccess({ frameSku: frameSku }))];
            case 31:
                _c.sent();
                return [2 /*return*/];
            case 32: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed(new Error('unknown failure')))];
            case 33:
                _c.sent();
                return [2 /*return*/];
            case 34: return [2 /*return*/];
        }
    });
}
var legacyAddToCartSagas = [Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(addToCart.type, onAddToCart)];

function prescriptionGlassesSaga () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* all */ "a"])(__spread(bundleSagas, configurationSagas, configuratorSagas, dataLayerSagas, legacyAddToCartSagas))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var variantGroupProp = function (_, _a) {
    var variantGroup = _a.variantGroup;
    return variantGroup;
};
var getContactLensSubscription = function (state) {
    return state.contactLensSubscription;
};

var getConfiguration$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getContactLensSubscription, variantGroupProp, function (contactLensSubscription, variantGroup) {
    return contactLensSubscription.configurations[variantGroup];
});

var getSelectedDeliveryFrequency = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration$1, function (c) { return c === null || c === void 0 ? void 0 : c.deliveryFrequency; });
var getSelectedBillingPeriod = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration$1, function (c) { return c === null || c === void 0 ? void 0 : c.billingPeriod; });
var getSelectedStartDate = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration$1, function (c) { return c === null || c === void 0 ? void 0 : c.startDate; });
var getSelectedRatePlan = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration$1, function (c) { return c === null || c === void 0 ? void 0 : c.ratePlan; });
var getSelectedSolution = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfiguration$1, function (c) { return c === null || c === void 0 ? void 0 : c.solution; });

var selectors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getSelectedDeliveryFrequency: getSelectedDeliveryFrequency,
    getSelectedBillingPeriod: getSelectedBillingPeriod,
    getSelectedStartDate: getSelectedStartDate,
    getSelectedRatePlan: getSelectedRatePlan,
    getSelectedSolution: getSelectedSolution
});

var namespace = 'products/contact-lens-subscription';
var selectDeliveryFrequency = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-delivery-frequency", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectDeliveryFrequencyFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-delivery-frequency-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectDeliveryFrequencySuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-delivery-frequency-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectBillingPeriod = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-billing-period", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectBillingPeriodFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-billing-period-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectBillingPeriodSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-billing-period-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectStartDate = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-start-date", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectStartDateFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-start-date-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectStartDateSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-start-date-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectRatePlan = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-rate-plan", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectRatePlanFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-rate-plan-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectRatePlanSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-rate-plan-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var selectSolution = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace + "/select-solution", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var namespace$1 = 'products/contact-lens-subscription';
var addToCart$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/add-to-cart");
var addToCartFailed$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/add-to-cart-failed", function (error) { return ({ error: error }); });
var addToCartSuccess$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/add-to-cart-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var setSkipSteps = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/set-skip-steps", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var toggleFooter$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/footer/toggle");
var openFooter$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/footer/open");
var closeFooter$2 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/footer/close");
var stepShown$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$1 + "/step-shown", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var namespace$2 = 'products/contact-lens-subscription';
var fetchSolutions = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$2 + "/fetch-solutions");
var fetchSolutionsFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$2 + "/fetch-solutions-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchSolutionsSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$2 + "/fetch-solutions-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var namespace$3 = 'products/contact-lens-subscription';
var fetchRatePlans = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$3 + "/fetch-rate-plans");
var fetchRatePlansFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$3 + "/fetch-rate-plans-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchRatePlansSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$3 + "/fetch-rate-plans-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var namespace$4 = 'products/contact-lens-subscription';
var startContactLensSubscriptionConfiguration = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/start", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var startContactLensSubscriptionConfigurationSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/start-success");
var nextStep$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/next-step");
var nextStepSuccess$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/next-step-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var nextStepFailed$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/next-step-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var previousStep$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/previous-step");
var previousStepFailed$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/previous-step-failed", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var previousStepSuccess$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action(namespace$4 + "/previous-step-success", _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var reducer$5 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer({}, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(
/**
 * Create a blank configuration but only on the first call
 */
startContactLensSubscriptionConfiguration, function (s, _a) {
    var _b;
    var variantGroup = _a.payload.variantGroup;
    // If we have an existing configuration for a variant group (brand key) we use it.
    if (variantGroup in s) {
        return s;
    }
    return __assign(__assign({}, s), (_b = {}, _b[variantGroup] = {}, _b));
}), 
/**
 * Changes the delivery frequency.
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectDeliveryFrequencySuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, deliveryFrequency = _c.deliveryFrequency;
    return __assign(__assign({}, s), (_b = {}, _b[variantGroup] = __assign(__assign({}, s[variantGroup]), { deliveryFrequency: deliveryFrequency }), _b));
}), 
/**
 * Changes the billing period.
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectBillingPeriodSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, billingPeriod = _c.billingPeriod;
    return __assign(__assign({}, s), (_b = {}, _b[variantGroup] = __assign(__assign({}, s[variantGroup]), { billingPeriod: billingPeriod }), _b));
}), 
/**
 * Changes the start date.
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectStartDateSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, startDate = _c.startDate;
    return __assign(__assign({}, s), (_b = {}, _b[variantGroup] = __assign(__assign({}, s[variantGroup]), { startDate: startDate }), _b));
}), 
/**
 * Changes the rate plan and (re)sets other selections to their rate plan
 * values to ensure all values are compatible with a plan.
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectRatePlanSuccess, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, ratePlan = _c.ratePlan;
    return __assign(__assign({}, s), (_b = {}, _b[variantGroup] = __assign(__assign({}, s[variantGroup]), { deliveryFrequency: ratePlan.shippingSchedule, billingPeriod: ratePlan.billingPeriod, ratePlan: ratePlan }), _b));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(selectSolution, function (s, _a) {
    var _b;
    var _c = _a.payload, variantGroup = _c.variantGroup, solution = _c.solution;
    return __assign(__assign({}, s), (_b = {}, _b[variantGroup] = __assign(__assign({}, s[variantGroup]), { solution: solution }), _b));
}));

var getConfigurator$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getContactLensSubscription, function (contactLensSubscription) { return contactLensSubscription.configurator; });
var getCurrentStepNumber$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (c) { return c.currentStep; });

var getSteps$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (c) { return c.steps; });
var getSkipSteps = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (c) { return c.skipSteps; });
var getActiveSteps$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getCurrentStepNumber$1, getSteps$1, getSkipSteps, function (currentStepNumber, steps, skipSteps) {
    var isStepNotSkipped = function (stepName) { return !skipSteps.includes(stepName); };
    var stepNameToSteps = function (stepName, i) { return ({
        name: stepName,
        isCurrent: currentStepNumber === i,
        skip: false,
    }); };
    return steps.filter(isStepNotSkipped).map(stepNameToSteps);
});
var isLastStep$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getActiveSteps$1, function (steps) {
    if (steps.length === 0) {
        return false;
    }
    var lastStepIsCurrentStep = steps[steps.length - 1].isCurrent;
    if (lastStepIsCurrentStep) {
        return true;
    }
    // We're not on the last step, we have to check skipped steps to be sure we're not practically on the last step
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    var remainingSteps = steps.slice(currentStep + 1);
    return remainingSteps.every(function (s) { return s.skip; });
});

var isReady = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (c) { return c.isReady; });
var getVariantGroup = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.variantGroup; });
var getPackSize = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.packSize; });
var getUsageFrequency = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.usageFrequency; });
var getEyeSides = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.eyeSides; });
var getLensVariants = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.lensVariants; });
var getProduct = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.product; });
var getAddToCartCall$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.calls.addToCart || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(); });
var getStaticsUrl = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator === null || configurator === void 0 ? void 0 : configurator.staticsUrl; });
var getRecommendedCategoryKey = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator === null || configurator === void 0 ? void 0 : configurator.recommendedCategoryKey; });
/**
 * The currently selected delivery frequency of the variant group that is being configured
 */
var getSelectedDeliveryFrequency$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedDeliveryFrequency(state, { variantGroup: variantGroup });
});
/**
 * The currently selected billing period of the variant group that is being configured
 */
var getSelectedBillingPeriod$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedBillingPeriod(state, { variantGroup: variantGroup });
});
/**
 * The currently selected start date of the variant group that is being configured
 */
var getSelectedStartDate$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedStartDate(state, { variantGroup: variantGroup });
});
var getSelectedRatePlan$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedRatePlan(state, { variantGroup: variantGroup });
});
var getSelectedSolution$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getVariantGroup, function (s) { return s; }, function (variantGroup, state) {
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedSolution(state, { variantGroup: variantGroup });
});
/**
 * Step related selectors
 */
var getCurrentStep$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(
// workaround to preventcircular dependency,
// see https://github.com/reduxjs/reselect/issues/169#issuecomment-675021575
function (state) { return getActiveSteps$1(state); }, getCurrentStepNumber$1, function (activeSteps, currentStep) {
    return { name: activeSteps[currentStep].name };
});
/**
 * Aggregates
 */
var getConfigurationTotalPrice = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSelectedRatePlan$1, getCurrentStep$1, getSelectedSolution$1, getEyeSides, function (selectedRatePlan, currentStep, selectedSolution, eyeSides) {
    var _a, _b;
    if (!selectedRatePlan) {
        return undefined;
    }
    var solutionPrice = currentStep.name === 'solution'
        ? ((_a = selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.price) === null || _a === void 0 ? void 0 : _a.discountedPrice) || ((_b = selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.price) === null || _b === void 0 ? void 0 : _b.originalPrice) || 0
        : 0;
    return {
        originalPrice: eyeSides.length * selectedRatePlan.basePrice.price + solutionPrice,
        currency: selectedRatePlan.basePrice.currency,
    };
});
var isFooterOpen$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (c) { return c.isFooterOpen; });
var getFormatProductUrl$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getConfigurator$1, function (configurator) { return configurator.formatProductUrl; });

var selectors$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isReady: isReady,
    getVariantGroup: getVariantGroup,
    getPackSize: getPackSize,
    getUsageFrequency: getUsageFrequency,
    getEyeSides: getEyeSides,
    getLensVariants: getLensVariants,
    getProduct: getProduct,
    getAddToCartCall: getAddToCartCall$1,
    getStaticsUrl: getStaticsUrl,
    getRecommendedCategoryKey: getRecommendedCategoryKey,
    getSelectedDeliveryFrequency: getSelectedDeliveryFrequency$1,
    getSelectedBillingPeriod: getSelectedBillingPeriod$1,
    getSelectedStartDate: getSelectedStartDate$1,
    getSelectedRatePlan: getSelectedRatePlan$1,
    getSelectedSolution: getSelectedSolution$1,
    getCurrentStep: getCurrentStep$1,
    getConfigurationTotalPrice: getConfigurationTotalPrice,
    isFooterOpen: isFooterOpen$1,
    getFormatProductUrl: getFormatProductUrl$1
});

var initialState$3 = {
    isReady: false,
    steps: [],
    currentStep: 0,
    stepsAttempted: new Set(),
    stepsVisited: [],
    skipSteps: [],
    calls: {
        addToCart: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    },
    isFooterOpen: false,
    lensVariants: [],
    eyeSides: [],
};
var reducer$6 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(initialState$3, 
/**
 * Set the correct frameSku and always reset the configurator to the initial state
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startContactLensSubscriptionConfiguration, function (_s, _a) {
    var _b = _a.payload, steps = _b.steps, input = _b.input, variantGroup = _b.variantGroup, lensVariants = _b.lensVariants, product = _b.product, staticsUrl = _b.staticsUrl, formatProductUrl = _b.formatProductUrl;
    return (__assign(__assign(__assign({}, initialState$3), input), { variantGroup: variantGroup,
        lensVariants: lensVariants,
        staticsUrl: staticsUrl,
        product: product,
        formatProductUrl: formatProductUrl,
        steps: steps, stepsVisited: [steps[0]] }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startContactLensSubscriptionConfigurationSuccess, function (s) { return (__assign(__assign({}, s), { isReady: true })); }), 
/**
 * When user tries to move on to the next step record so we mark the form as submitted
 *
 * This will reveal validation errors
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(nextStep$1, function (s) { return (__assign(__assign({}, s), { stepsAttempted: new Set(__spread(s.stepsAttempted, [s.currentStep])) })); }), 
/**
 * When the steps change is allowed it's communicated by dispatching the nextStepSuccess action
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(nextStepSuccess$1, function (s, a) { return (__assign(__assign({}, s), { currentStep: a.payload.newStepIndex, stepsVisited: __spread(new Set(__spread(s.stepsVisited, [a.payload.newStepName]))) })); }), 
/**
 * When the current step is moved back it's communicated by dispatching the previousStepSuccess action
 *
 * When user returns from step 3 to step 2, both 3 (currentStep) and 2 (newStep) are removed so we don't show error messages when returning
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(previousStepSuccess$1, function (s, a) { return (__assign(__assign({}, s), { currentStep: a.payload.newStepIndex, stepsAttempted: new Set(__spread(s.stepsAttempted).filter(function (s) { return s !== a.payload.currentStep && s !== a.payload.newStepIndex; })) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(setSkipSteps, function (s, a) { return (__assign(__assign({}, s), { skipSteps: a.payload.steps })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addToCart$1, function (s, _) { return (__assign(__assign({}, s), { calls: __assign(__assign({}, s.calls), { addToCart: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() }) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addToCartFailed$1, function (s, a) { return (__assign(__assign({}, s), { calls: __assign(__assign({}, s.calls), { addToCart: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(a.error) }) })); }), 
/**
 * When adding the config to cart has succeeded we start from 0
 *
 * Resetting the lensVariants to undefined also closes the modal
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addToCartSuccess$1, function (s, _) { return (__assign(__assign({}, initialState$3), { lensVariants: [] })); }), 
/**
 * Toggles footer
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(toggleFooter$1, function (s) { return (__assign(__assign({}, s), { isFooterOpen: !s.isFooterOpen })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(closeFooter$2, function (s) { return (__assign(__assign({}, s), { isFooterOpen: false })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(openFooter$1, function (s) { return (__assign(__assign({}, s), { isFooterOpen: true })); }));

var getState = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getContactLensSubscription, function (cls) { return cls.solutions; });
var getSolutions = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getState, function (s) { return s.solutions; });

var selectors$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getSolutions: getSolutions
});

var initialState$4 = Object.freeze({
    solutions: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])(),
});
var reducer$7 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(initialState$4, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startContactLensSubscriptionConfiguration, function (s) { return (__assign(__assign({}, s), { solutions: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchSolutions, function (s) { return (__assign(__assign({}, s), { solutions: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchSolutionsFailed, function (s, _a) {
    var error = _a.payload.error;
    return (__assign(__assign({}, s), { solutions: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(error) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchSolutionsSuccess, function (s, _a) {
    var solutions = _a.payload.solutions;
    return (__assign(__assign({}, s), { solutions: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(solutions) }));
}));

var getSubscriptions = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getContactLensSubscription, function (cls) { return cls.subscriptions; });

var getRatePlans = Object(reselect__WEBPACK_IMPORTED_MODULE_4__[/* createSelector */ "a"])(getSubscriptions, function (s) { return s.ratePlans; });

var selectors$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getRatePlans: getRatePlans
});

var initialState$5 = Object.freeze({
    ratePlans: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])(),
});
var reducer$8 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].reducer(initialState$5, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(startContactLensSubscriptionConfiguration, function (s) { return (__assign(__assign({}, s), { ratePlans: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchRatePlans, function (s) { return (__assign(__assign({}, s), { ratePlans: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchRatePlansFailed, function (s, _a) {
    var error = _a.payload.error;
    return (__assign(__assign({}, s), { ratePlans: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(error) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchRatePlansSuccess, function (s, _a) {
    var ratePlans = _a.payload.ratePlans;
    return (__assign(__assign({}, s), { ratePlans: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(ratePlans) }));
}));

var contactLensSubscriptionReducer = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* combineReducers */ "t"])({
    configurations: reducer$5,
    configurator: reducer$6,
    subscriptions: reducer$8,
    solutions: reducer$7,
});

function selectDeliveryFrequency$1(_a) {
    var _b = _a.payload, variantGroup = _b.variantGroup, deliveryFrequency = _b.deliveryFrequency;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectDeliveryFrequencySuccess({
                    variantGroup: variantGroup,
                    deliveryFrequency: deliveryFrequency,
                }))];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function selectBillingPeriod$1(_a) {
    var _b = _a.payload, variantGroup = _b.variantGroup, billingPeriod = _b.billingPeriod;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectBillingPeriodSuccess({
                    variantGroup: variantGroup,
                    billingPeriod: billingPeriod,
                }))];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function selectStartDate$1(_a) {
    var _b = _a.payload, variantGroup = _b.variantGroup, startDate = _b.startDate;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectStartDateSuccess({
                    variantGroup: variantGroup,
                    startDate: startDate,
                }))];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function selectRatePlan$1(_a) {
    var selectedDeliveryFrequency, selectedBillingPeriod, ratePlans, compatibleRatePlans, resolvedRatePlan;
    var variantGroup = _a.payload.variantGroup;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedDeliveryFrequency$1)];
            case 1:
                selectedDeliveryFrequency = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedBillingPeriod$1)];
            case 2:
                selectedBillingPeriod = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getRatePlans)];
            case 3:
                ratePlans = _b.sent();
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(ratePlans)) {
                    return [2 /*return*/];
                }
                compatibleRatePlans = [];
                if (selectedBillingPeriod) {
                    compatibleRatePlans = ratePlans.result.filter(function (rp) { return rp.shippingSchedule === selectedDeliveryFrequency && rp.billingPeriod === selectedBillingPeriod; });
                }
                if (!compatibleRatePlans.length && selectedDeliveryFrequency) {
                    compatibleRatePlans = ratePlans.result.filter(function (rp) { return rp.shippingSchedule === selectedDeliveryFrequency; });
                }
                if (!!compatibleRatePlans.length) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectRatePlanFailed({
                        variantGroup: variantGroup,
                        ratePlan: undefined,
                        error: new Error('Unable to resolve selections to a compatible rate plan.')
                    }))];
            case 4: return [2 /*return*/, _b.sent()];
            case 5:
                resolvedRatePlan = compatibleRatePlans[0];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectRatePlanSuccess({
                        variantGroup: variantGroup,
                        ratePlan: resolvedRatePlan,
                    }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
var configurationsSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectDeliveryFrequency.type, selectDeliveryFrequency$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectBillingPeriod.type, selectBillingPeriod$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectStartDate.type, selectStartDate$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectDeliveryFrequencySuccess.type, selectRatePlan$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(selectBillingPeriodSuccess.type, selectRatePlan$1),
];



var selectors$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    configurations: selectors,
    configurator: selectors$1,
    subscriptions: selectors$3,
    solutions: selectors$2
});

var deliveryFrequency = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(selectDefaultDeliveryFrequency)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var deliveryFrequency;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedDeliveryFrequency$1)];
                case 1:
                    deliveryFrequency = _a.sent();
                    if (!deliveryFrequency) {
                        return [2 /*return*/, new Error('Selecting a delivery frequency is required.')];
                    }
                    return [2 /*return*/];
            }
        });
    },
};
function selectDefaultDeliveryFrequency() {
    var selectedDeliveryFrequency, ratePlans, _a, success, variantGroup;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedDeliveryFrequency$1)];
            case 1:
                selectedDeliveryFrequency = _c.sent();
                if (!!selectedDeliveryFrequency) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getRatePlans)];
            case 2:
                ratePlans = _c.sent();
                if (!(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(ratePlans) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(ratePlans))) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(fetchRatePlansSuccess.type),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(fetchRatePlansFailed.type),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 3:
                _a = __read.apply(void 0, [_c.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getRatePlans)];
            case 4:
                ratePlans = _c.sent();
                _c.label = 5;
            case 5:
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(ratePlans)) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getVariantGroup)];
            case 6:
                variantGroup = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectDeliveryFrequency({
                        variantGroup: variantGroup,
                        deliveryFrequency: (_b = ratePlans.result[0]) === null || _b === void 0 ? void 0 : _b.shippingSchedule,
                    }))];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}

var solution = {
// *onEnter(): SagaIterator {},
// *onNext(): SagaIterator {},
};

var subscriptionPlan = {
    onEnter: function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(selectDefaultBillingPeriod)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(selectDefaultStartDate)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    onNext: function () {
        var billingPeriod, startDate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedBillingPeriod$1)];
                case 1:
                    billingPeriod = _a.sent();
                    if (!billingPeriod) {
                        return [2 /*return*/, new Error('Selecting a billing period is required.')];
                    }
                    return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedStartDate$1)];
                case 2:
                    startDate = _a.sent();
                    if (!startDate) {
                        return [2 /*return*/, new Error('Selecting a start date is required.')];
                    }
                    return [2 /*return*/];
            }
        });
    },
};
function selectDefaultBillingPeriod() {
    var selectedBillingPeriod, ratePlans, _a, success, variantGroup, selectedDeliveryFrequency_1, filteredRatePlans;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedBillingPeriod$1)];
            case 1:
                selectedBillingPeriod = _c.sent();
                if (!!selectedBillingPeriod) return [3 /*break*/, 9];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getRatePlans)];
            case 2:
                ratePlans = _c.sent();
                if (!(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(ratePlans) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(ratePlans))) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(fetchRatePlansSuccess.type),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(fetchRatePlansFailed.type),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 3:
                _a = __read.apply(void 0, [_c.sent(), 1]), success = _a[0];
                if (!success) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getRatePlans)];
            case 4:
                ratePlans = _c.sent();
                _c.label = 5;
            case 5:
                if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(ratePlans)) return [3 /*break*/, 9];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getVariantGroup)];
            case 6:
                variantGroup = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedDeliveryFrequency$1)];
            case 7:
                selectedDeliveryFrequency_1 = _c.sent();
                filteredRatePlans = ratePlans.result.filter(function (ratePlan) { return ratePlan.shippingSchedule === selectedDeliveryFrequency_1; });
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectBillingPeriod({
                        variantGroup: variantGroup,
                        billingPeriod: (_b = filteredRatePlans[0]) === null || _b === void 0 ? void 0 : _b.billingPeriod,
                    }))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
function selectDefaultStartDate() {
    var selectedStartDate, variantGroup, startDate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getSelectedStartDate$1)];
            case 1:
                selectedStartDate = _a.sent();
                if (!!selectedStartDate) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getVariantGroup)];
            case 2:
                variantGroup = _a.sent();
                startDate = new Date();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(selectStartDate({
                        variantGroup: variantGroup,
                        startDate: startDate,
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}

var steps$1 = {
    deliveryFrequency: deliveryFrequency,
    subscriptionPlan: subscriptionPlan,
    solution: solution,
};

function onNextStep$2() {
    var activeSteps, currentStep, stepName, step, result, nextActiveStep;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getActiveSteps$1)];
            case 1:
                activeSteps = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getCurrentStepNumber$1)];
            case 2:
                currentStep = _a.sent();
                stepName = activeSteps[currentStep].name;
                step = steps$1[stepName];
                if (!step.onNext) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(step.onNext)];
            case 3:
                result = _a.sent();
                if (!result) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStepFailed$1({ currentStep: currentStep, reason: result }))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5:
                nextActiveStep = currentStep + 1;
                if (!(nextActiveStep >= activeSteps.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStepFailed$1({
                        currentStep: currentStep,
                        reason: new Error("We're already on the last step."),
                    }))];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(nextStepSuccess$1({
                    currentStep: currentStep,
                    newStepIndex: nextActiveStep,
                    newStepName: activeSteps[nextActiveStep].name,
                }))];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onPreviousStep$1() {
    var activeSteps, currentStep, previousActiveStep;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getActiveSteps$1)];
            case 1:
                activeSteps = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getCurrentStepNumber$1)];
            case 2:
                currentStep = _a.sent();
                previousActiveStep = currentStep - 1;
                if (!(previousActiveStep < 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(previousStepFailed$1({
                        currentStep: currentStep,
                        reason: new Error("Can't go back beyond the first step"),
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(previousStepSuccess$1({
                    currentStep: currentStep,
                    newStepIndex: previousActiveStep,
                    newStepName: activeSteps[previousActiveStep].name,
                }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function triggerOnEnterForFirstStep$1(_a) {
    var lensType, firstStepName, step;
    var _b = _a.payload, product = _b.product, stepNames = _b.steps;
    var _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                lensType = (_e = (_d = (_c = product.masterVariant) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.find(function (attr) { return attr.name == 'replacementFrequency'; })) === null || _e === void 0 ? void 0 : _e.value.en;
                if (!(lensType === 'Daily')) return [3 /*break*/, 2];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(setSkipSteps({ steps: ['solution'] }))];
            case 1:
                _f.sent();
                _f.label = 2;
            case 2:
                firstStepName = stepNames[0];
                step = steps$1[firstStepName];
                if (!(step && step.onEnter)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(step.onEnter)];
            case 3:
                _f.sent();
                _f.label = 4;
            case 4: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(stepShown$1({ step: firstStepName }))
                // all configurator data loaded, time to show it
            ];
            case 5:
                _f.sent();
                // all configurator data loaded, time to show it
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(startContactLensSubscriptionConfigurationSuccess())];
            case 6:
                // all configurator data loaded, time to show it
                _f.sent();
                return [2 /*return*/];
        }
    });
}
function onSuccessfulStepSwitch$1(_a) {
    var step;
    var newStepName = _a.payload.newStepName;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                step = steps$1[newStepName];
                if (!step.onEnter) return [3 /*break*/, 2];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(step.onEnter)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(stepShown$1({ step: newStepName }))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onAddToCart$1() {
    var intl, locale, lensVariants, startSequenceId, lineItems, formatProductUrl, country, currency, startAction, error_1, _a, success, failed, timeout, sequence;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getIntl)];
            case 1:
                intl = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale)];
            case 2:
                locale = _c.sent();
                if (!(!intl || !locale)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed$1(new Error("Need intl data to add product to cart")))];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getLensVariants)];
            case 5:
                lensVariants = _c.sent();
                if (!!lensVariants) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed$1(new Error('Need lens variants to add products to cart')))];
            case 6:
                _c.sent();
                return [2 /*return*/];
            case 7:
                lineItems = lensVariants
                    .filter(function (lensVariant) {
                    return typeof lensVariant !== 'undefined';
                })
                    .map(function (lensVariant) { return ({
                    sku: lensVariant.sku,
                    quantity: 1,
                }); });
                _c.label = 8;
            case 8:
                _c.trys.push([8, 11, , 13]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getFormatProductUrl$1)];
            case 9:
                formatProductUrl = _c.sent();
                country = intl.country, currency = intl.currency;
                startAction = _grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.addToCart({
                    locale: locale,
                    country: country,
                    currency: currency,
                    formatProductUrl: formatProductUrl,
                    lineItems: lineItems,
                });
                startSequenceId = startAction.sequenceId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(startAction)];
            case 10:
                _c.sent();
                return [3 /*break*/, 13];
            case 11:
                error_1 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed$1(error_1))];
            case 12:
                _c.sent();
                return [3 /*break*/, 13];
            case 13:
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* race */ "g"])([
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.ADD_TO_CART_SUCCESS),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* take */ "i"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.ADD_TO_CART_FAILED),
                        Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* delay */ "d"])(30000, true),
                    ])];
            case 14:
                _a = __read.apply(void 0, [_c.sent(), 3]), success = _a[0], failed = _a[1], timeout = _a[2];
                sequence = (_b = failed === null || failed === void 0 ? void 0 : failed.sequenceId) !== null && _b !== void 0 ? _b : success === null || success === void 0 ? void 0 : success.sequenceId;
                if (typeof sequence === 'number' && sequence !== startSequenceId) {
                    // If the sequence ID doesn't match to the ID from the action we've put from this saga, we don't act on it
                    return [3 /*break*/, 13];
                }
                if (!timeout) return [3 /*break*/, 16];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed$1(new Error('Adding configured products to cart exceeded the timeout of 30 seconds.')))];
            case 15:
                _c.sent();
                return [2 /*return*/];
            case 16:
                if (!failed) return [3 /*break*/, 18];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed$1(failed.error))];
            case 17:
                _c.sent();
                return [2 /*return*/];
            case 18:
                if (!success) return [3 /*break*/, 20];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartSuccess$1({ lensVariants: lensVariants }))];
            case 19:
                _c.sent();
                return [2 /*return*/];
            case 20: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(addToCartFailed$1(new Error('unknown failure')))];
            case 21:
                _c.sent();
                return [2 /*return*/];
            case 22: return [2 /*return*/];
        }
    });
}
var configuratorSagas$1 = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(nextStep$1.type, onNextStep$2),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(previousStep$1.type, onPreviousStep$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])([nextStepSuccess$1.type, previousStepSuccess$1.type], onSuccessfulStepSwitch$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])([nextStep$1.type, previousStep$1.type], closeFooter$2),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(startContactLensSubscriptionConfiguration.type, triggerOnEnterForFirstStep$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(addToCart$1.type, onAddToCart$1),
];

function fetchSolutions$1() {
    var config, recommendedCategoryKey, results, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 1:
                config = _a.sent();
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* assertApiConfig */ "s"])(config);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getRecommendedCategoryKey)];
            case 2:
                recommendedCategoryKey = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 6, , 8]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].query, config.productsUrl, { categoryType: recommendedCategoryKey }, config.apiKey)];
            case 4:
                results = (_a.sent()).results;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchSolutionsSuccess({ solutions: results }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchSolutionsFailed({
                        error: new Error("Fetching solutions failed with: " + err_1),
                    }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
var solutionsSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(startContactLensSubscriptionConfiguration.type, fetchSolutions$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(fetchSolutions.type, fetchSolutions$1),
];

function fetchRatePlans$1() {
    var config, variantGroup, packSize, usageFrequency, ratePlans, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 1:
                config = _a.sent();
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* assertApiConfig */ "s"])(config);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getVariantGroup)];
            case 2:
                variantGroup = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getPackSize)];
            case 3:
                packSize = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* select */ "h"])(getUsageFrequency)];
            case 4:
                usageFrequency = _a.sent();
                _a.label = 5;
            case 5:
                _a.trys.push([5, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Subscriptions */ "j"].RatePlans.list, config.subscriptionsUrl, {
                        brandKey: variantGroup,
                        packageQuantity: packSize,
                        usageLevel: usageFrequency,
                    })];
            case 6:
                ratePlans = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchRatePlansSuccess({ ratePlans: ratePlans }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                error_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* put */ "f"])(fetchRatePlansFailed({ error: error_1 }))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
var subscriptionsSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(startContactLensSubscriptionConfiguration.type, fetchRatePlans$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* takeLatest */ "j"])(fetchRatePlans.type, fetchRatePlans$1),
];

function contactLensSubscriptionSaga () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__[/* all */ "a"])(__spread(configurationsSagas, configuratorSagas$1, subscriptionsSagas, solutionsSagas))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}



var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var isLightProductModel = function (product) {
    return 'objectID' in product;
};
var isContactLenses = function (productType) {
    return _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(productType) || _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isContactLensBundle(productType);
};

var Details = function (_a) {
    var brand = _a.brand, name = _a.name;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("header", { className: "product-block-details" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { className: "product-block-details__brand", variant: "subheading1" }, brand),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { className: "product-block-details__name", variant: "caption" }, name)));
};

var Images = function (_a) {
    var front = _a.front, angle = _a.angle;
    // Default width and height to set the right aspect ratios 320/180 = 16:9
    var defaultSettings = { width: 320, height: 180, rootMargin: '150px 0px' };
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var Placeholder = (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "product-block-image-placeholder" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* SkeletonLoader */ "hb"], null)));
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("section", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-block-image-wrapper', {
            'product-block-image-wrapper--hover': !!angle,
        }), style: { paddingBottom: (defaultSettings.height / defaultSettings.width) * 100 + "%" } },
        front && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("figure", { className: "product-block-image product-block-image--front" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LazyImage */ "C"], __assign({}, defaultSettings, { src: front.url, alt: front.alt || '', placeholder: Placeholder })))),
        angle && !isSmallScreen && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("figure", { className: "product-block-image product-block-image--angle" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LazyImage */ "C"], __assign({}, defaultSettings, { src: angle.url, alt: angle.alt || '', placeholder: Placeholder }))))));
};

var Prices = function (_a) {
    var price = _a.price, discountedPrice = _a.discountedPrice;
    var currency = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().currency;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-block-prices" },
        !!discountedPrice && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price, currency: currency, size: "small", type: "strikethrough" })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : price, currency: currency, size: "small" })));
};

var PromotionLabel = function (_a) {
    var children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "product-block-promotion-label" }, children));
};

var VariantSwitcherItem = function (_a) {
    var image = _a.image, sku = _a.sku, isActive = _a.isActive, onClick = _a.onClick;
    var handleClick = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (e) {
        onClick(sku);
        e.preventDefault();
    }, [sku]);
    if (!image) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("button", { onClick: handleClick, "aria-label": image.alt || '', className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('variant-switcher-item', { 'variant-switcher-item--active': isActive }) },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LazyImage */ "C"], { className: "variant-switcher-item__image", src: image.url, alt: image.alt || '', 
            // 16:9 ratio
            height: 22.5, width: 40 })));
};
var VariantSwitcher = function (_a) {
    var variants = _a.variants, activeSku = _a.activeSku, onVariantChange = _a.onVariantChange;
    var itemsPerSlide = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone() ? 2 : 3;
    var carouselItems = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () {
        var max = Math.ceil(variants.length / itemsPerSlide);
        var items = [];
        for (var i = 0; i < max; i++) {
            var start = i * itemsPerSlide;
            var end = (i + 1) * itemsPerSlide;
            items.push(react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { key: "variant-switcher-" + i, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('variant-switcher__slide', {
                    'variant-switcher__slide--single': max === 1,
                }) }, variants.slice(start, end).map(function (_a) {
                var sku = _a.sku, image = _a.image;
                return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(VariantSwitcherItem, { key: sku, image: image, sku: sku, isActive: sku === activeSku, onClick: onVariantChange }));
            })));
        }
        return items;
    }, [variants, activeSku, onVariantChange, itemsPerSlide]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-switcher" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Carousel */ "h"], { pagination: false }, carouselItems)));
};

var ProductBlock = function (_a) {
    var brand = _a.brand, name = _a.name, url = _a.url, productType = _a.productType, activeSku = _a.activeSku, images = _a.images, price = _a.price, discountedPrice = _a.discountedPrice, variants = _a.variants, promotionLabel = _a.promotionLabel, className = _a.className, onVariantChange = _a.onVariantChange, onClick = _a.onClick;
    if (!activeSku || !price || !url) {
        console.warn("Cannot render ProductBlock component without a valid price: " + price + " and url: " + url + " and active sku: " + activeSku + ".");
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("a", { href: url, onClick: onClick, "aria-label": brand + " " + name, "data-t": "product-block", className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-block', {
            'product-block--contact-lenses': isContactLenses(productType),
        }, className) },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("aside", { className: "product-block__header" }, promotionLabel && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PromotionLabel, null, promotionLabel)),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-block__main" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Images, { front: images.front, angle: images.angle }),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Details, { brand: brand, name: name }),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Prices, { price: price, discountedPrice: discountedPrice })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("footer", { className: "product-block__footer" }, !!(variants === null || variants === void 0 ? void 0 : variants.length) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(VariantSwitcher, { variants: variants, activeSku: activeSku, onVariantChange: onVariantChange })))));
};

var imageSizes = {
    S: 171,
    M: 192,
    L: 272,
    XL: 544,
};
var defaultParams = {
    fit: 'fill',
    fm: 'jpeg',
    auto: 'format',
};
var createImgUrl = function (url, path, params) {
    if (params === void 0) { params = {}; }
    return "" + url + path + _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* QueryString */ "e"].stringify(__assign(__assign({}, defaultParams), params));
};
// Calculates 16:9 aspect ratio height
var calcHeightToRatio = function (w) { return Math.round(w * (9 / 16)); };
var createImageSrcSetItem = function (url, path, width) {
    return createImgUrl(url, path) + "&w=" + width + "&h=" + calcHeightToRatio(width) + " " + width + "w";
};
var createImageSrcSet = function (url, path) {
    return Object.values(imageSizes)
        .map(function (size) { return createImageSrcSetItem(url, path, size); })
        .toString();
};
var createImageSizes = function () {
    var sizes = Object.values(imageSizes);
    return Object.values(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].Breakpoints)
        .map(function (bp, i) { return "(max-width: " + bp + "px) " + sizes[i] + "px"; })
        .join(', ');
};
var createAltTag = function (variant, locale) {
    var frameColor = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(variant, 'frameColor', locale) || '';
    var lensColor = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(variant, 'lensColor', locale) || '';
    var colorsLabel = [frameColor, lensColor].filter(function (s) { return s.trim() !== ''; }).join(' / ');
    return variant.name + " " + colorsLabel;
};
function getVariantImages(variant, locale, staticsUrl, imgSettings, responsive) {
    if (responsive === void 0) { responsive = true; }
    if (!variant || !variant.images || !variant.images.length) {
        return [];
    }
    var images = variant.images;
    var altTag = createAltTag(variant, locale);
    var settings = !!imgSettings
        ? imgSettings
        : { w: imageSizes.XL, h: calcHeightToRatio(imageSizes.XL) };
    return images.map(function (img) { return (__assign(__assign({ url: createImgUrl(staticsUrl, img.url, settings), alt: altTag }, (responsive ? { srcSet: createImageSrcSet(staticsUrl, img.url) } : {})), (responsive ? { sizes: createImageSizes() } : {}))); });
}

function getVariantInfo$1(locale, product, variant, productType) {
    var isLenses = _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(productType) || _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isContactLensBundle(productType);
    var brand = isLenses
        ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale)
        : String(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'brand'));
    var name = isLenses
        ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(variant, 'replacementFrequency', locale)
        : variant.name;
    var _a = getPrice(variant) || {}, originalPrice = _a.originalPrice, discountedPrice = _a.discountedPrice;
    var framePriceIncluded = _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isFrames(productType) && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'priceIncluded');
    var price = framePriceIncluded && typeof framePriceIncluded === 'object'
        ? Number(framePriceIncluded.centAmount)
        : originalPrice;
    return __assign({ brand: brand || '', name: name || '', sku: variant.sku, price: price }, (discountedPrice && discountedPrice !== originalPrice ? { discountedPrice: discountedPrice } : {}));
}

function getVariantUrl(formatProductUrl, product, variant, productType) {
    if (!productType) {
        console.error("ProductType data is missing from product with id " + product.id + ", make sure you 'expand' the productType when fetching from commercetools.", product);
        return '#';
    }
    if (!variant.sku) {
        console.error("Variant for product with id " + product.id + " has no sku", {
            variant: variant,
            product: product,
        });
        return '#';
    }
    return formatProductUrl({
        productType: productType,
        sku: variant.sku,
        slug: product.slug,
    });
}

var getActiveVariant$1 = function (variants, sku) { return (sku && variants.find(function (variant) { return variant.sku === sku; })) || variants[0]; };

var getProductTypeName$1 = function (product) { var _a, _b; return (_b = (_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; };
function useCommerceToolsProductData(product, activeSku, staticsUrl, formatProductUrl, getProductImages) {
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().locale;
    var productType = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return getProductTypeName$1(product); }, [product]);
    var variants = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return __spread([product.masterVariant], product.variants); }, [
        product.masterVariant,
        product.variants,
    ]);
    var activeVariant = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return getActiveVariant$1(variants, activeSku); }, [
        variants,
        activeSku,
    ]);
    var variantInfo = getVariantInfo$1(locale, product, activeVariant, productType);
    var variantUrl = getVariantUrl(formatProductUrl, product, activeVariant, productType);
    var promotionLabel = getDiscountText(locale, activeVariant);
    var variantImages = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        // Create custom image urls for BeNe banners
        if (getProductImages) {
            var _a = getProductImages(product, imageSizes.L, calcHeightToRatio(imageSizes.L)), primary = _a.primary, secondary = _a.secondary;
            var front_1 = __assign(__assign({}, primary), { url: staticsUrl + primary.url });
            var angle_1 = secondary && __assign(__assign({}, secondary), { url: staticsUrl + secondary.url });
            return { front: front_1, angle: angle_1 };
        }
        var _b = __read(getVariantImages(activeVariant, locale, staticsUrl), 2), front = _b[0], angle = _b[1];
        return { front: front, angle: angle };
    }, [staticsUrl, locale, activeVariant, getProductImages]);
    var otherVariants = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        var thumbnailSize = { w: 40, h: 23 };
        return variants.length > 1
            ? variants.map(function (variant) { return ({
                sku: variant.sku,
                image: !!getProductImages
                    ? getProductImages(product, thumbnailSize.w, thumbnailSize.h).primary
                    : getVariantImages(variant, locale, staticsUrl, thumbnailSize, false)[0],
            }); })
            : [];
    }, [variants, staticsUrl, locale, getProductImages]);
    return {
        productType: productType,
        variantInfo: variantInfo,
        variantUrl: variantUrl,
        promotionLabel: promotionLabel,
        variantImages: variantImages,
        otherVariants: otherVariants,
    };
}

var CommerceToolsProductBlock = function (_a) {
    var product = _a.product, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, getProductImageUrls = _a.getProductImageUrls, onClick = _a.onClick, className = _a.className;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(product.masterVariant.sku || ''), 2), activeSku = _b[0], setActiveSku = _b[1];
    var handleVariantChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (sku) {
        sku && setActiveSku(sku);
    }, []);
    var _c = useCommerceToolsProductData(product, activeSku, staticsUrl, formatProductUrl, getProductImageUrls), productType = _c.productType, variantInfo = _c.variantInfo, variantUrl = _c.variantUrl, variantImages = _c.variantImages, otherVariants = _c.otherVariants, promotionLabel = _c.promotionLabel;
    if (!variantInfo || !variantUrl) {
        console.error('CommerceToolsProductBlock: missing critical info required for rendering', {
            variantInfo: variantInfo,
            variantUrl: variantUrl,
        });
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductBlock, __assign({ className: className, url: variantUrl, images: variantImages, variants: otherVariants || [], promotionLabel: promotionLabel, productType: productType, activeSku: activeSku, onVariantChange: handleVariantChange, onClick: onClick }, variantInfo)));
};

var AlgoliaProductBlock = function (_a) {
    var product = _a.product, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, getProductImageUrls = _a.getProductImageUrls, onClick = _a.onClick, className = _a.className;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(product.masterVariant.sku || ''), 2), activeSku = _b[0], setActiveSku = _b[1];
    var handleVariantChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (sku) {
        sku && setActiveSku(sku);
    }, []);
    // TODO: in the near future, we want to start stripping the data models we use in algolia (ProductProjectionLight)
    //  to make the records much smaller and improve performance. Then we can start splitting stuff from the CT data resolver.
    var _c = useCommerceToolsProductData(product, activeSku, staticsUrl, formatProductUrl, getProductImageUrls), productType = _c.productType, variantInfo = _c.variantInfo, variantUrl = _c.variantUrl, variantImages = _c.variantImages, otherVariants = _c.otherVariants, promotionLabel = _c.promotionLabel;
    if (!variantInfo || !variantUrl) {
        console.error('AlgoliaProductBlock: missing critical info required for rendering', {
            variantInfo: variantInfo,
            variantUrl: variantUrl,
        });
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductBlock, __assign({ productType: productType, className: className, url: variantUrl, images: variantImages, variants: otherVariants || [], promotionLabel: promotionLabel, activeSku: activeSku, onVariantChange: handleVariantChange, onClick: onClick }, variantInfo)));
};

var updateActiveVariant = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('UPDATE_ACTIVE_VARIANT', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());

var actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    updateActiveVariant: updateActiveVariant
});

var initialState$6 = {
    activeSku: '',
};
var productDetailContextReducer = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* reducer */ "B"])(initialState$6, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(updateActiveVariant, function (state, action) { return (__assign(__assign({}, state), { activeSku: action.payload.sku })); }));

var ProductDetailContext = Object(react__WEBPACK_IMPORTED_MODULE_10__["createContext"])({});
var useProductDetailContext = function () { return Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(ProductDetailContext); };
var ProductDetailProvider = function (_a) {
    var children = _a.children, product = _a.product, locale = _a.locale, sku = _a.sku, productType = _a.productType, staticsUrl = _a.staticsUrl, getProductImageUrls = _a.getProductImageUrls, getSolutionImageUrl = _a.getSolutionImageUrl, isPrescriptionGlassesConfiguratorValidationStepEnabled = _a.isPrescriptionGlassesConfiguratorValidationStepEnabled, renderAddToCartButton = _a.renderAddToCartButton, useAddToCart = _a.useAddToCart;
    var isCartV2Enabled = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useFeatureToggles */ "P"])().isCartV2Enabled;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), isAddToCartNotificationShown = _b[0], setIsAddToCartNotificationShown = _b[1];
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useReducer"])(productDetailContextReducer, __assign(__assign({}, initialState$6), { activeSku: sku })), 2), state = _c[0], dispatch = _c[1];
    var handleNotification = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (show) {
        setIsAddToCartNotificationShown(show);
    }, []);
    var activeVariant = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return getVariantInfo(product, productType, locale, state.activeSku, getProductImageUrls, staticsUrl);
    }, [staticsUrl, getProductImageUrls, locale, product, productType, state.activeSku]);
    var value = __assign(__assign({}, state), { activeVariant: activeVariant,
        dispatch: dispatch,
        product: product,
        productType: productType,
        staticsUrl: staticsUrl,
        getProductImageUrls: getProductImageUrls,
        getSolutionImageUrl: getSolutionImageUrl,
        isPrescriptionGlassesConfiguratorValidationStepEnabled: isPrescriptionGlassesConfiguratorValidationStepEnabled,
        renderAddToCartButton: renderAddToCartButton,
        useAddToCart: useAddToCart, isAddToCartNotificationShown: isCartV2Enabled ? false : isAddToCartNotificationShown, setIsAddToCartNotificationShown: isCartV2Enabled ? function () { return null; } : handleNotification });
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailContext.Provider, { value: value }, children);
};

var attributes = {
    addition: undefined,
    axis: undefined,
    baseCurve: undefined,
    color: undefined,
    cylinder: undefined,
    diameter: undefined,
    power: undefined,
};
var initialState$7 = {
    left: attributes,
    right: attributes,
};
var reducer$9 = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'set': {
            var _c = action.payload, key = _c.key, value = _c.value;
            return __assign(__assign({}, state), (_a = {}, _a[key] = __assign(__assign({}, state[key]), value), _a));
        }
        case 'clear': {
            var key = action.payload;
            if (key) {
                return __assign(__assign({}, state), (_b = {}, _b[key] = initialState$7[key], _b));
            }
            return initialState$7;
        }
        default:
            return state;
    }
};
var useAttributes = function () {
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useReducer(reducer$9, initialState$7), 2), attributes = _a[0], dispatch = _a[1];
    var setAttribute = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (eyeSide, attribute, value) {
        var _a;
        return dispatch({
            type: 'set',
            payload: {
                key: eyeSide,
                value: (_a = {}, _a[attribute] = value, _a),
            },
        });
    }, []);
    var reset = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function () {
        return dispatch({
            type: 'clear',
        });
    }, []);
    var clearEyeSide = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (eyeSide) {
        return dispatch({
            type: 'clear',
            payload: eyeSide,
        });
    }, []);
    var actions = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        clearEyeSide: clearEyeSide,
        reset: reset,
        setAttribute: setAttribute,
    }); }, []);
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return [attributes, actions]; }, [actions, attributes]);
};

var useFetchBundle = function (bundleSku) {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useApiConfig */ "N"])(), apiKey = _a.apiKey, productsUrl = _a.productsUrl;
    var params = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () {
        return bundleSku
            ? {
                sku: bundleSku,
            }
            : null;
    }, [bundleSku]);
    var bundleRequestOptions = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({ skip: !params }); }, [params]);
    var _b = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].getContactLensBundles, bundleRequestOptions, productsUrl, params, apiKey), 2), data = _b[1];
    return data;
};

var upperFirst = function (value) {
    return value[0].toUpperCase() + value.slice(1);
};
var defaultLineItems = {
    leftLensSku: '',
    leftLensName: '',
    rightLensSku: '',
    rightLensName: '',
};
var convertAttributesToLineItems = function (_a) {
    var attributesState = _a.attributesState, bundleSku = _a.bundleSku, name = _a.name, sku = _a.sku, solutionSku = _a.solutionSku, solutionName = _a.solutionName;
    var productType = 'contact-lens-bundle';
    var eyeSides = Object.keys(attributesState);
    var eyeAttributes = eyeSides.reduce(function (result, eyeSide) {
        var _a;
        var lensAttributes = attributesState[eyeSide];
        var attributeKeys = Object.keys(lensAttributes);
        var lineItems = attributeKeys.reduce(function (eyeSideResult, attribute) {
            var _a;
            var lensAttributeName = eyeSide + "Lens" + upperFirst(attribute);
            var lensAttributeValue = lensAttributes[attribute];
            if (lensAttributeValue === undefined) {
                return eyeSideResult;
            }
            // Some values can be "- 5.25", parseFloat needs "-5.25"
            var cleanValue = lensAttributeValue.replace(/\s+/g, '');
            return __assign(__assign({}, eyeSideResult), (_a = {}, _a[lensAttributeName] = parseFloat(cleanValue), _a));
        }, {});
        return __assign(__assign(__assign({}, result), lineItems), (_a = {}, _a[eyeSide + "LensSku"] = sku, _a[eyeSide + "LensName"] = name, _a));
    }, defaultLineItems);
    // Remove undefined or empty string values
    var customAttributes = Object.entries(__assign(__assign({}, eyeAttributes), { solutionSku: solutionSku,
        solutionName: solutionName, type: productType })).reduce(function (result, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return value == null || value === '' ? result : __assign(__assign({}, result), (_b = {}, _b[key] = value, _b));
    }, {});
    return [{ sku: bundleSku, customAttributes: customAttributes }];
};

var LensBundleContext = Object(react__WEBPACK_IMPORTED_MODULE_10__["createContext"])(null);
var LensBundleProvider = function (_a) {
    var subscriptionProductSKU = _a.subscriptionProductSKU, children = _a.children;
    var data = useFetchBundle(subscriptionProductSKU);
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().locale;
    var bundle = data && data.results[0];
    var solutions = data && data.solutions;
    // Bridge between current lenses logic and bundle logic
    var _b = __read(useAttributes(), 2), attributesState = _b[0], attributeActions = _b[1];
    // When the solution changes, the requested sku is updated
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(''), 2), bundleSku = _c[0], setBundleSku = _c[1];
    // This sets the initial selected sku
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku) {
            setBundleSku(bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku);
        }
        else {
            console.error('LensBundleProvider: Missing contact lens bundle product');
        }
    }, [bundle]);
    var solution = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return solutions === null || solutions === void 0 ? void 0 : solutions.find(function (solution) { return solution.bundleSku === bundleSku; });
    }, [bundleSku, solutions]);
    // Based on the selected solution a price is calculated for each month
    var pricePerMonth = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return solution && solution.bundlePrice[0].value;
    }, [solution]);
    var lensSku = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        var _a, _b, _c, _d;
        if (bundle) {
            var productReference = (_b = (_a = bundle.masterVariant.attributes) === null || _a === void 0 ? void 0 : _a.find(function (attribute) { return attribute.name === 'bundleProduct1'; })) === null || _b === void 0 ? void 0 : _b.value;
            var lensMasterData = (_d = (_c = productReference === null || productReference === void 0 ? void 0 : productReference.obj) === null || _c === void 0 ? void 0 : _c.masterData) === null || _d === void 0 ? void 0 : _d.current;
            var sku = lensMasterData === null || lensMasterData === void 0 ? void 0 : lensMasterData.masterVariant.sku;
            return sku;
        }
    }, [bundle]);
    var lineItems = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return convertAttributesToLineItems({
            bundleSku: bundleSku,
            name: (bundle === null || bundle === void 0 ? void 0 : bundle.name) ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(bundle === null || bundle === void 0 ? void 0 : bundle.name, locale) : '',
            sku: lensSku,
            attributesState: attributesState,
            solutionName: (solution === null || solution === void 0 ? void 0 : solution.name) ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(solution === null || solution === void 0 ? void 0 : solution.name, locale) : undefined,
            solutionSku: solution === null || solution === void 0 ? void 0 : solution.sku,
        });
    }, [bundleSku, bundle, lensSku, attributesState, solution, locale]);
    var context = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        bundleSku: bundleSku,
        pricePerMonth: pricePerMonth,
        attributes: {
            state: attributesState,
            actions: attributeActions,
        },
        lineItems: lineItems,
        solutions: {
            onSolutionChange: function (sku, onChanged) {
                setBundleSku(sku);
                onChanged && onChanged();
            },
            activeSolution: solution,
            items: (data === null || data === void 0 ? void 0 : data.solutions) || [],
        },
    }); }, [attributesState, lineItems, bundle, bundleSku]);
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensBundleContext.Provider, { value: context }, children);
};
var useLensBundle = function () {
    var context = Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(LensBundleContext);
    if (context === null) {
        throw new Error('Missing contact lens bundle provider. Make sure the page is wrapped with the LensBundleProvider');
    }
    return context;
};

var ConfiguratorContext = Object(react__WEBPACK_IMPORTED_MODULE_10__["createContext"])({});
var useConfiguratorContext = function () { return Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(ConfiguratorContext); };
var ConfiguratorProvider = function (_a) {
    var children = _a.children, opticianForm = _a.opticianForm, noAddOnsImage = _a.noAddOnsImage, isPrescriptionFileEnabled = _a.isPrescriptionFileEnabled;
    var value = {
        opticianForm: opticianForm,
        noAddOnsImage: noAddOnsImage,
        isPrescriptionFileEnabled: isPrescriptionFileEnabled,
    };
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorContext.Provider, { value: value }, children);
};

var animations = {
    expanded: {
        height: 'auto',
        overflow: 'auto',
        transition: {
            ease: 'easeOut',
            duration: 0.2,
        },
    },
    collapsed: {
        height: '0px',
        overflow: 'hidden',
        transition: {
            ease: 'easeIn',
            duration: 0.2,
        },
    },
};
var Expander = function (_a) {
    var isExpanded = _a.isExpanded, children = _a.children;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(framer_motion__WEBPACK_IMPORTED_MODULE_16__[/* motion */ "b"].div, { initial: animations.collapsed, animate: isExpanded ? animations.expanded : animations.collapsed, "aria-hidden": !isExpanded, className: "configurator-footer-expander" }, children));
};

var ExpanderContainer = function (_a) {
    var children = _a.children;
    var isFooterOpen$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isFooterOpen);
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Expander, { isExpanded: isFooterOpen$1 }, children);
};

var FrameInformation = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, imageUrl = _a.imageUrl, _b = _a.showImage, showImage = _b === void 0 ? true : _b, _c = _a.textOrientation, textOrientation = _c === void 0 ? 'vertical' : _c;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": "frame-information", className: "frame-information frame-information--" + textOrientation },
        showImage && imageUrl && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { src: imageUrl, alt: title + " " + subtitle, className: "frame-information__image" })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "frame-information__text" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { variant: "subheading1", className: "frame-information__title" }, title),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "frame-information__subtitle" }, subtitle))));
};

var FrameInformationContainer = function (props) {
    var _a = useProductDetailContext(), staticsUrl = _a.staticsUrl, getProductImageUrls = _a.getProductImageUrls;
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var image = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(function (s) {
        return getFrameImage$1(s, { width: 100, staticsUrl: staticsUrl, getProductImageUrls: getProductImageUrls });
    });
    if (!frame) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(FrameInformation, __assign({}, props, { title: frame.brand, subtitle: frame.code, imageUrl: image === null || image === void 0 ? void 0 : image.url })));
};

var ConfigurationSummaryDivider = function (_a) {
    var isSmallScreen = _a.isSmallScreen;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "configuration-summary-divider" }, isSmallScreen ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Line, null)) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Line, null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Line, null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Line, null)))));
};
var Line = function () { return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], { className: "configuration-summary-divider__line" }); };

var PriceTagOrIncluded = function (props) {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _a.getLabel, hasLabel = _a.hasLabel;
    var originalPrice = props.originalPrice, discountedPrice = props.discountedPrice, discountText = props.discountText, className = props.className;
    if (originalPrice === 0) {
        var labelKey = 'products.glasses.configurator.priceIsZero';
        return hasLabel(labelKey) ? Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: className }, getLabel(labelKey)) : null;
    }
    if (discountedPrice === 0 && discountText && (discountText === null || discountText === void 0 ? void 0 : discountText.length) > 0) {
        return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: className }, discountText);
    }
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* PriceTag */ "X"], __assign({}, props));
};

var ConfigurationSummaryRow = function (_a) {
    var label = _a.label, value = _a.value, price = _a.price, discountText = _a.discountText;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "configuration-summary-row", "data-t": "configuration-summary-row" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", null,
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("strong", { className: "configuration-summary-row__label" }, label || ''),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "configuration-summary-row__value" }, value || '')),
        typeof (price === null || price === void 0 ? void 0 : price.originalPrice) !== 'undefined' && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PriceTagOrIncluded, __assign({}, price, { discountText: discountText })))));
};

var ConfigurationSummary = function (_a) {
    var labels = _a.labels, frame = _a.frame, addOn = _a.addOn, lensType = _a.lensType, lensPackage = _a.lensPackage, bundlePrice = _a.bundlePrice, isPhone = _a.isPhone, isSmallScreen = _a.isSmallScreen, hasVisitedStepLensPackage = _a.hasVisitedStepLensPackage, hasVisitedStepAddOn = _a.hasVisitedStepAddOn;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
        frame && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(FrameInformationContainer, { showImage: isPhone, textOrientation: isPhone ? 'vertical' : 'horizontal' }), price: frame.price })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configuration-summary", "data-t": "configuration-summary" },
            lensType && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryDivider, { isSmallScreen: isSmallScreen }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.lensType, value: getBundleProductTitle(lensType), price: lensType.price, discountText: lensType.discountText }))),
            hasVisitedStepLensPackage && lensPackage && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.lensPackage, value: lensPackage.title, price: lensPackage.price, discountText: lensPackage.discountText })),
            hasVisitedStepAddOn && addOn && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.addOn, value: getBundleProductTitle(addOn), price: addOn.price, discountText: addOn.discountText })),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryDivider, { isSmallScreen: isSmallScreen }),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryRow, { zeroPriceLabel: labels.zeroPrice, label: labels.totalPrice, price: bundlePrice, priceSize: "medium" }))));
};

var ConfigurationSummaryContainer = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var hasVisitedStepLensPackage$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(hasVisitedStepLensPackage);
    var hasVisitedStepAddOn$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(hasVisitedStepAddOn);
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var lensType = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedLensType$1);
    var lensPackage = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedPackage$1);
    var addOn = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedAddOn$1);
    var bundlePrice = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getBundlePrice);
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        lensType: getLabel('products.glasses.configurator.lensType'),
        lensPackage: getLabel('products.glasses.configurator.lensPackage'),
        addOn: getLabel('products.glasses.configurator.addOn'),
        totalPrice: getLabel('products.glasses.configurator.totalPrice'),
        zeroPrice: getLabel('products.glasses.configurator.priceIsZero'),
    }); }, [getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummary, { frame: frame, lensType: lensType, lensPackage: lensPackage, addOn: addOn, bundlePrice: bundlePrice, labels: labels, isPhone: isPhone, isSmallScreen: isSmallScreen, hasVisitedStepLensPackage: hasVisitedStepLensPackage$1, hasVisitedStepAddOn: hasVisitedStepAddOn$1 }));
};

var Wrapper = function (_a) {
    var children = _a.children, title = _a.title;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-prescription-column" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("strong", { className: "glasses-configurator-footer-prescription-column__title" }, title),
        children));
};
var PrescriptionSummaryColumn = function (_a) {
    var title = _a.title, labels = _a.labels, parameters = _a.parameters, fields = _a.fields, prescriptionType = _a.prescriptionType;
    var sortedParameterNames = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* sortPrescriptionParameters */ "F"])((parameters || []).map(function (p) { return p.name; }));
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType) && fields && parameters) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Wrapper, { title: title },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("ol", { className: "glasses-configurator-footer-prescription-column__fields" }, sortedParameterNames.map(function (name) {
                return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNumber */ "z"])(fields[name]) ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionColumnRow, { key: name, name: name, label: labels[name], value: fields[name] })) : null;
            }))));
    }
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isExistingCustomer(prescriptionType)) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Wrapper, { title: title },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "body" }, labels.existingCustomer)));
    }
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isEmailPrescription(prescriptionType)) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Wrapper, { title: title },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "body" }, labels.emailPrescription)));
    }
    return null;
};
var PrescriptionColumnRow = function (_a) {
    var label = _a.label, name = _a.name, value = _a.value;
    var _b;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "glasses-configurator-footer-prescription-column__row" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "glasses-configurator-footer-prescription-column__label" }, label + " "),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("strong", { className: "glasses-configurator-footer-prescription-column__value" }, (_b = _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* PrescriptionValueUtils */ "d"].formatPrescriptionValue(name, value)) !== null && _b !== void 0 ? _b : '')));
};

var PrescriptionSummary = function (_a) {
    var parameters = _a.parameters, right = _a.right, left = _a.left, labels = _a.labels, prescriptionType = _a.prescriptionType;
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType)) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-prescription", "data-t": "prescription-summary" },
            Object.keys(right).length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionSummaryColumn, { title: labels.rightEye, fields: right, parameters: parameters, prescriptionType: prescriptionType, labels: labels })),
            Object.keys(left).length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionSummaryColumn, { title: labels.leftEye, fields: left, parameters: parameters, prescriptionType: prescriptionType, labels: labels }))));
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-prescription", "data-t": "prescription-summary" }, !_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionSummaryColumn, { title: labels.prescriptionTitle, labels: labels, prescriptionType: prescriptionType }))));
};

var PrescriptionSummaryContainer = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var prescription = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescription$2);
    var hasVisitedStepPrescription$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(hasVisitedStepPrescription);
    var prescriptionType = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescriptionType$2);
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(prescription)) {
            return {};
        }
        var parameters = prescription.result.parameters;
        var paramLabels = parameters.reduce(function (acc, _a) {
            var _b;
            var name = _a.name;
            return (__assign(__assign({}, acc), (_b = {}, _b[name] = getLabel("products.glasses.prescription." + name), _b)));
        }, {});
        return __assign(__assign({}, paramLabels), { rightEye: getLabel('products.glasses.rightEye'), leftEye: getLabel('products.glasses.leftEye'), prescriptionTitle: getLabel('products.glasses.configurator.footer.prescription.title'), existingCustomer: getLabel('products.glasses.configurator.footer.existingCustomer'), emailPrescription: getLabel('products.glasses.configurator.footer.emailPrescription') });
    }, [getLabel, prescription]);
    if (!hasVisitedStepPrescription$1) {
        return null;
    }
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(prescription)) {
        return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("p", null, getLabel('products.glasses.prescription.loadingFailed'));
    }
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prescription)) {
        return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Loader */ "L"], null);
    }
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(prescription)) {
        return null;
    }
    var _a = prescription.result, right = _a.right, left = _a.left, parameters = _a.parameters;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionSummary, { prescriptionType: prescriptionType, parameters: parameters, right: right, left: left, labels: labels }));
};

var ExpanderContent = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-expander-content" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-expander-content__summary" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationSummaryContainer, null)),
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-expander-content__prescription" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionSummaryContainer, null)))); };

var CallToAction = function (_a) {
    var formId = _a.formId, label = _a.label, isLoading = _a.isLoading, isSmallScreen = _a.isSmallScreen;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { type: "submit", "data-t": "cta-button", caption: label, form: formId, isLoading: isLoading, size: isSmallScreen ? 'custom' : 'medium', className: "configurator-footer-cta" }));
};

var STEP_FORM_ID = 'configurator-step-form';

var CallToActionContainer = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var addToCartCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddToCartCall);
    var isOnLastStep = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isLastStep);
    var label = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return isOnLastStep
            ? getLabel('products.glasses.configurator.addToCart')
            : getLabel('products.glasses.configurator.footer.CTA');
    }, [isOnLastStep, getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CallToAction, { label: label, isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(addToCartCall), isSmallScreen: isSmallScreen, formId: STEP_FORM_ID }));
};

var ConfigurationTotalPrice = function (_a) {
    var originalPrice = _a.originalPrice, discountedPrice = _a.discountedPrice, rest = __rest(_a, ["originalPrice", "discountedPrice"]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "configuration-total-price-wrapper" },
        discountedPrice && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], __assign({}, rest, { type: "strikethrough", value: originalPrice, className: "configuration-total-price" }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], __assign({}, rest, { value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : originalPrice, className: "configuration-total-price" }))));
};

var ConfigurationTotalPriceContainer = function () {
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var bundlePrice = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getBundlePrice);
    if (!bundlePrice || !bundlePrice.originalPrice) {
        return null;
    }
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationTotalPrice, __assign({ centAmount: true, size: isPhone ? 'small' : 'large' }, bundlePrice));
};

var ExpanderToggle = function (_a) {
    var label = _a.label, isExpanded = _a.isExpanded, onToggleClick = _a.onToggleClick;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* IconButton */ "w"], { outline: true, onClick: onToggleClick, "aria-expanded": isExpanded, "aria-label": label, "data-t": "expander-toggle", className: "configurator-footer-expander-toggle" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "chevron-up", height: 18, width: 18 })));
};

var ExpanderToggleContainer = function (props) {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isFooterOpen$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isFooterOpen);
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var onToggle = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        dispatch(toggleFooter());
    }, []);
    var label = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return getLabel('products.glasses.configurator.footer.toggle'); }, [
        getLabel,
    ]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderToggle, __assign({}, props, { label: label, isExpanded: isFooterOpen$1, onToggleClick: onToggle })));
};

var TopBar = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-topbar" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-topbar__aside" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(FrameInformationContainer, null)),
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "glasses-configurator-footer-topbar__main" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationTotalPriceContainer, null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderToggleContainer, null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CallToActionContainer, null)))); };

var ConfiguratorFooter = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("footer", { "data-t": "glasses-configurator-footer", className: "glasses-configurator-footer" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(TopBar, null),
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderContainer, null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderContent, null)))); };

var ConfiguratorHeader = function (_a) {
    var className = _a.className, currentStepIndex = _a.currentStepIndex, disableSteps = _a.disableSteps, stepLabelNamespace = _a.stepLabelNamespace, skipSteps = _a.skipSteps, stepNames = _a.stepNames, rest = __rest(_a, ["className", "currentStepIndex", "disableSteps", "stepLabelNamespace", "skipSteps", "stepNames"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var stepLabels = stepNames.map(function (name) {
        return getLabel("products." + stepLabelNamespace + ".configurator.step." + name);
    });
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('configurator-header', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* WizardProgress */ "ub"], { steps: stepLabels, active: currentStepIndex, disableSteps: disableSteps, skipSteps: skipSteps, labelStyle: isPhone ? 'hidden' : 'inline' })));
};

var ConfiguratorHeaderContainer = function () {
    var steps = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSteps);
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    var stepNames = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return steps.map(function (s) { return s.name; }); }, [steps]);
    // We disable all steps from the active step onwards, because we don't support jumping forward by clicking in the header
    var disableSteps = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return Array.from(stepNames, function (_, i) { return i; }).slice(currentStep + 1); }, [stepNames, currentStep]);
    var skipSteps = steps.reduce(function (acc, step, i) { return (step.skip ? __spread(acc, [i]) : acc); }, []);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorHeader, { stepNames: stepNames, currentStepIndex: currentStep, disableSteps: disableSteps, skipSteps: skipSteps, stepLabelNamespace: "glasses" }));
};

var ConfiguratorStep = function (_a) {
    var children = _a.children, className = _a.className, title = _a.title, description = _a.description, rest = __rest(_a, ["children", "className", "title", "description"]);
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('configurator-step', className), "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { component: "h2", variant: isPhone ? 'subheading1' : 'medium', align: isPhone ? 'left' : 'center', className: "configurator-step__heading" }, title),
        description && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('configurator-step__description', className + "__description"), variant: "body", align: isPhone ? 'left' : 'center' }, description)),
        children));
};

var useStepFormSubmit = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var isOnLastStep = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isLastStep);
    var lineItemToBeAdded = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddToCartLineItem);
    var _a = useProductDetailContext(), useAddToCart = _a.useAddToCart, setIsAddToCartNotificationShown = _a.setIsAddToCartNotificationShown;
    var onAddToCartSuccess = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function () {
        dispatch(addSuccess());
        setIsAddToCartNotificationShown(true);
    }, [dispatch, setIsAddToCartNotificationShown]);
    var onValidationError = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (validationCodes) {
        dispatch(addFailed(new Error("Add to cart failed with following validation errors: " + validationCodes.join(', '))));
        validationCodes.forEach(function (code) { return _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* toast */ "vb"].failed("cart." + code); });
    }, [dispatch]);
    var onError = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (errorCode) {
        dispatch(addFailed(new Error("Add to cart failed with following error code: " + errorCode)));
        _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* toast */ "vb"].failed("cart." + errorCode);
    }, [dispatch]);
    /**
     * Officially we are conditionally calling a hook here. In this case it's not an issue, as the hook
     * will either always be there or always be undefined. There won't be a difference between renders.
     * We're either always calling it, or always ignoring it, depending on whether CARTS_V2 is enabled.
     */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _b = __read(useAddToCart ? useAddToCart() : [undefined], 2), addToCart$1 = _b[0], addToCartResult = _b[1];
    // This makes sure the loading state resets when the addToCart call fails
    react__WEBPACK_IMPORTED_MODULE_10___default.a.useEffect(function () {
        if (addToCartResult === null || addToCartResult === void 0 ? void 0 : addToCartResult.error) {
            dispatch(addFailed(addToCartResult.error));
        }
        // Being a bit cautious about showing errors. We only dispatch error when error flips from `undefined` to error`
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeof (addToCartResult === null || addToCartResult === void 0 ? void 0 : addToCartResult.error) !== 'undefined']);
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (!isOnLastStep) {
            dispatch(nextStep());
        }
        else if (addToCart$1) {
            // if addToCart is defined, then use the carts-v2 method for adding to cart
            var draftLineItems = lineItemToBeAdded ? [lineItemToBeAdded] : [];
            dispatch(add());
            addToCart$1(draftLineItems, onAddToCartSuccess, onValidationError, onError);
        }
        else {
            // if addToCart is not defined, add to cart with the carts-v1 method
            dispatch(addToCart());
        }
    }, [isOnLastStep, addToCart$1, lineItemToBeAdded, dispatch, onAddToCartSuccess]);
};
var StepForm = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    var handleFormSubmit = useStepFormSubmit();
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("form", { noValidate: true, onSubmit: handleFormSubmit, id: STEP_FORM_ID, "aria-label": rest['aria-label'], "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('step-form', className) }, children));
};
var ConnectedStepForm = function (_a) {
    var children = _a.children, initialFormState = _a.initialFormState, onChange = _a.onChange, className = _a.className, rest = __rest(_a, ["children", "initialFormState", "onChange", "className"]);
    var handleFormSubmit = useStepFormSubmit();
    var handleSubmit = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function () { return handleFormSubmit(); }, [handleFormSubmit]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Form */ "j"], { name: STEP_FORM_ID, "aria-label": rest['aria-label'], "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('step-form', className), initialFormState: initialFormState, onChange: onChange, onSubmit: handleSubmit }, children));
};

var ImageSection = function (_a) {
    var image = _a.image, alt = _a.alt, className = _a.className;
    if ('dimensions' in image) {
        var url = image.url, label = image.label, dimensions = image.dimensions;
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { src: url, alt: label ? label : alt, height: dimensions.h, width: dimensions.w, className: className }));
    }
    else {
        var description = image.description, original = image.original;
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { src: original.url, alt: description ? description : alt, height: original.height, width: original.width, className: className }));
    }
};
var RadioCardBody = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.alignment, alignment = _b === void 0 ? 'top' : _b, title = _a.title, description = _a.description, tag = _a.tag, image = _a.image, icon = _a.icon, imageClassName = _a.imageClassName, price = _a.price, discountText = _a.discountText, priceComment = _a.priceComment, _c = _a.withDivider, withDivider = _c === void 0 ? false : _c;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": "radio-card-body", className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('radio-card-body', className) },
        tag && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("em", { className: "radio-card-body__tag" }, tag),
        !tag && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "radio-card-body__tag radio-card-body__tag--hidden", "aria-hidden": "true" }, "\u00A0")),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('radio-card-body__content', "radio-card-body__content--align-" + alignment) },
            image && !icon && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ImageSection, { image: image, alt: title, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('radio-card-body__image', imageClassName) })),
            icon && !image && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "radio-card-body__icon" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: icon }))),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { className: "radio-card-body__header", component: "h3", variant: "smallest" }, title),
            description && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { className: "radio-card-body__description", variant: "caption-head" }, description)),
            children),
        withDivider && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], null),
        price && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "radio-card-body__price-wrapper" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PriceTagOrIncluded, __assign({}, price, { discountText: discountText })))),
        priceComment && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { className: "radio-card-body__price-comment", variant: "caption" }, priceComment))));
};

var RadioCard = function (_a) {
    var className = _a.className, isChecked = _a.isChecked, value = _a.value, id = _a.id, onChange = _a.onChange, rest = __rest(_a, ["className", "isChecked", "value", "id", "onChange"]);
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (e) { return onChange(e.currentTarget.value); }, [onChange]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* RadioButton */ "ab"], { name: name, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('radio-card', className), id: id, isChecked: isChecked, position: "bottom", onChange: handleChange, value: value, "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCardBody, __assign({}, rest))));
};

var SingleItemRadioCard = function (_a) {
    var cardClassName = _a.cardClassName, rest = __rest(_a, ["cardClassName"]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Card */ "g"], { className: cardClassName },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCardBody, __assign({}, rest))));
};

var RadioCardWithVariants = function (_a) {
    var name = _a.name, variants = _a.variants, selectedVariantSku = _a.selectedVariantSku, onChange = _a.onChange, className = _a.className, rest = __rest(_a, ["name", "variants", "selectedVariantSku", "onChange", "className"]);
    var containsSelectedAddOn = variants.some(function (a) { return a.sku === selectedVariantSku; });
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (e) { return onChange(e.currentTarget.value); }, [onChange]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Card */ "g"], { "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('radio-card-with-variants', className, {
            'radio-card-with-variants--active': containsSelectedAddOn,
        }) },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCardBody, { title: rest.title, description: rest.description, image: rest.image, imageClassName: rest.imageClassName, tag: rest.tag, price: rest.price, discountText: rest.discountText }, variants.map(function (v) {
            var _a;
            var isChecked = v.sku === selectedVariantSku;
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* RadioButton */ "ab"], { key: v.sku, name: name, variant: "plain", position: "left", value: v.sku, isChecked: isChecked, onChange: handleChange, className: "radio-card-with-variants__variant-item" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { alt: "", src: (_a = v.image) === null || _a === void 0 ? void 0 : _a.url, className: "radio-card-with-variants__variant-item-image" }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "radio-card-with-variants__variant-item-label" }, v.title)));
        }))));
};

var BundleProductRadioCard = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, id = _a.id, productInfo = _a.productInfo, selectedVariantSku = _a.selectedVariantSku, showPriceAsZero = _a.showPriceAsZero, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "id", "productInfo", "selectedVariantSku", "showPriceAsZero", "value", "onChange"]);
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () { return onChange(productInfo); }, [onChange, productInfo]);
    var description = productInfo.description, image = productInfo.image, price = productInfo.price, title = productInfo.title, discountText = productInfo.discountText;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var handleVariantChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (sku) {
        var _a;
        var addOn = (_a = productInfo.variants) === null || _a === void 0 ? void 0 : _a.find(function (v) { return v.sku === sku; });
        addOn && onChange(addOn);
    }, [productInfo.variants, onChange]);
    var zeroPriceLabel = showPriceAsZero
        ? undefined
        : getLabel('products.glasses.configurator.priceIsZero');
    var sharedProps = {
        className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('bundle-product-radio-card', className),
        alignment: 'bottom',
        title: title,
        description: description,
        image: image,
        imageClassName: 'bundle-product-radio-card__image',
        price: price,
        zeroPriceLabel: zeroPriceLabel,
        discountText: discountText,
        'data-t': rest['data-t'],
    };
    if ((_b = productInfo.variants) === null || _b === void 0 ? void 0 : _b.length) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCardWithVariants, __assign({}, sharedProps, { variants: productInfo.variants, selectedVariantSku: selectedVariantSku, onChange: handleVariantChange })));
    }
    var isChecked = selectedVariantSku === productInfo.sku;
    // Check if this is the dummy lens add-on and if it's checked
    if (selectedVariantSku === undefined && productInfo.sku === '') {
        isChecked = true;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCard, __assign({}, sharedProps, { id: id !== null && id !== void 0 ? id : value + "-radio", isChecked: isChecked, value: value, onChange: handleChange })));
};

/*
 * This component is used to show the "No Add-ons" option in the frontend.
 * No value is returned when it is selected, and nothing is returned to the BE when the user proceeds to checkout.
 */
var DummyLensAddOn = function (_a) {
    var children = _a.children, className = _a.className, selectedLensAddOnSku = _a.selectedLensAddOnSku, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "selectedLensAddOnSku", "onChange"]);
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () { return onChange(); }, [onChange]);
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, currency = _b.currency;
    var noAddOnsImage = useConfiguratorContext().noAddOnsImage;
    var productInfo = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        variants: [],
        isDefault: false,
        sku: '',
        title: getLabel('products.glasses.lensAddOn.noAddOn.title'),
        price: {
            originalPrice: 0,
            currency: currency,
        },
        image: noAddOnsImage,
    }); }, [noAddOnsImage, getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(BundleProductRadioCard, { className: className, id: "dummy-add-on-radio", productInfo: productInfo, selectedVariantSku: selectedLensAddOnSku, value: "", onChange: handleChange, showPriceAsZero: true, "data-t": rest['data-t'] }));
};

var LensAddOnStep = function (_a) {
    var children = _a.children, className = _a.className, lensAddOns = _a.lensAddOns, selectedLensAddOn = _a.selectedLensAddOn, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "lensAddOns", "selectedLensAddOn", "onChange"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var stepTitle = getLabel('products.glasses.lensAddOn.title');
    var selectedLensAddOnSku = selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.sku;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('lens-add-on-step', className), title: stepTitle, description: getLabel('products.glasses.lensAddOn.description'), "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(StepForm, { "aria-label": stepTitle },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-add-on-step__scroll-container" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-add-on-step__scroll-container__inner" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-add-on-step__list" },
                        lensAddOns.map(function (lensAddOn) {
                            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(BundleProductRadioCard, { "data-t": rest['data-t'] ? rest['data-t'] + "-" + lensAddOn.sku : undefined, className: "lens-add-on-step__list-item", productInfo: lensAddOn, selectedVariantSku: selectedLensAddOnSku, value: lensAddOn.sku, key: lensAddOn.sku, onChange: onChange }));
                        }),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(DummyLensAddOn, { className: "lens-add-on-step__list-item", onChange: onChange, selectedLensAddOnSku: selectedLensAddOnSku })))))));
};

var LensAddOnStepContainer = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var addOns = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddOns$1);
    var selectedAddOn = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedAddOn$1);
    var onChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (args) {
        if (!frame) {
            return;
        }
        if (!(args === null || args === void 0 ? void 0 : args.sku)) {
            dispatch(resetSelectedAddOn({ frameSku: frame.sku, reason: 'user selection' }));
        }
        else {
            dispatch(selectAddOn({
                frameSku: frame.sku,
                addOnSku: args.sku,
                reason: 'user selection',
            }));
        }
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(addOns)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(LensAddOnStep, { onChange: onChange, lensAddOns: addOns.result, selectedLensAddOn: selectedAddOn }));
};

var LensPackage = function (_a) {
    var className = _a.className, lensPackage = _a.lensPackage, isChecked = _a.isChecked, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["className", "lensPackage", "isChecked", "value", "onChange"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isTabletPortrait = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsTabletPortrait();
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () { return onChange(lensPackage); }, [onChange, lensPackage]);
    var title = lensPackage.title, description = lensPackage.description, price = lensPackage.price, discountText = lensPackage.discountText, tag = lensPackage.tag, usps = lensPackage.usps;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCard, { "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('lens-package', className), id: value + "-radio", isChecked: isChecked, onChange: handleChange, value: value, tag: tag, title: title, description: description, price: price, discountText: discountText, zeroPriceLabel: getLabel('products.glasses.lensPackage.priceIsZero') },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-package__content" },
            !!usps && !!usps.length && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], null),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-package__usp-list-wrapper" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* List */ "K"], { type: isTabletPortrait ? 'default' : 'checkmark-small', items: usps, renderText: function (item) { return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "caption-head" }, item); }, className: "lens-package__usp-list" })),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], { className: "lens-package__bottom-divider" }))));
};

var LensPackageStep = function (_a) {
    var className = _a.className, lensPackages = _a.lensPackages, selectedLensPackage = _a.selectedLensPackage, onChange = _a.onChange, rest = __rest(_a, ["className", "lensPackages", "selectedLensPackage", "onChange"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var stepTitle = getLabel('products.glasses.lensPackage.title');
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('lens-package-step', className), title: stepTitle, description: getLabel('products.glasses.lensPackage.description'), "data-t": rest['data-t'] },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(StepForm, { "aria-label": stepTitle },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "lens-package-step__scroll-container" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "lens-package-step__scroll-container__inner" },
                    react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "lens-package-step__list" }, lensPackages.map(function (lensPackage) {
                        var isChecked = (selectedLensPackage === null || selectedLensPackage === void 0 ? void 0 : selectedLensPackage.sku) === lensPackage.sku;
                        return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(LensPackage, { "data-t": rest['data-t'] ? rest['data-t'] + "-" + lensPackage.sku : undefined, isChecked: isChecked, className: "lens-package-step__list-item", lensPackage: lensPackage, value: lensPackage.sku, key: lensPackage.sku, onChange: onChange }));
                    })))))));
};

var LensPackageStepContainer = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var lensPackages = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPackages$2);
    var selectedLensPackage = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedPackage$1);
    var onChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (lensPackage) {
        if (!frame) {
            return;
        }
        dispatch(selectPackage({
            frameSku: frame.sku,
            packageSku: lensPackage.sku,
            reason: 'user selection',
        }));
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensPackages)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(LensPackageStep, { selectedLensPackage: selectedLensPackage, onChange: onChange, lensPackages: lensPackages.result }));
};

var LensTypeStep = function (_a) {
    var children = _a.children, className = _a.className, lensTypeInfoList = _a.lensTypeInfoList, selectedLensType = _a.selectedLensType, onChange = _a.onChange, rest = __rest(_a, ["children", "className", "lensTypeInfoList", "selectedLensType", "onChange"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var stepTitle = getLabel('products.glasses.lensType.title');
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('lens-type-step', className), title: stepTitle, "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(StepForm, { "aria-label": stepTitle },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-type-step__list" }, lensTypeInfoList.map(function (lensTypeInfo) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(BundleProductRadioCard, { className: "lens-type-step__list-item", productInfo: lensTypeInfo, selectedVariantSku: selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku, value: lensTypeInfo.sku, onChange: onChange, key: lensTypeInfo.sku, "data-t": rest['data-t'] ? rest['data-t'] + "-" + lensTypeInfo.sku : undefined })); })))));
};

var LensTypeStepContainer = function (_a) {
    var className = _a.className;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var lensTypes = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getLensTypes$2);
    var selectedLensType = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedLensType$1);
    var onChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (lensType) {
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: lensType.sku,
            reason: 'user selection',
        }));
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(lensTypes)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(LensTypeStep, { className: className, onChange: onChange, lensTypeInfoList: lensTypes.result, selectedLensType: selectedLensType }));
};

var getOptions = function (values, prescriptionAttribute) {
    var formatter = _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* PrescriptionValueUtils */ "d"].getFormatter(prescriptionAttribute);
    return Array.from(values).reduce(function (acc, value) {
        var _a;
        var formattedValue = formatter(value);
        if (formattedValue) {
            return __assign(__assign({}, acc), (_a = {}, _a[formattedValue] = value, _a));
        }
        else {
            console.error("Error formatting prescription value " + value + " for attribute: " + prescriptionAttribute);
            return acc;
        }
    }, {});
};
var PrescriptionSelect = Object(react__WEBPACK_IMPORTED_MODULE_10__["memo"])(function (_a) {
    var name = _a.name, parentId = _a.parentId, values = _a.values, selectClassName = _a.selectClassName, onChange = _a.onChange, errorMessageId = _a.errorMessageId, value = _a.value, isValid = _a.isValid, isDisabled = _a.isDisabled;
    var _b;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var options = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return getOptions(values, name); }, [values, name]);
    var sortOptions = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (a, b) { return Number(a) - Number(b); }, []);
    var formattedValue = (_b = _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* PrescriptionValueUtils */ "d"].formatPrescriptionValue(name, value)) !== null && _b !== void 0 ? _b : '';
    var valueAsString = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({ value: isPrescriptionValue(value) && values.has(value) ? formattedValue : '' }); }, [values, value, formattedValue]);
    var _c = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        selectId: parentId + "-" + name + "-select",
        labelId: parentId + "-" + name + "-label",
        selectName: "prescription-select-" + name,
    }); }, [parentId, name]), selectId = _c.selectId, labelId = _c.labelId, selectName = _c.selectName;
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (newValue) {
        onChange(name, newValue);
    }, [onChange, name]);
    var isInvalid = isValid === false;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription-column__label-wrapper" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("label", { id: labelId, htmlFor: selectId, className: "prescription-column__label" }, getLabel("products.glasses.prescription." + name)),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tooltip */ "sb"], { id: parentId + "-" + name + "-tooltip", greyedOut: isDisabled, className: "prescription-column__tooltip", message: getLabel("products.glasses.prescription." + name + ".tooltip") })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Select */ "A"], { id: selectId, "aria-labelledby": labelId + " " + parentId, "aria-describedby": errorMessageId, "aria-invalid": isInvalid, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-column__select', selectClassName), options: options, sortOptionsBy: sortOptions, initialState: valueAsString, onChange: handleChange, name: selectName, "data-t": selectName, placeholder: "---" })));
});
var PrescriptionColumn = function (_a) {
    var id = _a.id, className = _a.className, hideSelectLabels = _a.hideSelectLabels, columnTitle = _a.columnTitle, errorMessageId = _a.errorMessageId, parameters = _a.parameters, selectedValues = _a.selectedValues, validations = _a.validations, showValidation = _a.showValidation, onAttributeChange = _a.onAttributeChange, isDisabled = _a.isDisabled, rest = __rest(_a, ["id", "className", "hideSelectLabels", "columnTitle", "errorMessageId", "parameters", "selectedValues", "validations", "showValidation", "onAttributeChange", "isDisabled"]);
    var sortedParams = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* sortPrescriptionParameters */ "F"])(parameters.map(function (p) { return p.name; }));
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("fieldset", { "data-t": "prescription-column-fieldset", disabled: isDisabled, className: className },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-column', {
                'prescription-column--hide-labels': hideSelectLabels,
                'prescription-column--disabled': isDisabled,
            }) },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { component: "h3", variant: "subheading2", id: id, className: "prescription-column__title" }, columnTitle),
            sortedParams.map(function (paramName, index, array) {
                var parameter = parameters.find(function (p) { return p.name === paramName; });
                if (!parameter) {
                    return;
                }
                var parameterValue = selectedValues[parameter.name];
                var isParameterValid = showValidation ? validations === null || validations === void 0 ? void 0 : validations[parameter.name] : undefined;
                return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionSelect, { key: parameter.name, name: parameter.name, parentId: id, value: !isDisabled ? parameterValue : undefined, isValid: isParameterValid, isDisabled: isDisabled, values: parameter.values, onChange: onAttributeChange, selectClassName: classnames__WEBPACK_IMPORTED_MODULE_11___default()({
                        'prescription-column__select--first': index === 0,
                        'prescription-column__select--last': index === array.length - 1,
                    }) }));
            }))));
};
var PrescriptionColumn$1 = Object(react__WEBPACK_IMPORTED_MODULE_10__["memo"])(PrescriptionColumn);

var renderPdLink = function (intl) {
    var hasLabel = intl.hasLabel, getFormattedLabel = intl.getFormattedLabel;
    return hasLabel('products.glasses.prescription.form.pdLink') ? (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("p", { className: "prescription-form__pd-link" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "glasses", className: "prescription-form__pd-link-icon" }),
        ' ',
        getFormattedLabel('products.glasses.prescription.form.pdLink', {
            parseLink: true,
            openLinksInNewTab: true,
        }))) : null;
};
var PrescriptionForm = function (_a) {
    var idExtension = _a.idExtension, className = _a.className, prescription = _a.prescription, setLeftParameter = _a.setLeftParameter, setRightParameter = _a.setRightParameter, opticalParameters = _a.opticalParameters, prescriptionValidationState = _a.prescriptionValidationState, isSubmitted = _a.isSubmitted, isDisabled = _a.isDisabled, rest = __rest(_a, ["idExtension", "className", "prescription", "setLeftParameter", "setRightParameter", "opticalParameters", "prescriptionValidationState", "isSubmitted", "isDisabled"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(StepForm, { "aria-label": getLabel('products.glasses.prescription.title'), className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-form', className), "data-t": rest['data-t'] },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PrescriptionColumn$1, { className: "prescription-form__column", id: "right-configurator-" + idExtension, columnTitle: getLabel("products.glasses.rightEye"), parameters: opticalParameters, selectedValues: prescription.right, validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.right, showValidation: isSubmitted, onAttributeChange: setRightParameter, isDisabled: isDisabled }),
            isPhone && renderPdLink(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])()),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PrescriptionColumn$1, { className: "prescription-form__column", id: "left-configurator-" + idExtension, columnTitle: getLabel("products.glasses.leftEye"), parameters: opticalParameters, selectedValues: prescription.left, validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.left, showValidation: isSubmitted, onAttributeChange: setLeftParameter, hideSelectLabels: true, isDisabled: isDisabled })),
        renderPdLink(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])())));
};

var PrescriptionFormContainer = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var handleChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (side) { return function (parameter, value) {
        if (!frame) {
            return;
        }
        dispatch(updatePrescriptionValue({
            side: side,
            frameSku: frame.sku,
            parameter: parameter,
            value: value,
        }));
    }; }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    var prescription = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescription$2);
    var prescriptionType = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescriptionType$2);
    var prescriptionValidationState = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescriptionValidationState$1);
    var isSubmitted = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(showValidationErrorForCurrentStep);
    var isEnabled = !prescriptionType || _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType);
    var handleRightChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(handleChange('right'), [handleChange]);
    var handleLeftChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(handleChange('left'), [handleChange]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(prescription) || !frame) {
        // Loading / error states are handled further up the tree
        return null;
    }
    var _a = prescription.result, left = _a.left, right = _a.right, parameters = _a.parameters;
    var shouldDisplayValidationError = isSubmitted && isEnabled ? prescriptionValidationState : undefined;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PrescriptionForm, { "aria-label": getLabel('products.glasses.prescription.title'), className: "prescription-step__form", opticalParameters: parameters, prescription: { left: left, right: right }, prescriptionValidationState: shouldDisplayValidationError, idExtension: frame.sku, setLeftParameter: handleLeftChange, setRightParameter: handleRightChange, isSubmitted: isSubmitted, isDisabled: !isEnabled }));
};

var getRadioItems = function (getLabel, isPrescriptionFileEnabled) {
    var items = [
        {
            value: 'NewPrescription',
            label: getLabel('products.glasses.existingCustomerRadio.isNotExisting'),
        },
        {
            value: 'ExistingCustomer',
            label: getLabel('products.glasses.existingCustomerRadio.isExisting'),
        },
    ];
    return !isPrescriptionFileEnabled
        ? items
        : __spread(items, [
            {
                value: 'EmailPrescription',
                label: getLabel('products.glasses.existingCustomerRadio.isEmailPrescription'),
            },
        ]);
};
var PrescriptionStep = function (_a) {
    var className = _a.className, showValidationError = _a.showValidationError, frame = _a.frame, frameImage = _a.frameImage, prescriptionType = _a.prescriptionType, changePrescriptionType = _a.changePrescriptionType, rest = __rest(_a, ["className", "showValidationError", "frame", "frameImage", "prescriptionType", "changePrescriptionType"]);
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, hasLabel = _b.hasLabel;
    var isPrescriptionFileEnabled = useConfiguratorContext().isPrescriptionFileEnabled;
    var stepTitle = getLabel('products.glasses.prescription.title');
    var radioItems = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return getRadioItems(getLabel, isPrescriptionFileEnabled); }, [
        getLabel,
        isPrescriptionFileEnabled,
    ]);
    //creates a label like 'products.glasses.newPrescriptionRadio.alert'
    var alertLabelKey = prescriptionType
        ? "products.glasses." + (prescriptionType.charAt(0).toLowerCase() + prescriptionType.substring(1)) + "Radio.alert"
        : '';
    var onRadioChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (selected) {
        if (prescriptionType !== selected.value) {
            changePrescriptionType === null || changePrescriptionType === void 0 ? void 0 : changePrescriptionType(selected.value);
        }
    }, [changePrescriptionType, prescriptionType]);
    var alertRef = react__WEBPACK_IMPORTED_MODULE_10___default.a.createRef();
    react__WEBPACK_IMPORTED_MODULE_10___default.a.useEffect(function () {
        var _a, _b;
        if ('scrollBehavior' in document.documentElement.style) {
            (_a = alertRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        else {
            (_b = alertRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
        }
    }, [showValidationError]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-step', className), title: stepTitle, "data-t": rest['data-t'] || 'prescription-step' },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("fieldset", null,
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* RadioButtons */ "w"], { alignment: isPhone ? 'vertical' : 'horizontal', items: radioItems, scope: "prescription-type", onChange: onRadioChange, initialValue: prescriptionType !== null && prescriptionType !== void 0 ? prescriptionType : '', className: "prescription-step__radios" })),
        hasLabel(alertLabelKey) && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "info", icon: "information-circle", title: getLabel(alertLabelKey), className: "prescription-step__alert" })),
        showValidationError && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { ref: alertRef },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "error", icon: "alert-circle", title: getLabel('products.glasses.prescription.form.validationError'), className: "prescription-step__alert" }))),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-step__body" },
            !isPhone && frameImage && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-step__section" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("img", { src: frameImage.url, alt: frame.title, className: "prescription-step__image" }))),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-step__section" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PrescriptionFormContainer, null)))));
};

var PrescriptionStepContainer = function () {
    var _a = useProductDetailContext(), staticsUrl = _a.staticsUrl, getProductImageUrls = _a.getProductImageUrls;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frame = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedFrame);
    var frameImage = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(function (s) {
        return getFrameImage$1(s, { width: 590, staticsUrl: staticsUrl, getProductImageUrls: getProductImageUrls });
    });
    var showValidationError = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(showValidationErrorForCurrentStep);
    var prescription = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescription$2);
    var prescriptionType = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescriptionType$2);
    var prescriptionValidationState = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getPrescriptionValidationState$1);
    var handlePrescriptionTypeChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (value) {
        if (!frame) {
            return;
        }
        if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isPrescriptionType(value)) {
            dispatch(updatePrescriptionType({
                frameSku: frame.sku,
                prescriptionType: value,
                reason: 'user selection',
            }));
        }
    }, [dispatch, frame === null || frame === void 0 ? void 0 : frame.sku]);
    if (!prescription || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(prescription) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prescription)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Loading, null);
    }
    if (!frame || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusWarning */ "J"])(prescription) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(prescription)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Failed, null);
    }
    var isFormEnabled = !prescriptionType || _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isNewPrescription(prescriptionType);
    var shouldDisplayValidationError = showValidationError && isFormEnabled && !(prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.isValid);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PrescriptionStep, { showValidationError: shouldDisplayValidationError, frame: frame, frameImage: frameImage, prescriptionType: prescriptionType, changePrescriptionType: handlePrescriptionTypeChange }));
};
function Loading() {
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
}
function Failed() {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "error", title: getLabel('products.glasses.configurator.error'), className: "prescription-step__error" }));
}

var PrescriptionStepValidationStep = function (_a) {
    var className = _a.className, prescriptionInfoFormState = _a.prescriptionInfoFormState, showValidationError = _a.showValidationError, verificationAllowed = _a.verificationAllowed, onVerificationAllowedChange = _a.onVerificationAllowedChange, onChange = _a.onChange;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var stepTitle = getLabel('products.glasses.validationStep.title');
    var placeholderLabels = {
        dayPlaceholder: getLabel('common.placeholder.day.abbr'),
        monthPlaceholder: getLabel('common.placeholder.month.abbr'),
        yearPlaceholder: getLabel('common.placeholder.year.abbr'),
    };
    var verificationCheckbox = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        label: getLabel('products.glasses.validationStep.verificationAllowed.checkbox'),
        value: 'verificationAllowed',
    }); }, [getLabel]);
    var handleFormChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(Object(throttle_debounce__WEBPACK_IMPORTED_MODULE_18__["debounce"])(250, function (state) {
        onChange === null || onChange === void 0 ? void 0 : onChange(state.formState);
    }), [onChange]);
    var handleConsentChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (selectedItems) {
        onVerificationAllowedChange === null || onVerificationAllowedChange === void 0 ? void 0 : onVerificationAllowedChange(!!selectedItems.includes(verificationCheckbox));
    }, [onVerificationAllowedChange]);
    var opticianForm = useConfiguratorContext().opticianForm;
    var currentYear = new Date().getFullYear();
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-validation-step', className), title: stepTitle, "data-t": "prescription-validation-step" },
        showValidationError && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "error", icon: "alert-circle", title: getLabel('products.glasses.validationStep.form.validationError'), className: "prescription-validation-step__alert" })),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConnectedStepForm, { "aria-label": stepTitle, className: "prescription-validation-step__form", initialFormState: prescriptionInfoFormState, onChange: handleFormChange },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* DateOfBirthSelect */ "e"], __assign({ required: true, name: "expiryDate", label: getLabel('products.glasses.validationStep.expiryDate'), errorMessage: getLabel('products.glasses.validationStep.expiryDate.errorMessage'), validations: [_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Util */ "D"].validations.isDate], tooltipLabel: getLabel('products.glasses.validationStep.expiryDate.tooltip'), minYear: currentYear, maxYear: currentYear + 3 }, placeholderLabels)),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* DateOfBirthSelect */ "e"], __assign({ name: "examDate", label: getLabel('products.glasses.validationStep.examDate'), errorMessage: getLabel('products.glasses.validationStep.examDate.errorMessage'), tooltipLabel: getLabel('products.glasses.validationStep.examDate.tooltip'), validations: [_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Util */ "D"].validations.isDate], minYear: currentYear - 4 }, placeholderLabels)),
            opticianForm && opticianForm(),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* CheckboxList */ "k"], { idPrefix: "prescription_validation__", items: [verificationCheckbox], selectedItems: verificationAllowed ? [verificationCheckbox] : [], onChange: handleConsentChange, getItemIdentifier: function (item) { return item.value; }, renderItem: function (item) { return item.label; } }))));
};

var PrescriptionValidationStepContainer = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frameSku = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getFrameSku);
    var showValidationError = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(showValidationErrorForCurrentStep);
    var prescriptionInfoFormState = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAdditionalPrescriptionInfoFormState$1);
    var isVerificationAllowed = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getVerificationAllowed$1);
    var handleChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (formState) {
        if (!frameSku) {
            return;
        }
        dispatch(updatePrescriptionInfo({
            frameSku: frameSku,
            value: formState,
        }));
    }, [frameSku, dispatch]);
    var handleIsVerificationAllowedChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (verificationAllowed) {
        if (!frameSku) {
            return;
        }
        dispatch(updateVerificationAllowed({
            frameSku: frameSku,
            value: verificationAllowed,
        }));
    }, [frameSku, dispatch]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PrescriptionStepValidationStep, { prescriptionInfoFormState: prescriptionInfoFormState, verificationAllowed: isVerificationAllowed, onVerificationAllowedChange: handleIsVerificationAllowedChange, showValidationError: showValidationError, onChange: handleChange }));
};

var ConfiguratorMain = function (_a) {
    var children = _a.children, className = _a.className, currentStep = _a.currentStep, rest = __rest(_a, ["children", "className", "currentStep"]);
    var mainRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["createRef"])();
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useLayoutEffect"])(function () {
        var _a;
        if (!isPhone) {
            return;
        }
        (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [currentStep]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { ref: mainRef, "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('glasses-configurator-main', className) },
        currentStep === 'lensType' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensTypeStepContainer, null),
        currentStep === 'prescription' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionStepContainer, null),
        currentStep === 'prescriptionValidation' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionValidationStepContainer, null),
        currentStep === 'lensPackage' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensPackageStepContainer, null),
        currentStep === 'lensAddOn' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensAddOnStepContainer, null)));
};

var ConfiguratorMainContainer = function (_a) {
    var className = _a.className;
    var currentStepName = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getCurrentStep).name;
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorMain, { currentStep: currentStepName, className: className });
};

var Configurator = function (_a) {
    var dataT = _a["data-t"];
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { "data-t": dataT, className: "glasses-configurator" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorHeaderContainer, null),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorMainContainer, { className: "glasses-configurator__main" }),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorFooter, null)));
};

var ConfiguratorContainer = function (_a) {
    var frame = _a.frame, frameSku = _a.frameSku, formatProductUrl = _a.formatProductUrl, dataT = _a["data-t"];
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var isExtraValidationStepEnabled = useProductDetailContext().isPrescriptionGlassesConfiguratorValidationStepEnabled;
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        dispatch(startPrescriptionGlassesConfiguration({
            frame: frame,
            frameSku: frameSku,
            formatProductUrl: formatProductUrl,
            isExtraValidationStepEnabled: isExtraValidationStepEnabled,
        }));
    }, [frame, frameSku]);
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Configurator, { "data-t": dataT });
};

var ConfiguratorModal = function (_a) {
    var className = _a.className, frame = _a.frame, frameSku = _a.frameSku, rest = __rest(_a, ["className", "frame", "frameSku"]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Modal */ "Q"], __assign({}, rest, { "data-t": "glasses-configurator-modal", className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('glasses-configurator-modal', className), isFullScreen: true, showIcon: true }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorContainer, __assign({}, rest, { frame: frame, frameSku: frameSku }))));
};

var ConfiguratorModalContainer = function (props) {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var frameSku = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getFrameSku);
    var prevFrameSku = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Util */ "tb"].usePrevious(frameSku);
    var steps = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSteps);
    var bundlePrice = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getBundlePrice);
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        bundlePrice && props.onPriceChange(bundlePrice);
    }, [bundlePrice, props.onPriceChange]);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var _a, _b, _c;
        if (prevFrameSku && !frameSku) {
            (_a = props.onModalClose) === null || _a === void 0 ? void 0 : _a.call(props);
            (_c = (_b = props.triggerButtonRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
    }, [frameSku, prevFrameSku]);
    var previousSteps = steps.slice(0, currentStep);
    var isFirstStep = currentStep === 0;
    var allPreviousStepsSkipped = previousSteps.every(function (s) { return s.skip; });
    var handleBackClick = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        if (!isFirstStep) {
            dispatch(previousStep());
        }
    }, [dispatch, isFirstStep, previousStep]);
    var onBackClick = isFirstStep || allPreviousStepsSkipped ? undefined : handleBackClick;
    var backLabel = getLabel('common.actions.previous');
    var secondaryIconOptions = onBackClick && {
        'aria-label': backLabel,
        name: 'chevron-left',
        onClick: onBackClick,
        label: backLabel,
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorProvider, { opticianForm: props.opticianForm, noAddOnsImage: props.noAddOnsImage, isPrescriptionFileEnabled: props.isPrescriptionFileEnabled },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorModal, __assign({}, props, { secondaryIconOptions: secondaryIconOptions }))));
};
ConfiguratorModalContainer.displayName = 'ConfiguratorModal';

var ProductDetailDescription = function (_a) {
    var children = _a.children, description = _a.description, header = _a.header, title = _a.title, usps = _a.usps;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-description" },
        title && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { variant: "smallest", component: "h2" }, title)),
        usps,
        header && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { variant: "subheading1", className: "product-detail-description__subheading", component: "h3" }, header)),
        description && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "body" }, description),
        children));
};

var ProductDetailOpticsFeatures = function (_a) {
    var frame = _a.frame, antiReflex = _a.antiReflex, antiScratch = _a.antiScratch;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("ul", { className: "product-detail-optics-features" },
        !!frame && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-optics-features__feature" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "checkmark-circle", viewBox: "-1 -1 26 26" }),
            frame)),
        !!antiReflex && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-optics-features__feature" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "checkmark-circle", viewBox: "-1 -1 26 26" }),
            antiReflex)),
        antiScratch && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-optics-features__feature" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "checkmark-circle", viewBox: "-1 -1 26 26" }),
            antiScratch))));
};

var getAttributeFactory = function (_a) {
    var _b = _a.isLocalised, isLocalised = _b === void 0 ? false : _b, _c = _a.isSet, isSet = _c === void 0 ? false : _c;
    if ((!isLocalised && !isSet) || (!isLocalised && isSet)) {
        return _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"];
    }
    if (isLocalised && isSet) {
        return _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValues */ "p"];
    }
    return _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"];
};
/**
 *
 * Helper for converting specification data to a string format
 *
 * if a value is an array, that value has to be converted to a string of those values. ('blue'. 'red')
 * if a value is a boolean, that value has to be converted to ('yes'/'no')
 * if a value is a number, that value has to be converted to a string of that number. (preventing things like 8.5e10)
 *
 */
var getSpecificationItem = function (config, variant, getLabel, locale) {
    var getAttribute = getAttributeFactory(config);
    var attr = getAttribute(variant, config.attribute, locale);
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNil */ "y"])(attr) || attr === '') {
        return;
    }
    var value = attr;
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isArray */ "v"])(attr)) {
        value = attr.join(', ');
    }
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isBoolean */ "w"])(attr)) {
        value = attr ? getLabel('common.yes') : getLabel('common.no');
    }
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNumber */ "z"])(attr)) {
        value = attr.toString();
    }
    // Final check for when something unexpected happend
    if (!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isString */ "B"])(value)) {
        console.warn("Could not render " + config.labelKey + " because the received value is a " + typeof attr + " while expecting a string");
        return;
    }
    return {
        label: getLabel(config.labelKey),
        value: value,
    };
};

var SpecificationItem = function (_a) {
    var config = _a.config, variant = _a.variant;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    var item = getSpecificationItem(config, variant, getLabel, locale);
    if (!item) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-specification__item", "data-t": "specification-item" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("p", { className: "product-detail-specification__item--label" }, item.label),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-specification__item--value" }, item.value)));
};
var SpecificationItem$1 = Object(react__WEBPACK_IMPORTED_MODULE_10__["memo"])(SpecificationItem);

var ProductDetailSpecification = function (_a) {
    var configuration = _a.configuration, variant = _a.variant;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    if (!configuration || !variant) {
        return null;
    }
    var items = configuration.map(function (config) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SpecificationItem$1, { config: config, variant: variant, key: config.labelKey })); });
    if (!items.length) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-specification" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h4", { className: "product-detail-specification__title" }, getLabel('products.detail.specifications.title')),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-specification__list" }, items)));
};

var ProductDetailTitle = function (_a) {
    var brand = _a.brand, model = _a.model, href = _a.href;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-title" },
        !!href ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("a", { href: href, className: "product-detail-title__link" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { component: "h1", variant: "small", className: "product-detail-title__brand" }, brand))) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { component: "h1", variant: "small", className: "product-detail-title__brand" }, brand)),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-title__model" }, model)));
};
var ProductDetailTitle$1 = Object(react__WEBPACK_IMPORTED_MODULE_10__["memo"])(ProductDetailTitle);

var ProductDiscountLabel = function (_a) {
    var _b;
    var title = _a.title, modifier = _a.modifier;
    return title ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-discount-label', (_b = {},
            _b["product-discount-label--" + modifier] = !!modifier,
            _b)) },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-discount-label__title" }, title))) : null;
};
var ProductDiscountLabel$1 = Object(react__WEBPACK_IMPORTED_MODULE_10__["memo"])(ProductDiscountLabel);

var ProductTypeUspItem = function (_a) {
    var item = _a.item, className = _a.className;
    var icon = item.icon, text = item.text;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-type-usps__item" },
        icon && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-type-usps__icon" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: icon, width: 24, height: 24 }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-type-usps__message" }, text)));
};

var ProductTypeUsps = function (_a) {
    var productTypeUsps = _a.productTypeUsps, className = _a.className;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-type-usps', className) }, productTypeUsps.map(function (usp) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductTypeUspItem, { item: usp, key: usp.text })); })));
};

var ProductDetailImage = function (_a) {
    var image = _a.image, altText = _a.altText;
    var encodedImage = encodeURI(image); // Needed for url with spaces, which is not supported in srcSet
    var imgSuffix = "&fm=jpeg&auto=format";
    var sizes = "(min-width: 64em) calc(60vw - 30px), (min-width: 48em) calc(100vw - 1.5rem), 450w";
    var srcSet = encodedImage + "?w=450" + imgSuffix + " 450w, " + encodedImage + "?w=675" + imgSuffix + " 675w, " + encodedImage + "?w=1350" + imgSuffix + " 1350w";
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-image" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* ResponsiveImage */ "i"], { src: encodedImage + "?w=900" + imgSuffix, srcSet: srcSet, sizes: sizes, alt: altText })));
};

var VtoConfig = Object(react__WEBPACK_IMPORTED_MODULE_10__["createContext"])({ isEnabled: false });
var useVtoConfig = function () { return Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(VtoConfig); };

function loadDitto(sdkUrl) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (window.ditto ||
                    new Promise(function (resolve, reject) {
                        return load_script__WEBPACK_IMPORTED_MODULE_20___default()(sdkUrl, function (err) { return (err ? reject(err) : resolve(window.ditto)); });
                    }))];
        });
    });
}
function useHasVirtualTryOn(vtoId) {
    var vtoConfig = useVtoConfig();
    var _a = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), hasVto = _a[0], setHasVto = _a[1];
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var didCancel = false;
        runEffect();
        return function () {
            didCancel = true;
        };
        function runEffect() {
            return __awaiter(this, void 0, void 0, function () {
                var url, headers, _a, _b, ids;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!vtoId || !vtoConfig.isEnabled) {
                                return [2 /*return*/, setHasVto(false)];
                            }
                            url = vtoConfig.apiUrl + '/api/1.3/products';
                            _a = {
                                'X-Ditto-Access-Key-Id': vtoConfig.accessKey
                            };
                            _b = 'X-Ditto-Signature';
                            return [4 /*yield*/, vtoConfig.getSignature(vtoConfig.partnerId)];
                        case 1:
                            headers = (_a[_b] = _c.sent(),
                                _a);
                            return [4 /*yield*/, fetch(url, { headers: headers }).then(function (_) { return _.json(); })];
                        case 2:
                            ids = (_c.sent()).ids;
                            if (!didCancel) {
                                setHasVto(ids.includes(vtoId));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    }, [vtoId, vtoConfig]);
    return hasVto;
}
var dittoLocalesMap = {
    'nl-BE': 'nl-nl',
    'fr-BE': 'fr-fr',
    'en-IE': 'en-gb',
    'en-IO': 'pt-pt',
};
var getDittoLocale = function (locale) {
    var dittoLocale = locale.toLowerCase();
    if (locale in dittoLocalesMap) {
        dittoLocale = dittoLocalesMap[locale];
    }
    return dittoLocale;
};
function createVtoServerConfig(publicRuntimeDittoConfig, locale) {
    var apiUrl = publicRuntimeDittoConfig.apiUrl, partnerId = publicRuntimeDittoConfig.partnerId, sdkCompany = publicRuntimeDittoConfig.sdkCompany, sdkUrl = publicRuntimeDittoConfig.sdkUrl, sdkVersion = publicRuntimeDittoConfig.sdkVersion, accessKey = publicRuntimeDittoConfig.accessKey, signatureRoute = publicRuntimeDittoConfig.signatureRoute;
    var dittoLocale = getDittoLocale(locale);
    var composedSdkUrl = sdkUrl + "/" + sdkCompany + "/" + sdkVersion + "/" + dittoLocale + "/api.js";
    return {
        apiUrl: apiUrl,
        sdkUrl: composedSdkUrl,
        accessKey: accessKey,
        partnerId: partnerId,
        signatureRoute: signatureRoute,
    };
}
function useDittoId(onDeleteCallback) {
    var _this = this;
    var vtoConfig = useVtoConfig();
    var _a = __read(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* useLocalStorage */ "L"])('vto.dittoId', undefined, function (value) { return value === undefined; }), 2), dittoId = _a[0], setDittoId = _a[1];
    var deleteDittoId = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () { return __awaiter(_this, void 0, void 0, function () {
        var url, headers, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!vtoConfig.isEnabled) {
                        return [2 /*return*/];
                    }
                    if (!dittoId) return [3 /*break*/, 3];
                    setDittoId(undefined);
                    url = vtoConfig.apiUrl + ("/api/1.3/dittos/" + dittoId);
                    _a = {
                        'X-Ditto-Access-Key-Id': vtoConfig.accessKey
                    };
                    _b = 'X-Ditto-Signature';
                    return [4 /*yield*/, vtoConfig.getSignature(dittoId)];
                case 1:
                    headers = (_a[_b] = _c.sent(),
                        _a);
                    return [4 /*yield*/, fetch(url, { headers: headers, method: 'delete' })];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [dittoId]);
    var idRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])();
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (onDeleteCallback && dittoId === undefined && (idRef === null || idRef === void 0 ? void 0 : idRef.current) !== undefined) {
            onDeleteCallback();
        }
        idRef.current = dittoId;
    }, [dittoId]);
    return { dittoId: dittoId, setDittoId: setDittoId, deleteDittoId: deleteDittoId };
}
var vtoEvents = {
    'vto.close': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Close',
            eventLabel: "Product " + sku,
        });
    },
    'vto.creation.success': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Save',
            eventLabel: "Product " + sku,
        });
    },
    'vto.creation.error': function (_a) {
        var sku = _a.sku, status = _a.status, description = _a.description;
        return ({
            eventAction: 'Failure',
            eventLabel: "Product " + sku + " - Creation: error " + status + ", " + (description || ''),
        });
    },
    'vto.creation.view.intro': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Intro",
        });
    },
    'vto.creation.view.creation': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - Creation",
        });
    },
    'vto.tryon.view': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'View',
            eventLabel: "Product " + sku + " - TryOn",
        });
    },
    'vto.tryon.error': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Failure',
            eventLabel: "Product " + sku + " - TryOn: error unknown",
        });
    },
    'vto.tryon.initialized': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Initialize',
            eventLabel: "Product " + sku + " - TryOn",
        });
    },
    'vto.tryon.retake': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Retake',
            eventLabel: "Product " + sku + " - TryOn",
        });
    },
    'vto.tryon.delete': function (_a) {
        var sku = _a.sku;
        return ({
            eventAction: 'Delete',
            eventLabel: "Product " + sku + " - TryOn",
        });
    },
};
var vtoEvent = function (key, args) {
    if (!vtoEvents[key]) {
        console.warn("cannot send event '" + key + "', key does not exist");
        return;
    }
    var _a = vtoEvents[key](args), eventAction = _a.eventAction, eventLabel = _a.eventLabel;
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'VTOevent',
            eventCategory: 'Virtual Try-On',
            eventAction: eventAction,
            eventLabel: eventLabel,
        });
    }
};

/*
  This component should be loaded as soon as the user
  starts a VtoCreation process. This process will happen mostly in
  a modal.
*/
var VtoCreationStep;
(function (VtoCreationStep) {
    VtoCreationStep[VtoCreationStep["INTRO"] = 0] = "INTRO";
    VtoCreationStep[VtoCreationStep["CREATION"] = 1] = "CREATION";
})(VtoCreationStep || (VtoCreationStep = {}));
var CreateDitto = function (_a) {
    var onCreate = _a.onCreate, onCancel = _a.onCancel, onError = _a.onError, skipIntro = _a.skipIntro, sku = _a.sku;
    var vtoConfig = useVtoConfig();
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), hasAgreed = _b[0], setAgreement = _b[1];
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(skipIntro ? VtoCreationStep.CREATION : VtoCreationStep.INTRO), 2), activeStep = _c[0], setActiveStep = _c[1];
    var imgUrl = intl.getLabel('vto.imgUrl', { hideLabelKey: true });
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        switch (activeStep) {
            case VtoCreationStep.INTRO:
                return vtoEvent('vto.creation.view.intro', { sku: sku });
            case VtoCreationStep.CREATION:
                return vtoEvent('vto.creation.view.creation', { sku: sku });
        }
    }, [activeStep]);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var isCanceled = false;
        if (!vtoConfig.isEnabled || activeStep !== VtoCreationStep.CREATION) {
            return;
        }
        var instance;
        Promise.all([loadDitto(vtoConfig.sdkUrl), vtoConfig.getSignature(vtoConfig.partnerId)])
            .then(function (_a) {
            var _b = __read(_a, 2), ditto = _b[0], clientSignature = _b[1];
            if (!isCanceled) {
                instance = new ditto.api.DittoCreation({
                    serverNetloc: vtoConfig.apiUrl,
                    selector: '.vto-create-ditto__target',
                    accessKeyId: vtoConfig.accessKey,
                    clientSignature: clientSignature,
                }, {
                    success: function (response) {
                        vtoEvent('vto.creation.success', { sku: sku });
                        onCreate(response.dittoId);
                    },
                    close: onCancel,
                    failure: function (_a) {
                        var status = _a.status, description = _a.description;
                        vtoEvent('vto.creation.error', { sku: sku, status: status, description: description });
                    },
                });
            }
        })
            .catch(onError);
        return function () {
            isCanceled = true;
            instance && instance.destroy();
        };
    }, [activeStep]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Modal */ "Q"], { isOpen: true, onModalClose: onCancel, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('vto-create-ditto__modal', {
            'vto-create-ditto__modal--image': imgUrl,
        }), showIcon: true },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LockBodyScroll */ "N"], null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-create-ditto" },
            activeStep === VtoCreationStep.INTRO && renderPrivacy(),
            activeStep === VtoCreationStep.CREATION && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-create-ditto__target" }))));
    function renderPrivacy() {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
            imgUrl && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-create-ditto__aside", style: { backgroundImage: "url(" + imgUrl + ")" } })),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-create-ditto__main" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-create-ditto__titles" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "vto-create-ditto__title" }, intl.getLabel('vto.title')),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h4", { className: "vto-create-ditto__subtitle" }, intl.getLabel('vto.subtitle'))),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* List */ "K"], { className: "vto-create-ditto__usps", items: [
                        intl.getLabel('vto.usp.1'),
                        intl.getLabel('vto.usp.2'),
                        intl.getLabel('vto.usp.3'),
                    ], type: "checkmark" }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("label", { className: "vto-create-ditto__opt-in" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Checkbox */ "c"], { onChange: function () { return setAgreement(!hasAgreed); }, checked: hasAgreed, value: "vto-create-ditto", "data-t": "vto-create-ditto-checkbox" }),
                    "\u00A0 ",
                    react_html_parser__WEBPACK_IMPORTED_MODULE_19___default()(intl.getLabel('vto.optIn'))),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { caption: intl.getLabel('vto.actions.start'), disabled: !hasAgreed, onClick: function () { return setActiveStep(VtoCreationStep.CREATION); }, "data-t": "vto-create-ditto-button" }))));
    }
};

var ViewDitto = function (_a) {
    var sku = _a.sku, dittoId = _a.dittoId, onError = _a.onError, onDelete = _a.onDelete, onRetake = _a.onRetake;
    var vtoConfig = useVtoConfig();
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (!vtoConfig.isEnabled || !dittoId) {
            return;
        }
        var instance;
        Promise.all([loadDitto(vtoConfig.sdkUrl), vtoConfig.getSignature(dittoId)])
            .then(function (_a) {
            var _b = __read(_a, 2), ditto = _b[0], signature = _b[1];
            return (instance = new ditto.api.TryOn({
                serverNetloc: vtoConfig.apiUrl,
                selector: '.vto-view-ditto__target',
                sku: sku,
                accessKeyId: vtoConfig.accessKey,
                dittoId: dittoId,
                signature: signature,
            }, {
                failure: function () {
                    vtoEvent('vto.tryon.error', { sku: sku });
                    onRetake();
                },
                initialized: function () { return vtoEvent('vto.tryon.initialized', { sku: sku }); },
                success: function () { return vtoEvent('vto.tryon.view', { sku: sku }); },
            }));
        })
            .catch(onError);
        return function () {
            instance && instance.destroy();
        };
    }, [dittoId, vtoConfig, sku]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-view-ditto" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-view-ditto__actions" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* IconButton */ "w"], { className: "vto-view-ditto__action", onClick: function () {
                    vtoEvent('vto.tryon.retake', { sku: sku });
                    onRetake();
                }, "data-t": "vto-view-ditto-retake" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "pencil" })),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* IconButton */ "w"], { className: "vto-view-ditto__action", onClick: function () {
                    vtoEvent('vto.tryon.delete', { sku: sku });
                    onDelete();
                }, "data-t": "vto-view-ditto-delete" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "trash" }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "vto-view-ditto__target" })));
};

var VirtualTryOn = function (_a) {
    var onClose = _a.onClose, sku = _a.sku;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), skipIntro = _b[0], setSkipIntro = _b[1];
    var _c = useDittoId(onClose), dittoId = _c.dittoId, setDittoId = _c.setDittoId, deleteDittoId = _c.deleteDittoId;
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () { return function () { return vtoEvent('vto.close', { sku: sku }); }; }, []);
    return dittoId ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ViewDitto, { dittoId: dittoId, onDelete: handleDelete, onError: handleError, onRetake: handleRetake, sku: sku })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CreateDitto, { onCreate: setDittoId, onCancel: onClose, onError: handleError, skipIntro: skipIntro, sku: sku }));
    function handleRetake() {
        deleteDittoId();
        setSkipIntro(true);
    }
    function handleDelete() {
        deleteDittoId();
    }
    function handleError() {
        onClose();
        // @TODO implement error logging
        _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* toast */ "vb"].failed('vto.errors.connection');
    }
};

var VtoConfigProvider = function (_a) {
    var enabled = _a.enabled, config = _a.config, children = _a.children;
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().locale;
    var value = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        if (enabled && config) {
            var serverConfig_1 = createVtoServerConfig(config, locale);
            var getSignature = function (message) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, fetch(serverConfig_1.signatureRoute + "?message=" + message)
                            .then(function (response) { return response.json(); })
                            .then(function (_a) {
                            var signature = _a.signature;
                            return signature;
                        })];
                });
            }); };
            return __assign(__assign({}, serverConfig_1), { getSignature: getSignature, isEnabled: true });
        }
        return { isEnabled: false };
    }, [config, enabled, locale]);
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(VtoConfig.Provider, { value: value }, children);
};

var VisualSwitcherViews;
(function (VisualSwitcherViews) {
    VisualSwitcherViews["FRONT"] = "front";
    VisualSwitcherViews["SIDE"] = "side";
    VisualSwitcherViews["VTO"] = "vto";
})(VisualSwitcherViews || (VisualSwitcherViews = {}));
var ProductVisualSwitcher = function (_a) {
    var productImages = _a.productImages, alt = _a.alt, sticker = _a.sticker, sku = _a.sku, ean = _a.ean;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(VisualSwitcherViews.FRONT), 2), activeView = _b[0], setActiveView = _b[1];
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var vtoId = ean || sku;
    var hasVto = vtoId && useHasVirtualTryOn(vtoId);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (!hasVto && activeView === VisualSwitcherViews.VTO) {
            setActiveView(VisualSwitcherViews.FRONT);
        }
    }, [activeView, hasVto]);
    var getButtonClassNames = function (angle) {
        var _a;
        var base = 'product-visuals__button';
        return classnames__WEBPACK_IMPORTED_MODULE_11___default()(base, base + "--" + angle, (_a = {},
            _a[base + "--active"] = activeView === angle,
            _a));
    };
    var getThumbnailStyle = function (url) { return ({
        backgroundImage: "url(" + url + "?w=74&h=29&fit=fill&fm=jpeg&auto=format)",
    }); };
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-visuals" },
        activeView !== VisualSwitcherViews.VTO && sticker,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-visuals__main" },
            activeView === VisualSwitcherViews.FRONT && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailImage, { image: productImages[0].url, altText: alt })),
            productImages[1] && activeView === VisualSwitcherViews.SIDE && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailImage, { image: productImages[1].url, altText: alt })),
            hasVto && activeView === VisualSwitcherViews.VTO && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(VirtualTryOn, { sku: vtoId, onClose: function () { return setActiveView(VisualSwitcherViews.FRONT); } }))),
        productImages[1] && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-visuals__buttons" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("button", { type: "button", onClick: function () { return setActiveView(VisualSwitcherViews.FRONT); }, className: getButtonClassNames(VisualSwitcherViews.FRONT) },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-visuals__thumb", style: getThumbnailStyle(productImages[0].url) })),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("button", { type: "button", onClick: function () { return setActiveView(VisualSwitcherViews.SIDE); }, className: getButtonClassNames(VisualSwitcherViews.SIDE) },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-visuals__thumb", style: getThumbnailStyle(productImages[1].url) })),
            hasVto && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("button", { type: "button", onClick: function () { return setActiveView(VisualSwitcherViews.VTO); }, className: getButtonClassNames(VisualSwitcherViews.VTO) },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "try-on" }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", null,
                    "\u00A0 ",
                    intl.getLabel('vto.caption'))))))));
};

// Re-export the viewHistory API but with the products key used in localStorage bound to it
var useProductViewHistory = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useViewHistory */ "S"].bind(null, _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ViewHistoryKey */ "q"].Products);

var imgSuffix = '?w=64&fm=jpeg&auto=format';
function VariantPicker(_a) {
    var title = _a.title, variants = _a.variants, currentSku = _a.currentSku, currentLabel = _a.currentLabel, stockIndicator = _a.stockIndicator, onPick = _a.onPick;
    if (!variants.length) {
        return null;
    }
    if (variants.length === 1) {
        return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker__header" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker__info" }, currentLabel),
                stockIndicator)));
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker__header" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("strong", null, title),
            stockIndicator),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker__info" }, currentLabel),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "variant-picker__variants" }, variants.map(function (_a) {
            var sku = _a.sku, image = _a.image, url = _a.url;
            return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("a", { href: url, key: sku, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('variant-picker__variant', {
                    'variant-picker__variant--active': currentSku === sku,
                }), onClick: function (event) { return onPick(event, sku); }, style: { backgroundImage: "url(" + (image + imgSuffix) + ")" } }));
        }))));
}

var ProductDetailPrice = function (_a) {
    var originalPrice = _a.originalPrice, discountedPrice = _a.discountedPrice, currency = _a.currency;
    if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
        return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: originalPrice, currency: currency, size: "large", type: "strikethrough", className: "product-detail__price" }),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: discountedPrice, currency: currency, size: "large", className: "product-detail__price" })));
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: originalPrice, currency: currency, size: "large", className: "product-detail__price" }));
};
react__WEBPACK_IMPORTED_MODULE_10___default.a.memo(ProductDetailPrice);

var useBrandLink = function (brand) {
    var _a;
    if (typeof window === 'undefined') {
        return '';
    }
    var link = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        var _a;
        var path = ((_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) || '';
        var parts = path.split('/').filter(function (v) { return v !== ''; });
        var isMultilingual = /[[a-z]{2}_[A-Z]{2}/g.test(parts[0]);
        var category = isMultilingual ? parts[1] : parts[0];
        return "/" + (isMultilingual ? parts[0] + "/" : '') + category + "?brand=" + encodeURIComponent(brand);
    }, [(_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname, brand]);
    return link;
};

var Frames = function (_a) {
    var isPrescriptionGlassesEnabled = _a.isPrescriptionGlassesEnabled, isPrescriptionFileEnabled = _a.isPrescriptionFileEnabled, activeSku = _a.activeSku, ean = _a.ean, addToCartRef = _a.addToCartRef, formatProductUrl = _a.formatProductUrl, handleVariantPick = _a.handleVariantPick, onPriceChange = _a.onPriceChange, product = _a.product, productTypeUsps = _a.productTypeUsps, noAddOnsImage = _a.noAddOnsImage, showStickyButton = _a.showStickyButton, staticsUrl = _a.staticsUrl, storesRoute = _a.storesRoute, variant = _a.variant, specificationConfiguration = _a.specificationConfiguration, price = _a.price, opticianForm = _a.opticianForm, children = _a.children, stickyTop = _a.stickyTop;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), currency = _b.currency, getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, hasLabel = _b.hasLabel, locale = _b.locale;
    var reviews = Object(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* useReviewsContext */ "f"])();
    var productViewHistory = useProductViewHistory();
    var brandLink = useBrandLink(variant.brand);
    var variants = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return __spread([product.masterVariant], product.variants); }, [product]);
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), isConfiguratorOpen = _c[0], setIsConfiguratorOpen = _c[1];
    // Add SKU to viewed product history
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map(function (v) { return v.sku || ''; }));
        productViewHistory.add(variant.sku);
    }, [variants.length, variant.sku]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (reviews.enabled) {
            reviews.dispatch(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* Actions */ "a"].updateReviewDisplay({
                variantId: activeSku,
            }));
        }
    }, [activeSku, reviews.enabled]);
    var openConfiguratorButtonRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(null);
    var handleConfiguratorClose = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        var _a;
        setIsConfiguratorOpen(false);
        (_a = openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : openConfiguratorButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [openConfiguratorButtonRef]);
    var handleConfiguratorOpen = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        setIsConfiguratorOpen(true);
    }, []);
    var isOrderable = variant.channelAvailability
        ? variant.channelAvailability === 'ONLINE'
        : !variant.excludedFromCheckout;
    var callToActionButton = isPrescriptionGlassesEnabled && isOrderable ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { caption: getLabel('products.actions.openConfigurator'), "data-t": "btn-open-configurator", onClick: handleConfiguratorOpen, btnRef: openConfiguratorButtonRef })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { caption: getLabel('products.actions.bookAppointment'), "data-t": "btn-book-examination", href: storesRoute }));
    var framePrice = variant.price.originalPrice;
    var totalPrice = price || framePrice;
    var nonFramePrice = totalPrice - framePrice;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__main product-detail__main--optical" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "desktop-hidden product-detail__header--mobile" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailTitle$1, { brand: variant.brand, model: variant.modelName, href: brandLink }),
            isSmallScreen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* ReviewSnippet */ "c"], { productId: product.masterVariant.sku, variantId: activeSku }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__visual-switcher" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductVisualSwitcher, { productImages: variant.images || [], alt: getProductAltTag(variant.name, variants.find(function (v) { return v.sku === activeSku; }) || variants[0], 'Frames', locale), sku: activeSku, ean: ean })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__description" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailDescription, { title: getLabel('products.contactLenses.header.details'), header: variant.header, description: variant.description, usps: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* List */ "K"], { type: "checkmark", items: variant.usps }) },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailOpticsFeatures, { frame: getLabel('products.frame'), antiReflex: getLabel('products.lens.features.antiReflex'), antiScratch: getLabel('products.lens.features.antiScratch') }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__specification" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailSpecification, { configuration: specificationConfiguration, variant: getActiveVariant(product, activeSku) })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__aside" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Sticky */ "ib"], { top: stickyTop || 0, bottomBoundary: ".product-detail", enabled: !isSmallScreen },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "mobile-hidden" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailTitle$1, { brand: variant.brand, model: variant.modelName, href: brandLink })),
                    !!variant.price && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-detail__specification-prices', {
                            'product-detail__specification-prices--has-discount': !!variant.discountText,
                        }) },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__price-container" }, isPrescriptionGlassesEnabled ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailPrice, { originalPrice: variant.price.originalPrice, discountedPrice: variant.price.discountedPrice, currency: currency })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailPrice, { originalPrice: totalPrice, discountedPrice: variant.price.discountedPrice + nonFramePrice, currency: currency }))),
                        variant.discountText && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" })))),
                    !isSmallScreen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* ReviewSnippet */ "c"], { productId: product.masterVariant.sku, variantId: activeSku })),
                    hasLabel('products.frames.contents') && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__specification-contents" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail__specification-contents__header" }, getLabel('products.including')),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("p", null, getLabel('products.frames.contents')))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(VariantPicker, { title: getFormattedLabel('products.numberOfVariants', {
                            labelData: { number: variants.length },
                        }), variants: getVariants(variants, staticsUrl, variant, product, formatProductUrl), currentSku: variant.sku, currentLabel: variant.frameColorLabel, onPick: handleVariantPick }),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__cart-details", ref: addToCartRef },
                        callToActionButton,
                        isSmallScreen && showStickyButton && !!variant.price && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* StickyCallToAction */ "jb"], { button: callToActionButton, price: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: variant.price.discountedPrice
                                    ? variant.price.discountedPrice + nonFramePrice
                                    : totalPrice, currency: currency, centAmount: true }) }))),
                    productTypeUsps && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], { className: "product-detail__usp-divider" }),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductTypeUsps, { productTypeUsps: productTypeUsps })))))),
        children && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__configuration" }, children),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorModalContainer, { frame: product, frameSku: activeSku, isOpen: isConfiguratorOpen, triggerButtonRef: openConfiguratorButtonRef, onModalClose: handleConfiguratorClose, onPriceChange: onPriceChange, formatProductUrl: formatProductUrl, opticianForm: opticianForm, noAddOnsImage: noAddOnsImage, isPrescriptionFileEnabled: isPrescriptionFileEnabled })));
};

var ConfiguratorContext$1 = Object(react__WEBPACK_IMPORTED_MODULE_10__["createContext"])({});
var ConfiguratorProvider$1 = function (_a) {
    var children = _a.children;
    var value = {};
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorContext$1.Provider, { value: value }, children);
};

var ExpanderContainer$1 = function (_a) {
    var children = _a.children;
    var isFooterOpen = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isFooterOpen$1);
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Expander, { isExpanded: isFooterOpen }, children);
};

var ExpanderContent$1 = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cls-configurator-footer-expander-content" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cls-configurator-footer-expander-content__summary" }),
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cls-configurator-footer-expander-content__prescription" }))); };

var STEP_FORM_ID$1 = 'cls-configurator-step-form';

var CallToActionContainer$1 = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var addToCartCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddToCartCall$1);
    var isOnLastStep = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isLastStep$1);
    var label = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return isOnLastStep
            ? getLabel('products.contactLenses.configurator.footer.addToCart')
            : getLabel('products.contactLenses.configurator.footer.nextStep');
    }, [isOnLastStep, getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CallToAction, { label: label, isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(addToCartCall), isSmallScreen: isSmallScreen, formId: STEP_FORM_ID$1 }));
};

var ConfigurationTotalPriceContainer$1 = function () {
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var totalPrice = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getConfigurationTotalPrice);
    if (!totalPrice) {
        return null;
    }
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationTotalPrice, __assign({ centAmount: true, size: isPhone ? 'small' : 'large' }, totalPrice));
};

var ExpanderToggleContainer$1 = function (props) {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isFooterOpen = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isFooterOpen$1);
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var onToggle = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        dispatch(toggleFooter$1());
    }, []);
    var label = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return getLabel('products.contactLenses.subscription.configurator.footer.toggle'); }, [getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderToggle, __assign({}, props, { label: label, isExpanded: isFooterOpen, onToggleClick: onToggle })));
};

var SubscriptionInformation = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, imageUrl = _a.imageUrl, _b = _a.showImage, showImage = _b === void 0 ? true : _b, // TODO replace with icon when we have multiple subscription items
    _c = _a.textOrientation, // TODO replace with icon when we have multiple subscription items
    textOrientation = _c === void 0 ? 'vertical' : _c;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": "subscription-information", className: "subscription-information subscription-information--" + textOrientation },
        showImage && imageUrl && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { src: imageUrl, alt: title, className: "subscription-information__image" })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "subscription-information__text" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { variant: "subheading1", className: "subscription-information__title" }, title),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "frame-information__subtitle" }, subtitle))));
};

var SubscriptionInformationContainer = function (props) {
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().locale;
    var _a = useProductDetailContext(), staticsUrl = _a.staticsUrl, getProductImageUrls = _a.getProductImageUrls;
    var product = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getProduct);
    if (!product) {
        return null;
    }
    var brand = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale);
    var replacementFrequency = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(product.masterVariant, 'replacementFrequency', locale);
    var image = getProductImageData(product, product.masterVariant.sku, 100, staticsUrl, getProductImageUrls);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SubscriptionInformation, __assign({}, props, { title: brand, subtitle: replacementFrequency, imageUrl: image === null || image === void 0 ? void 0 : image.url })));
};

var TopBar$1 = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cls-configurator-footer-topbar" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cls-configurator-footer-topbar__aside" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SubscriptionInformationContainer, null)),
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cls-configurator-footer-topbar__main" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfigurationTotalPriceContainer$1, null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderToggleContainer$1, null),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CallToActionContainer$1, null)))); };

var ConfiguratorFooter$1 = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("footer", { "data-t": "cls-configurator-footer", className: "cls-configurator-footer" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(TopBar$1, null),
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderContainer$1, null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ExpanderContent$1, null)))); };

var ConfiguratorHeaderContainer$1 = function () {
    var steps = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getActiveSteps$1);
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    var stepNames = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return steps.map(function (s) { return s.name; }); }, [steps]);
    // We disable all steps from the active step onwards, because we don't support jumping forward by clicking in the header
    var disableSteps = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return Array.from(stepNames, function (_, i) { return i; }).slice(currentStep + 1); }, [stepNames, currentStep]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorHeader, { stepNames: stepNames, currentStepIndex: currentStep, disableSteps: disableSteps, stepLabelNamespace: "contactLenses" }));
};

var CardTrack = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.itemSize, itemSize = _c === void 0 ? 'large' : _c, rest = __rest(_a, ["className", "children", "itemSize"]);
    var baseClassNames = classnames__WEBPACK_IMPORTED_MODULE_11___default()('configurator-card-track', className);
    var containerClassNames = classnames__WEBPACK_IMPORTED_MODULE_11___default()('configurator-card-track__container', (_b = {},
        _b["item-size-" + itemSize] = !!itemSize,
        _b));
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: baseClassNames, "data-t": rest['data-t'] },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: containerClassNames }, react__WEBPACK_IMPORTED_MODULE_10___default.a.Children.map(children, function (child) {
            return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "card-track-item" }, child);
        }))));
};

var StepForm$1 = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var isOnLastStep = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isLastStep$1);
    var formSubmit = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (event) {
        event.preventDefault();
        if (isOnLastStep) {
            dispatch(addToCart$1());
        }
        else {
            dispatch(nextStep$1());
        }
    }, [dispatch, isLastStep$1]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("form", { noValidate: true, onSubmit: formSubmit, id: STEP_FORM_ID$1, "aria-label": rest['aria-label'], "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('step-form', className) }, children));
};

var DeliveryFrequencyStep = function (_a) {
    var deliveryFrequencies = _a.deliveryFrequencies, selectedDeliveryFrequency = _a.selectedDeliveryFrequency, className = _a.className, labels = _a.labels, onChange = _a.onChange, rest = __rest(_a, ["deliveryFrequencies", "selectedDeliveryFrequency", "className", "labels", "onChange"]);
    var stepTitle = labels.stepTitle, stepDescription = labels.stepDescription;
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (deliveryFrequency) {
        onChange({ deliveryFrequency: deliveryFrequency });
    }, [onChange]);
    var singleDeliveryFrequency = deliveryFrequencies.length == 1 ? deliveryFrequencies[0] : null;
    var cardClassName = classnames__WEBPACK_IMPORTED_MODULE_11___default()('cls-delivery-frequency-card', className);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('delivery-frequency-step', className), title: stepTitle, description: stepDescription, "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(StepForm$1, { "aria-label": stepTitle },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CardTrack, { itemSize: "large" }, singleDeliveryFrequency ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SingleItemRadioCard, { cardClassName: cardClassName, className: "cls-delivery-frequency-card--single", title: singleDeliveryFrequency.title, description: singleDeliveryFrequency.description, icon: "calendar-" + singleDeliveryFrequency.deliveryFrequency })) : (deliveryFrequencies.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCard, { key: item.deliveryFrequency, withDivider: true, className: cardClassName, id: item.deliveryFrequency + "-radio", isChecked: item.deliveryFrequency === selectedDeliveryFrequency, onChange: handleChange, value: item.deliveryFrequency, title: item.title, description: item.description, icon: "calendar-" + item.deliveryFrequency })); }))))));
};

var DeliveryFrequencyStepContainer = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var variantGroup = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getVariantGroup) || 'UNKNOWN';
    var ratePlans = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getRatePlans);
    var selectedDeliveryFrequency = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedDeliveryFrequency$1);
    var labels = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        stepTitle: getLabel('products.contactLenses.subscription.steps.deliveryFrequency.title'),
        stepDescription: getLabel('products.contactLenses.subscription.steps.deliveryFrequency.description'),
    }); }, [getLabel]);
    var onChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (_a) {
        var deliveryFrequency = _a.deliveryFrequency;
        dispatch(selectDeliveryFrequency({ variantGroup: variantGroup, deliveryFrequency: deliveryFrequency }));
    }, [dispatch, variantGroup]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(ratePlans)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
    }
    function removeDuplicatesByPropertyValue(objArr, prop) {
        return objArr.filter(function (obj, pos, arr) { return arr.map(function (rp) { return rp[prop]; }).indexOf(obj[prop]) === pos; });
    }
    var uniqueRatePlans = removeDuplicatesByPropertyValue(ratePlans.result, 'shippingSchedule');
    var deliveryFrequencySelectionList = uniqueRatePlans
        .map(function (ratePlan) { return ({
        deliveryFrequency: ratePlan.shippingSchedule,
        packageQuantity: ratePlan.packageQuantity,
        title: getLabel("products.contactLenses.subscription.steps.deliveryFrequency." + ratePlan.shippingSchedule + ".title"),
        description: getLabel("products.contactLenses.subscription.steps.deliveryFrequency." + ratePlan.shippingSchedule + ".description"),
    }); })
        .sort(function (a, b) { return a.deliveryFrequency.localeCompare(b.deliveryFrequency); });
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(DeliveryFrequencyStep, { deliveryFrequencies: deliveryFrequencySelectionList, selectedDeliveryFrequency: selectedDeliveryFrequency, onChange: onChange, labels: labels }));
};

/**
 * From the API returned solution data, create objects that can be processed
 * by the CrossSellBlock
 */
var parseCTSolutionData = function (solutions, language, staticsUrl, getLabel, getSolutionImageUrl) {
    if (!solutions || solutions.length === 0) {
        return [];
    }
    return solutions.reduce(function (storedSolutions, solution, index) {
        var masterVariant = solution.masterVariant, name = solution.name;
        var price = getPrice(masterVariant);
        if (price === undefined || index > 3) {
            return storedSolutions;
        }
        var title = name[language];
        var SKU = masterVariant.sku ? masterVariant.sku : '';
        var imageUrl = getSolutionImageUrl
            ? getSolutionImageUrl(solution)
            : getFullImageUrls(masterVariant, staticsUrl)[0].url;
        var solutionType = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(masterVariant, 'solutionType');
        var volume = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(masterVariant, 'volume');
        var subTitle;
        if (solutionType && volume) {
            subTitle = solutionType + ", " + volume + getLabel('products.unit.metric.liter.milli.abbr');
        }
        var product = {
            title: title,
            subTitle: subTitle,
            imageUrl: imageUrl,
            SKU: SKU,
            price: price,
            quantity: 0,
        };
        storedSolutions.push(product);
        return storedSolutions;
    }, []);
};

var useSolutions = function () {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _a.getLabel, language = _a.language;
    var getSolutionImageUrl = useProductDetailContext().getSolutionImageUrl;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var staticsUrl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getStaticsUrl) || '';
    var solutionsCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSolutions);
    var variantGroup = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getVariantGroup) || 'UNKNOWN';
    var selectedSolution = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedSolution$1);
    var fetchSolutions$1 = function () {
        dispatch(fetchSolutions());
    };
    var parsedSolutions = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(solutionsCall)) {
            return parseCTSolutionData(solutionsCall.result, language, staticsUrl, getLabel, getSolutionImageUrl).map(function (_a) {
                var imageUrl = _a.imageUrl, title = _a.title, SKU = _a.SKU, subTitle = _a.subTitle, price = _a.price;
                return {
                    sku: SKU,
                    image: {
                        url: imageUrl,
                        dimensions: {
                            w: 175,
                            h: 100,
                        },
                    },
                    description: subTitle,
                    title: title,
                    price: price,
                };
            });
        }
        return [];
    }, [solutionsCall, getLabel, getSolutionImageUrl, staticsUrl, language]);
    var onSolutionChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (_a) {
        var solution = _a.solution;
        var selected = parsedSolutions.find(function (_a) {
            var sku = _a.sku;
            return sku === solution;
        });
        selected &&
            dispatch(selectSolution({ solution: selected, variantGroup: variantGroup }));
    }, [variantGroup, dispatch]);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(solutionsCall) && !selectedSolution) {
            onSolutionChange({ solution: parsedSolutions[0].sku });
        }
    }, [solutionsCall]);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(solutionsCall) && !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(solutionsCall)) {
            fetchSolutions$1();
        }
    }, []);
    return {
        parsedSolutions: parsedSolutions,
        solutionsCall: solutionsCall,
        onSolutionChange: onSolutionChange,
        selectedSolution: selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.sku,
    };
};

var SolutionStep = function (_a) {
    var onSolutionChange = _a.onSolutionChange, labels = _a.labels, solutions = _a.solutions, selectedSolution = _a.selectedSolution, className = _a.className, rest = __rest(_a, ["onSolutionChange", "labels", "solutions", "selectedSolution", "className"]);
    var handleSolutionChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (solution) {
        onSolutionChange({ solution: solution });
    }, [onSolutionChange]);
    var isSolutionNoSolutionValue = function (solution) {
        return solution.sku.startsWith('-');
    };
    var solutionRadioCardClassname = function (solution) {
        return classnames__WEBPACK_IMPORTED_MODULE_11___default()('solution-step__radio', {
            'solution-step__radio--none': solution && isSolutionNoSolutionValue(solution),
        });
    };
    var singleSolution = solutions.length == 1 ? solutions[0] : null;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('solution-step', className), title: labels.stepTitle, description: labels.stepDescription, "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(StepForm$1, { "aria-label": labels.stepTitle },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CardTrack, { itemSize: "small" }, singleSolution ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SingleItemRadioCard, { withDivider: !isSolutionNoSolutionValue(singleSolution), cardClassName: "solution-step__single", className: solutionRadioCardClassname(singleSolution), image: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.image, title: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.title, description: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.description, price: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.price })) : (solutions.map(function (sol) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCard, { key: sol.sku, withDivider: !isSolutionNoSolutionValue(sol), className: solutionRadioCardClassname(sol), "data-t": sol.sku + "-radio", id: sol.sku, isChecked: sol.sku === selectedSolution, value: sol.sku, onChange: handleSolutionChange, image: sol === null || sol === void 0 ? void 0 : sol.image, title: sol === null || sol === void 0 ? void 0 : sol.title, description: sol === null || sol === void 0 ? void 0 : sol.description, price: sol === null || sol === void 0 ? void 0 : sol.price, priceComment: labels.priceComment })); }))))));
};

var SolutionStepContainer = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _a = useSolutions(), parsedSolutions = _a.parsedSolutions, solutionsCall = _a.solutionsCall, onSolutionChange = _a.onSolutionChange, selectedSolution = _a.selectedSolution;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        stepTitle: getLabel('products.contactLenses.subscription.steps.solution.title'),
        stepDescription: getLabel('products.contactLenses.subscription.steps.solution.description'),
        priceComment: getLabel('products.contactLenses.subscription.steps.solution.text')
    }); }, [getLabel]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(solutionsCall)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(SolutionStep, { labels: labels, solutions: parsedSolutions, onSolutionChange: onSolutionChange, selectedSolution: selectedSolution }));
};

var SubscriptionPlanStep = function (_a) {
    var billingPeriods = _a.billingPeriods, selectedBillingPeriod = _a.selectedBillingPeriod, onBillingPeriodChange = _a.onBillingPeriodChange, selectedStartDate = _a.selectedStartDate, onStartDateChange = _a.onStartDateChange, startDates = _a.startDates, className = _a.className, labels = _a.labels, rest = __rest(_a, ["billingPeriods", "selectedBillingPeriod", "onBillingPeriodChange", "selectedStartDate", "onStartDateChange", "startDates", "className", "labels"]);
    var handleBillingPeriodChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (billingPeriod) {
        onBillingPeriodChange({ billingPeriod: billingPeriod });
    }, [onBillingPeriodChange]);
    var handleDateChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (startDate) {
        onStartDateChange({ startDate: startDate });
    }, [onStartDateChange]);
    var singleBillingPeriod = billingPeriods.length == 1 ? billingPeriods[0] : null;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorStep, { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('subscription-plan-step', className), title: labels.stepTitle, description: labels.stepDescription, "data-t": rest['data-t'] },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(StepForm$1, { "aria-label": labels.stepTitle },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CardTrack, { itemSize: "large" }, singleBillingPeriod ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SingleItemRadioCard, { withDivider: true, cardClassName: "subscription-plan-step--single", icon: "calendar-" + singleBillingPeriod.billingPeriod, title: singleBillingPeriod.title || 'NO_TITLE', description: singleBillingPeriod.description || 'NO_DESC', price: singleBillingPeriod.price })) : (billingPeriods.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(RadioCard, { key: item.billingPeriod, withDivider: true, className: "subscription-plan-step__radio", "data-t": item.billingPeriod + "-radio", id: item.billingPeriod, isChecked: item.billingPeriod === selectedBillingPeriod, value: item.billingPeriod, onChange: handleBillingPeriodChange, icon: "calendar-" + item.billingPeriod, title: item.title || 'NO_TITLE', description: item.description || 'NO_DESC', price: item.price })); }))),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "subscription-plan-step__date-picker" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* DatePicker */ "f"], { onChange: handleDateChange, label: labels.datePickerLabel, required: true, initialValue: selectedStartDate, minDate: startDates === null || startDates === void 0 ? void 0 : startDates.min, maxDate: startDates === null || startDates === void 0 ? void 0 : startDates.max, dateFormat: "d MMMM yyyy" }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "caption" }, labels.datePickerText)))));
};

var MAX_DATE_SHIFT = { period: 'month', amount: 3 };
var SubscriptionPlanStepContainer = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var variantGroup = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getVariantGroup) || 'UNKNOWN';
    var ratePlans = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getRatePlans);
    var selectedDeliveryFrequency = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedDeliveryFrequency$1);
    var selectedBillingPeriod = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedBillingPeriod$1);
    var selectedStartDate = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSelectedStartDate$1);
    // min = today at midnight,
    // max = today shifted by MAX_DATE_SHIFT constant
    var startDates = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        min: new Date(new Date().setHours(0, 0, 0, 0)),
        max: _grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* DateUtils */ "a"].shiftDate(new Date(), MAX_DATE_SHIFT.period, MAX_DATE_SHIFT.amount),
    }); }, []);
    var labels = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        datePickerLabel: getLabel('products.contactLenses.subscription.steps.startDate.title'),
        datePickerText: getLabel('products.contactLenses.subscription.steps.startDate.description'),
        stepTitle: getLabel('products.contactLenses.subscription.steps.subscriptionPlan.title'),
        stepDescription: getLabel('products.contactLenses.subscription.steps.subscriptionPlan.description'),
    }); }, [getLabel]);
    var onBillingPeriodChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (_a) {
        var billingPeriod = _a.billingPeriod;
        dispatch(selectBillingPeriod({ variantGroup: variantGroup, billingPeriod: billingPeriod }));
    }, [dispatch, variantGroup]);
    var onStartDateChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (_a) {
        var startDate = _a.startDate;
        dispatch(selectStartDate({ variantGroup: variantGroup, startDate: startDate }));
    }, [dispatch, variantGroup]);
    if (!Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(ratePlans)) {
        return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* LoaderScreen */ "M"], null);
    }
    var billingPeriods = ratePlans.result
        // Only include rate plans that match the selected usage and delivery frequencies
        .filter(function (ratePlan) { return ratePlan.shippingSchedule === selectedDeliveryFrequency; }) // TODO include usage frequency
        .map(function (ratePlan) { return ({
        billingPeriod: ratePlan.billingPeriod,
        price: {
            originalPrice: ratePlan.basePrice.price,
            currency: ratePlan.basePrice.currency,
        },
        title: getLabel("products.contactLenses.subscription.steps.subscriptionPlan." + ratePlan.billingPeriod + ".title"),
        description: getLabel("products.contactLenses.subscription.steps.subscriptionPlan." + ratePlan.billingPeriod + ".description"),
    }); })
        .sort(function (a, b) { return a.billingPeriod.localeCompare(b.billingPeriod); });
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(SubscriptionPlanStep, { billingPeriods: billingPeriods, selectedBillingPeriod: selectedBillingPeriod, onBillingPeriodChange: onBillingPeriodChange, selectedStartDate: selectedStartDate, onStartDateChange: onStartDateChange, startDates: startDates, labels: labels }));
};

var ConfiguratorMain$1 = function (_a) {
    var children = _a.children, className = _a.className, currentStep = _a.currentStep, rest = __rest(_a, ["children", "className", "currentStep"]);
    var mainRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["createRef"])();
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useLayoutEffect"])(function () {
        var _a;
        if (!isPhone) {
            return;
        }
        (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [currentStep]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { ref: mainRef, "data-t": rest['data-t'], className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('cls-configurator-main', className) },
        currentStep === 'deliveryFrequency' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(DeliveryFrequencyStepContainer, null),
        currentStep === 'subscriptionPlan' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SubscriptionPlanStepContainer, null),
        currentStep === 'solution' && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SolutionStepContainer, null)));
};

var ConfiguratorMainContainer$1 = function (_a) {
    var className = _a.className;
    var currentStepName = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(selectors$4 === null || selectors$4 === void 0 ? void 0 : getCurrentStep$1).name;
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorMain$1, { currentStep: currentStepName, className: className });
};

var Configurator$1 = function (_a) {
    var dataT = _a["data-t"];
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { "data-t": dataT, className: "cls-configurator" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorHeaderContainer$1, null),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorMainContainer$1, { className: "cls-configurator__main" }),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ConfiguratorFooter$1, null)));
};

var ConfiguratorContainer$1 = function (_a) {
    var input = _a.input, lensVariants = _a.lensVariants, product = _a.product, variantGroup = _a.variantGroup, staticsUrl = _a.staticsUrl, recommendedCategoryKey = _a.recommendedCategoryKey, formatProductUrl = _a.formatProductUrl, dataT = _a["data-t"];
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var isReady$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(isReady);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var steps = ['deliveryFrequency', 'subscriptionPlan', 'solution'];
        dispatch(startContactLensSubscriptionConfiguration({
            steps: steps,
            input: input,
            lensVariants: lensVariants,
            product: product,
            staticsUrl: staticsUrl,
            recommendedCategoryKey: recommendedCategoryKey,
            variantGroup: variantGroup,
            formatProductUrl: formatProductUrl,
        }));
    }, [input, dispatch, formatProductUrl, lensVariants, product, recommendedCategoryKey, staticsUrl, variantGroup]);
    return isReady$1 ? Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Configurator$1, { "data-t": dataT }) : Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Loader */ "L"], { className: "cls-configurator__loader" });
};

var ConfiguratorModal$1 = function (_a) {
    var className = _a.className, lensVariants = _a.lensVariants, rest = __rest(_a, ["className", "lensVariants"]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Modal */ "Q"], __assign({}, rest, { "data-t": "cls-configurator-modal", className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('cls-configurator-modal', className), isFullScreen: true, showIcon: true }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorContainer$1, __assign({}, rest, { lensVariants: lensVariants }))));
};

var ConfiguratorModalContainer$1 = function (props) {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var steps = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getActiveSteps$1);
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    var previousSteps = steps.slice(0, currentStep);
    var isFirstStep = currentStep === 0;
    var handleBackClick = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        if (!isFirstStep) {
            dispatch(previousStep$1());
        }
    }, [dispatch, isFirstStep, previousStep$1]);
    var onBackClick = isFirstStep ? undefined : handleBackClick;
    var backLabel = getLabel('common.actions.previous');
    var secondaryIconOptions = onBackClick && {
        'aria-label': backLabel,
        name: 'chevron-left',
        onClick: onBackClick,
        label: backLabel,
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorProvider$1, null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorModal$1, __assign({}, props, { secondaryIconOptions: secondaryIconOptions }))));
};
ConfiguratorModalContainer$1.displayName = 'ConfiguratorModal';

function productIsAvailableForSubscription(product) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = product === null || product === void 0 ? void 0 : product.masterVariant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
        var name = _a.name;
        return name === 'isAvailableForSubscription';
    })) === null || _c === void 0 ? void 0 : _c.value);
}

var useCartSolutionChange = function (lineItems) {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var cart = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Selectors.getCartResult);
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        if (cart) {
            // When a solution changes we need to remove the old lens bundle and add a new one.
            var existingLensBundles = cart.lineItems.reduce(function (result, lineItem) {
                var _a;
                if (((_a = lineItem.productType.obj) === null || _a === void 0 ? void 0 : _a.name) === 'Contact-lens-bundles') {
                    return __spread(result, [lineItem]);
                }
                return result;
            }, []);
            var removeActions = existingLensBundles.map(function (lineItem) { return ({
                action: 'removeLineItem',
                lineItemId: lineItem.id,
            }); });
            var addActions = lineItems.map(function (_a) {
                var sku = _a.sku, _b = _a.quantity, quantity = _b === void 0 ? 1 : _b, customAttributes = _a.customAttributes;
                var type = customAttributes.type, custom = __rest(customAttributes, ["type"]);
                return {
                    action: 'addLineItem',
                    sku: sku,
                    quantity: quantity,
                    custom: {
                        type: {
                            key: type,
                        },
                        fields: custom,
                    },
                };
            });
            var actions = __spread(removeActions, addActions);
            // TODO: handleSDActions as updateCart does not have that working yet.
            dispatch(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.updateCart({ actions: actions }));
        }
    }, [cart, lineItems]);
};

var SubscriptionSolution = function (_a) {
    var isChecked = _a.isChecked, onChange = _a.onChange, solution = _a.solution, title = _a.title;
    var bundleSku = solution.bundleSku, bundlePrice = solution.bundlePrice;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* RadioButton */ "ab"], { isChecked: isChecked, onChange: onChange, position: "bottom", value: bundleSku, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('subscription-solution', {
            'subscription-solution--empty': !solution.description && !solution.imageUrl,
        }) },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "subscription-solution__container" },
            solution.imageUrl && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "subscription-solution__image-holder" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("img", { className: "subscription-solution__image", src: solution.imageUrl, alt: title }))),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("h3", { className: "subscription-solution__title", "data-t": "subscription-solution-title" }, title),
            bundlePrice[0].value && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "subscription-solution__price" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: bundlePrice[0].value.centAmount, currency: bundlePrice[0].value.currencyCode }))))));
};

var SubscriptionSolutionContainer = function (_a) {
    var onChange = _a.onChange, isChecked = _a.isChecked, solution = _a.solution;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    var title = solution.name
        ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(solution.name, locale)
        : getLabel('products.contactLenses.solutions.missing');
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(SubscriptionSolution, { isChecked: isChecked, onChange: onChange, solution: solution, title: title }));
};

var SubscriptionSolutionPicker = function (_a) {
    var labels = _a.labels, onChange = _a.onChange, selectedSolution = _a.selectedSolution, solutions = _a.solutions;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "subscription-solution-picker" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { variant: "subheading1", className: "subscription-solution-picker__title" }, labels.title),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "subscription-solution-picker__list" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null, solutions.map(function (solution) { return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "subscription-solution-picker__item", key: solution.bundleSku },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(SubscriptionSolutionContainer, { onChange: onChange, isChecked: selectedSolution ? solution.bundleSku === selectedSolution.bundleSku : false, solution: solution }))); }))),
        selectedSolution && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("p", { className: "subscription-solution-picker__description" }, labels.description))));
};

var SubscriptionSolutionPickerContainer = function () {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _a.getLabel, locale = _a.locale;
    var _b = useLensBundle(), lineItems = _b.lineItems, _c = _b.solutions, items = _c.items, onSolutionChange = _c.onSolutionChange, activeSolution = _c.activeSolution;
    var _d = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(false), 2), shouldUpdateCart = _d[0], setShouldUpdateCart = _d[1];
    var handleCartSolutionChange = useCartSolutionChange(lineItems);
    var labels = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        title: getLabel('products.contactLenses.solutions.title'),
        description: (activeSolution === null || activeSolution === void 0 ? void 0 : activeSolution.description) && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(activeSolution.description, locale),
    }); }, []);
    react__WEBPACK_IMPORTED_MODULE_10___default.a.useEffect(function () {
        if (shouldUpdateCart) {
            handleCartSolutionChange();
            setShouldUpdateCart(false);
        }
    }, [shouldUpdateCart]);
    var handleChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (event) {
        onSolutionChange(event.currentTarget.value, function () { return setShouldUpdateCart(true); });
    }, [items, handleCartSolutionChange]);
    if (!activeSolution) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(SubscriptionSolutionPicker, { onChange: handleChange, selectedSolution: activeSolution, solutions: items, labels: labels }));
};

function createSubscriptionPriceSpecification(activeVariant, pricePerMonth) {
    var currency = pricePerMonth.currencyCode;
    var subscriptionPriceSpecification = {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: Object(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* calcPrice */ "o"])(pricePerMonth.centAmount),
        priceCurrency: currency,
        valueAddedTaxIncluded: true,
    };
    return subscriptionPriceSpecification;
}
var createViewProductEvent = function (_a) {
    var product = _a.product, activeSKU = _a.activeSKU, staticsUrl = _a.staticsUrl, url = _a.url, locale = _a.locale, isSubscriptionSelected = _a.isSubscriptionSelected, pricePerMonth = _a.pricePerMonth, extra = _a.extra;
    var _b, _c;
    var activeVariant = __spread([product.masterVariant], product.variants).find(function (variant) { return variant.sku === activeSKU; }) ||
        product.masterVariant;
    var subscriptionProductSku = (_c = (_b = activeVariant.attributes) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
        var name = _a.name;
        return name === 'subscriptionProductSKU';
    })) === null || _c === void 0 ? void 0 : _c.value;
    var vat = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getNestedProperty */ "s"])(product, 'taxCategory.obj.rates', []).find(function (rate) { return rate.includedInPrice; });
    var offers = [
        {
            '@type': 'Offer',
            priceSpecification: isSubscriptionSelected && pricePerMonth
                ? createSubscriptionPriceSpecification(activeVariant, pricePerMonth)
                : Object(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* createPriceSpecification */ "r"])(activeVariant, vat.amount),
        },
    ];
    var _d = Object(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* parseProductData */ "s"])(product, activeVariant, staticsUrl, locale), name = _d.name, image = _d.image, description = _d.description, brand = _d.brand, category = _d.category, sku = _d.sku;
    var action = {
        '@context': 'https://schema.org',
        '@type': _grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* ActionType */ "a"].Action,
        name: 'product_detail',
        // The object currently has the same structure as what is sent by the `Product` SD component.
        object: __assign(__assign(__assign(__assign(__assign({ '@type': 'Product', '@id': url + "#product", url: url, sku: isSubscriptionSelected ? subscriptionProductSku : sku, skuMaster: product.masterVariant.sku, purchaseModel: isSubscriptionSelected ? 'subscription' : 'single purchase', image: image, name: (name && String(name)) || sku }, Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* optionalKey */ "C"])('description', description)), Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* optionalKey */ "C"])('brand', brand)), Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* optionalKey */ "C"])('category', category)), Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* optionalKey */ "C"])('offers', offers)), extra),
    };
    return action;
};
var viewProductSdEvent = function (params) {
    var action = createViewProductEvent(params);
    Object(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* pushSdAction */ "t"])(action);
};

var ConfiguratorButton = function (_a) {
    var calculatedPrice = _a.calculatedPrice, calculatedDiscountPrice = _a.calculatedDiscountPrice, isPrescriptionEnabled = _a.isPrescriptionEnabled, hasLenses = _a.hasLenses, btnRef = _a.btnRef, onClick = _a.onClick;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, currency = _b.currency;
    var caption = (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { component: "span", variant: "body" }, getLabel('products.actions.openContactLensSubscriptionConfigurator')),
        isPrescriptionEnabled && hasLenses && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { component: "span", variant: "body", className: "product-detail__add-to-cart" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: calculatedDiscountPrice || calculatedPrice, currency: currency, centAmount: true }),
            ' ',
            getLabel('common.frequency.perMonth')))));
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { size: "large", caption: caption, "data-t": "btn-open-cls-configurator", onClick: onClick, btnRef: btnRef }));
};

var CTAButton = function (_a) {
    var onPrescriptionClick = _a.onPrescriptionClick, handleMiniCartChange = _a.handleMiniCartChange, isPrescriptionEnabled = _a.isPrescriptionEnabled, isSubscription = _a.isSubscription, calculatedDiscountPrice = _a.calculatedDiscountPrice, calculatedPrice = _a.calculatedPrice, cartLineItems = _a.cartLineItems, excludedFromCheckout = _a.excludedFromCheckout, storesRoute = _a.storesRoute, hasLenses = _a.hasLenses, onClick = _a.onClick, pricePerMonth = _a.pricePerMonth, renderAddToCartButton = _a.renderAddToCartButton;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, currency = _b.currency;
    var addToCartCallback = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        handleMiniCartChange && handleMiniCartChange();
        onClick && onClick();
    }, [handleMiniCartChange, onClick]);
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var buttonSize = isPhone ? 'small' : 'medium';
    /*
     * If subscription product and configuration is valid, show button with monthly costs that triggers the MiniCart
     * */
    if (isSubscription && hasLenses) {
        var addToCartSharedProps = {
            'data-t': 'btn-subscription',
            caption: (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { component: "span", variant: "body" }, getLabel('products.actions.addToCart')),
                pricePerMonth && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { component: "span", variant: "body", className: "product-detail__add-to-cart" },
                    '(',
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: pricePerMonth.centAmount, currency: currency, centAmount: true }),
                    ' / ',
                    getLabel('common.frequency.perMonth'),
                    ')')))),
        };
        var addToCartPropsV1 = __assign(__assign({}, addToCartSharedProps), { onClick: addToCartCallback, lineItems: cartLineItems });
        var addToCartPropsV2 = __assign(__assign({}, addToCartSharedProps), { onSuccess: addToCartCallback, lineItemDrafts: cartLineItems.map(function (_a) {
                var sku = _a.sku, quantity = _a.quantity, custom = _a.custom, customAttributes = _a.customAttributes;
                return ({
                    sku: sku,
                    quantity: quantity,
                    type: 'contact-lenses-bundle-benelux',
                    typeDetails: __assign(__assign({}, custom), customAttributes),
                });
            }) });
        return renderAddToCartButton ? (renderAddToCartButton(addToCartPropsV2)) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* AddToCart */ "a"], __assign({}, addToCartPropsV1)));
    }
    if (isPrescriptionEnabled && hasLenses) {
        var addToCartSharedProps = {
            caption: (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { component: "span", variant: "body" }, getLabel('products.actions.addToCart')),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { component: "span", variant: "body", className: "product-detail__add-to-cart" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: calculatedDiscountPrice ? calculatedDiscountPrice : calculatedPrice, currency: currency, centAmount: true })))),
        };
        var addToCartPropsV1 = __assign(__assign({}, addToCartSharedProps), { onClick: addToCartCallback, lineItems: cartLineItems });
        var addToCartPropsV2 = __assign(__assign({}, addToCartSharedProps), { onSuccess: addToCartCallback, lineItemDrafts: cartLineItems.map(function (_a) {
                var sku = _a.sku, quantity = _a.quantity, custom = _a.custom, customAttributes = _a.customAttributes;
                return ({
                    sku: sku,
                    quantity: quantity,
                    type: 'contact-lenses',
                    typeDetails: __assign(__assign({}, custom), customAttributes),
                });
            }) });
        return renderAddToCartButton ? (renderAddToCartButton(addToCartPropsV2)) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* AddToCart */ "a"], __assign({}, addToCartPropsV1)));
    }
    if (excludedFromCheckout) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { size: buttonSize, caption: getLabel('products.actions.excludedFromCheckout'), "data-t": "btn-excluded-from-checkout", href: storesRoute }));
    }
    if (!isPrescriptionEnabled) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { size: buttonSize, caption: getLabel('products.actions.bookAppointment'), href: storesRoute, "data-t": "btn-book-appointment" }));
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { size: buttonSize, className: "add-to-cart", caption: getLabel('products.actions.addToCart'), "data-t": "btn-enter-prescription", onClick: onPrescriptionClick }));
};

var CrossSellItem = function (_a) {
    var imageUrl = _a.imageUrl, onUpdate = _a.onUpdate, price = _a.price, quantity = _a.quantity, SKU = _a.SKU, subTitle = _a.subTitle, title = _a.title, intl = _a.intl, maxQuantity = _a.maxQuantity;
    var increaseQuantity = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        onUpdate('increment', SKU);
    }, [onUpdate, SKU]);
    var decreaseQuantity = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        onUpdate('decrement', SKU);
    }, [onUpdate, SKU]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('cross-sell-item', {
            _is_active: quantity > 0,
        }) },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cross-sell-item__image-holder" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { className: "cross-sell-item__image", src: imageUrl + "?w=300&auto=format", alt: title })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cross-sell-item__title" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "cross-sell-item__title-heading" }, title)),
        subTitle ? Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "cross-sell-item__subtitle" }, subTitle) : null,
        price && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* PriceTag */ "X"], { className: "cross-sell-item__price", currency: intl.currency, discountedPrice: price.discountedPrice, originalPrice: price.originalPrice })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cross-sell-item__quantity-selector" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* QuantitySelector */ "Z"], { maximumQuantity: maxQuantity, quantity: quantity, minimumQuantity: 0, onDecreaseQuantity: decreaseQuantity, onIncreaseQuantity: increaseQuantity }))));
};
var CrossSellItem$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(CrossSellItem);

var CrossSellBlock = function (_a) {
    var onUpdateItem = _a.onUpdateItem, products = _a.products, maxQuantity = _a.maxQuantity;
    var crossSellItems = products &&
        products.map(function (_a) {
            var imageUrl = _a.imageUrl, price = _a.price, quantity = _a.quantity, SKU = _a.SKU, subTitle = _a.subTitle, title = _a.title;
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CrossSellItem$1, { imageUrl: imageUrl, key: SKU, onUpdate: onUpdateItem, price: price, quantity: quantity, SKU: SKU, subTitle: subTitle, title: title, maxQuantity: maxQuantity }));
        });
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "cross-sell" }, crossSellItems);
};

var Solutions = function (_a) {
    var labels = _a.labels, onUpdateItem = _a.onUpdateItem, solutions = _a.solutions, maxQuantity = _a.maxQuantity;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "solutions" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { variant: "subheading1", className: "solutions__title" }, labels.title),
        labels.disclaimer && !!solutions.length && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "info" }, labels.disclaimer),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CrossSellBlock, { onUpdateItem: onUpdateItem, products: solutions, maxQuantity: maxQuantity })));
};

var SolutionsContainer = function (_a) {
    var recommendedCategoryKey = _a.recommendedCategoryKey, staticsUrl = _a.staticsUrl, maxQuantity = _a.maxQuantity;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), currency = _b.currency, country = _b.country, getLabel = _b.getLabel, language = _b.language, locale = _b.locale;
    var _c = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useApiConfig */ "N"])(), apiKey = _c.apiKey, productsUrl = _c.productsUrl;
    var getSolutionImageUrl = useProductDetailContext().getSolutionImageUrl;
    var _d = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])([]), 2), solutions = _d[0], setSolutions = _d[1];
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var cart = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Selectors.getCartResult);
    /**
     * Load solutions for a given category key.
     * Parse the results and store it in the state
     */
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var fetchSolutions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].query(productsUrl, { categoryType: recommendedCategoryKey }, apiKey)];
                    case 1:
                        results = (_a.sent()).results;
                        data = parseCTSolutionData(results, language, staticsUrl, getLabel, getSolutionImageUrl);
                        setSolutions(data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Error fetching solutions " + e_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchSolutions();
    }, [apiKey, productsUrl, recommendedCategoryKey]);
    var handleSolutionChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (action, SKU) {
        var _a;
        var lineItem = (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (lineItem) { return lineItem.variant.sku === SKU; });
        var incrementAllowed = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNumber */ "z"])(maxQuantity) && lineItem ? lineItem.quantity <= maxQuantity : true;
        var decrementAllowed = !!lineItem && lineItem.quantity > 0;
        if (action === 'increment' && incrementAllowed) {
            dispatch(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.addToCart({
                currency: currency,
                country: country,
                locale: locale,
                lineItems: [{ sku: SKU, quantity: 1 }],
            }));
        }
        if (action === 'decrement' && lineItem && decrementAllowed) {
            if (lineItem.quantity === 1) {
                dispatch(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.removeLineItems({
                    lineItems: [lineItem],
                }));
            }
            else {
                dispatch(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* ReduxDataSource */ "f"].Actions.changeQuantity({
                    lineItem: lineItem,
                    newQuantity: lineItem.quantity - 1,
                }));
            }
        }
        if (incrementAllowed || decrementAllowed) {
            setSolutions(function (prevState) {
                var newSolutions = prevState.map(function (solution) {
                    return solution.SKU === SKU
                        ? __assign(__assign({}, solution), { quantity: Math.max(0, (solution.quantity || 0) + (action === 'increment' ? 1 : -1)) }) : solution;
                });
                return newSolutions;
            });
        }
    }, [cart, currency, country, locale, maxQuantity, dispatch]);
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        title: getLabel('products.contactLenses.solutions.title'),
        disclaimer: getLabel('products.solutions.disclaimer', { hideLabelKey: true }),
    }); }, [getLabel]);
    if (solutions.length === 0) {
        return null;
    }
    var solutionsWithQuantity = solutions.map(function (solution) {
        var _a;
        var lineItem = (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (lineItem) { return lineItem.variant.sku === solution.SKU; });
        var quantity = lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity;
        if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNumber */ "z"])(quantity) && solution.quantity !== quantity) {
            return __assign(__assign({}, solution), { quantity: quantity });
        }
        return solution;
    });
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Solutions, { onUpdateItem: handleSolutionChange, labels: labels, solutions: solutionsWithQuantity, maxQuantity: maxQuantity }));
};

var calculatePrescription = function (config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug, isPrescriptionValid) {
    if (!config || !Object.keys(config).length || !config.packPrice) {
        return {
            selectedProducts: [],
            packageQuantity: 0,
            totalDiscount: undefined,
            totalPrice: 0,
            totalSubscriptionPrice: 0,
        };
    }
    var leftEyeBoxSKU = config.leftEyeBoxSKU, leftEyeChecked = config.leftEyeChecked, leftEyeBoxQuantity = config.leftEyeBoxQuantity, leftEyeBoxAvailableQuantity = config.leftEyeBoxAvailableQuantity, rightEyeBoxSKU = config.rightEyeBoxSKU, rightEyeChecked = config.rightEyeChecked, rightEyeBoxQuantity = config.rightEyeBoxQuantity, rightEyeBoxAvailableQuantity = config.rightEyeBoxAvailableQuantity, hasHardQuantityLimit = config.hasHardQuantityLimit, subscriptionPrice = config.subscriptionPrice, centAmount = config.packPrice.value.centAmount, prescriptionInfo = config.prescriptionInfo;
    var hasDiscount = !!config.packPrice.discounted &&
        !!config.packPrice.discounted.value &&
        !!config.packPrice.discounted.value.centAmount;
    var discountedPackPrice = config.packPrice.discounted;
    var discountedCentAmount = discountedPackPrice && discountedPackPrice.value.centAmount;
    var selectedProducts = [];
    var calculatedPrices = [];
    var calculatedDiscountedPrices = [];
    if (isPrescriptionValid &&
        leftEyeBoxQuantity &&
        (leftEyeBoxAvailableQuantity || !hasHardQuantityLimit) &&
        leftEyeChecked &&
        leftEyeBoxSKU) {
        var totalPriceLeft = leftEyeBoxQuantity * centAmount;
        var leftLensSKU = {
            sku: leftEyeBoxSKU,
            quantity: leftEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'left',
            },
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            var prescriptionExpiryDate = prescriptionInfo.prescriptionExpiryDate, prescriptionExamDate = prescriptionInfo.prescriptionExamDate, externalOptician = prescriptionInfo.externalOptician, internalOptician = prescriptionInfo.internalOptician;
            leftLensSKU.customAttributes = __assign(__assign({}, leftLensSKU.customAttributes), { prescriptionExpiryDate: prescriptionExpiryDate,
                prescriptionExamDate: prescriptionExamDate,
                externalOptician: externalOptician,
                internalOptician: internalOptician });
        }
        selectedProducts.push(leftLensSKU);
        calculatedPrices.push(totalPriceLeft);
        if (hasDiscount) {
            var totalDiscountLeft = totalPriceLeft - discountedCentAmount * leftEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountLeft);
        }
    }
    if (isPrescriptionValid &&
        rightEyeBoxQuantity &&
        (rightEyeBoxAvailableQuantity || !hasHardQuantityLimit) &&
        rightEyeChecked &&
        rightEyeBoxSKU) {
        var totalPriceRight = rightEyeBoxQuantity * centAmount;
        var rightLensSKU = {
            sku: rightEyeBoxSKU,
            quantity: rightEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'right',
            },
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            var prescriptionExpiryDate = prescriptionInfo.prescriptionExpiryDate, prescriptionExamDate = prescriptionInfo.prescriptionExamDate, externalOptician = prescriptionInfo.externalOptician, internalOptician = prescriptionInfo.internalOptician;
            rightLensSKU.customAttributes = __assign(__assign({}, rightLensSKU.customAttributes), { prescriptionExpiryDate: prescriptionExpiryDate,
                prescriptionExamDate: prescriptionExamDate,
                externalOptician: externalOptician,
                internalOptician: internalOptician });
        }
        selectedProducts.push(rightLensSKU);
        calculatedPrices.push(totalPriceRight);
        if (hasDiscount) {
            var totalDiscountRight = totalPriceRight - discountedCentAmount * rightEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountRight);
        }
    }
    var calculatedPrice = calculatedPrices.reduce(function (a, b) { return a + b; }, 0);
    var totalDiscount = calculatedDiscountedPrices.reduce(function (a, b) { return a + b; }, 0);
    var calculatedDiscountPrice = totalDiscount && calculatedPrice - totalDiscount;
    // selectedProducts is eye side lenses i.e. max is two.
    // Hence multiplying the subscripton price for one eye.
    var totalSubscriptionPrice = (subscriptionPrice !== null && subscriptionPrice !== void 0 ? subscriptionPrice : 0) * selectedProducts.length;
    var packageQuantity = (config && config.packSize) || variant.packageQuantity;
    var cartLineItems = selectedProducts.map(function (product) {
        var productType = 'Contact-lenses';
        var newProduct = __assign({}, product);
        if (product.customAttributes && product.customAttributes.eyeSide) {
            var variantUrl = formatProductUrl({
                productType: productType,
                sku: product.sku,
                slug: slug,
            });
            newProduct.productUrl = variantUrl + "#product";
        }
        return newProduct;
    });
    return {
        selectedProducts: cartLineItems,
        totalPrice: calculatedPrice,
        totalSubscriptionPrice: totalSubscriptionPrice,
        totalDiscount: calculatedDiscountPrice,
        packageQuantity: packageQuantity,
    };
};

/**
 * Returns the product and lens features from a given variant
 */
var getContactLensFeatures = function (variant, getLabel) {
    var productFeatures = [
        {
            labelKey: 'products.contactLenses.materialType',
            attribute: 'materialType',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.lensType',
            attribute: 'lensType',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.material',
            attribute: 'material',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.waterContent',
            attribute: 'waterContent',
            isLocalised: true,
        },
        {
            labelKey: 'products.contactLenses.features.uv',
            attribute: 'features.uv',
            isLocalised: true,
        },
    ];
    var hydration = {
        label: getLabel('products.contactLenses.features.hydration'),
        variantHasAttribute: (function () { return !!variant.features.hydration; })(),
    };
    var softness = {
        label: getLabel('products.contactLenses.features.softness'),
        variantHasAttribute: (function () { return !!variant.features.softness; })(),
    };
    var breathability = {
        label: getLabel('products.contactLenses.features.breathability'),
        variantHasAttribute: (function () { return !!variant.features.breathability; })(),
    };
    var fatigue = {
        label: getLabel('products.contactLenses.features.eyeFatigue'),
        variantHasAttribute: (function () { return !!variant.features.fatigue; })(),
    };
    var uv = {
        label: getLabel('products.contactLenses.features.uv'),
        variantHasAttribute: (function () { return !!variant.features.uv; })(),
    };
    var basics = {
        label: getLabel('products.contactLenses.features.basics'),
        variantHasAttribute: (function () { return !!variant.features.basics; })(),
    };
    var lensFeatures = {
        hydration: hydration,
        softness: softness,
        breathability: breathability,
        fatigue: fatigue,
        uv: uv,
        basics: basics,
    };
    return {
        productFeatures: productFeatures,
        lensFeatures: lensFeatures,
    };
};

var getAvailability = function (config) {
    if (!config.selectedVariants) {
        return { selectedVariantsData: [], availability: [] };
    }
    var selectedVariantsData = Object.values(config.selectedVariants);
    var availability = selectedVariantsData.map(function (variant) {
        if (variant &&
            variant.availability &&
            ((config.leftEyeChecked && variant.sku === config.leftEyeBoxSKU) ||
                (config.rightEyeChecked && variant.sku === config.rightEyeBoxSKU))) {
            return variant.availability;
        }
        return undefined;
    });
    return {
        selectedVariantsData: selectedVariantsData,
        availability: availability,
    };
};

/**
 * returns the validity for the configurator and the prescription info section
 */
var validateConfigurator = function (config, isPrescriptionInfoEnabled) {
    var _a;
    var leftEyeValid = config.leftEyeChecked ? !!config.leftEyeBoxSKU : true;
    var rightEyeValid = config.rightEyeChecked ? !!config.rightEyeBoxSKU : true;
    var isConfiguratorValid = leftEyeValid && rightEyeValid;
    var isPrescriptionInfoValid = isPrescriptionInfoEnabled
        ? ((_a = config === null || config === void 0 ? void 0 : config.prescriptionInfo) === null || _a === void 0 ? void 0 : _a.valid) || false
        : true;
    return {
        isConfiguratorValid: isConfiguratorValid,
        isPrescriptionInfoValid: isPrescriptionInfoValid,
    };
};

/**
 * Calls the different helper functions in order to retrieve the complete state
 * needed for the Lenses component
 */
var getPrescriptionState = function (config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug) {
    var _a = getAvailability(config), availability = _a.availability, selectedVariantsData = _a.selectedVariantsData;
    var formErrorState = validateConfigurator(config, isPrescriptionInfoEnabled);
    var isPrescriptionInfoValid = formErrorState.isPrescriptionInfoValid, isConfiguratorValid = formErrorState.isConfiguratorValid;
    var prescriptionResult = calculatePrescription(config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug, isPrescriptionInfoValid && isConfiguratorValid);
    return {
        availability: availability,
        formErrorState: formErrorState,
        prescriptionResult: prescriptionResult,
        selectedVariantsData: selectedVariantsData,
    };
};

var useLenses = function (_a) {
    var product = _a.product, isPrescriptionEnabled = _a.isPrescriptionEnabled, isPrescriptionInfoEnabled = _a.isPrescriptionInfoEnabled, variant = _a.variant, formatProductUrl = _a.formatProductUrl;
    var _b;
    var packageQuantity = Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product.masterVariant, 'packageQuantity'));
    /**
     * Stores the pack price, this updates when a different pack size is selected
     */
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])((_b = product.masterVariant.prices) === null || _b === void 0 ? void 0 : _b[0]), 2), packPrice = _c[0], setPackPrice = _c[1];
    var _d = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(), 2), subscriptionPrice = _d[0], setSubscriptionPrice = _d[1];
    /**
     * Stores the pack price, usage frequency and subscription pack size when a
     * different pack size is selected. These values are passed into the contact
     * lens configurator.
     */
    var _e = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])({ eyeSides: [] }), 2), subscriptionConfiguratorInput = _e[0], setSubscriptionConfiguratorInput = _e[1];
    /**
     * Selected prescription state which keeps track of the selected lenses
     * and the corresponding prices
     */
    var _f = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])({
        packageQuantity: packageQuantity,
        selectedProducts: [],
        totalPrice: 0,
        totalSubscriptionPrice: 0,
        totalDiscount: undefined,
    }), 2), lensesState = _f[0], setLensesState = _f[1];
    /**
     * Keeps track of the availability and the selected lenses,
     * these are used in the DeliveryIndicator
     */
    var _g = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])([]), 2), availability = _g[0], setAvailability = _g[1];
    var _h = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])([]), 2), selectedLensVariants = _h[0], setSelectedLensVariants = _h[1];
    /**
     * Keeps track of the error states for the configurator and prescriptionInfo,
     * the error count is used for re-rendering the error Alert components
     */
    var _j = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])({
        errorCount: 0,
        showError: false,
        isConfiguratorValid: false,
        isPrescriptionInfoValid: !isPrescriptionEnabled,
    }), 2), formValidations = _j[0], setFormValidations = _j[1];
    /**
     * Keeps track of the when to show the MiniCart
     */
    var _k = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), showMiniCart = _k[0], setShowMiniCart = _k[1];
    /**
     * Click handler assigned to the enter prescription button
     * Clicking this button always means the user has not filled in
     * the requested forms completely.
     */
    var handlePrescriptionClick = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        setFormValidations(__assign(__assign({}, formValidations), { showError: true, errorCount: formValidations.errorCount + 1 }));
    }, [formValidations]);
    /**
     * Contact lens configurator callback
     * This will derive the different states based on the form
     */
    var handleFormChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (config) {
        var _a = getPrescriptionState(config, !!isPrescriptionInfoEnabled, variant, formatProductUrl, product.slug), prescriptionResult = _a.prescriptionResult, availability = _a.availability, formErrorState = _a.formErrorState, selectedVariantsData = _a.selectedVariantsData;
        var eyeSides = [{
                side: 'left',
                checked: config.leftEyeChecked,
            }, {
                side: 'right',
                checked: config.rightEyeChecked,
            }].filter(function (eyeSide) { return eyeSide.checked; }).map(function (eyeSide) { return eyeSide.side; });
        setPackPrice(config.packPrice);
        setSubscriptionPrice(config.subscriptionPrice);
        setLensesState(prescriptionResult);
        setAvailability(availability);
        setSelectedLensVariants(selectedVariantsData);
        setFormValidations(__assign(__assign(__assign({}, formValidations), formErrorState), { showError: false }));
        setSubscriptionConfiguratorInput({
            packSize: config.subscriptionPackSize,
            usageFrequency: config.dailiesUsageLevel,
            eyeSides: eyeSides,
        });
    }, [formValidations, formatProductUrl, isPrescriptionInfoEnabled, product, variant]);
    /**
     * MiniCart change handler, will fire when user proceeds to purchase lenses
     */
    var handleMiniCartChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        setShowMiniCart(function (showMiniCart) {
            return !showMiniCart;
        });
    }, []);
    var priceTotals = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        calculatedPrice: lensesState.totalPrice,
        calculatedDiscountPrice: lensesState.totalDiscount,
        selectedProducts: lensesState.selectedProducts,
        subscriptionCalculatedPrice: lensesState.totalSubscriptionPrice,
    }); }, [lensesState]);
    var state = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        availability: availability,
        hasLenses: !!lensesState.selectedProducts.length,
        formValidations: formValidations,
        packPrice: packPrice,
        subscriptionPrice: subscriptionPrice,
        subscriptionConfiguratorInput: subscriptionConfiguratorInput,
        priceTotals: priceTotals,
        selectedLensVariants: selectedLensVariants,
        showMiniCart: showMiniCart,
    }); }, [
        availability,
        lensesState,
        formValidations,
        packPrice,
        subscriptionPrice,
        subscriptionConfiguratorInput,
        priceTotals,
        selectedLensVariants,
        showMiniCart,
    ]);
    var handles = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        handleFormChange: handleFormChange,
        handleMiniCartChange: handleMiniCartChange,
        handlePrescriptionClick: handlePrescriptionClick,
    }); }, []);
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return [state, handles]; }, [handles, state]);
};

var GridNavigationDirection;
(function (GridNavigationDirection) {
    GridNavigationDirection["UP"] = "up";
    GridNavigationDirection["DOWN"] = "down";
    GridNavigationDirection["LEFT"] = "left";
    GridNavigationDirection["RIGHT"] = "right";
})(GridNavigationDirection || (GridNavigationDirection = {}));
function useGridNavigation(isActive, grid, targetElement, close) {
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        function handleKeyDownEvent(event) {
            switch (event.key) {
                case 'Down':
                case 'ArrowDown':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.DOWN });
                    break;
                case 'Up':
                case 'ArrowUp':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.UP });
                    break;
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.LEFT });
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    dispatch({ type: GridNavigationDirection.RIGHT });
                    break;
                case 'Esc':
                case 'Escape':
                    close();
                    break;
            }
        }
        var target = targetElement.current;
        if (isActive && target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return function () { return target.removeEventListener('keydown', handleKeyDownEvent, false); };
        }
    }, [isActive, targetElement.current]);
    var _a = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useReducer"])(navigationReducer, {
        colIndex: 0,
        rowIndex: 0,
        grid: grid,
    }), 2), state = _a[0], dispatch = _a[1];
    function setState(rowIndex, colIndex) {
        dispatch({ type: 'SET', payload: { rowIndex: rowIndex, colIndex: colIndex } });
    }
    return [{ colIndex: state.colIndex, rowIndex: state.rowIndex }, setState];
}
function navigationReducer(state, action) {
    switch (action.type) {
        case GridNavigationDirection.UP: {
            var rowIndex = state.rowIndex - 1;
            if (rowIndex < 0) {
                return state;
            }
            return __assign(__assign({}, state), { rowIndex: rowIndex });
        }
        case GridNavigationDirection.DOWN: {
            var rowIndex = state.rowIndex + 1;
            if (rowIndex >= state.grid[state.colIndex]) {
                return state;
            }
            return __assign(__assign({}, state), { rowIndex: rowIndex });
        }
        case GridNavigationDirection.LEFT: {
            var colIndex = state.colIndex - 1;
            if (colIndex < 0) {
                return state;
            }
            var newState = __assign(__assign({}, state), { colIndex: colIndex });
            if (state.rowIndex >= state.grid[colIndex]) {
                newState.rowIndex = state.grid[colIndex] - 1;
            }
            return newState;
        }
        case GridNavigationDirection.RIGHT: {
            var colIndex = state.colIndex + 1;
            if (colIndex >= state.grid.length) {
                return state;
            }
            var newState = __assign(__assign({}, state), { colIndex: colIndex });
            if (state.rowIndex >= state.grid[colIndex]) {
                newState.rowIndex = state.grid[colIndex] - 1;
            }
            return newState;
        }
        case 'SET': {
            var _a = action.payload, colIndex = _a.colIndex, rowIndex = _a.rowIndex;
            if (colIndex >= state.grid.length || rowIndex >= state.grid[colIndex]) {
                return state;
            }
            return __assign(__assign({}, state), action.payload);
        }
        default: {
            throw new Error();
        }
    }
}

var PrescriptionDropdown = function (_a) {
    var allOptions = _a.allOptions, onChange = _a.onChange, disabled = _a.disabled, leftColumnOptions = _a.leftColumnOptions, name = _a.name, placeholder = _a.placeholder, rightColumnOptions = _a.rightColumnOptions, className = _a.className;
    var isDisabled = disabled || allOptions.length <= 1;
    var grid = [];
    if (leftColumnOptions.length > 0) {
        grid.push(leftColumnOptions.length);
    }
    if (rightColumnOptions.length > 0) {
        grid.push(rightColumnOptions.length);
    }
    var rowCount = grid.reduce(function (prev, curr) { return (prev > curr ? prev : curr); }, 0);
    var dropdownRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(null);
    var gridRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(null);
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(placeholder || ''), 2), value = _b[0], setValue = _b[1];
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read(useGridNavigation(isOpen, grid, dropdownRef, function () {
        return setIsOpen(false);
    }), 2), _e = _d[0], rowIndex = _e.rowIndex, colIndex = _e.colIndex, setGridFocus = _d[1];
    Object(use_onclickoutside__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"])(dropdownRef, function () { return setIsOpen(false); });
    /**
     * Effect that adds focus to a selected element,
     * Focus is changed after navigating with the keyboard controls,
     * on mouse hover or whenever the drodpown is opened
     */
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var elementRef = gridRef && gridRef.current;
        var selectedRow = elementRef && elementRef.querySelector(".prescription-dropdown__grid-row-" + rowIndex);
        var cellIndex = grid.length === 1 ? (leftColumnOptions.length > 0 ? 0 : 1) : colIndex;
        var selectedChild = selectedRow && selectedRow.childNodes[cellIndex];
        if (selectedRow && selectedChild) {
            selectedChild.focus();
        }
    }, [rowIndex, colIndex, isOpen, grid, leftColumnOptions]);
    /**
     * When only one option is given,
     * pre-select it
     */
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (allOptions.length === 1) {
            selectOption(allOptions[0], 0, 0);
        }
    }, [allOptions.length]);
    var dropdownClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-dropdown', className, {
        'prescription-dropdown--disabled': isDisabled,
    });
    var columnHeaderClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-dropdown__grid-cell', 'prescription-dropdown__grid-header', 'prescription-dropdown__grid-cell--disabled');
    var buttonWithDropdownClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-dropdown__button', {
        'prescription-dropdown__button--disabled': isDisabled,
    });
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: dropdownClass, ref: dropdownRef },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* ButtonWithDropdown */ "b"], { isActive: isOpen, label: renderLabel(value || placeholder), isFullWidth: true, title: name, onClick: function () { return !isDisabled && setIsOpen(!isOpen); }, className: buttonWithDropdownClass },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription-dropdown__container" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { role: "grid", className: "prescription-dropdown__grid", "aria-label": name, ref: gridRef },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription-dropdown__grid-row", role: "row" },
                        leftColumnOptions.length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "aria-label": "-", role: "columnheader", className: columnHeaderClass },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "minus", className: "prescription-dropdown__icon" }))),
                        rightColumnOptions.length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "aria-label": "+", role: "columnheader", className: columnHeaderClass },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* Icon */ "b"], { name: "plus", className: "prescription-dropdown__icon" })))),
                    renderGrid())))));
    function renderGrid() {
        var rows = [];
        for (var i = 0; i < rowCount; i++) {
            var left = leftColumnOptions[i];
            var right = rightColumnOptions[i];
            var row = (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription-dropdown__grid-row prescription-dropdown__grid-row-" + i, role: "row", key: i },
                left ? renderCell(left, i, 0) : renderEmptyCell(),
                right ? renderCell(right, i, 1) : renderEmptyCell()));
            rows.push(row);
        }
        return rows;
    }
    function renderEmptyCell() {
        var emptyCellClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-dropdown__grid-cell', 'prescription-dropdown__grid-cell--disabled');
        return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { role: "gridcell", className: emptyCellClass });
    }
    function renderCell(option, rowIndex, colIndex) {
        if (rowIndex === void 0) { rowIndex = 0; }
        if (colIndex === void 0) { colIndex = 0; }
        var gridCellClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-dropdown__grid-cell', {
            'prescription-dropdown__grid-cell--single-column': grid.length === 1,
        });
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("button", { role: "gridcell", className: gridCellClass, onClick: function () { return selectOption(option, rowIndex, colIndex); }, onMouseEnter: function () { return setGridFocus(rowIndex, colIndex); } }, option.value));
    }
    function selectOption(option, rowIndex, colIndex) {
        setValue(option.value);
        setGridFocus(rowIndex, colIndex);
        setIsOpen(false);
        var validatedSelection = __assign(__assign({}, option), { isValid: option.value !== '' });
        onChange && onChange(validatedSelection);
    }
    function renderLabel(value) {
        if (!value) {
            return null;
        }
        var valueClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription-dropdown__value', {
            'prescription-dropdown__value--invalid': !value || value === placeholder,
            'prescription-dropdown__value--disabled': allOptions.length <= 1,
        });
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "prescription-dropdown__button-label" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: valueClass, "data-t": "prescription-dropdown-value" }, value)));
    }
};

var MAX_QUANTITY_LIMIT = 99;
var Prescription = /** @class */ (function (_super) {
    __extends(Prescription, _super);
    function Prescription() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeFilters: {},
            attributes: {},
            allowBackOrder: _this.props.allowBackOrder,
        };
        _this.getInitialFilters = function (filterAttributes) {
            var e_1, _a;
            var initialFilters = {};
            try {
                for (var _b = __values(Object.keys(filterAttributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var attribute = _c.value;
                    var currentAttribute = Array.from(filterAttributes[attribute].values);
                    if (currentAttribute.length === 1 && attribute !== 'packageQuantity') {
                        initialFilters[attribute] = currentAttribute[0];
                        // TODO fix the missing types in here some other time (been there for 1+ year now)
                        _this.props.handleLensBundleChange(_this.props.id, attribute, currentAttribute[0]);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return initialFilters;
        };
        _this.handleAttributeChange = function (key, value) {
            var _a, _b;
            if (value) {
                var newFilter_1 = __assign(__assign({}, _this.state.activeFilters), (_a = {}, _a[key] = value, _a));
                var attribute = _this.state.attributes[key];
                if (!attribute) {
                    return;
                }
                attribute.selected = value;
                _this.setState({
                    activeFilters: newFilter_1,
                    attributes: __assign(__assign({}, _this.state.attributes), (_b = {}, _b[key] = attribute, _b)),
                }, function () {
                    key !== 'packageQuantity' && _this.props.handleLensBundleChange(_this.props.id, key, value);
                    // Omit packageQuantity just like it is removed from filter.
                    var length = Object.keys(_this.state.attributes).length;
                    var attributeLength = _this.state.attributes.packageQuantity ? length - 1 : length;
                    if (Object.keys(newFilter_1).length === attributeLength) {
                        _this.getSkuByAttributes(newFilter_1);
                    }
                });
            }
            else {
                _this.setFoundProduct(undefined);
            }
        };
        _this.handleQuantityChange = function (quantity, action) {
            var newQuantity = action === 'increase' ? quantity + 1 : quantity - 1;
            _this.props.onQuantityChange(newQuantity);
        };
        _this.setFoundProduct = function (product) {
            _this.setState({
                foundProduct: product,
                allowBackOrder: product && typeof product.attributes.allowBackOrder === 'boolean'
                    ? product.attributes.allowBackOrder
                    : _this.props.allowBackOrder,
            });
            _this.props.onFoundProduct(product);
        };
        _this.getSkuByAttributes = function (filters) {
            var enrichedFilters = __assign(__assign({}, filters), { packageQuantity: _this.props.packSize });
            var foundProduct = _this.props.products.find(function (_a) {
                var e_2, _b;
                var attributes = _a.attributes;
                var valid = true;
                try {
                    for (var _c = __values(Object.keys(enrichedFilters)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var filter = _d.value;
                        var value = enrichedFilters[filter];
                        valid = filter in attributes && attributes[filter] === value;
                        if (!valid) {
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return valid;
            });
            if (foundProduct) {
                _this.setFoundProduct(foundProduct);
            }
            else {
                _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* toast */ "vb"].failed("products.contactLenses.prescription.alert." + _this.props.id + "Eye");
            }
        };
        _this.getSortedArrayFromSet = function (set, _locale) {
            if (_locale === void 0) { _locale = undefined; }
            return Array.from(set)
                .sort(function (a, b) { return a.localeCompare(b, _locale, { numeric: true }); })
                .map(function (item) { return ({ label: item.toString(), value: item }); });
        };
        _this.getFilterOptions = function (options) {
            if (options === void 0) { options = []; }
            var arr = options instanceof Set ? _this.getSortedArrayFromSet(options) : options;
            return arr.reduce(function (prev, curr) {
                prev[curr.label] = curr.value;
                return prev;
            }, {});
        };
        _this.getQuantitySelectorMaximumQuantity = function () {
            var _a = _this.props, availableQuantity = _a.availableQuantity, maxOrderableQuantity = _a.maxOrderableQuantity;
            var allowBackOrder = _this.state.allowBackOrder;
            if (!allowBackOrder) {
                if (maxOrderableQuantity && availableQuantity) {
                    return maxOrderableQuantity > availableQuantity ? availableQuantity : maxOrderableQuantity;
                }
                if (availableQuantity !== undefined) {
                    return availableQuantity;
                }
            }
            if (maxOrderableQuantity) {
                return maxOrderableQuantity;
            }
            return MAX_QUANTITY_LIMIT;
        };
        _this.formatPowerValues = function (values) {
            return _this.getSortedArrayFromSet(values)
                .map(function (_a) {
                var value = _a.value;
                return ({ label: value, value: value });
            })
                .sort(function (a, b) { return powerToFloat(a) - powerToFloat(b); });
        };
        _this.renderToolTip = function (type) {
            var _a = _this.props, intl = _a.intl, currentBreakpoint = _a.currentBreakpoint, id = _a.id;
            /**
             * Decide if we have to show labels or not,
             *  - On mobile we always want to show the labels including the tooltip
             *  - On tablet landscape and up we want the dashed tooltip,
             *    which includes the label, but only for the Prescription for the right eye-side
             */
            var isMobile = currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE ||
                currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT;
            var showTooltip = isMobile || id === 'right';
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "prescription__input-label" }, intl.getLabel("products.contactLenses.prescription." + type))),
                showTooltip && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tooltip */ "sb"], { dashed: !isMobile, className: "prescription__input-tooltip", id: type, label: intl.getLabel("products.contactLenses.prescription." + type), message: intl.getLabel("products.contactLenses.prescription." + type + ".tooltip") }))));
        };
        _this.sortPowerOptions = function (a, b) {
            return powerValueToFloat(a) - powerValueToFloat(b);
        };
        _this.renderSelectElement = function (key) {
            var _a;
            var _b = _this.props, attributes = _b.attributes, intl = _b.intl, isActive = _b.isActive, hasError = _b.hasError;
            var _c = _this.state, activeFilters = _c.activeFilters, foundProduct = _c.foundProduct;
            var attibuteValues = (_a = attributes[key]) === null || _a === void 0 ? void 0 : _a.values;
            var filter = activeFilters[key];
            var initialState = filter ? { value: filter } : _this.getInitialState(attibuteValues);
            var selectElementClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription__select', {
                'prescription__select--error': hasError && !foundProduct && isActive,
            });
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription__input-wrapper", key: key },
                _this.renderToolTip(key),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Select */ "A"], { id: key, className: selectElementClass, name: intl.getLabel("products.contactLenses.prescription." + key), options: _this.getFilterOptions(attibuteValues), sortOptionsBy: key === 'power' ? _this.sortPowerOptions : undefined, initialState: initialState, placeholder: "---", onChange: function (value) { return _this.handleAttributeChange(key, value); }, disabled: !isActive, "data-t": "prescription-" + key })));
        };
        _this.renderPowerSelector = function (isMobile) {
            var _a = _this.props, attributes = _a.attributes, intl = _a.intl, isActive = _a.isActive, hasError = _a.hasError;
            var _b = _this.state, activeFilters = _b.activeFilters, foundProduct = _b.foundProduct;
            var allOptions = attributes.power ? _this.formatPowerValues(attributes.power.values) : [];
            var positiveOptions = allOptions.filter(function (power) { return powerToFloat(power) >= 0; });
            var negativeOptions = allOptions.filter(function (power) { return powerToFloat(power) <= 0; });
            negativeOptions.reverse(); // 🙈 mutation; reversed for the UI (eg render 0 - -5 instead of -5 - 0)
            var selectElementClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription__select', {
                'prescription__select--error': hasError && !foundProduct && isActive,
            });
            // value to set within PrescriptionDropdown via placeholder prop when selected
            // needed because of the isMobile render check below
            var initialValue = (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.power) || '---';
            return !isMobile ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription__input-wrapper prescription__power-dropdown" },
                _this.renderToolTip('power'),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionDropdown, { name: intl.getLabel('products.contactLenses.prescription.power'), className: selectElementClass, allOptions: allOptions, leftColumnOptions: negativeOptions, rightColumnOptions: positiveOptions, placeholder: initialValue, onChange: function (_a) {
                        var value = _a.value;
                        return _this.handleAttributeChange('power', value);
                    }, disabled: !isActive, "data-t": "prescription-power" }))) : (_this.renderSelectElement('power'));
        };
        return _this;
    }
    Prescription.prototype.componentDidMount = function () {
        var _a = this.props, attributes = _a.attributes, products = _a.products;
        var initialFilters = this.getInitialFilters(attributes);
        this.setState({
            activeFilters: initialFilters,
            attributes: attributes,
        });
        if (products.length === 1) {
            this.getSkuByAttributes(initialFilters);
        }
    };
    Prescription.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        if (this.props.isSubscriptionSelected &&
            prevProps.isSubscriptionSelected !== this.props.isSubscriptionSelected) {
            // Reset back to 1 as quantity should not be updated in subscription lenses
            this.props.onQuantityChange(1);
            this.props.onSelection(true);
        }
        if (((_a = this.props.products) === null || _a === void 0 ? void 0 : _a.length) === 1 && ((_b = prevProps === null || prevProps === void 0 ? void 0 : prevProps.products) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            var initialFilters = this.state.activeFilters;
            if (!initialFilters || !Object.keys(initialFilters).length) {
                initialFilters = this.getInitialFilters(this.props.attributes);
            }
            this.getSkuByAttributes(initialFilters);
        }
    };
    /**
     * This method checks if there is only one option available.
     * If this is the case, return only this value.
     * This will make sure the select boxes are prefilled with the only available option.
     */
    Prescription.prototype.getInitialState = function (options) {
        if (!options) {
            return undefined;
        }
        if (options instanceof Set && options.size === 1) {
            var value = options.values().next().value;
            return {
                value: value,
            };
        }
        if (Array.isArray(options) && options.length === 1) {
            var value = options[0].value;
            return {
                value: value,
            };
        }
        return { value: '' };
    };
    Prescription.prototype.renderStockIndicator = function () {
        var _a = this.props, availableQuantity = _a.availableQuantity, isStockEnabled = _a.isStockEnabled;
        if (!isStockEnabled || !this.state.foundProduct) {
            return null;
        }
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__[/* StockIndicator */ "d"], { stockCount: availableQuantity, allowBackOrder: this.state.allowBackOrder }));
    };
    Prescription.prototype.render = function () {
        var _this = this;
        var _a = this.props, isActive = _a.isActive, availableQuantity = _a.availableQuantity, id = _a.id, currentBreakpoint = _a.currentBreakpoint, intl = _a.intl, quantity = _a.quantity, className = _a.className, isSubscriptionSelected = _a.isSubscriptionSelected, isAvailableForSubscription = _a.isAvailableForSubscription;
        var _b = this.state, foundProduct = _b.foundProduct, allowBackOrder = _b.allowBackOrder, attributes = _b.attributes;
        var contentLabel = id === 'left' ? 'contactLenses.leftEye' : 'contactLenses.rightEye';
        var isMobile = currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE ||
            currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT;
        var checkboxClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription__checkbox', {
            'prescription__checkbox--indented': id === 'right' && !isMobile,
            'prescription__checkbox--selectable': !isSubscriptionSelected || isAvailableForSubscription,
        });
        var checkboxLabelClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription__checkbox-label', {
            'prescription__checkbox-label--indented': !isSubscriptionSelected || isAvailableForSubscription,
        });
        var stockIndicatorClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription__stock-indicator', {
            'prescription__stock-indicator--indented': id === 'right' && !isMobile,
        });
        var quantitySelectorClass = classnames__WEBPACK_IMPORTED_MODULE_11___default()('prescription__quantity-selector', {
            'prescription__quantity-selector--indented': id === 'right' && !isMobile,
        });
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription " + className, "data-t": this.props['data-t'] },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("label", { className: checkboxClass },
                (!isSubscriptionSelected || isAvailableForSubscription) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Checkbox */ "c"], { value: id, checked: isActive, onChange: function (event) {
                        _this.props.onSelection(event.checked);
                    }, "data-t": "prescription-checkbox" })),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: checkboxLabelClass }, intl.getLabel("products." + contentLabel))),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "prescription__selectors" },
                attributes.color && this.renderSelectElement('color'),
                attributes.power && this.renderPowerSelector(isMobile),
                attributes.baseCurve && this.renderSelectElement('baseCurve'),
                attributes.diameter && this.renderSelectElement('diameter'),
                attributes.axis && this.renderSelectElement('axis'),
                attributes.addition && this.renderSelectElement('addition'),
                attributes.cylinder && this.renderSelectElement('cylinder')),
            (!isSubscriptionSelected || isAvailableForSubscription) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: quantitySelectorClass },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* QuantitySelector */ "Z"], { quantity: quantity, minimumQuantity: 1, maximumQuantity: this.getQuantitySelectorMaximumQuantity(), isDisabled: !isActive ||
                        (foundProduct &&
                            !foundProduct.attributes.allowBackOrder &&
                            !allowBackOrder &&
                            !availableQuantity), onDecreaseQuantity: function () { return _this.handleQuantityChange(quantity, 'decrease'); }, onIncreaseQuantity: function () { return _this.handleQuantityChange(quantity, 'increase'); }, "data-t": "prescription-quantity" }))),
            (!isSubscriptionSelected || !isAvailableForSubscription) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: stockIndicatorClass }, this.renderStockIndicator()))));
    };
    Prescription.defaultProps = {
        allowBackOrder: true,
        isActive: true,
    };
    return Prescription;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var Prescription$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].WithBreakpoints(Prescription));
function powerToFloat(power) {
    return powerValueToFloat(power === null || power === void 0 ? void 0 : power.value);
}
function powerValueToFloat(powerValue) {
    return parseFloat(powerValue.replace(/[^\d.+-]/g, ''));
}

var PrescriptionContainer = function (props) {
    var actions = useLensBundle().attributes.actions;
    // Use void function to scope logic to only lens bundle enabled products
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var handleLensBundleChange = props.hasSubscriptions ? actions.setAttribute : function () { };
    // Preliminary sorting of selected packSize
    var products = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return props.products.filter(function (product) { return product.attributes.packageQuantity === props.packSize; }); }, [props.products, props.packSize]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Prescription$1, __assign({}, props, { products: products, handleLensBundleChange: handleLensBundleChange })));
};

/**
 * A customer's optician can either be internal or extrnal.
 * Internal = the OpCo of which the site is being visited (e.g. Vision express)
 * External = any other Optician that does eye tests (the user will have to specifiy the opticians information)
 */
var OpticianType;
(function (OpticianType) {
    OpticianType["Internal"] = "internal";
    OpticianType["External"] = "external";
})(OpticianType || (OpticianType = {}));
var Optician = function (_a) {
    var selectedStore = _a.selectedStore, onStoreChange = _a.onStoreChange, selectedOpticianType = _a.selectedOpticianType, onOpticianTypeChange = _a.onOpticianTypeChange, OpticianForm = _a.opticianForm;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var radioOptions = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return [
        {
            value: OpticianType.Internal,
            label: getLabel('products.contactLens.info.optician.internal'),
        },
        {
            value: OpticianType.External,
            label: getLabel('products.contactLens.info.optician.external'),
        },
    ]; }, [getLabel]);
    var handleRadiosChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (_a) {
        var value = _a.value;
        onOpticianTypeChange(value);
    }, [onOpticianTypeChange]);
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-info-optician" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "prescription-info-optician__label" },
            getLabel('products.contactLens.info.optician.label'),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tooltip */ "sb"], { message: getLabel('products.contactLens.info.optician.hint'), id: "validation-optician-tooltip" })),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* RadioButtons */ "w"], { formName: "optician-type", scope: "opticianType", alignment: "vertical", onChange: handleRadiosChange, initialValue: selectedOpticianType, items: radioOptions }),
        selectedOpticianType === OpticianType.Internal && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-info-optician__store-finder" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_stores__WEBPACK_IMPORTED_MODULE_22__[/* PreferredStoreFinder */ "a"], { selected: selectedStore, onStoreSelect: onStoreChange }))),
        selectedOpticianType === OpticianType.External && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-info-optician__store-form" }, OpticianForm))));
};

var createExternalOpticianInfo = function (formState) {
    var obj = Object.entries(formState).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], field = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = field ? field.value : '', _b)));
    }, {});
    return JSON.stringify(obj);
};
var isInfoValid = function (state, opticianType, isPrescriptionExtraInfoEnabled) {
    if (isPrescriptionExtraInfoEnabled === void 0) { isPrescriptionExtraInfoEnabled = true; }
    var prescriptionExpiryDate = state.prescriptionExpiryDate, externalOptician = state.externalOptician, internalOptician = state.internalOptician, consent = state.consent;
    // when isPrescriptionExtraInfoEnabled is false, having consent is enough to continue
    if (!isPrescriptionExtraInfoEnabled && consent) {
        return true;
    }
    if (!prescriptionExpiryDate || !consent) {
        return false;
    }
    if (opticianType === OpticianType.Internal && !internalOptician) {
        return false;
    }
    if (opticianType === OpticianType.External && !externalOptician) {
        return false;
    }
    return true;
};
var onlyHistory = function () {
    return _grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Util */ "D"].createMaxDate(new Date(), 0);
};
var getMaxExpiryDate = function () {
    var maxYears = 5;
    var date = new Date();
    date.setFullYear(date.getFullYear() + maxYears);
    return date;
};
var PrescriptionInfo = function (_a) {
    var onChange = _a.onChange, opticianForm = _a.opticianForm, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'MMMM d, yyyy' : _b, _c = _a.isPrescriptionExtraInfoEnabled, isPrescriptionExtraInfoEnabled = _c === void 0 ? true : _c, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _d = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(), 2), examDate = _d[0], setExamDate = _d[1];
    var _e = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(), 2), expiryDate = _e[0], setExpiryDate = _e[1];
    var _f = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(OpticianType.Internal), 2), opticianType = _f[0], setOpticianType = _f[1];
    var _g = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(), 2), selectedStore = _g[0], setSelectedStore = _g[1];
    var _h = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(), 2), opticianInfo = _h[0], setOpticanInfo = _h[1];
    var _j = __read(react__WEBPACK_IMPORTED_MODULE_10___default.a.useState(false), 2), consent = _j[0], setConsent = _j[1];
    var handleExamDateChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (date) {
        setExamDate(date);
    }, []);
    var handleExpiryDateChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (date) {
        setExpiryDate(date);
    }, []);
    var handleOpticianTypeChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (type) {
        setOpticianType(type);
    }, []);
    var handleStoreChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (store) {
        setSelectedStore(store);
    }, []);
    var handleOpticianFormChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (form) {
        if (form.formValid) {
            setOpticanInfo(form.formState);
        }
    }, []);
    var handleConsentChange = react__WEBPACK_IMPORTED_MODULE_10___default.a.useCallback(function (_a) {
        var checked = _a.checked;
        setConsent(checked);
    }, []);
    var state = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return (__assign(__assign({ prescriptionExamDate: examDate && examDate.toISOString(), prescriptionExpiryDate: expiryDate && expiryDate.toISOString() }, (opticianType === OpticianType.Internal
        ? { internalOptician: selectedStore && selectedStore.code.toString() }
        : { externalOptician: opticianInfo && createExternalOpticianInfo(opticianInfo) })), { consent: consent })); }, [examDate, expiryDate, opticianType, opticianInfo, consent, selectedStore]);
    react__WEBPACK_IMPORTED_MODULE_10___default.a.useEffect(function () {
        if (onChange) {
            onChange(__assign(__assign({}, state), { valid: isInfoValid(state, opticianType, isPrescriptionExtraInfoEnabled) }));
        }
    }, [onChange, state, opticianType]);
    var OpticianForm = (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* Form */ "j"], { name: "opticianForm", "data-t": "optician-form", className: "prescription-info-optician__form", initialFormState: opticianInfo, onChange: handleOpticianFormChange }, opticianForm && opticianForm()));
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-info" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { className: "prescription-info__heading", variant: "smallest" }, getLabel('products.contactLenses.info.title')),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* RequiredFieldsLabel */ "z"], null),
        prescriptionInfoAdditionalContent,
        isPrescriptionExtraInfoEnabled && (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-info__dates" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* DatePicker */ "f"], { label: getLabel('products.contactLenses.info.eyeTestDate.label'), placeholder: getLabel('common.selectDate'), optionalText: getLabel('checkout.form.field.optional'), initialValue: examDate, onChange: handleExamDateChange, required: false, maxDate: onlyHistory(), dateFormat: dateFormat }),
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_7__[/* DatePicker */ "f"], { label: getLabel('products.contactLenses.info.expiryDate.label'), tooltip: getLabel('products.contactLenses.info.expiryDate.hint'), errorMessage: getLabel('products.contactLenses.info.expiryDate.errorMessage'), placeholder: getLabel('common.selectDate'), initialValue: expiryDate, onChange: handleExpiryDateChange, maxDate: getMaxExpiryDate(), dateFormat: dateFormat })),
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Optician, { opticianForm: OpticianForm, selectedStore: selectedStore, onStoreChange: handleStoreChange, selectedOpticianType: opticianType, onOpticianTypeChange: handleOpticianTypeChange }))),
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "prescription-info__consent" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("label", { className: "prescription-info__checkbox-label" },
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Checkbox */ "c"], { className: "prescription-info__checkbox", id: "prescription-info-consent", value: "prescription-info-consent", checked: consent, onChange: handleConsentChange }),
                react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "prescription-info__checkbox-label-text" }, getLabel('products.contactLenses.info.consent'))))));
};

var MonthlyPrice = function (_a) {
    var currency = _a.currency, price = _a.price, labels = _a.labels;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "contact-lens-configurator__monthly-price" },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price.centAmount, currency: currency, className: "contact-lens-configurator__pack-size-price" }),
            ' / ',
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "caption", component: "span" }, labels.perMonth))));
};

var MonthlyPriceContainer = function () {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), currency = _a.currency, getLabel = _a.getLabel;
    var pricePerMonth = useLensBundle().pricePerMonth;
    var labels = react__WEBPACK_IMPORTED_MODULE_10___default.a.useMemo(function () { return ({
        perMonth: getLabel('common.frequency.perMonth'),
    }); }, [getLabel]);
    if (!pricePerMonth) {
        return null;
    }
    return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(MonthlyPrice, { currency: currency, labels: labels, price: pricePerMonth });
};

var ProductDetailUnitInfo = function (_a) {
    var amount = _a.amount, valueUnits = _a.valueUnits, perBox = _a.perBox, _b = _a["data-t"], dataT = _b === void 0 ? 'product-detail-unit-info' : _b;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-unit-info", "data-t": dataT },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-unit-info__amount" },
            amount,
            " ",
            amount > 1 ? valueUnits.plural : valueUnits.singular),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-unit-info__unit" },
            " ",
            perBox,
            " ")));
};

var joinExistingStrings = function (strings, separator) {
    return strings.filter(function (value) { return !!value; }).join(separator || '');
};

var QuantityContainer = function (_a) {
    var items = _a.items, handleClick = _a.handleClick, selected = _a.selected;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "quantity-container" }, items.map(function (item) { return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("button", { key: item.label, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('quantity-container__item', {
            _is_selected: selected.value === item.value,
        }), onClick: function () { return handleClick(item); }, "data-t": item.label },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: "quantity-container__quantity" },
            react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "quantity-container__amount" }, item.label),
            item.subtext && react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "quantity-container__subtext" }, item.subtext)),
        item.aside && react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", { className: "quantity-container__aside" }, item.aside))); })));
};

var PackageQuantityItem = function (_a) {
    var label = _a.label, subtext = _a.subtext, aside = _a.aside, className = _a.className;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: className + "__content" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: className + "__quantity" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: className + "__amount" }, label),
            subtext && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: className + "__subtext" }, subtext)),
        aside && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: className + "__aside" }, aside)));
};

var PackageQuantityDropdown = function (_a) {
    var title = _a.title, items = _a.items, selectedSize = _a.selectedSize, onChange = _a.onChange, _b = _a["data-t"], dataT = _b === void 0 ? 'package-quantity-dropdown' : _b;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(function () {
        var item = items.find(function (_a) {
            var value = _a.value;
            return value === selectedSize;
        });
        return item || items[0] || { value: '', label: '' };
    }), 2), selected = _c[0], setSelected = _c[1];
    var _d = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), isOpen = _d[0], setIsOpen = _d[1];
    var dropdownRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(null);
    Object(use_onclickoutside__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"])(dropdownRef, function () { return setIsOpen(false); });
    var label = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantityItem, __assign({ className: "package-quantity-dropdown" }, selected)); }, [selected]);
    var handleSelect = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (option) {
        setSelected(option);
        setIsOpen(false);
        onChange(option);
    }, []);
    var handleClick = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        setIsOpen(function (isOpen) { return !isOpen; });
    }, []);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "package-quantity-dropdown", ref: dropdownRef, "data-t": dataT },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "package-quantity-dropdown__label" }, getLabel('products.contactLenses.boxQuantity')),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* ButtonWithDropdown */ "b"], { title: title, label: label, className: "package-quantity-dropdown__button", onClick: handleClick, isActive: isOpen, isFullWidth: true },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(QuantityContainer, { items: items, handleClick: handleSelect, selected: selected }))));
};

var PackageQuantity = function (_a) {
    var _b = _a["data-t"], dataT = _b === void 0 ? 'package-quantity' : _b, handlePackSizeChange = _a.handlePackSizeChange, selectedSize = _a.selectedSize, packageQuantities = _a.packageQuantities, className = _a.className, children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()(['contact-lens-configurator__package-quantity', className]), "data-t": dataT }, packageQuantities.length === 1 ? (children) : (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PackageQuantityDropdown, { items: packageQuantities, title: packageQuantities[0].value, selectedSize: "" + selectedSize, onChange: handlePackSizeChange }))));
};

var PriceAside = function (_a) {
    var value = _a.value, currency = _a.currency, discountValue = _a.discountValue, asideLabel = _a.asideLabel;
    if (!value)
        return null;
    var isZeroPercentDiscount = value === discountValue;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: value, currency: currency, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('contact-lens-configurator__pack-size-price', {
                'contact-lens-configurator__pack-size-price--original': discountValue && !isZeroPercentDiscount,
            }) }),
        discountValue && !isZeroPercentDiscount && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: discountValue, currency: currency, className: "contact-lens-configurator__pack-size-price contact-lens-configurator__pack-size-price--discounted" })),
        asideLabel && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "contact-lens-configurator__reminder" },
            " ",
            asideLabel)));
};

var usePackageQuantity = function (packageTypes, mapper) {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), currency = _a.currency, getLabel = _a.getLabel, hasLabel = _a.hasLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        lenses: getLabel('products.unit.contactLenses'),
        lens: getLabel('products.unit.contactLens'),
        box: getLabel('products.unit.contactLensBox'),
        boxes: getLabel('products.unit.contactLensBoxes'),
        perEye: hasLabel('products.perEye') ? getLabel('products.perEye') : '',
        perBoxLabel: getLabel('products.perBox'),
        perMonth: getLabel('common.frequency.perMonth'),
    }); }, [getLabel, hasLabel]);
    var packageQuantities = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return packageTypes.map(function (pack) { return mapper(pack, labels, currency); });
    }, [packageTypes, labels, currency]);
    return {
        labels: labels,
        packageQuantities: packageQuantities,
    };
};

var PackageQuantityContainer = function (_a) {
    var handlePackSizeChange = _a.handlePackSizeChange, packageTypes = _a.packageTypes, selectedSize = _a.selectedSize;
    var mapper = function (pack, labels, currency) {
        var _a;
        var price = pack.price;
        var value = pack.packageQuantity.toString();
        return {
            label: value + " " + labels.lenses,
            value: value,
            subtext: joinExistingStrings([labels.perBoxLabel, labels.perEye], ', '),
            aside: (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PriceAside, { value: price.value.centAmount, currency: currency, discountValue: (_a = price === null || price === void 0 ? void 0 : price.discounted) === null || _a === void 0 ? void 0 : _a.value.centAmount, asideLabel: labels.perEye })),
        };
    };
    var _b = usePackageQuantity(packageTypes, mapper), labels = _b.labels, packageQuantities = _b.packageQuantities;
    return (react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(PackageQuantity, { handlePackSizeChange: handlePackSizeChange, selectedSize: selectedSize, packageQuantities: packageQuantities },
        react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(ProductDetailUnitInfo, { amount: +packageQuantities[0].value, valueUnits: {
                singular: labels.lens,
                plural: labels.lenses,
            }, perBox: packageQuantities[0].subtext })));
};

var PackageQuantityContainer$1 = function (_a) {
    var handlePackSizeChange = _a.handlePackSizeChange, selectedSize = _a.selectedSize, packageTypes = _a.packageTypes;
    var mapper = function (pack, labels, currency) {
        var price = pack.basePrice;
        var value = pack.packageQuantity.toString();
        return {
            label: value + " " + labels.lenses,
            value: value,
            subtext: joinExistingStrings([labels.perBoxLabel, labels.perEye], ', '),
            aside: (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PriceAside, { value: price.price, currency: currency, asideLabel: joinExistingStrings([labels.perMonth, labels.perEye], ', ') })),
        };
    };
    var packageQuantities = usePackageQuantity(packageTypes, mapper).packageQuantities;
    if (packageQuantities.length === 0) {
        return null;
    }
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (_a) {
        var value = _a.value;
        handlePackSizeChange(+value || 0);
    }, [handlePackSizeChange]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantity, { handlePackSizeChange: handleChange, selectedSize: selectedSize, packageQuantities: packageQuantities },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantityItem, { className: "package-quantity-dropdown", label: packageQuantities[0].label, subtext: packageQuantities[0].subtext, aside: packageQuantities[0].aside })));
};

var DailyPackageQuantityContainer = function (_a) {
    var handlePackSizeChange = _a.handlePackSizeChange, selectedSize = _a.selectedSize, packageTypes = _a.packageTypes;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var mapper = function (pack, labels, currency) {
        var basePrice = pack.basePrice, packageQuantity = pack.packageQuantity, includedUnits = pack.includedUnits, usageLevel = pack.usageLevel;
        var value = usageLevel || '';
        return {
            label: getLabel("products.contactLenses.usageLevel." + value),
            value: value,
            subtext: joinExistingStrings([
                getFormattedLabel('products.contactLenses.amountPerBox', {
                    labelData: {
                        includedUnits: includedUnits,
                        packageQuantity: packageQuantity,
                        boxLabel: includedUnits > 1 ? labels.boxes : labels.box,
                        lensLabel: packageQuantity > 1 ? labels.lenses : labels.lens,
                    },
                }),
                labels.perEye,
            ], ', '),
            aside: (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PriceAside, { value: basePrice.price, currency: currency, asideLabel: joinExistingStrings([labels.perMonth, labels.perEye], ' ') })),
        };
    };
    var packageQuantities = usePackageQuantity(packageTypes, mapper).packageQuantities;
    if (packageQuantities.length === 0) {
        return null;
    }
    var handleChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (_a) {
        var value = _a.value;
        handlePackSizeChange(value);
    }, [handlePackSizeChange]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantity, { handlePackSizeChange: handleChange, selectedSize: selectedSize, packageQuantities: packageQuantities, className: "contact-lens-configurator__package-quantity--daily" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantityItem, { className: "package-quantity-dropdown", label: packageQuantities[0].label, subtext: packageQuantities[0].subtext, aside: packageQuantities[0].aside })));
};

var getPriceForPack = function (packSize, packageTypes) {
    var matchedVariant = packageTypes.find(function (packageType) { return packageType.packageQuantity === packSize; });
    // not using multiple prices for now
    return matchedVariant && matchedVariant.price;
};

var ContactLensesConfigurator = /** @class */ (function (_super) {
    __extends(ContactLensesConfigurator, _super);
    function ContactLensesConfigurator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedVariants: {},
            leftEyeChecked: true,
            leftEyeBoxQuantity: 1,
            prescriptionModalOpen: false,
            rightEyeChecked: true,
            rightEyeBoxQuantity: 1,
            packSize: 0,
        };
        _this.setInitialPackSize = function (_a, rateplan) {
            var packageQuantity = _a.packageQuantity;
            packageQuantity && _this.handlePackSizeChange(packageQuantity);
            if (rateplan === null || rateplan === void 0 ? void 0 : rateplan.usageLevel) {
                _this.handleUsageLevelChange(rateplan.usageLevel);
            }
            else {
                (rateplan === null || rateplan === void 0 ? void 0 : rateplan.packageQuantity) && _this.handleSubscriptionPackSizeChange(rateplan.packageQuantity);
            }
        };
        _this.handleChange = function (key, value) {
            var handleFormChange = _this.props.handleFormChange;
            _this.setState(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[key] = value, _a)));
            }, function () { return handleFormChange && handleFormChange(_this.state); });
        };
        _this.handleLeftEyeChecked = _this.handleChange.bind(_this, 'leftEyeChecked');
        _this.handleRightEyeChecked = _this.handleChange.bind(_this, 'rightEyeChecked');
        _this.handleLeftEyeQuantity = _this.handleChange.bind(_this, 'leftEyeBoxQuantity');
        _this.handleRightEyeQuantity = _this.handleChange.bind(_this, 'rightEyeBoxQuantity');
        _this.handleSubscriptionPriceChange = _this.handleChange.bind(_this, 'subscriptionPrice');
        _this.handlePackSizeChange = function (packSize) {
            var newPackSize;
            switch (typeof packSize) {
                case 'string':
                    newPackSize = parseInt(packSize);
                    break;
                case 'number':
                    newPackSize = packSize;
                    break;
                case 'object':
                    newPackSize = +packSize.value;
                    break;
            }
            _this.setState({
                packPrice: getPriceForPack(newPackSize, _this.props.packageTypes),
            }, function () { return _this.handleChange('packSize', newPackSize); });
        };
        _this.handleSubscriptionPackSizeChange = function (packSize) {
            var _a;
            _this.setState({
                subscriptionPrice: ((_a = _this.props.ratePlans.find(function (_a) {
                    var packageQuantity = _a.packageQuantity;
                    return packageQuantity === +packSize;
                })) === null || _a === void 0 ? void 0 : _a.basePrice.price) || 0,
            }, function () { return _this.handleChange('subscriptionPackSize', packSize); });
        };
        _this.handleUsageLevelChange = function (selectedUsageLevel) {
            var _a;
            _this.setState({
                subscriptionPrice: ((_a = _this.props.ratePlans.find(function (_a) {
                    var usageLevel = _a.usageLevel;
                    return usageLevel === selectedUsageLevel;
                })) === null || _a === void 0 ? void 0 : _a.basePrice.price) || 0,
            }, function () { return _this.handleChange('dailiesUsageLevel', selectedUsageLevel); });
        };
        _this.handleProductSelection = function (side, product) {
            var _a;
            _this.setState({
                selectedVariants: __assign(__assign({}, _this.state.selectedVariants), (_a = {}, _a[side] = product, _a)),
            });
            var skuKey = side === 'left' ? 'leftEyeBoxSKU' : 'rightEyeBoxSKU';
            var SKU = product && product.sku;
            _this.handleChange(skuKey, SKU);
            var availableQuantityKey = side === 'left' ? 'leftEyeBoxAvailableQuantity' : 'rightEyeBoxAvailableQuantity';
            var availableQuantity = product && _grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__[/* Helpers */ "c"].getAvailableQuantity(product.availability);
            _this.handleChange(availableQuantityKey, availableQuantity);
        };
        _this.handleLeftEyeProductSelection = _this.handleProductSelection.bind(_this, 'left');
        _this.handleRightEyeProductSelection = _this.handleProductSelection.bind(_this, 'right');
        _this.setScroll = function () {
            var body = document && document.body;
            if (body) {
                _this.state.prescriptionModalOpen && !body.classList.contains('body--no-scroll')
                    ? body.classList.add('body--no-scroll')
                    : body.classList.remove('body--no-scroll');
            }
        };
        _this.onPrescriptionModalOpen = function (event) {
            event.preventDefault();
            _this.setState({ prescriptionModalOpen: true }, function () {
                _this.setScroll();
            });
        };
        _this.onPrescriptionModalClose = function () {
            _this.setState({ prescriptionModalOpen: false }, function () {
                _this.setScroll();
            });
        };
        _this.handlePrescriptionInfoChange = function (prescriptionState) {
            _this.handleChange('prescriptionInfo', prescriptionState);
        };
        return _this;
    }
    ContactLensesConfigurator.prototype.componentDidMount = function () {
        this.setInitialPackSize(this.props.packageTypes[0], this.props.ratePlans[0]);
    };
    ContactLensesConfigurator.prototype.showErrorAlert = function () {
        var _a = this.props, intl = _a.intl, formValidations = _a.formValidations;
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* ScrollIntoView */ "db"], { key: formValidations.errorCount },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "error", icon: "alert-circle" }, intl.getFormattedLabel('products.contactLenses.prescription.text', { parseLink: true }))));
    };
    ContactLensesConfigurator.prototype.render = function () {
        var _a = this.props, attributes = _a.attributes, prescriptionModalContent = _a.prescriptionModalContent, intl = _a.intl, isStockEnabled = _a.isStockEnabled, maxOrderableQuantity = _a.maxOrderableQuantity, allowBackOrder = _a.allowBackOrder, isPrescriptionInfoEnabled = _a.isPrescriptionInfoEnabled, isPrescriptionExtraInfoEnabled = _a.isPrescriptionExtraInfoEnabled, opticianForm = _a.opticianForm, dateFormat = _a.dateFormat, formValidations = _a.formValidations, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent, variantData = _a.variantData, packageTypes = _a.packageTypes, isAvailableForSubscription = _a.isAvailableForSubscription, isDaily = _a.isDaily, isSubscriptionSelected = _a.isSubscriptionSelected, promotionalText = _a.promotionalText, hasSubscriptions = _a.hasSubscriptions, ratePlans = _a.ratePlans;
        var _b = this.state, leftEyeChecked = _b.leftEyeChecked, leftEyeBoxQuantity = _b.leftEyeBoxQuantity, leftEyeBoxAvailableQuantity = _b.leftEyeBoxAvailableQuantity, rightEyeChecked = _b.rightEyeChecked, rightEyeBoxQuantity = _b.rightEyeBoxQuantity, rightEyeBoxAvailableQuantity = _b.rightEyeBoxAvailableQuantity, packSize = _b.packSize, prescriptionModalOpen = _b.prescriptionModalOpen;
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "contact-lens-configurator" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                promotionalText && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "body" }, promotionalText),
                isSubscriptionSelected ? (isAvailableForSubscription ? (isDaily ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(DailyPackageQuantityContainer, { packageTypes: ratePlans, selectedSize: this.state.dailiesUsageLevel, handlePackSizeChange: this.handleUsageLevelChange })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantityContainer$1, { packageTypes: ratePlans, selectedSize: this.state.subscriptionPackSize, handlePackSizeChange: this.handleSubscriptionPackSizeChange }))) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(MonthlyPriceContainer, null))) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PackageQuantityContainer, { handlePackSizeChange: this.handlePackSizeChange, selectedSize: this.state.packSize, packageTypes: packageTypes })),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "contact-lens-configurator__error-message" }, formValidations.showError &&
                    !formValidations.isConfiguratorValid &&
                    this.showErrorAlert()),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "contact-lens-configurator__prescription" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionContainer, { isSubscriptionSelected: isSubscriptionSelected, hasSubscriptions: hasSubscriptions, isStockEnabled: isStockEnabled, isActive: rightEyeChecked, id: "right", onSelection: this.handleRightEyeChecked, isAvailableForSubscription: isAvailableForSubscription, quantity: rightEyeBoxQuantity, availableQuantity: rightEyeBoxAvailableQuantity, attributes: attributes, products: variantData, packSize: packSize, onFoundProduct: this.handleRightEyeProductSelection, onQuantityChange: this.handleRightEyeQuantity, "data-t": "prescription-right-eye", maxOrderableQuantity: maxOrderableQuantity, allowBackOrder: allowBackOrder, className: "contact-lens-configurator__prescription-right", hasError: formValidations.showError }),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionContainer, { isSubscriptionSelected: isSubscriptionSelected, hasSubscriptions: hasSubscriptions, isStockEnabled: isStockEnabled, isActive: leftEyeChecked, id: "left", onSelection: this.handleLeftEyeChecked, isAvailableForSubscription: isAvailableForSubscription, quantity: leftEyeBoxQuantity, availableQuantity: leftEyeBoxAvailableQuantity, attributes: attributes, products: variantData, packSize: packSize, onFoundProduct: this.handleLeftEyeProductSelection, onQuantityChange: this.handleLeftEyeQuantity, "data-t": "prescription-left-eye", maxOrderableQuantity: maxOrderableQuantity, allowBackOrder: allowBackOrder, className: "contact-lens-configurator__prescription-left", hasError: formValidations.showError })),
                prescriptionModalContent && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("button", { className: "contact-lens-configurator__prescription-link", onClick: this.onPrescriptionModalOpen }, intl.getLabel('products.contactLenses.prescription.link')),
                    prescriptionModalOpen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Modal */ "Q"], { showIcon: true, isOpen: prescriptionModalOpen, onModalClose: this.onPrescriptionModalClose },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "contact-lens-configurator__prescription-modal" },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* RichTextArea */ "cb"], { content: prescriptionModalContent })))))),
                isPrescriptionInfoEnabled && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    formValidations.showError &&
                        !formValidations.isPrescriptionInfoValid &&
                        (formValidations.isConfiguratorValid ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* ScrollIntoView */ "db"], { key: formValidations.errorCount },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { icon: "info", message: intl.getLabel('products.contactLens.info.invalidMessage') }))) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { icon: "info", message: intl.getLabel('products.contactLens.info.invalidMessage') }))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PrescriptionInfo, { opticianForm: opticianForm, dateFormat: dateFormat, onChange: this.handlePrescriptionInfoChange, isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled, prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent }))))));
    };
    return ContactLensesConfigurator;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var ContactLensesConfigurator$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(ContactLensesConfigurator);

var getSortedPackageTypes = function (masterPackageType, packageTypes) {
    // Put the master package type first,
    // this will guarantee the default selected
    var newPackageTypes = __spread([masterPackageType], packageTypes);
    // remove duplicates
    return newPackageTypes.reduce(function (prev, curr) {
        var duplicate = prev.some(function (packageType) { return packageType.packageQuantity === curr.packageQuantity; });
        if (!duplicate) {
            prev.push(curr);
        }
        return prev;
    }, []);
};

// only dailies should have a usageLevel attribute present
var isRateplansDaily = function (ratePlans) {
    return !ratePlans.length ? false : ratePlans.every(function (_a) {
        var usageLevel = _a.usageLevel;
        return !!usageLevel;
    });
};

var allowedAttributes = [
    'addition',
    'axis',
    'baseCurve',
    'color',
    'cylinder',
    'diameter',
    'power',
    'packageQuantity',
];
var ContactLensesConfiguratorContainer = /** @class */ (function (_super) {
    __extends(ContactLensesConfiguratorContainer, _super);
    function ContactLensesConfiguratorContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            attributes: {},
            isLoading: true,
            isDaily: false,
            packageTypes: [],
            variantData: [],
            ratePlans: [],
        };
        _this.getLensData = function (variantGroup) { return __awaiter(_this, void 0, void 0, function () {
            var _a, apiKey, productsUrl, subscriptionsUrl, lensData, ratePlans, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props.apiConfig, apiKey = _a.apiKey, productsUrl = _a.productsUrl, subscriptionsUrl = _a.subscriptionsUrl;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].getContactLenses(productsUrl, { variantGroup: variantGroup }, apiKey)];
                    case 2:
                        lensData = _b.sent();
                        ratePlans = [];
                        if (!this.props.isAvailableForSubscription) return [3 /*break*/, 4];
                        return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Subscriptions */ "j"].RatePlans.defaults(subscriptionsUrl, {
                                brandKey: variantGroup,
                            })];
                    case 3:
                        ratePlans = _b.sent();
                        if (isRateplansDaily(ratePlans)) {
                            this.setState({ isDaily: true });
                        }
                        else {
                            ratePlans = ratePlans.sort(function (a, b) { return a.packageQuantity - b.packageQuantity; });
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/, this.parseLensData(lensData, ratePlans)];
                    case 5:
                        err_1 = _b.sent();
                        console.warn('No variant data provided', err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.parseLensData = function (lensData, ratePlans) {
            var availableAttributes = {};
            var contactLensesVariants = lensData.contactLensesVariants, masterPackageType = lensData.masterPackageType, packageTypes = lensData.packageTypes;
            contactLensesVariants.forEach(function (_a) {
                var e_1, _b;
                var attributes = _a.attributes;
                try {
                    for (var _c = __values(Object.keys(attributes)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var key = _d.value;
                        if (allowedAttributes.includes(key)) {
                            var value = attributes[key];
                            if (!availableAttributes[key]) {
                                availableAttributes[key] = {
                                    selected: '',
                                    values: new Set(),
                                };
                            }
                            availableAttributes[key].values.add(value);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
            _this.setState({
                attributes: availableAttributes,
                isLoading: false,
                packageTypes: getSortedPackageTypes(masterPackageType, packageTypes),
                variantData: contactLensesVariants,
                ratePlans: ratePlans,
            });
        };
        return _this;
    }
    ContactLensesConfiguratorContainer.prototype.componentDidMount = function () {
        return this.getLensData(this.props.variantGroup);
    };
    ContactLensesConfiguratorContainer.prototype.render = function () {
        return this.state.isLoading ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Loader */ "L"], { className: "contact-lens-configurator__loader" })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ContactLensesConfigurator$1, __assign({}, this.props, { attributes: this.state.attributes, packageTypes: this.state.packageTypes, variantData: this.state.variantData, ratePlans: this.state.ratePlans, isDaily: this.state.isDaily })));
    };
    return ContactLensesConfiguratorContainer;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var ContactLensesConfigurator$2 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withApiConfig */ "U"])(ContactLensesConfiguratorContainer);

var ProductDetailLensesFeatures = function (_a) {
    var hydration = _a.hydration, softness = _a.softness, breathability = _a.breathability, fatigue = _a.fatigue, basics = _a.basics, uv = _a.uv, color = _a.color;
    if (!hydration && !softness && !breathability && !fatigue && !basics && !uv && !color) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("ul", { className: "product-detail-lenses-features" },
        basics && basics.variantHasAttribute && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--basics" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "basics", color: color, size: 38 }),
            basics.label)),
        hydration && hydration.variantHasAttribute && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--hydration" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "hydratation", color: color, size: 38 }),
            hydration.label)),
        softness && softness.variantHasAttribute && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--softness" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "softness", color: color, size: 38 }),
            softness.label)),
        breathability && breathability.variantHasAttribute && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--breathability" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "breathability", color: color, size: 38 }),
            breathability.label)),
        fatigue && fatigue.variantHasAttribute && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--fatigue" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "fatigue", color: color, size: 38 }),
            fatigue.label)),
        uv && uv.variantHasAttribute && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--uv" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "uv", color: color, size: 38 }),
            uv.label))));
};

var Description = function (_a) {
    var colorFeatureIcons = _a.colorFeatureIcons, labels = _a.labels, lensFeatures = _a.lensFeatures, productFeatures = _a.productFeatures, specificationVariant = _a.specificationVariant;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailDescription, { title: labels.title, header: labels.header, description: labels.description },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailLensesFeatures, __assign({ color: colorFeatureIcons }, lensFeatures)),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailSpecification, { configuration: productFeatures, variant: specificationVariant })));
};

var DescriptionContainer = function (_a) {
    var colorFeatureIcons = _a.colorFeatureIcons, specificationVariant = _a.specificationVariant, variant = _a.variant, specificationConfiguration = _a.specificationConfiguration;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        description: variant.description,
        header: variant.header,
        title: getLabel('products.contactLenses.header.details'),
    }); }, [getLabel, variant]);
    var _b = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return getContactLensFeatures(variant, getLabel); }, [getLabel, variant]), productFeatures = _b.productFeatures, lensFeatures = _b.lensFeatures;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Description, { colorFeatureIcons: colorFeatureIcons, labels: labels, lensFeatures: lensFeatures, productFeatures: specificationConfiguration || productFeatures, specificationVariant: specificationVariant }));
};

var SubscriptionOffer = function (_a) {
    var className = _a.className;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var label = getLabel('products.contactLenses.subscriptionOffer.label');
    var tooltipLabel = getLabel('products.contactLenses.subscriptionOffer.tooltip');
    if (!label) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()(['subscription-offer', className]) },
        tooltipLabel && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tooltip */ "sb"], { id: "subscription-offer_tooltip", message: tooltipLabel }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "subscription-offer__label" }, label)));
};

var Lenses = function (_a) {
    var addToCartRef = _a.addToCartRef, contactLensesConfiguratorConfig = _a.contactLensesConfiguratorConfig, ctaButton = _a.ctaButton, currency = _a.currency, deliveryIndicatorConfig = _a.deliveryIndicatorConfig, descriptionConfig = _a.descriptionConfig, _b = _a.hasSubscriptions, hasSubscriptions = _b === void 0 ? false : _b, isSmallScreen = _a.isSmallScreen, labels = _a.labels, packPrice = _a.packPrice, subscriptionPrice = _a.subscriptionPrice, productImageAlt = _a.productImageAlt, productTypeUsps = _a.productTypeUsps, showStickyButton = _a.showStickyButton, stickerText = _a.stickerText, stickyTop = _a.stickyTop, variant = _a.variant, variantGroup = _a.variantGroup, activeTabIndex = _a.activeTabIndex, setActiveTabIndex = _a.setActiveTabIndex, isSubscriptionSelected = _a.isSubscriptionSelected, isAvailableForSubscription = _a.isAvailableForSubscription, _c = _a.subscriptionConfiguratorModal, subscriptionConfiguratorModal = _c === void 0 ? null : _c;
    var _d, _e;
    var packPriceDiscount = (_d = packPrice === null || packPrice === void 0 ? void 0 : packPrice.discounted) === null || _d === void 0 ? void 0 : _d.value.centAmount;
    var hasPackPriceDiscount = typeof packPriceDiscount === 'number';
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__main product-detail-lenses" },
        isSmallScreen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__header--mobile" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailTitle$1, { brand: variant.brand, model: variant.replacementFrequency }),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* ReviewSnippet */ "c"], { productId: variantGroup }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__visual-switcher" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductVisualSwitcher, { productImages: variant.images, alt: productImageAlt, sticker: stickerText && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDiscountLabel$1, { title: variant.discountText ? variant.discountText : stickerText, modifier: "product-detail" })) })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__aside product-detail-lenses__aside" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Sticky */ "ib"], { top: stickyTop || 0, bottomBoundary: ".product-detail-lenses", enabled: !isSmallScreen },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    !isSmallScreen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailTitle$1, { brand: variant.brand, model: variant.replacementFrequency })),
                    packPrice && !isSubscriptionSelected && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-detail__specification-prices', {
                            'product-detail__specification-prices--has-discount': hasPackPriceDiscount,
                        }) },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__price-container" },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailPrice, { originalPrice: packPrice.value.centAmount, currency: currency, discountedPrice: packPriceDiscount })),
                        variant.discountText && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" })))),
                    subscriptionPrice && isSubscriptionSelected && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-detail__specification-prices', {
                            'product-detail__specification-prices--has-discount': false,
                        }) },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__price-container" },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailPrice, { originalPrice: subscriptionPrice, currency: currency })))),
                    !isSmallScreen && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* ReviewSnippet */ "c"], { productId: variantGroup }),
                    isSubscriptionSelected && isAvailableForSubscription && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], { className: "product-detail__usp-divider" }),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SubscriptionOffer, null))),
                    (hasSubscriptions || isAvailableForSubscription) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tabs */ "qb"], { onChange: setActiveTabIndex, activeTabIndex: activeTabIndex, variant: "secondary" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tab */ "pb"], { label: labels.oneTimeTitle }),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Tab */ "pb"], { label: labels.subscriptionTitle }))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__configuration product-detail-lenses__configuration" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ContactLensesConfigurator$2, __assign({}, contactLensesConfiguratorConfig, { isSubscriptionSelected: isSubscriptionSelected, isAvailableForSubscription: isAvailableForSubscription, hasSubscriptions: hasSubscriptions, variantGroup: variantGroup }))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__cart-details", ref: addToCartRef },
                        ctaButton,
                        isSmallScreen &&
                            showStickyButton &&
                            !!variant.price &&
                            (isSubscriptionSelected && !isAvailableForSubscription ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* StickyCallToAction */ "jb"], { button: ctaButton })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* StickyCallToAction */ "jb"], { button: ctaButton, price: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: (_e = (packPriceDiscount ? packPriceDiscount : packPrice === null || packPrice === void 0 ? void 0 : packPrice.value.centAmount)) !== null && _e !== void 0 ? _e : 0, currency: currency, centAmount: true }), perBox: labels.perBox })))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], { className: "product-detail__usp-divider" }),
                    !isSubscriptionSelected && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__[/* DeliveryIndicator */ "a"], __assign({}, deliveryIndicatorConfig)),
                    productTypeUsps && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductTypeUsps, { productTypeUsps: productTypeUsps })))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail-lenses__description" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(DescriptionContainer, __assign({}, descriptionConfig, { variant: variant }))),
        subscriptionConfiguratorModal));
};

var LensesContainer = function (_a) {
    var activeSku = _a.activeSku, addToCartRef = _a.addToCartRef, allowBackOrder = _a.allowBackOrder, colorFeatureIcons = _a.colorFeatureIcons, dateFormat = _a.dateFormat, deliveryResolverFactory = _a.deliveryResolverFactory, formatProductUrl = _a.formatProductUrl, isContactLensStockEnabled = _a.isContactLensStockEnabled, isPrescriptionEnabled = _a.isPrescriptionEnabled, _b = _a.isPrescriptionExtraInfoEnabled, isPrescriptionExtraInfoEnabled = _b === void 0 ? true : _b, _c = _a.isPrescriptionInfoEnabled, isPrescriptionInfoEnabled = _c === void 0 ? false : _c, isSolutionsEnabled = _a.isSolutionsEnabled, maxOrderableQuantity = _a.maxOrderableQuantity, onCTAClick = _a.onCTAClick, onPriceChange = _a.onPriceChange, opticianForm = _a.opticianForm, pageRoutes = _a.pageRoutes, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent, prescriptionModalContent = _a.prescriptionModalContent, product = _a.product, productTypeUsps = _a.productTypeUsps, showStickyButton = _a.showStickyButton, staticsUrl = _a.staticsUrl, stickerText = _a.stickerText, stickyTop = _a.stickyTop, storesRoute = _a.storesRoute, variant = _a.variant, hasSubscriptions = _a.hasSubscriptions, specificationConfiguration = _a.specificationConfiguration, renderAddToCartButton = _a.renderAddToCartButton;
    var excludedFromCheckout = variant.excludedFromCheckout, promotionalText = variant.promotionalText;
    var masterVariant = product.masterVariant;
    var _d = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), currency = _d.currency, getLabel = _d.getLabel, locale = _d.locale;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var isCartV2Enabled = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useFeatureToggles */ "P"])().isCartV2Enabled;
    var productViewHistory = useProductViewHistory();
    var _e = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(0), 2), activeTabIndex = _e[0], setActiveTabIndex = _e[1];
    var productCatKey = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product.masterVariant, 'recommendedProductCatKey');
    var recommendedCategoryKey = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isString */ "B"])(productCatKey) ? productCatKey : undefined;
    var variantGroup = String(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product.masterVariant, 'brandKey'));
    /**
     * "Old" way of handling subscriptions, currently in use by the BeNe opco's.
     */
    var isSubscriptionSelected = activeTabIndex === 1;
    /**
     * Enables the new subscription configurator based on a boolean variant attribute.
     */
    var isAvailableForSubscription = productIsAvailableForSubscription(product);
    var _f = __read(useLenses({
        product: product,
        isPrescriptionEnabled: isPrescriptionEnabled,
        isPrescriptionInfoEnabled: isPrescriptionInfoEnabled,
        variant: variant,
        formatProductUrl: formatProductUrl,
    }), 2), lensState = _f[0], lensActions = _f[1];
    var _g = useLensBundle(), bundleLineItems = _g.lineItems, pricePerMonth = _g.pricePerMonth;
    var cartLineItems = isSubscriptionSelected
        ? bundleLineItems
        : lensState.priceTotals.selectedProducts;
    /**
     * Add SKU to view history
     * Only adds the masterProduct so we don't get duplicates
     */
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (Boolean(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(masterVariant, 'masterProduct')) && masterVariant.sku) {
            productViewHistory.add(masterVariant.sku);
        }
    }, []);
    /**
     * Callback to update the AddToCartNotification in ProductDetail
     * should execute when either the solutions or the lenses update
     */
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        onPriceChange(lensState.priceTotals);
    }, [onPriceChange, lensState.priceTotals]);
    /**
     * Triggers the product_detail SD action when the user clicks on the subscription tab
     */
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        viewProductSdEvent({
            product: product,
            activeSKU: variant.sku,
            staticsUrl: staticsUrl,
            url: "" + window.location + formatProductUrl({
                productType: 'Contact-lenses',
                slug: product.slug,
            }),
            locale: locale,
            isSubscriptionSelected: isSubscriptionSelected,
            pricePerMonth: pricePerMonth,
        });
    }, [activeTabIndex]); // eslint-disable-line react-hooks/exhaustive-deps
    var _h = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(false), 2), isConfiguratorOpen = _h[0], setIsConfiguratorOpen = _h[1];
    var openConfiguratorButtonRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(null);
    var handleConfiguratorOpen = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        if (lensState.formValidations.isConfiguratorValid) {
            setIsConfiguratorOpen(true);
        }
        else {
            lensActions.handlePrescriptionClick(); // Show the alert
        }
    }, [lensActions, lensState, setIsConfiguratorOpen]);
    var handleConfiguratorClose = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () {
        var _a;
        setIsConfiguratorOpen(false);
        (_a = openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : openConfiguratorButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [setIsConfiguratorOpen, openConfiguratorButtonRef]);
    var getSelectedLensVariants = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return __assign({}, lensState.selectedLensVariants
            .filter(function (selectedLensVariant) {
            return !!selectedLensVariant;
        })
            .map(function (selectedLensVariant) {
            var _a, _b;
            return (__assign(__assign({}, selectedLensVariant), { eyeSide: (_b = (_a = lensState.priceTotals.selectedProducts.find(function (_a) {
                    var sku = _a.sku;
                    return sku === (selectedLensVariant === null || selectedLensVariant === void 0 ? void 0 : selectedLensVariant.sku);
                })) === null || _a === void 0 ? void 0 : _a.customAttributes) === null || _b === void 0 ? void 0 : _b.eyeSide }));
        }));
    }, [lensState]);
    var subscriptionConfiguratorModal = (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorModalContainer$1, { input: lensState.subscriptionConfiguratorInput, lensVariants: getSelectedLensVariants, variantGroup: variantGroup, product: product, isOpen: isConfiguratorOpen, staticsUrl: staticsUrl, recommendedCategoryKey: recommendedCategoryKey, onModalClose: handleConfiguratorClose, triggerButtonRef: openConfiguratorButtonRef, formatProductUrl: formatProductUrl }));
    var ctaButton = isAvailableForSubscription && activeTabIndex === 1 ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ConfiguratorButton, { onClick: handleConfiguratorOpen, btnRef: openConfiguratorButtonRef, calculatedPrice: lensState.priceTotals.subscriptionCalculatedPrice, isPrescriptionEnabled: isPrescriptionEnabled, hasLenses: lensState.hasLenses })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CTAButton, { calculatedDiscountPrice: lensState.priceTotals.calculatedDiscountPrice, calculatedPrice: lensState.priceTotals.calculatedPrice, cartLineItems: cartLineItems, excludedFromCheckout: excludedFromCheckout, storesRoute: storesRoute, isPrescriptionEnabled: isPrescriptionEnabled, isSubscription: isSubscriptionSelected, hasLenses: lensState.hasLenses, onPrescriptionClick: lensActions.handlePrescriptionClick, handleMiniCartChange: lensActions.handleMiniCartChange, onClick: onCTAClick, pricePerMonth: pricePerMonth, renderAddToCartButton: renderAddToCartButton }));
    var solutionsConfig = isSolutionsEnabled && recommendedCategoryKey
        ? {
            recommendedCategoryKey: recommendedCategoryKey,
            maxQuantity: maxOrderableQuantity,
        }
        : undefined;
    var contactLensesConfiguratorConfig = {
        allowBackOrder: allowBackOrder,
        dateFormat: dateFormat,
        formValidations: lensState.formValidations,
        handleFormChange: lensActions.handleFormChange,
        isStockEnabled: isContactLensStockEnabled,
        isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled,
        isPrescriptionInfoEnabled: isPrescriptionInfoEnabled,
        maxOrderableQuantity: maxOrderableQuantity,
        opticianForm: opticianForm,
        prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent,
        prescriptionModalContent: prescriptionModalContent,
        promotionalText: promotionalText,
        hasSubscriptions: hasSubscriptions,
    };
    var deliveryIndicatorConfig = {
        // TODO: Add availability info when bundles have that
        availability: !isSubscriptionSelected ? lensState.availability : [undefined],
        deliveryResolver: deliveryResolverFactory && deliveryResolverFactory(lensState.selectedLensVariants),
        fallbackLabelKey: 'products.deliveryIndicator.selectPrescription',
        view: 'icon',
        className: 'product-detail__delivery-indicator',
    };
    var descriptionConfig = {
        colorFeatureIcons: colorFeatureIcons,
        specificationVariant: getActiveVariant(product, activeSku),
        specificationConfiguration: specificationConfiguration,
    };
    var labels = {
        perBox: getLabel('products.perBox'),
        perMonth: getLabel('common.frequency.perMonth'),
        descriptionTitle: getLabel('products.contactLenses.header.details'),
        subscriptionTitle: getLabel('products.contactLenses.subscription.title'),
        oneTimeTitle: getLabel('products.contactLenses.oneTime.title'),
    };
    var subscriptionPriceObject = {
        originalPrice: (pricePerMonth && pricePerMonth.centAmount) || 0,
        currency: currency,
    };
    var oneTimePurchasePriceObject = {
        originalPrice: lensState.priceTotals.calculatedPrice,
        discountedPrice: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNumber */ "z"])(lensState.priceTotals.calculatedDiscountPrice) &&
            lensState.priceTotals.calculatedDiscountPrice > 0
            ? lensState.priceTotals.calculatedDiscountPrice
            : undefined,
        currency: currency,
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Lenses, { addToCartRef: addToCartRef, contactLensesConfiguratorConfig: contactLensesConfiguratorConfig, ctaButton: ctaButton, currency: currency, deliveryIndicatorConfig: deliveryIndicatorConfig, descriptionConfig: descriptionConfig, formatProductUrl: formatProductUrl, hasSubscriptions: hasSubscriptions, isSmallScreen: isSmallScreen, labels: labels, packPrice: lensState.packPrice, subscriptionPrice: lensState.subscriptionPrice, productImageAlt: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(product.name, locale), productTypeUsps: productTypeUsps, showStickyButton: showStickyButton, staticsUrl: staticsUrl, stickerText: stickerText, stickyTop: stickyTop, variant: variant, variantGroup: variantGroup, activeTabIndex: activeTabIndex, setActiveTabIndex: setActiveTabIndex, isSubscriptionSelected: isSubscriptionSelected, isAvailableForSubscription: isAvailableForSubscription, subscriptionConfiguratorModal: subscriptionConfiguratorModal }),
        !isCartV2Enabled ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* MiniCart */ "e"], { open: lensState.showMiniCart, product: {
                title: variant.brand,
                body: variant.replacementFrequency,
                price: isSubscriptionSelected ? subscriptionPriceObject : oneTimePurchasePriceObject,
                imageUrl: variant.images[0].url + "?w=450",
            }, onClose: lensActions.handleMiniCartChange, onToCart: pageRoutes.cart, onToCheckout: pageRoutes.checkout },
            isSubscriptionSelected && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SubscriptionSolutionPickerContainer, null),
            !isSubscriptionSelected && solutionsConfig && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(SolutionsContainer, __assign({}, solutionsConfig, { staticsUrl: staticsUrl }))))) : null));
};

var isEnabled = function (item) {
    if (typeof item.value === 'string') {
        return parseInt(item.value, 10) > 0;
    }
    return !!item.value;
};
var ProductDetailFeatures = function (_a) {
    var uvCategory = _a.uvCategory, polarised = _a.polarised, glazable = _a.glazable;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("ul", { className: "product-detail-features" },
        isEnabled(uvCategory) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-features__feature product-detail-features__feature--uv" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "uv", color: "orange", size: 38 }),
            uvCategory.label)),
        polarised && !!polarised.value && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-features__feature product-detail-features__feature--polarised" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "polarized", color: "orange", size: 38 }),
            polarised.label)),
        glazable && !!glazable.value && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-detail-features__feature product-detail-features__feature--glazable" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_17__[/* FeatureIcon */ "a"], { name: "reading", color: "orange", size: 38 }),
            glazable.label))));
};

var Sunglasses = function (_a) {
    var activeSku = _a.activeSku, ean = _a.ean, addToCartRef = _a.addToCartRef, allowBackOrder = _a.allowBackOrder, formatProductUrl = _a.formatProductUrl, handleVariantPick = _a.handleVariantPick, product = _a.product, productTypeUsps = _a.productTypeUsps, showStickyButton = _a.showStickyButton, staticsUrl = _a.staticsUrl, stockResolver = _a.stockResolver, storesRoute = _a.storesRoute, variant = _a.variant, specificationConfiguration = _a.specificationConfiguration, deliveryResolver = _a.deliveryResolver, stickyTop = _a.stickyTop, onCTAClick = _a.onCTAClick, renderAddToCartButton = _a.renderAddToCartButton;
    var _b;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var _c = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _c.getLabel, getFormattedLabel = _c.getFormattedLabel, currency = _c.currency, locale = _c.locale;
    var productViewHistory = useProductViewHistory();
    var reviews = Object(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* useReviewsContext */ "f"])();
    var brandLink = useBrandLink(variant.brand);
    var variants = __spread([product.masterVariant], product.variants);
    var allowBackOrderAttribute = variant.allowBackOrder, availability = variant.availability, excludedFromCheckout = variant.excludedFromCheckout, price = variant.price, features = variant.features;
    // Add SKU to viewed product history
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map(function (v) { return v.sku || ''; }));
        productViewHistory.add(variant.sku);
    }, [variants.length, variant.sku]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (reviews.enabled) {
            reviews.dispatch(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* Actions */ "a"].updateReviewDisplay({
                variantId: activeSku,
            }));
        }
    }, [activeSku, reviews.enabled]);
    var availableQuantity = (availability === null || availability === void 0 ? void 0 : availability.availableQuantity) ? availability.availableQuantity : 0;
    var doesAllowBackOrder = typeof allowBackOrderAttribute === 'boolean' ? allowBackOrderAttribute : allowBackOrder;
    var variantInStock = availableQuantity > 0;
    var variantUrl = formatProductUrl({
        productType: variant.productType,
        sku: activeSku || '',
        slug: product.slug,
    });
    var addToCartSharedProps = {
        caption: getLabel('products.actions.addToCart'),
        disabled: !variantInStock && !doesAllowBackOrder,
        formatProductUrl: formatProductUrl,
        onClick: onCTAClick,
    };
    var addToCartPropsV1 = __assign(__assign({}, addToCartSharedProps), { lineItems: [
            {
                sku: activeSku,
                productUrl: variantUrl + "#product",
                quantity: 1,
            },
        ] });
    var addToCartPropsV2 = __assign(__assign({}, addToCartSharedProps), { onSuccess: onCTAClick, lineItemDrafts: [{ sku: activeSku, quantity: 1, type: 'regular' }] });
    var CTAButton = Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* AddToCart */ "a"], __assign({}, addToCartPropsV1));
    if (renderAddToCartButton) {
        CTAButton = renderAddToCartButton(addToCartPropsV2);
    }
    if (excludedFromCheckout) {
        CTAButton = (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { caption: getLabel('products.actions.excludedFromCheckout'), "data-t": "btn-excluded-from-checkout", href: storesRoute }));
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__main product-detail__main--sunglasses" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "desktop-hidden product-detail__header--mobile" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailTitle$1, { brand: variant.brand, model: variant.modelName, href: brandLink }),
            isSmallScreen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* ReviewSnippet */ "c"], { productId: product.masterVariant.sku, variantId: activeSku }))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__visual-switcher" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductVisualSwitcher, { productImages: variant.images, alt: getProductAltTag(variant.name, variants.find(function (v) { return v.sku === activeSku; }) || variants[0], 'Sunglasses', locale), sku: activeSku, ean: ean })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__description" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailDescription, { title: getLabel('products.contactLenses.header.details'), header: variant.header, description: variant.description, usps: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* List */ "K"], { type: "checkmark", items: variant.usps }) }, (!!features.uvCategory || !!features.polarized || !!features.glazable) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailFeatures, { uvCategory: {
                    label: getLabel('products.sunglasses.features.uvCategory'),
                    value: features.uvCategory,
                }, polarised: {
                    label: getLabel('products.sunglasses.features.polarized'),
                    value: features.polarized,
                }, glazable: {
                    label: getLabel('products.sunglasses.features.glazeable'),
                    value: features.glazable,
                } })))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__specification" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailSpecification, { configuration: specificationConfiguration, variant: getActiveVariant(product, activeSku) })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__aside" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Sticky */ "ib"], { top: stickyTop || 0, bottomBoundary: '.product-detail', enabled: !isSmallScreen },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "mobile-hidden" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailTitle$1, { brand: variant.brand, model: variant.modelName, href: brandLink })),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-detail__specification-prices', {
                        'product-detail__specification-prices--has-discount': !!variant.discountText,
                    }) },
                    price && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__price-container" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDetailPrice, { originalPrice: price.originalPrice, discountedPrice: price.discountedPrice, currency: currency }))),
                    variant.discountText && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductDiscountLabel$1, { title: variant.discountText, modifier: "product-detail-price" }))),
                !isSmallScreen && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_15__[/* ReviewSnippet */ "c"], { productId: product.masterVariant.sku, variantId: activeSku })),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(VariantPicker, { title: getFormattedLabel('products.numberOfVariants', {
                        labelData: { number: variants.length },
                    }), variants: getVariants(variants, staticsUrl, variant, product, formatProductUrl), currentSku: variant.sku, currentLabel: getVariantPickerLabel(variant), onPick: handleVariantPick, stockIndicator: !excludedFromCheckout && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__[/* StockIndicator */ "d"], { stockCount: availableQuantity, allowBackOrder: doesAllowBackOrder, stockResolver: stockResolver })) }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail__cart-details", ref: addToCartRef }, CTAButton),
                isSmallScreen && showStickyButton && variant.price && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* StickyCallToAction */ "jb"], { button: CTAButton, price: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: (_b = variant.price.discountedPrice) !== null && _b !== void 0 ? _b : variant.price.originalPrice, currency: currency, centAmount: true }) })),
                (!excludedFromCheckout || productTypeUsps) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Hr */ "g"], { className: "product-detail__usp-divider" })),
                !excludedFromCheckout && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_2__[/* DeliveryIndicator */ "a"], { availability: [getActiveVariant(product, activeSku).availability], deliveryResolver: deliveryResolver, view: "icon", className: "product-detail__delivery-indicator" })),
                productTypeUsps && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductTypeUsps, { productTypeUsps: productTypeUsps })))));
};

var ProductDetail = function (_a) {
    var colorFeatureIcons = _a.colorFeatureIcons, children = _a.children, isContactLensStockEnabled = _a.isContactLensStockEnabled, isPrescriptionEnabled = _a.isPrescriptionEnabled, isPrescriptionFileEnabled = _a.isPrescriptionFileEnabled, isPrescriptionGlassesEnabled = _a.isPrescriptionGlassesEnabled, isPrescriptionInfoEnabled = _a.isPrescriptionInfoEnabled, isPrescriptionExtraInfoEnabled = _a.isPrescriptionExtraInfoEnabled, allowBackOrder = _a.allowBackOrder, isSolutionsEnabled = _a.isSolutionsEnabled, maxOrderableQuantity = _a.maxOrderableQuantity, deliveryResolver = _a.deliveryResolver, deliveryResolverFactory = _a.deliveryResolverFactory, prescriptionModalContent = _a.prescriptionModalContent, opticianForm = _a.opticianForm, dateFormat = _a.dateFormat, price = _a.price, productTypeUsps = _a.productTypeUsps, noAddOnsImage = _a.noAddOnsImage, formatProductUrl = _a.formatProductUrl, routes = _a.routes, stockResolver = _a.stockResolver, specificationConfiguration = _a.specificationConfiguration, prescriptionInfoAdditionalContent = _a.prescriptionInfoAdditionalContent;
    var _b = useProductDetailContext(), activeSku = _b.activeSku, activeVariant = _b.activeVariant, product = _b.product, productType = _b.productType, staticsUrl = _b.staticsUrl, dispatch = _b.dispatch, renderAddToCartButton = _b.renderAddToCartButton, isAddToCartNotificationShown = _b.isAddToCartNotificationShown, setIsAddToCartNotificationShown = _b.setIsAddToCartNotificationShown;
    var isMobile = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useBreakpoint() === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var algoliaAnalytics = Object(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* useAlgoliaAnalytics */ "x"])();
    var storedQueryId = (algoliaAnalytics.algoliaAnalyticsData || {}).queryId;
    var algoliaQueryId = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(storedQueryId);
    var containerRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])(null);
    var _c = __read(Object(react_intersection_observer__WEBPACK_IMPORTED_MODULE_14__[/* useInView */ "a"])(), 2), ctaRef = _c[0], ctaInview = _c[1];
    var showStickyButton = isMobile && !ctaInview;
    var _d = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _d.getLabel, hasLabel = _d.hasLabel, locale = _d.locale;
    var _e = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(0), 2), topOffset = _e[0], setTopOffset = _e[1];
    var _f = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])(null), 2), calculatedAddToCartPrice = _f[0], setCalculatedAddToCartPrice = _f[1];
    var shouldShowAddToCartNotification = productType === 'Sunglasses' ||
        productType === 'Solutions' ||
        (productType === 'Frames' && isPrescriptionGlassesEnabled);
    var showNotificationOverlay = function () {
        if (shouldShowAddToCartNotification) {
            setIsAddToCartNotificationShown(true);
        }
    };
    var closeNotificationOverlay = function () {
        if (shouldShowAddToCartNotification) {
            setIsAddToCartNotificationShown(false);
        }
    };
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        if (storedQueryId) {
            algoliaQueryId.current = storedQueryId;
        }
    }, [storedQueryId]);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        // make sure the queryId will not be used when a user doesn't click the CTA. For example: user clicks on a product suggestion and clicks the CTA there.
        algoliaQueryId.current && algoliaAnalytics.clearQueryId();
    }, [algoliaQueryId.current]);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        // set offset based on headerHeight
        setTopOffset(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* calculateHeaderHeight */ "h"])());
        window.addEventListener('cart.change', showNotificationOverlay);
        return function () {
            window.removeEventListener('cart.change', showNotificationOverlay);
        };
    }, []);
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var body = document.body;
        isAddToCartNotificationShown && !body.classList.contains('body--lock')
            ? body.classList.add('body--lock')
            : body.classList.remove('body--lock');
    }, [isAddToCartNotificationShown]);
    var ean = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        var ean = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product.masterVariant, 'supplierEAN');
        if (typeof ean === 'string') {
            return ean;
        }
        return undefined;
    }, [product]);
    var stickerText = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isSunglasses(productType)) {
            return getLabel('sunglasses.sticker.text', { hideLabelKey: true });
        }
        if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(productType)) {
            var pricePerDay = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product.masterVariant, 'pricePerDay');
            var centAmount = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isPlainObject */ "A"])(pricePerDay) ? pricePerDay.centAmount : 0;
            return pricePerDay && hasLabel('products.perDay') ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: centAmount, className: "product-discount-label__price-per-day" }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-discount-label__price-per-day-unit" }, getLabel('products.perDay')))) : (getLabel('contactLenses.sticker.text', { hideLabelKey: true }));
        }
        return '';
    }, [productType, product]);
    if (!productType || !activeVariant || _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isSolutions(activeVariant)) {
        return null;
    }
    var handleVariantPick = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (event, sku) {
        dispatch(updateActiveVariant({ sku: sku }));
        var newUrl = formatProductUrl({
            sku: sku,
            slug: product.slug,
            productType: productType,
        });
        var brand = getVariantInfo(product, productType, locale, sku).brand;
        window.history.replaceState(null, brand, newUrl);
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (!event.metaKey && !event.ctrlKey && !event.shiftKey) {
            event.preventDefault();
        }
    }, [product, productType, locale]);
    /**
     * This callback is used in the Prescription Glasses configurator
     * to supply the full bundle price (Frame, LensType, Package, and Add-ons)
     * to the AddToCartNotification
     */
    var handlePrescriptionGlassesPriceChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (bundlePrice) {
        setCalculatedAddToCartPrice(bundlePrice);
    }, []);
    /**
     * This handler is called from the Lenses page whenever the
     * price changes from their prescription selection.
     * This price object is supplied to the AddToCartNotification
     */
    var handleLensPriceChange = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function (_a) {
        var calculatedPrice = _a.calculatedPrice, calculatedDiscountPrice = _a.calculatedDiscountPrice;
        var _b = calculatedAddToCartPrice
            ? calculatedAddToCartPrice
            : { originalPrice: 0, discountedPrice: undefined }, originalPrice = _b.originalPrice, discountedPrice = _b.discountedPrice;
        if (originalPrice !== calculatedPrice || discountedPrice !== calculatedDiscountPrice) {
            var calculatedAddToCartPrice_1 = {
                originalPrice: calculatedPrice,
                discountedPrice: calculatedDiscountPrice,
            };
            setCalculatedAddToCartPrice(calculatedAddToCartPrice_1);
        }
    }, []);
    /**
     * Sends a conversion event to Algolia
     */
    var handleConversionEvent = Object(react__WEBPACK_IMPORTED_MODULE_10__["useCallback"])(function () { return algoliaAnalytics.handleConversionEvent(activeSku, algoliaQueryId.current); }, [activeSku, algoliaAnalytics]);
    var handleCtaClick = function () {
        handleConversionEvent();
        showNotificationOverlay();
    };
    /**
     * Calculates the right offset for the addToCart notification
     */
    var rightOffset = function () {
        var _a;
        if (!isPhone && typeof window !== 'undefined' && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth)) {
            return (window.innerWidth - containerRef.current.clientWidth) / 2;
        }
        return 0;
    };
    var commonProps = {
        activeSku: activeSku,
        ean: ean,
        addToCartRef: ctaRef,
        formatProductUrl: formatProductUrl,
        product: product,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        staticsUrl: staticsUrl,
        storesRoute: routes.stores,
        specificationConfiguration: specificationConfiguration,
        stickyTop: topOffset,
        onCTAClick: handleCtaClick,
        renderAddToCartButton: renderAddToCartButton,
    };
    var variantUrl = formatProductUrl({
        productType: activeVariant.productType,
        sku: activeVariant.sku,
        slug: product.slug,
    });
    var productUrl = variantUrl + "#product";
    var subscriptionProductSKU = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(product.masterVariant, 'subscriptionProductSKU');
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-detail" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { ref: containerRef, className: "site-container product-detail__container" }, (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isLenses(activeVariant) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensBundleProvider, { subscriptionProductSKU: subscriptionProductSKU },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensesContainer, __assign({}, commonProps, { colorFeatureIcons: colorFeatureIcons, stickerText: stickerText, variant: activeVariant, isSolutionsEnabled: isSolutionsEnabled, isPrescriptionEnabled: isPrescriptionEnabled, onPriceChange: handleLensPriceChange, pageRoutes: routes, specificationConfiguration: specificationConfiguration, 
                /**
                 * Stock configurations props
                 */
                isContactLensStockEnabled: isContactLensStockEnabled, maxOrderableQuantity: maxOrderableQuantity, deliveryResolverFactory: deliveryResolverFactory, allowBackOrder: allowBackOrder, 
                /**
                 * Prescription props
                 */
                isPrescriptionInfoEnabled: isPrescriptionInfoEnabled, prescriptionModalContent: prescriptionModalContent, opticianForm: opticianForm, dateFormat: dateFormat, isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled, prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent, hasSubscriptions: !!subscriptionProductSKU }))))) ||
            (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isFrames(activeVariant) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Frames, __assign({}, commonProps, { isPrescriptionGlassesEnabled: isPrescriptionGlassesEnabled, isPrescriptionFileEnabled: isPrescriptionFileEnabled, noAddOnsImage: noAddOnsImage, handleVariantPick: handleVariantPick, onPriceChange: handlePrescriptionGlassesPriceChange, variant: activeVariant, specificationConfiguration: specificationConfiguration, price: price, opticianForm: opticianForm }), children))) ||
            (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_1__[/* CommerceToolsApi */ "a"].isSunglasses(activeVariant) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Sunglasses, __assign({}, commonProps, { handleVariantPick: handleVariantPick, stockResolver: stockResolver, variant: activeVariant, specificationConfiguration: specificationConfiguration, allowBackOrder: allowBackOrder, deliveryResolver: deliveryResolver }))))),
        isAddToCartNotificationShown && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "add-to-cart-notification-overlay", role: "button", onClick: closeNotificationOverlay, "data-t": "add-to-cart-notification-overlay" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { style: { top: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* calculateHeaderHeight */ "h"])(), right: rightOffset() }, className: "add-to-cart-notification-wrapper" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_9__[/* AddToCartNotification */ "b"], { productName: activeVariant.brand, ean: activeVariant.modelName, imgUrl: activeVariant.images[0].url, price: calculatedAddToCartPrice || activeVariant.price, onClose: closeNotificationOverlay, cartRoute: routes.cart, stickerText: stickerText })))),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* WebPage */ "m"], { url: productUrl, pageType: "ProductDetail", name: activeVariant.brand, description: activeVariant.description })));
};

function getProductSeoInfo(staticsUrl, locale, product) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!(product === null || product === void 0 ? void 0 : product.masterVariant)) {
        return {};
    }
    var productType = (_c = (_b = (_a = product.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '';
    var title = getProductTitle(productType, product, product.masterVariant, locale);
    var description = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(product.masterVariant, 'description', locale);
    var imagePath = (_g = (_f = (_e = (_d = product.masterVariant) === null || _d === void 0 ? void 0 : _d.images) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.url) !== null && _g !== void 0 ? _g : '';
    var imageUrl = "" + staticsUrl + imagePath + "?q=70&w=1200&h=630&fit=fill&fm=jpeg";
    return {
        title: title,
        description: description,
        imageUrl: imageUrl,
    };
}

var LensPacksItem = /** @class */ (function (_super) {
    __extends(LensPacksItem, _super);
    function LensPacksItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function () {
            _this.props.onChange(_this.props.value);
        };
        return _this;
    }
    LensPacksItem.prototype.getDioptries = function (str) {
        return str
            .replace(/[a-zA-Z]/g, '')
            .replace(/\s+/g, '')
            .replace(/[{()}]/g, '');
    };
    LensPacksItem.prototype.render = function () {
        var _a = this.props, isSelected = _a.isSelected, intl = _a.intl, currentBreakpoint = _a.currentBreakpoint, price = _a.price, item = _a.item, useIncludedLensPack = _a.useIncludedLensPack;
        // TODO: type this properly without any but it's way to messy atm
        // Special instance where the enum key is needed
        var packAttribute = item.attributes.find(function (attribute) { return attribute.name === 'pack'; });
        var type = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isPlainObject */ "A"])(packAttribute) ? packAttribute.value.key : '';
        var packName = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isPlainObject */ "A"])(packAttribute) && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(packAttribute.value, intl.locale);
        var thicknessValue = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(item, 'thickness', intl.locale);
        var thickness = thicknessValue.split('(')[0];
        var dioptries = this.getDioptries(thicknessValue);
        var voucher = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(item, 'voucher');
        var voucherValue = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isPlainObject */ "A"])(voucher) ? Number(voucher.centAmount) : 0;
        var isSelectedClass = isSelected ? '_is_selected' : '';
        if (currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE ||
            currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT ||
            currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE) {
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("label", { className: "lens-packs-accordion-item lens-packs-accordion-item--" + type + " " + isSelectedClass },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-accordion-item__header" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("input", { className: "lens-packs-accordion-item__radio", type: "radio", name: "ssp-lens-pack", value: type, "aria-checked": isSelected, onChange: this.handleChange }),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h4", null, packName)),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-accordion-item__body" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("ul", null, item.benefits.map(function (benefit) { return benefit.value && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { key: benefit.name }, benefit.label); })),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-accordion-item__price" }, item.isIncluded ? (intl.getLabel('products.included')) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                        "+",
                        ' ',
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price.value.centAmount, centAmount: true, currency: intl.currency })))),
                    !item.isIncluded && !!voucherValue && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("p", { className: "lens-packs-accordion-item__voucher" },
                        intl.getLabel('products.ssp.voucher.label'),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: voucherValue, centAmount: true, currency: intl.currency }))))));
        }
        else {
            var visualFieldValue = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(item, 'visualField', intl.locale);
            var higherTitle = visualFieldValue ? 'lens-packs-cell--title--with-visual-field' : '';
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("label", { className: "lens-packs-column " + isSelectedClass },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell lens-packs-cell--type lens-packs-cell--" + type },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h4", null, packName)),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell lens-packs-cell--title " + higherTitle },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h5", null, thickness),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", null,
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("small", { className: "lens-packs-cell__dioptry" },
                            "(",
                            dioptries,
                            " ",
                            intl.getLabel('products.unit.dioptries'),
                            ")")),
                    visualFieldValue && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("small", { className: "lens-packs-cell__visual-field" }, visualFieldValue))),
                item.benefits.map(function (benefit) {
                    var checked = benefit.value ? 'check' : 'no-check';
                    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { key: benefit.name, className: "lens-packs-cell lens-packs-cell--" + checked }));
                }),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell lens-packs-cell--footer" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell__price" }, useIncludedLensPack && item.isIncluded ? (intl.getLabel('products.included')) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", null,
                        useIncludedLensPack && '+ ',
                        ' ',
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price.value.centAmount, centAmount: true, currency: intl.currency })))),
                    !item.isIncluded && !!voucherValue && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("p", { className: "lens-packs-cell__voucher" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("small", null, intl.getLabel('products.ssp.voucher.label')),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("br", null),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: voucherValue, centAmount: true, currency: intl.currency }))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("input", { className: "lens-packs-cell__radio", type: "radio", name: "ssp-lens-pack", value: type, "aria-checked": isSelected, onChange: this.handleChange }))));
        }
    };
    return LensPacksItem;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var LensPacksItem$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].WithBreakpoints(LensPacksItem));

var LensPacks = /** @class */ (function (_super) {
    __extends(LensPacks, _super);
    function LensPacks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPackChange = function (packType) {
            _this.props.onChange && _this.props.onChange(packType);
        };
        _this.renderItems = function () {
            var _a = _this.props, packs = _a.packs, selectedPack = _a.selectedPack, useIncludedLensPack = _a.useIncludedLensPack;
            return packs.map(function (pack) {
                if (!pack.packType) {
                    console.error('No packType found');
                    return;
                }
                var price = pack.prices && pack.prices.length && pack.prices[0];
                if (!price) {
                    console.error("No price found for pack with packType \"" + pack.packType + "\"");
                    return;
                }
                return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensPacksItem$1, { key: pack.id, item: pack, value: pack.packType, price: price, isSelected: pack.packType === selectedPack, onChange: _this.onPackChange, useIncludedLensPack: useIncludedLensPack }));
            });
        };
        return _this;
    }
    LensPacks.prototype.render = function () {
        var _a = this.props, packs = _a.packs, currentBreakpoint = _a.currentBreakpoint, intl = _a.intl;
        var hasBasicClass = packs.length === 6 ? 'lens-packs--has-basic' : '';
        var benefitLabels = (packs.length > 0 && packs[0].benefits.map(function (benefit) { return benefit.label; })) || [];
        if (currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE ||
            currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT ||
            currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE) {
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-accordion" },
                this.renderItems(),
                intl.getLabel('products.disclaimer', { hideLabelKey: true }) !== '' && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-accordion__disclaimer" }, intl.getLabel('products.disclaimer')))));
        }
        else {
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs " + hasBasicClass },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("label", { className: "lens-packs-column lens-packs-column--labels" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell lens-packs-cell--type lens-packs-cell--empty" }),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell lens-packs-cell--title lens-packs-cell--empty" }),
                    benefitLabels.map(function (label) {
                        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { key: label, className: "lens-packs-cell lens-packs-cell--label" },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", null, label)));
                    }),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs-cell lens-packs-cell--footer lens-packs-cell--empty" })),
                this.renderItems(),
                intl.getLabel('products.ssp.voucher.disclaimer', { hideLabelKey: true }) !== '' && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "lens-packs__disclaimer" }, intl.getLabel('products.ssp.voucher.disclaimer')))));
        }
    };
    return LensPacks;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var LensPacks$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].WithBreakpoints(LensPacks));

function useGetProductsBySku(skus) {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useApiConfig */ "N"])(), productsUrl = _a.productsUrl, apiKey = _a.apiKey;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_10__["useState"])({ products: [], isLoading: true, error: null }), 2), state = _b[0], setState = _b[1];
    Object(react__WEBPACK_IMPORTED_MODULE_10__["useEffect"])(function () {
        var isCancelled = false;
        function loadProducts() {
            return __awaiter(this, void 0, void 0, function () {
                var products, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetchProducts(productsUrl, skus, apiKey)];
                        case 1:
                            products = _a.sent();
                            if (products && !isCancelled) {
                                setState(__assign(__assign({}, state), { products: products, isLoading: false }));
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error(error_1);
                            if (!isCancelled) {
                                setState(__assign(__assign({}, state), { error: error_1, isLoading: false }));
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        (skus === null || skus === void 0 ? void 0 : skus.length) && loadProducts();
        return function () {
            isCancelled = true;
        };
    }, [productsUrl, apiKey, skus]);
    return state;
}
function fetchProducts(apiUrl, skus, apiKey) {
    if (skus === void 0) { skus = []; }
    return __awaiter(this, void 0, void 0, function () {
        var skusFilter, filters, expand, results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!skus.length) {
                        return [2 /*return*/, []];
                    }
                    skusFilter = skus
                        .filter(function (s) { return !!s.length; })
                        .map(function (sku) { return "\"" + sku + "\""; })
                        .join(',');
                    filters = ["variants.sku:" + skusFilter];
                    expand = [
                        'productType',
                        'masterVariant.prices[*].discounted.discount',
                        'variants[*].prices[*].discounted.discount',
                    ];
                    return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].query(apiUrl, { filters: filters, expand: expand }, apiKey)];
                case 1:
                    results = (_a.sent()).results;
                    return [2 /*return*/, sortProducts(skus, results)];
            }
        });
    });
}
// The Product service currently doesn't have a way to return the products in the same order
// as the SKUs array is provided, so we have to manually sort the products based on the SKU array.
function sortProducts(skus, products) {
    if (products === void 0) { products = []; }
    return __spread(products).sort(function (productA, productB) {
        var indexA = skus.findIndex(function (sku) {
            return __spread([productA.masterVariant], productA.variants).find(function (v) { return v.sku === sku; });
        });
        var indexB = skus.findIndex(function (sku) {
            return __spread([productB.masterVariant], productB.variants).find(function (v) { return v.sku === sku; });
        });
        return indexA - indexB;
    });
}

var ProductBanner = function (_a) {
    var products = _a.products, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, className = _a.className, _b = _a.isLoading, isLoading = _b === void 0 ? true : _b, error = _a.error, dataT = _a["data-t"];
    var isBigScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsAbove(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT);
    var itemsPerSlide = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsDesktop() ? 4 : 3;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-banner', className);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var productBlockProps = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () { return ({
        staticsUrl: staticsUrl,
        formatProductUrl: formatProductUrl,
        showVariants: true,
    }); }, [staticsUrl, formatProductUrl]);
    var renderProductBlock = function (product) {
        return isLightProductModel(product) ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(AlgoliaProductBlock, __assign({ key: product.id, product: product }, productBlockProps))) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CommerceToolsProductBlock, __assign({ key: product.id, product: product }, productBlockProps)));
    };
    var carouselItems = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        if (!isBigScreen || !products) {
            return [];
        }
        var items = [];
        var max = Math.ceil(products.length / itemsPerSlide);
        for (var i = 0; i < max; i++) {
            var start = i * itemsPerSlide;
            var end = (i + 1) * itemsPerSlide;
            items.push(Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { key: "product-banner-slide-" + i, className: "product-banner__carousel-item" }, products.slice(start, end).map(function (product) { return renderProductBlock(product); })));
        }
        return items;
    }, [products, itemsPerSlide, isBigScreen, staticsUrl, formatProductUrl]);
    if (error) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classNames, "data-t": dataT || 'product-banner' },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Alert */ "c"], { type: "warning", message: getLabel('products.banner.errorMessage') })));
    }
    if (isLoading) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classNames, "data-t": dataT || 'product-banner' },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Loader */ "L"], null)));
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classNames, "data-t": dataT || 'product-banner' }, isBigScreen ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Carousel */ "h"], { pagination: false, navigation: true }, carouselItems)) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("ul", { className: "product-banner__slider" }, products &&
        products.map(function (product) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("li", { className: "product-banner__slider-item", key: product.id }, renderProductBlock(product))); })))));
};

var ProductBannerContainer = function (_a) {
    var skus = _a.skus, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, className = _a.className;
    var _b = useGetProductsBySku(skus), isLoading = _b.isLoading, products = _b.products, error = _b.error;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-banner', className);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductBanner, { products: products, staticsUrl: staticsUrl, formatProductUrl: formatProductUrl, isLoading: isLoading, error: error, className: classNames }));
};

var Solution = function (_a) {
    var name = _a.name, solutionType = _a.solutionType, volume = _a.volume, image = _a.image, price = _a.price, minimumQuantity = _a.minimumQuantity, quantity = _a.quantity, onQuantityChange = _a.onQuantityChange;
    var isActive = quantity > 0 ? '_is_active' : '';
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "solution " + (isActive || '') },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { src: image.url, alt: name }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "solution__brand" }, name),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "solution__type" },
            solutionType,
            ", ",
            volume),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price, className: "solution__price" }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* QuantitySelector */ "Z"], { quantity: quantity, minimumQuantity: minimumQuantity, onDecreaseQuantity: function () { return onQuantityChange(quantity, 'decrease'); }, onIncreaseQuantity: function () { return onQuantityChange(quantity, 'increase'); } })));
};

/**
 * Product detail discount bar
 */
var ProductDiscountBar = function (_a) {
    var title = _a.title;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-discount-bar" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-discount-bar__title" }, title)));
};

var frameWidthImg = 'data:image/png;base64,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';
var bridgeWidthImg = 'data:image/png;base64,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';
var templeLengthImg = 'data:image/png;base64,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';
var lensWidthImg = 'data:image/png;base64,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';
var lensHeightImg = 'data:image/png;base64,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';
var ProductFrameMeasurements = function (_a) {
    var product = _a.product, currentBreakpoint = _a.currentBreakpoint, intl = _a.intl;
    var activeSku = useProductDetailContext().activeSku;
    var variant = getActiveVariant(product, activeSku);
    var frameWidth = {
        measurement: Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'frameWidth')),
        label: intl.getLabel('products.measurements.frame.width'),
        key: 'measurements.frame.width',
        image: frameWidthImg,
    };
    var bridgeWidth = {
        measurement: Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'bridgeWidth')),
        label: intl.getLabel('products.measurements.bridge.width'),
        key: 'measurements.bridge.width',
        image: bridgeWidthImg,
    };
    var templeLength = {
        measurement: Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'templeLength')),
        label: intl.getLabel('products.measurements.templeArm.length'),
        key: 'measurements.templeArm.length',
        image: templeLengthImg,
    };
    var lensWidth = {
        measurement: Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'lensWidth')),
        label: intl.getLabel('products.measurements.lens.width'),
        key: 'measurements.lens.width',
        image: lensWidthImg,
    };
    var lensHeight = {
        measurement: Number(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(variant, 'lensHeight')),
        label: intl.getLabel('products.measurements.lens.height'),
        key: 'measurements.lens.height',
        image: lensHeightImg,
    };
    var frameMeasurements = [frameWidth, bridgeWidth, templeLength, lensWidth, lensHeight].filter(function (item) { return item.measurement > 0; });
    var isMobile = currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE ||
        currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT;
    var FrameMeasurementsBlock = function (_a) {
        var label = _a.label, measurement = _a.measurement, image = _a.image;
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("section", { className: "product-detail-frame-measurements__item" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-frame-measurements__label" }, label),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("img", { src: image, alt: label }),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-detail-frame-measurements__details" },
                measurement,
                " ",
                intl.getLabel('products.measurements.metric'))));
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("section", { className: "product-detail-frame-measurements" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "site-container product-detail-frame-measurements__container" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h2", { className: "product-detail-frame-measurements__title" }, intl.getLabel('products.measurements.frame.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("article", { className: "product-detail-frame-measurements__items" },
                isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Carousel */ "h"], { pagination: true }, frameMeasurements.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(FrameMeasurementsBlock, __assign({}, item, { key: item.key }))); }))),
                !isMobile &&
                    frameMeasurements.map(function (item) { return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(FrameMeasurementsBlock, __assign({}, item, { key: item.key })); })))));
};
var ProductFrameMeasurements$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].WithBreakpoints(ProductFrameMeasurements));

var PromotionBlock = function (_a) {
    var title = _a.title, description = _a.description, image = _a.image, links = _a.links, size = _a.size, manageContentButton = _a.manageContentButton;
    var imageUrl = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone() ? image === null || image === void 0 ? void 0 : image.mobileUrl : image === null || image === void 0 ? void 0 : image.url;
    if (!imageUrl) {
        return null;
    }
    var buttonStyles = (links === null || links === void 0 ? void 0 : links.style) ? _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Util */ "tb"].createButtonStyles(links.style) : {};
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_11___default()('promotion-block', {
        'promotion-block--overlay': !!title || !!description,
        'promotion-block--large': size === 'large',
    });
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": "promotion-block", className: classNames },
        manageContentButton,
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("a", { className: "promotion-block__link", href: links === null || links === void 0 ? void 0 : links.url },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Image */ "y"], { url: imageUrl, cover: true, className: "promotion-block__image" })),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "promotion-block__inner" },
            (title || description) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "promotion-block__text" },
                title && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { component: "h2", variant: "medium", className: "promotion-block__title" }, title)),
                description && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Text */ "k"], { variant: "body", className: "promotion-block__subtitle" }, description)))),
            (links === null || links === void 0 ? void 0 : links.label) && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], __assign({}, buttonStyles, { className: "promotion-block__button", "data-t": "promotion-block-button", size: "custom", "aria-label": links.alt, href: links.url, caption: links.label }))))));
};

var ProductListingGrid = function (_a) {
    var hasBigPromo = _a.hasBigPromo, hasSmallPromo = _a.hasSmallPromo, children = _a.children;
    var breakpoint = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useBreakpoint();
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-listing-grid', {
        'product-listing-grid--with-promos': hasBigPromo && hasSmallPromo,
        'product-listing-grid--with-big-promo': hasBigPromo && !hasSmallPromo,
        'product-listing-grid--col-2': breakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE,
        'product-listing-grid--col-3': breakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT ||
            breakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE,
        'product-listing-grid--col-4': breakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.DESKTOP,
    });
    return Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classNames }, children);
};

var ProductListingGridCell = function (_a) {
    var children = _a.children, _b = _a.isWide, isWide = _b === void 0 ? false : _b;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-listing-grid-cell', {
            'product-listing-grid-cell--wide': isWide,
        }) }, children));
};

function usePromoIndices(productCount, hasPromotionSmall) {
    var currentBreakpoint = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useBreakpoint();
    switch (currentBreakpoint) {
        case _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE:
            return {
                smallPromoIndex: -1,
                bigPromoIndex: hasPromotionSmall ? 14 : 4,
            };
        case _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT:
        case _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE:
            return {
                smallPromoIndex: 4,
                bigPromoIndex: hasPromotionSmall ? 13 : 4,
            };
        case _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.DESKTOP:
            return {
                smallPromoIndex: 5,
                bigPromoIndex: hasPromotionSmall ? (productCount > 16 ? 17 : 13) : 5,
            };
        default:
            return {
                smallPromoIndex: -1,
                bigPromoIndex: -1,
            };
    }
}

var ProductListingPage = function (_a) {
    var products = _a.products, pageSize = _a.pageSize, pageNumber = _a.pageNumber, promotionSmall = _a.promotionSmall, promotionBig = _a.promotionBig, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, getProductImageUrls = _a.getProductImageUrls;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var dividerLabel = getLabel('common.page') + " " + pageNumber;
    var showPromos = pageNumber === 1 && products.length >= pageSize;
    var _b = usePromoIndices(products.length, !!promotionSmall), smallPromoIndex = _b.smallPromoIndex, bigPromoIndex = _b.bigPromoIndex;
    var augmentedProductList = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return products.reduce(function (result, product) {
            if (showPromos && !!promotionSmall && result.length === smallPromoIndex) {
                result.push(Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingGridCell, { key: "promo-small" },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PromotionBlock, __assign({}, promotionSmall, { size: "small" }))));
            }
            if (showPromos && !!promotionBig && result.length === bigPromoIndex) {
                result.push(Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingGridCell, { key: "promo-big", isWide: true },
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(PromotionBlock, __assign({}, promotionBig, { size: "large" }))));
                result.push(null);
            }
            var position = pageSize * (pageNumber - 1) + result.length + 1;
            result.push(Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingGridCell, { key: product.masterVariant.sku },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_8__[/* AlgoliaAnalytics */ "b"], null, function (handleSearchAnalytics) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(AlgoliaProductBlock, { className: "product-listing-product-block", product: product, staticsUrl: staticsUrl, formatProductUrl: formatProductUrl, getProductImageUrls: getProductImageUrls, onClick: handleSearchAnalytics(product.objectID, position) })); })));
            return result;
        }, []);
    }, [
        products,
        showPromos,
        smallPromoIndex,
        bigPromoIndex,
        promotionSmall,
        promotionBig,
        staticsUrl,
        formatProductUrl,
        getProductImageUrls,
    ]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { "data-t": "product-listing-page-" + pageNumber, className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('product-listing-page', {
            'product-listing-page--with-divider': pageNumber !== 1,
        }) },
        pageNumber !== 1 && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-listing-page__divider" }, dividerLabel),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingGrid, { hasSmallPromo: showPromos && !!promotionSmall, hasBigPromo: showPromos && !!promotionBig }, showPromos ? augmentedProductList.slice(0, products.length) : augmentedProductList)));
};

var ProductListingSkeleton = function (_a) {
    var pageSize = _a.pageSize;
    var skeletonGrid = Object(react__WEBPACK_IMPORTED_MODULE_10__["useMemo"])(function () {
        return Array.from({ length: pageSize }).map(function (_, i) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingGridCell, { key: "skeleton-cell-" + i },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* SkeletonLoader */ "hb"], { className: "product-listing-skeleton-loader" }))); });
    }, [pageSize]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-listing-skeleton" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingGrid, null, skeletonGrid)));
};

var ProductListing = function (_a) {
    var products = _a.products, showMoreButton = _a.showMoreButton, promotionBig = _a.promotionBig, promotionSmall = _a.promotionSmall, staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, getProductImageUrls = _a.getProductImageUrls;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-listing" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Container */ "d"], { className: "product-listing__container" },
            products.pages.map(function (page, i) {
                var pageNr = i + 1;
                return page === null ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingSkeleton, { key: "product-listing-skeleton-" + pageNr, pageSize: products.size })) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductListingPage, { key: "product-listing-page-" + pageNr, products: page, pageSize: products.size, pageNumber: pageNr, promotionBig: promotionBig, promotionSmall: promotionSmall, staticsUrl: staticsUrl, formatProductUrl: formatProductUrl, getProductImageUrls: getProductImageUrls }));
            }),
            showMoreButton && Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-listing__show-more" }, showMoreButton))));
};

var ProductPlaceholder = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-placeholder" },
    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("svg", { width: "282", height: "244", viewBox: "0 0 282 244", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("rect", { width: "282", height: "149", rx: "5", fill: "currentColor" }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("rect", { x: "26", y: "169", width: "230", height: "15", rx: "5", fill: "currentColor" }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("rect", { x: "26", y: "194", width: "230", height: "15", rx: "5", fill: "currentColor" }),
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("rect", { x: "71", y: "229", width: "140", height: "15", rx: "5", fill: "currentColor" })))); };

function moveHighlightedToLast(products) {
    var index = products.findIndex(function (product) { return product.isHighlighted; });
    var highlightedIndex = index > 0 ? index : 0;
    var newArray = __spread(products);
    var highlightedProduct = __assign(__assign({}, newArray[highlightedIndex]), { isHighlighted: true });
    newArray.splice(highlightedIndex, 1);
    newArray.push(highlightedProduct);
    return newArray;
}
function fetchProductData(apiUrl, skus, apiKey) {
    var filters = ["variants.sku:" + skus.join(',')];
    var expand = [
        'masterVariant.prices[*].discounted.discount',
        'variants[*].prices[*].discounted.discount',
        'productType',
    ];
    return _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Products */ "h"].query(apiUrl, { filters: filters, expand: expand }, apiKey);
}
var ProductPromotions = /** @class */ (function (_super) {
    __extends(ProductPromotions, _super);
    function ProductPromotions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            breakpoint: _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE,
            products: [],
            isLoading: true,
        };
        _this.handleWindowSizeChange = function () {
            var newBreakpoint = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].getCurrentBreakpoint();
            if (_this.state.breakpoint !== newBreakpoint) {
                _this.setState({
                    breakpoint: newBreakpoint,
                });
            }
        };
        _this.renderProduct = function (isHighlighted, product) {
            var highlightClass = isHighlighted ? 'product-promotions__block--highlighted' : '';
            if (!product) {
                return;
            }
            var _a = _this.props, formatProductUrl = _a.formatProductUrl, staticsUrl = _a.staticsUrl, getProductImageUrls = _a.getProductImageUrls;
            return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(CommerceToolsProductBlock, { key: product.id, product: product, formatProductUrl: formatProductUrl, getProductImageUrls: getProductImageUrls, staticsUrl: staticsUrl, className: "product-promotions__block " + highlightClass }));
        };
        _this.renderProductBlocks = function () {
            var products = _this.state.products;
            var _a = _this.props, _b = _a.products, cmsProducts = _b === void 0 ? [] : _b, promotionLabel = _a.promotionLabel, supertitle = _a.supertitle, title = _a.title;
            var sortedProducts = cmsProducts.length ? moveHighlightedToLast(cmsProducts) : cmsProducts;
            if (_this.state.breakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].BreakpointName.PHONE) {
                return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions__block" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions__title-block" },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "product-promotions__title" }, title),
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h5", { className: "product-promotions__supertitle" }, supertitle))),
                    !!products.length && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Carousel */ "h"], { pagination: true }, products.map(_this.renderProduct.bind(null, false))))));
            }
            else {
                // Copy all products, then pop last (highlighted) item of array and save it to render separately
                var highlightedSku_1 = (sortedProducts.find(function (product) { return product.isHighlighted; }) || {
                    sku: undefined,
                }).sku;
                var highlightProduct_1 = _this.state.products.find(function (product) {
                    return !!__spread([product.masterVariant], product.variants).find(function (variant) { return variant.sku === highlightedSku_1; });
                });
                var otherProducts = _this.state.products.filter(function (product) { return !highlightProduct_1 || product.id !== highlightProduct_1.id; }) || [];
                return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions__wrapper--standard" },
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions__block" },
                            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions__title-block" },
                                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "product-promotions__title" }, title),
                                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h5", { className: "product-promotions__supertitle" }, supertitle))),
                        !!products.length && otherProducts.map(_this.renderProduct.bind(null, false))),
                    !!products.length && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions__wrapper--highlighted" },
                        promotionLabel && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "product-promotions__highlight-label" }, promotionLabel)),
                        highlightProduct_1 && _this.renderProduct(true, highlightProduct_1)))));
            }
        };
        return _this;
    }
    ProductPromotions.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, products = _a.products, apiConfig = _a.apiConfig;
        var sortedProducts = products.length ? moveHighlightedToLast(products) : products;
        var productSkus = sortedProducts.map(function (product) { return "\"" + product.sku + "\""; });
        var promise = fetchProductData(apiConfig.productsUrl, productSkus, apiConfig.apiKey)
            .then(function (data) {
            if (data && data.results && data.results.length > 0) {
                _this.setState({
                    products: data.results,
                    isLoading: false,
                });
            }
            else {
                _this.setState({ isLoading: false });
                console.error('Product promotions: No products were returned by commerce tools');
            }
        })
            .catch(function (err) {
            _this.setState({ isLoading: false });
            console.error('Product promotions: No products were returned by commerce tools. Error : ' + err);
        });
        this.handleWindowSizeChange();
        window.addEventListener('resize', this.handleWindowSizeChange);
        return promise;
    };
    ProductPromotions.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    };
    ProductPromotions.prototype.render = function () {
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "product-promotions" },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Container */ "d"], { className: "product-promotions__container" }, this.state.isLoading ? Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Loader */ "L"], null) : this.renderProductBlocks())));
    };
    return ProductPromotions;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var ProductPromotions$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withApiConfig */ "U"])(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* withLazyLoading */ "N"])(ProductPromotions));

// PRODUCT
function getFrameData(product) {
    var gender = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValues */ "p"])(product.masterVariant, 'gender', 'en');
    // Check if it's a kids glasses
    var isKidsGlasses = gender.some(function (a) { return a.toLowerCase() === 'kids'; });
    var framePrice = (product.masterVariant.prices && product.masterVariant.prices[0].value.centAmount) || 0;
    var brand = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedAttrValue */ "o"])(product.masterVariant, 'brand', 'en');
    return {
        brand: brand,
        framePrice: framePrice,
        gender: gender,
        isKidsGlasses: isKidsGlasses,
    };
}
// LENS PACKS
function getLensPacks(product, isKids) {
    var attributes = product.masterVariant.attributes;
    var lensDetails = attributes && attributes.find(function (attr) { return attr.name === 'lensDetails'; });
    if (!lensDetails) {
        return {
            monofocalLensPacks: [],
            multifocalLensPacks: [],
        };
    }
    function movePackNameUp(lensPack) {
        var packType = (lensPack.attributes || []).find(function (attr) { return attr.name === 'pack'; }).value.key;
        return __assign(__assign({}, lensPack), { packType: packType || '' });
    }
    var lensPacksData = lensDetails.value.obj.masterData.current;
    var includedLensPack = movePackNameUp(__assign(__assign({}, lensPacksData.masterVariant), { isIncluded: true }));
    var lensPacks = lensPacksData.variants.map(function (pack) {
        return movePackNameUp(__assign(__assign({}, pack), { isIncluded: false }));
    });
    var monofocalLensPacks = lensPacks.filter(function (pack) {
        var lens = pack.attributes.find(function (attr) { return attr.name === 'lens'; });
        return lens.value.key === 'singleVision';
    });
    monofocalLensPacks.unshift(includedLensPack);
    var multifocalLensPacks = [];
    if (!isKids) {
        multifocalLensPacks = lensPacks.filter(function (pack) {
            var lens = pack.attributes.find(function (attr) { return attr.name === 'lens'; });
            return lens.value.key === 'multifocal';
        });
    }
    return {
        includedLensPack: includedLensPack,
        monofocalLensPacks: monofocalLensPacks,
        multifocalLensPacks: multifocalLensPacks,
    };
}
// CALCULATIONS
function calcGlassesPrice(opticalData, glassesType) {
    if (glassesType === 'frameAndMonofocal') {
        return opticalData.frameAndMonofocalPrice;
    }
    if (glassesType === 'frameAndMultifocal') {
        return opticalData.frameAndMultifocalPrice;
    }
    return opticalData.framePrice;
}
/**
 * Calculates the +/- price for a selected glasses type compared to the initial type.
 */
function calcGlassesPriceDifference(opticalData, glassesType, initialGlassesType) {
    if (initialGlassesType === void 0) { initialGlassesType = 'frameAndMonofocal'; }
    var priceMapping = {
        frameOnly: opticalData.framePrice,
        frameAndMonofocal: opticalData.frameAndMonofocalPrice,
        frameAndMultifocal: opticalData.frameAndMultifocalPrice,
    };
    return priceMapping[glassesType] - priceMapping[initialGlassesType];
}
function calcLensPackPrice(opticalData, glassesType, lensPack, useIncludedLensPack) {
    if (useIncludedLensPack === void 0) { useIncludedLensPack = false; }
    var _a, _b, _c, _d, _e, _f;
    var brand = opticalData.brand, isKidsGlasses = opticalData.isKidsGlasses;
    var lensPackPrice = 0;
    if (glassesType === 'frameOnly') {
        return lensPackPrice;
    }
    var monofocalLensPacks = opticalData.monofocalLensPacks, multifocalLensPacks = opticalData.multifocalLensPacks;
    var activePackList = glassesType === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
    var selectedPack = activePackList.find(function (pack) { return pack.packType === lensPack; });
    if (!selectedPack) {
        return lensPackPrice;
    }
    if (!useIncludedLensPack) {
        return (_a = getPriceOfLensPack(selectedPack)) !== null && _a !== void 0 ? _a : 0;
    }
    if (opticalData.includedLensPack &&
        opticalData.includedLensPack.packType === lensPack &&
        glassesType === 'frameAndMonofocal') {
        // if the lensPack is already included, then set lensPackPrice to 0
        lensPackPrice = 0;
    }
    else if (glassesType === 'frameAndMonofocal' &&
        lensPack === 'basic' &&
        (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' is included on Seen and kids glasses --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    }
    else if (glassesType === 'frameAndMonofocal' &&
        lensPack === 'basic' &&
        brand.toLowerCase() !== 'seen' &&
        !isKidsGlasses) {
        // 'bronze' is also included on other brands --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    }
    else if (glassesType === 'frameAndMultifocal' &&
        (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' pack price is also included on Seen and 'kids' glasses when MULTIfocal
        // The price of 'basic' needs to be subtracted from every lenspack to make calculations be correct
        var basicMultiPack = getInitialLensPack(opticalData.multifocalLensPacks, 'basic');
        var basicMultiPackPrice = (_b = getPriceOfLensPack(basicMultiPack)) !== null && _b !== void 0 ? _b : 0;
        lensPackPrice = ((_c = getPriceOfLensPack(selectedPack)) !== null && _c !== void 0 ? _c : 0) - basicMultiPackPrice;
    }
    else if (glassesType === 'frameAndMultifocal' && !isKidsGlasses) {
        // 'bronze' pack price is included on non-Seen and non-'kids' glasses when MULTIfocal
        // The price of 'bronze' needs to be subtracted from every lenspack to make calculations be correct
        var basicMultiPack = getInitialLensPack(opticalData.multifocalLensPacks, 'basic');
        var basicMultiPackPrice = (_d = getPriceOfLensPack(basicMultiPack)) !== null && _d !== void 0 ? _d : 0;
        lensPackPrice = ((_e = getPriceOfLensPack(selectedPack)) !== null && _e !== void 0 ? _e : 0) - basicMultiPackPrice;
    }
    else {
        lensPackPrice = (_f = getPriceOfLensPack(selectedPack)) !== null && _f !== void 0 ? _f : 0;
    }
    return lensPackPrice;
}
function calcSelectedExtrasPrice(extrasData, selectedExtras) {
    var price = 0;
    if (selectedExtras) {
        return extrasData
            .filter(function (_a) {
            var value = _a.value;
            return selectedExtras.indexOf(value) >= 0;
        })
            .reduce(function (sum, item) { return sum + item.price || 0; }, 0);
    }
    return price;
}
// HELPERS
function findAndSortBenefits(packs, intl, sorting) {
    var map = sorting.reduce(function (main, value, index) {
        var _a;
        return (__assign(__assign({}, main), (_a = {}, _a[value] = index, _a)));
    }, {});
    return packs.map(function (pack) {
        var benefits = pack.attributes &&
            pack.attributes
                .filter(function (attr) { return attr.name.match('(cb[A-Z])\\w+') && attr.name in map; })
                .sort(function (a, b) { return map[a.name] - map[b.name]; })
                .map(function (benefit) {
                var labelKey = "products.ssp.lenses." + benefit.name;
                var label = (intl && intl.getLabel && intl.getLabel(labelKey)) || '';
                return __assign(__assign({}, benefit), { label: label });
            });
        if (!benefits) {
            return __assign(__assign({}, pack), { benefits: [] });
        }
        return __assign(__assign({}, pack), { benefits: benefits });
    });
}
function getInitialLensPack(lensPackData, selector) {
    var selection = lensPackData.find(function (pack) { return pack.packType === selector; });
    return selection ? selection : lensPackData[0];
}
function getPriceOfLensPack(lensPack) {
    var _a, _b, _c;
    return (_c = (_b = (_a = lensPack === null || lensPack === void 0 ? void 0 : lensPack.prices) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.centAmount;
}

var isGlassesType = function (input) {
    return input === 'frameOnly' || input === 'frameAndMonofocal' || input === 'frameAndMultifocal';
};
var ExtraTypes;
(function (ExtraTypes) {
    ExtraTypes["tinted-lenses-pack"] = "tinted-lenses-pack";
    ExtraTypes["manufactured-lenses"] = "manufactured-lenses";
    ExtraTypes["screen-protection-pack"] = "screen-protection-pack";
    ExtraTypes["polarized-pack"] = "polarized-pack";
    ExtraTypes["personalized-pack"] = "personalized-pack";
    ExtraTypes["light-adaptive-pack"] = "light-adaptive-pack";
    ExtraTypes["gradient-pack"] = "gradient-pack";
})(ExtraTypes || (ExtraTypes = {}));
var isExtraType = function (input) { return input in ExtraTypes; };
var Aside = function (_a) {
    var currency = _a.currency, price = _a.price, prefix = _a.prefix, className = _a.className;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: className },
        prefix,
        " ",
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price, centAmount: true, currency: currency })));
};
var SSP = /** @class */ (function (_super) {
    __extends(SSP, _super);
    function SSP(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.setExtrasData = function (selectedGlasses, selectedLensPack, selectedExtras) {
            var _a = _this.createExtrasItems(_this.props.lensExtras), monofocalExtras = _a.monofocalExtras, multifocalExtras = _a.multifocalExtras;
            var allowedExtras = _this.props.lensExtrasResolver(selectedGlasses, selectedLensPack, selectedExtras, _this.opticalData);
            var extrasData = selectedGlasses === 'frameAndMonofocal' ? monofocalExtras : multifocalExtras;
            extrasData = extrasData.map(function (extra) {
                var enabled = allowedExtras && allowedExtras.indexOf(extra.value) > -1;
                var checked = enabled && selectedExtras && selectedExtras.indexOf(extra.value) > -1;
                return __assign(__assign({}, extra), { isChecked: checked, disabled: !enabled });
            });
            return extrasData;
        };
        _this.createExtrasItems = function (data) {
            var intl = _this.props.intl;
            var monofocalExtras = data
                .filter(function (item) {
                return isExtraType(item.slug.en) && item.masterVariant.prices && item.masterVariant.prices.length;
            })
                .map(function (item) {
                // @ts-ignore, is checked in the filter above
                var price = item.masterVariant.prices[0].value.centAmount;
                var Aside = (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", null,
                    "+ ",
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Price */ "W"], { value: price, centAmount: true, currency: intl.currency })));
                return {
                    scope: 'extras',
                    title: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(item.name, intl.locale),
                    text: item.description ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(item.description, intl.locale) : '',
                    value: item.slug.en,
                    aside: Aside,
                    price: price,
                    disabled: false,
                };
            });
            var multifocalExtras = data
                .filter(function (item) {
                return item.variants.length !== 0 &&
                    item.variants[0].prices &&
                    item.variants[0].prices.length &&
                    isExtraType(item.slug.en);
            })
                .map(function (item) {
                // @ts-ignore, is checked in the filter above
                var price = item.variants[0].prices[0].value.centAmount;
                return {
                    scope: 'extras',
                    title: item.name ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(item.name, intl.locale) : '',
                    text: item.description ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getLocalizedValue */ "q"])(item.description, intl.locale) : '',
                    value: item.slug.en,
                    aside: Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Aside, { prefix: "+", price: price, currency: intl.currency }),
                    price: price,
                    disabled: false,
                };
            });
            return {
                monofocalExtras: monofocalExtras,
                multifocalExtras: multifocalExtras,
            };
        };
        _this.createGlassesItems = function () {
            var _a = _this.props, initialGlasses = _a.initialGlasses, useIncludedFrame = _a.useIncludedFrame, intl = _a.intl;
            var glassesTypes = ['frameOnly', 'frameAndMonofocal', 'frameAndMultifocal'];
            var glassesItems = glassesTypes
                .filter(function (glassesType) {
                // Only NON-kids frames can have multifocal.
                return !(glassesType === 'frameAndMultifocal' && _this.opticalData.isKidsGlasses);
            })
                .map(function (glassesType) {
                var price = calcGlassesPrice(_this.opticalData, glassesType);
                var prefix = '';
                if (useIncludedFrame) {
                    price = calcGlassesPriceDifference(_this.opticalData, glassesType, initialGlasses);
                    prefix = price < 0 ? '-' : price > 0 ? '+' : '';
                }
                return {
                    title: intl.getLabel("products.ssp.glasses." + glassesType + ".title"),
                    text: intl.getLabel("products.ssp.glasses." + glassesType + ".text"),
                    value: glassesType,
                    scope: 'glasses',
                    aside: useIncludedFrame && price === 0 ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", null, intl.getLabel('products.included'))) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Aside, { prefix: prefix, price: Math.abs(price), currency: intl.currency })),
                    disabled: false,
                };
            });
            return glassesItems;
        };
        _this.handleGlassesTypeChange = function (type) {
            if (!isGlassesType(type)) {
                console.error("Invalid glasses type: \"" + type + "\"");
                return;
            }
            var _a = _this.state, selectedLensPack = _a.selectedLensPack, selectedExtras = _a.selectedExtras;
            _this.extrasData = _this.setExtrasData(type, selectedLensPack, selectedExtras);
            var newExtras = [];
            if (type === 'frameOnly') {
                newExtras = [];
            }
            else {
                newExtras = _this.filterByAllowed(type, selectedLensPack, selectedExtras);
            }
            var newGlassesPrice = calcGlassesPrice(_this.opticalData, type);
            var newLensPackPrice = calcLensPackPrice(_this.opticalData, type, selectedLensPack, _this.props.useIncludedLensPack);
            var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, newExtras);
            var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            _this.setState({
                selectedGlasses: type,
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice: totalPrice,
            }, function () {
                _this.props.onChange && _this.props.onChange(_this.state);
            });
        };
        _this.handleLensPackChange = function (pack) {
            var _a = _this.state, selectedGlasses = _a.selectedGlasses, selectedExtras = _a.selectedExtras;
            _this.extrasData = _this.setExtrasData(selectedGlasses, pack, selectedExtras);
            var newExtras = _this.filterByAllowed(selectedGlasses, pack, selectedExtras);
            var newGlassesPrice = calcGlassesPrice(_this.opticalData, selectedGlasses);
            var newLensPackPrice = calcLensPackPrice(_this.opticalData, selectedGlasses, pack, _this.props.useIncludedLensPack);
            var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, newExtras);
            var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            _this.setState({
                selectedLensPack: pack,
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice: totalPrice,
            }, function () {
                _this.props.onChange && _this.props.onChange(_this.state);
            });
        };
        _this.handleExtrasChange = function (items) {
            var extras = items.filter(function (item) { return isExtraType(item.value); });
            var values = extras.map(function (i) { return i.value; });
            var _a = _this.state, selectedGlasses = _a.selectedGlasses, selectedLensPack = _a.selectedLensPack;
            var newExtras = _this.filterByAllowed(selectedGlasses, selectedLensPack, values);
            var newGlassesPrice = calcGlassesPrice(_this.opticalData, selectedGlasses);
            var newLensPackPrice = calcLensPackPrice(_this.opticalData, selectedGlasses, selectedLensPack, _this.props.useIncludedLensPack);
            var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, newExtras);
            var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            _this.setState({
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice: totalPrice,
            }, function () {
                _this.props.onChange && _this.props.onChange(_this.state);
            });
        };
        // all product data, dynamically created based on data provided by page
        var frameData = getFrameData(_this.props.product);
        var lensPackData = getLensPacks(_this.props.product, frameData.isKidsGlasses);
        _this.opticalData = __assign(__assign(__assign({}, frameData), lensPackData), { lensExtras: _this.props.lensExtras, frameAndMonofocalPrice: 0, frameAndMultifocalPrice: 0 });
        var includedLensPackPrice = _this.opticalData.includedLensPack
            ? (_a = getPriceOfLensPack(_this.opticalData.includedLensPack)) !== null && _a !== void 0 ? _a : 0 : 0;
        var initialPrice = props.useIncludedLensPack
            ? includedLensPackPrice + frameData.framePrice
            : frameData.framePrice;
        var frameAndMonofocalPrice = initialPrice;
        var initLensPackMultifocal = getInitialLensPack(_this.opticalData.multifocalLensPacks);
        var initialLensPackMultifocalPrice = props.useIncludedLensPack && initLensPackMultifocal
            ? (_b = getPriceOfLensPack(initLensPackMultifocal)) !== null && _b !== void 0 ? _b : 0 : 0;
        var frameAndMultifocalPrice = !_this.opticalData.isKidsGlasses
            ? initialLensPackMultifocalPrice + initialPrice
            : 0;
        _this.opticalData = __assign(__assign({}, _this.opticalData), { frameAndMonofocalPrice: frameAndMonofocalPrice,
            frameAndMultifocalPrice: frameAndMultifocalPrice });
        // initial options
        // Initial selected type of glasses
        var initialGlasses = _this.props.initialGlasses || 'frameAndMonofocal';
        var initialLensPackType = _this.props.initialLensPack || getInitialLensPack(_this.opticalData.monofocalLensPacks).packType;
        // Initial extras start empty
        var initialExtras = _this.props.initialExtras || [];
        // Set extrasData
        _this.extrasData = _this.setExtrasData(initialGlasses, initialLensPackType, initialExtras);
        // Set all prices based on initial selections
        var newGlassesPrice = calcGlassesPrice(_this.opticalData, initialGlasses);
        var newLensPackPrice = calcLensPackPrice(_this.opticalData, initialGlasses, initialLensPackType, props.useIncludedLensPack);
        var newExtrasPrice = calcSelectedExtrasPrice(_this.extrasData, initialExtras);
        var totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
        _this.state = {
            isLoading: true,
            selectedGlasses: initialGlasses,
            selectedLensPack: initialLensPackType,
            selectedExtras: initialExtras,
            glassesPrice: newGlassesPrice,
            lensPackPrice: newLensPackPrice,
            extrasPrice: newExtrasPrice,
            totalPrice: totalPrice,
        };
        return _this;
    }
    SSP.prototype.filterByAllowed = function (glasses, lensPack, extras) {
        // Get allowed extras based on the value and assign to newExtras
        var allowedExtras = this.props.lensExtrasResolver(glasses, lensPack, extras, this.opticalData);
        var newExtras = extras.filter(function (item) { return allowedExtras.indexOf(item) > -1; });
        // With the newExtras, check allowedExtras again and filter it with the newExtras itself
        allowedExtras = this.props.lensExtrasResolver(glasses, lensPack, newExtras, this.opticalData);
        newExtras = extras.filter(function (item) { return allowedExtras.indexOf(item) > -1; });
        return newExtras;
    };
    SSP.prototype.componentDidMount = function () {
        this.setState({ isLoading: false });
        // Need to call onChange on mount to send initial values to parent on load
        this.props.onChange && this.props.onChange(this.state);
    };
    SSP.prototype.render = function () {
        var _this = this;
        var _a = this.opticalData, monofocalLensPacks = _a.monofocalLensPacks, multifocalLensPacks = _a.multifocalLensPacks;
        var _b = this.props, className = _b.className, useIncludedLensPack = _b.useIncludedLensPack, intl = _b.intl;
        var _c = this.state, selectedGlasses = _c.selectedGlasses, selectedExtras = _c.selectedExtras;
        var selectedLensPack = this.state.selectedLensPack || 'bronze';
        var activePacks = selectedGlasses === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
        this.extrasData = this.setExtrasData(selectedGlasses, selectedLensPack, selectedExtras);
        // Monofocal table will show only benefits that match this array and sort them accordingly
        var monoSorting = [
            'cbAntiBreakage',
            'cbAntiScratch',
            'cbAntiReflective',
            'cbHidrorrepelent',
            'cbReducedEyeFatigue',
            'cbThinnerLighter',
            'cbIdealForRimless',
            'cbUVprotection',
            'cbBetterContrast',
            'cbHDtechnology',
            'cbIndividualLenses',
        ];
        // Multifocal table will show only benefits that match this array and sort them accordingly
        var multiSorting = [
            'visualField',
            'cbPerfectSight',
            'cbAntiBreakage',
            'cbAntiScratch',
            'cbAntiReflective',
            'cbHidrorrepelent',
            'cbThinnerLighter',
            'cbIdealForRimless',
            'cbUVprotection',
            'cbBetterContrast',
            'cbHDtechnology',
            'cbIndividualLenses',
        ];
        var glassesItems = this.createGlassesItems();
        var sorting = selectedGlasses === 'frameAndMonofocal' ? monoSorting : multiSorting;
        var packsWithBenefits = findAndSortBenefits(activePacks, intl, sorting);
        var withVisualField = packsWithBenefits
            .filter(function (pack) { return pack.attributes; })
            .map(function (pack) { return pack.attributes; })
            .reduce(function (a, b) { return a.concat(b); }, [])
            .some(function (attr) { return attr.name === 'visualField'; });
        var withVoucherValues = packsWithBenefits.length > 0 &&
            packsWithBenefits
                .map(function (pack) {
                var voucherAttr = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getAttrValue */ "m"])(pack, 'voucher');
                return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* isPlainObject */ "A"])(voucherAttr) ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* getNestedProperty */ "s"])(voucherAttr, 'centAmount', 0) : 0;
            })
                .some(function (value) { return value > 0; });
        var SSPclasses = classnames__WEBPACK_IMPORTED_MODULE_11___default()({
            ssp: true,
            'ssp--with-voucher': withVoucherValues,
            'ssp--with-visual-field': withVisualField,
            className: className,
        });
        var selectedItems = this.state.selectedExtras.reduce(function (acc, name) {
            var extra = _this.extrasData.find(function (e) { return e.value === name; });
            return extra ? __spread(acc, [extra]) : acc;
        }, []);
        return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: SSPclasses },
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "site-container ssp__container" }, this.state.isLoading ? (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Loader */ "L"], null)) : (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "ssp__section-title" }, intl.getLabel('products.ssp.glasses.title')),
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* SelectionGroup */ "fb"], { items: glassesItems, selectedItem: this.state.selectedGlasses, onChange: this.handleGlassesTypeChange }),
                this.state.selectedGlasses !== 'frameOnly' && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                    intl.getLabel('products.ssp.lenses.title') && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "ssp__section-title" }, intl.getLabel('products.ssp.lenses.title'))),
                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(LensPacks$1, { packs: packsWithBenefits, selectedPack: this.state.selectedLensPack || 'bronze', selectedGlasses: this.state.selectedGlasses, onChange: this.handleLensPackChange, useIncludedLensPack: useIncludedLensPack }),
                    this.extrasData.length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(react__WEBPACK_IMPORTED_MODULE_10__["Fragment"], null,
                        intl.getLabel('products.ssp.extras.title') && (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("h3", { className: "ssp__section-title" }, intl.getLabel('products.ssp.extras.title'))),
                        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* CheckboxList */ "k"], { checkboxAlignment: "middle", className: "ssp__lens-extras", itemClassName: "ssp__lens-extras-item", idPrefix: "ssp-lens-extra__", items: this.extrasData, selectedItems: selectedItems, getItemIdentifier: function (item) { return item.value; }, isItemDisabled: function (item) { return item.disabled; }, renderItem: function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('ssp-lens-extra__content', {
                                    'ssp-lens-extra__content--disabled': item.disabled,
                                }) },
                                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "ssp-lens-extra__main" },
                                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "ssp-lens-extra__title" }, item.title),
                                    Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("span", { className: "ssp-lens-extra__text" }, item.text)),
                                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(Aside, { prefix: "+", price: item.price, currency: intl.currency, className: "ssp-lens-extra__price" }))); }, onChange: this.handleExtrasChange }))))))))));
    };
    return SSP;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]));
var SSP$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SSP);

var RecentlyViewedProducts = function (_a) {
    var title = _a.title, rest = __rest(_a, ["title"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _b = useProductViewHistory(), history = _b.history, clear = _b.clear;
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* MediaQuery */ "P"].useIsPhone();
    var _c = useGetProductsBySku(history), isLoading = _c.isLoading, products = _c.products, error = _c.error;
    var noHistory = Array.isArray(history) && history.length === 0;
    var noProducts = !error && (products === null || products === void 0 ? void 0 : products.length) === 0;
    // Only return null when we are sure the history is empty or when there are no products matching the SKU's in history,
    // i.e. unpublished products
    // as history will never be defined on the server and can result in HTML mismatches if we always return
    if (noHistory || noProducts) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "recently-viewed-products", "data-t": "recently-viewed-products" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Container */ "d"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { component: "h2", variant: isPhone ? 'small' : 'medium' }, title || getLabel('products.recentlyViewed.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductBanner, __assign({ isLoading: isLoading, error: error, products: products }, rest)),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "recently-viewed-products__clear" },
                Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_13__[/* Button */ "f"], { caption: getLabel('products.recentlyViewed.clear'), onClick: clear, variant: "ghost", size: "custom" })))));
};
var RecentlyViewedProducts$1 = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* withLazyLoading */ "N"])(RecentlyViewedProducts, { rootMargin: '200px 0px' });

var FeaturedProducts = function (_a) {
    var title = _a.title, rest = __rest(_a, ["title"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])("div", { className: "featured-products" },
        Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Container */ "d"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_12__[/* Heading */ "f"], { className: "featured-products__title", variant: "medium", align: "center" }, title || getLabel('products.featured.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_10__["createElement"])(ProductBannerContainer, __assign({}, rest)))));
};
var FeaturedProducts$1 = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_3__[/* withLazyLoading */ "N"])(FeaturedProducts);

/**
 * Products module
 *
 * Contains all components related to products
 *
 * @grandvision/products
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* SagaRegistry */ "p"].register('contactLensSubscription', contactLensSubscriptionSaga);
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ReducersRegistry */ "l"].register('contactLensSubscription', contactLensSubscriptionReducer);
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* SagaRegistry */ "p"].register('prescriptionGlasses', prescriptionGlassesSaga);
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ReducersRegistry */ "l"].register('prescriptionGlasses', prescriptionGlassesReducer);


//# sourceMappingURL=index.es.js.map


/***/ })

}]);